import Icon from "@ant-design/icons";
import styled from "styled-components";
import React from "react";
import Image from "next/image";
import { COLORS } from "../../const";

export const SettingsIcon = ({ color = undefined, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.1917 10.8167C16.225 10.55 16.25 10.2833 16.25 9.99999C16.25 9.71666 16.225 9.44999 16.1917 9.18332L17.95 7.80832C18.1083 7.68332 18.15 7.45832 18.05 7.27499L16.3833 4.39166C16.3083 4.25832 16.1667 4.18332 16.0167 4.18332C15.9667 4.18332 15.9167 4.19166 15.875 4.20832L13.8 5.04166C13.3667 4.70832 12.9 4.43332 12.3917 4.22499L12.075 2.01666C12.05 1.81666 11.875 1.66666 11.6667 1.66666H8.33334C8.125 1.66666 7.95 1.81666 7.925 2.01666L7.60834 4.22499C7.1 4.43332 6.63334 4.71666 6.2 5.04166L4.125 4.20832C4.075 4.19166 4.025 4.18332 3.975 4.18332C3.83334 4.18332 3.69167 4.25832 3.61667 4.39166L1.95 7.27499C1.84167 7.45832 1.89167 7.68332 2.05 7.80832L3.80834 9.18332C3.775 9.44999 3.75 9.72499 3.75 9.99999C3.75 10.275 3.775 10.55 3.80834 10.8167L2.05 12.1917C1.89167 12.3167 1.85 12.5417 1.95 12.725L3.61667 15.6083C3.69167 15.7417 3.83334 15.8167 3.98334 15.8167C4.03334 15.8167 4.08334 15.8083 4.125 15.7917L6.2 14.9583C6.63334 15.2917 7.1 15.5667 7.60834 15.775L7.925 17.9833C7.95 18.1833 8.125 18.3333 8.33334 18.3333H11.6667C11.875 18.3333 12.05 18.1833 12.075 17.9833L12.3917 15.775C12.9 15.5667 13.3667 15.2833 13.8 14.9583L15.875 15.7917C15.925 15.8083 15.975 15.8167 16.025 15.8167C16.1667 15.8167 16.3083 15.7417 16.3833 15.6083L18.05 12.725C18.15 12.5417 18.1083 12.3167 17.95 12.1917L16.1917 10.8167ZM14.5417 9.39166C14.575 9.64999 14.5833 9.82499 14.5833 9.99999C14.5833 10.175 14.5667 10.3583 14.5417 10.6083L14.425 11.55L15.1667 12.1333L16.0667 12.8333L15.4833 13.8417L14.425 13.4167L13.5583 13.0667L12.8083 13.6333C12.45 13.9 12.1083 14.1 11.7667 14.2417L10.8833 14.6L10.75 15.5417L10.5833 16.6667H9.41667L9.25834 15.5417L9.125 14.6L8.24167 14.2417C7.88334 14.0917 7.55 13.9 7.21667 13.65L6.45834 13.0667L5.575 13.425L4.51667 13.85L3.93334 12.8417L4.83334 12.1417L5.575 11.5583L5.45834 10.6167C5.43334 10.3583 5.41667 10.1667 5.41667 9.99999C5.41667 9.83332 5.43334 9.64166 5.45834 9.39166L5.575 8.44999L4.83334 7.86666L3.93334 7.16666L4.51667 6.15832L5.575 6.58332L6.44167 6.93332L7.19167 6.36666C7.55 6.09999 7.89167 5.89999 8.23334 5.75832L9.11667 5.39999L9.25 4.45832L9.41667 3.33332H10.575L10.7333 4.45832L10.8667 5.39999L11.75 5.75832C12.1083 5.90832 12.4417 6.09999 12.775 6.34999L13.5333 6.93332L14.4167 6.57499L15.475 6.14999L16.0583 7.15832L15.1667 7.86666L14.425 8.44999L14.5417 9.39166ZM10 6.66666C8.15834 6.66666 6.66667 8.15832 6.66667 9.99999C6.66667 11.8417 8.15834 13.3333 10 13.3333C11.8417 13.3333 13.3333 11.8417 13.3333 9.99999C13.3333 8.15832 11.8417 6.66666 10 6.66666ZM10 11.6667C9.08334 11.6667 8.33334 10.9167 8.33334 9.99999C8.33334 9.08332 9.08334 8.33332 10 8.33332C10.9167 8.33332 11.6667 9.08332 11.6667 9.99999C11.6667 10.9167 10.9167 11.6667 10 11.6667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const NotificationSettingsIcon = ({ color = undefined, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 14V15.5H16V14H15V11H13.5V14H6.5V9C6.514 8.028 6.86133 7.20167 7.542 6.521C8.222 5.84033 9.04133 5.5 10 5.5C10.278 5.5 10.5523 5.53467 10.823 5.604C11.0937 5.67333 11.354 5.77067 11.604 5.896L12.708 4.792C12.472 4.59733 12.2047 4.45133 11.906 4.354C11.6073 4.25667 11.3053 4.17333 11 4.104V3C11 2.722 10.9027 2.486 10.708 2.292C10.514 2.09733 10.278 2 10 2C9.722 2 9.486 2.09733 9.292 2.292C9.09733 2.486 9 2.722 9 3V4.104C7.83333 4.34 6.875 4.91633 6.125 5.833C5.375 6.74967 5 7.80533 5 9V14H4Z"
          fill={color || "currentColor"}
        />
        <path
          d="M8.938 17.562C9.22933 17.854 9.58333 18 10 18C10.4167 18 10.7707 17.854 11.062 17.562C11.354 17.2707 11.5 16.9167 11.5 16.5H8.5C8.5 16.9167 8.646 17.2707 8.938 17.562Z"
          fill={color || "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.084 8.979L15.292 9.875H16.479L16.688 8.979C16.7987 8.92367 16.9063 8.86467 17.011 8.802C17.115 8.73933 17.2017 8.67333 17.271 8.604L18.167 8.917L18.771 7.875L18.042 7.25C18.056 7.18067 18.063 7.125 18.063 7.083V6.781C18.063 6.73233 18.056 6.68033 18.042 6.625L18.771 6L18.167 4.958L17.271 5.271C17.2017 5.20167 17.115 5.13233 17.011 5.063C16.9063 4.993 16.7987 4.93733 16.688 4.896L16.479 4H15.313L15.104 4.896C14.9933 4.93733 14.8857 4.993 14.781 5.063C14.677 5.13233 14.5903 5.20167 14.521 5.271L13.625 4.958L13.021 6L13.75 6.625C13.736 6.68033 13.729 6.73233 13.729 6.781V6.938C13.729 6.99333 13.7257 7.04167 13.719 7.083C13.7117 7.125 13.715 7.18067 13.729 7.25L13 7.875L13.604 8.917L14.5 8.604C14.5693 8.67333 14.6563 8.73933 14.761 8.802C14.865 8.86467 14.9727 8.92367 15.084 8.979ZM16.636 7.677C16.4347 7.87833 16.188 7.979 15.896 7.979C15.604 7.979 15.3573 7.87833 15.156 7.677C14.9547 7.47567 14.854 7.22933 14.854 6.938C14.854 6.646 14.9547 6.39933 15.156 6.198C15.3573 5.99667 15.604 5.896 15.896 5.896C16.188 5.896 16.4347 5.99667 16.636 6.198C16.8373 6.39933 16.938 6.646 16.938 6.938C16.938 7.22933 16.8373 7.47567 16.636 7.677Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const CollapseIcon = ({ color = COLORS["gray-800"], size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_21443_189576)">
          <path
            d="M10 6.66797L5 11.668L6.175 12.843L10 9.0263L13.825 12.843L15 11.668L10 6.66797Z"
            fill={color || "currentColor"}
          />
        </g>
        <defs>
          <clipPath id="clip0_21443_189576">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const ExpandIcon = ({ color = undefined, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.825 7.15833L10 10.975L6.175 7.15833L5 8.33333L10 13.3333L15 8.33333L13.825 7.15833Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const ExpandRight = ({ color, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_21417_230411)">
          <path
            d="M7.15833 6.175L10.975 10L7.15833 13.825L8.33333 15L13.3333 10L8.33333 5L7.15833 6.175Z"
            fill={color || "currentColor"}
          />
        </g>
        <defs>
          <clipPath id="clip0_21417_230411">
            <rect width="20" height="20" fill="white" transform="translate(0 20) rotate(-90)" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const ExpandLeft = ({ color, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_375_36727)">
          <path
            d="M11.825 15L13 13.825L9.18333 10L13 6.175L11.825 5L6.825 10L11.825 15Z"
            fill={color || "currentColor"}
          />
        </g>
        <defs>
          <clipPath id="clip0_375_36727">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const NotificationIcon = ({ size = 24, color }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_96_9750)">
          <path
            d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z"
            fill={color || "currentColor"}
          />
        </g>
        <defs>
          <clipPath id="clip0_96_9750">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const LogoutIcon = ({ color = "black", size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1667 6.66667L12.9917 7.84167L14.3083 9.16667H7.5V10.8333H14.3083L12.9917 12.15L14.1667 13.3333L17.5 10L14.1667 6.66667ZM4.16667 4.16667H10V2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H10V15.8333H4.16667V4.16667Z"
          fill={color}
        />
      </svg>
    )}
    {...props}
  />
);
export const RefreshIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 3.33333V0.833328L6.66668 4.16666L10 7.49999V4.99999C12.7583 4.99999 15 7.24166 15 9.99999C15 10.8417 14.7917 11.6417 14.4167 12.3333L15.6333 13.55C16.2833 12.525 16.6667 11.3083 16.6667 9.99999C16.6667 6.31666 13.6833 3.33333 10 3.33333ZM10 15C7.24168 15 5.00001 12.7583 5.00001 9.99999C5.00001 9.15833 5.20834 8.35833 5.58334 7.66666L4.36668 6.44999C3.71668 7.47499 3.33334 8.69166 3.33334 9.99999C3.33334 13.6833 6.31668 16.6667 10 16.6667V19.1667L13.3333 15.8333L10 12.5V15Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const Refresh2Icon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill={color || "currentColor"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_11654_197110)">
          <path
            d="M14.7083 5.29158C13.5 4.08325 11.8417 3.33325 10 3.33325C6.31667 3.33325 3.34167 6.31658 3.34167 9.99992C3.34167 13.6833 6.31667 16.6666 10 16.6666C13.1083 16.6666 15.7 14.5416 16.4417 11.6666H14.7083C14.025 13.6083 12.175 14.9999 10 14.9999C7.24167 14.9999 5.00001 12.7583 5.00001 9.99992C5.00001 7.24159 7.24167 4.99992 10 4.99992C11.3833 4.99992 12.6167 5.57492 13.5167 6.48325L10.8333 9.16658H16.6667V3.33325L14.7083 5.29158Z"
            fill={color || "currentColor"}
          />
        </g>
        <defs>
          <clipPath id="clip0_11654_197110">
            <rect width={size} height={size} fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ResetIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_951_11268)">
          <path
            d="M5.00004 10.8333C5.00004 9.45833 5.55837 8.20833 6.46671 7.3L5.28337 6.11666C4.08337 7.325 3.33337 8.99166 3.33337 10.8333C3.33337 14.2333 5.87504 17.0333 9.16671 17.4417V15.7583C6.80837 15.3583 5.00004 13.3083 5.00004 10.8333ZM16.6667 10.8333C16.6667 7.15 13.6834 4.16666 10 4.16666C9.95004 4.16666 9.90004 4.175 9.85004 4.175L10.7584 3.26666L9.58337 2.08333L6.66671 4.99999L9.58337 7.91666L10.7584 6.74166L9.85837 5.84166C9.90837 5.84166 9.95837 5.83333 10 5.83333C12.7584 5.83333 15 8.075 15 10.8333C15 13.3083 13.1917 15.3583 10.8334 15.7583V17.4417C14.125 17.0333 16.6667 14.2333 16.6667 10.8333Z"
            fill={color || "currentColor"}
          />
        </g>
        <defs>
          <clipPath id="clip0_951_11268">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const DeleteIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3333 7.5V15.8333H6.66667V7.5H13.3333ZM12.0833 2.5H7.91667L7.08334 3.33333H4.16667V5H15.8333V3.33333H12.9167L12.0833 2.5ZM15 5.83333H5.00001V15.8333C5.00001 16.75 5.75001 17.5 6.66667 17.5H13.3333C14.25 17.5 15 16.75 15 15.8333V5.83333Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const MinusIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.83342 8.16699V9.83366H13.1667V8.16699H4.83342ZM9.00008 0.666992C4.40008 0.666992 0.666748 4.40033 0.666748 9.00033C0.666748 13.6003 4.40008 17.3337 9.00008 17.3337C13.6001 17.3337 17.3334 13.6003 17.3334 9.00033C17.3334 4.40033 13.6001 0.666992 9.00008 0.666992ZM9.00008 15.667C5.32508 15.667 2.33341 12.6753 2.33341 9.00033C2.33341 5.32533 5.32508 2.33366 9.00008 2.33366C12.6751 2.33366 15.6667 5.32533 15.6667 9.00033C15.6667 12.6753 12.6751 15.667 9.00008 15.667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const MinusOnlyIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 10 2"
        fill={color || "currentColor"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 1.75V0.25H10V1.75H0Z" fill={color || "currentColor"} />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const EditIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const EditIcon14 = ({ color, size = 14 }) => (
  <Icon
    component={() => (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.20167 5.26167L8.73833 5.79833L3.45333 11.0833H2.91667V10.5467L8.20167 5.26167ZM10.3017 1.75C10.1558 1.75 10.0042 1.80833 9.89333 1.91917L8.82583 2.98667L11.0133 5.17417L12.0808 4.10667C12.3083 3.87917 12.3083 3.51167 12.0808 3.28417L10.7158 1.91917C10.5992 1.8025 10.4533 1.75 10.3017 1.75ZM8.20167 3.61083L1.75 10.0625V12.25H3.9375L10.3892 5.79833L8.20167 3.61083Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    style={{ display: "flex" }}
    width={size}
    height={size}
  />
);

export const PdfIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.6667 1.66666H6.66666C5.75 1.66666 5 2.41666 5 3.33332V13.3333C5 14.25 5.75 15 6.66666 15H16.6667C17.5833 15 18.3333 14.25 18.3333 13.3333V3.33332C18.3333 2.41666 17.5833 1.66666 16.6667 1.66666ZM16.6667 13.3333H6.66666V3.33332H16.6667V13.3333ZM3.33333 4.99999H1.66666V16.6667C1.66666 17.5833 2.41666 18.3333 3.33333 18.3333H15V16.6667H3.33333V4.99999ZM13.3333 9.99999V7.49999C13.3333 7.04166 12.9583 6.66666 12.5 6.66666H10.8333V10.8333H12.5C12.9583 10.8333 13.3333 10.4583 13.3333 9.99999ZM11.6667 7.49999H12.5V9.99999H11.6667V7.49999ZM15 9.16666H15.8333V8.33332H15V7.49999H15.8333V6.66666H14.1667V10.8333H15V9.16666ZM8.33333 9.16666H9.16666C9.625 9.16666 10 8.79166 10 8.33332V7.49999C10 7.04166 9.625 6.66666 9.16666 6.66666H7.5V10.8333H8.33333V9.16666ZM8.33333 7.49999H9.16666V8.33332H8.33333V7.49999Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const PdfFileIcon = ({ color, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.00016 1.66663H11.6668L16.6668 6.66663V16.6666C16.6668 17.5833 15.9168 18.3333 15.0002 18.3333H4.99183C4.07516 18.3333 3.3335 17.5833 3.3335 16.6666V3.33329C3.3335 2.41663 4.0835 1.66663 5.00016 1.66663ZM5.00016 16.6666H15.0002V7.49996H10.8335V3.33329H5.00016V16.6666ZM5.92546 9.59998H7.26546C7.73212 9.59998 8.0699 9.72664 8.27879 9.97998C8.49212 10.2333 8.59879 10.6044 8.59879 11.0933C8.59879 11.5333 8.48546 11.8755 8.25879 12.12C8.03212 12.3644 7.70323 12.4866 7.27212 12.4866H6.67879V15H5.92546V9.59998ZM7.02546 11.9466C7.24768 11.9466 7.41879 11.9222 7.53879 11.8733C7.66323 11.8244 7.75212 11.74 7.80546 11.62C7.85879 11.5 7.88546 11.3266 7.88546 11.1C7.88546 10.8244 7.86546 10.6222 7.82546 10.4933C7.78546 10.3644 7.70546 10.2733 7.58546 10.22C7.4699 10.1666 7.28546 10.14 7.03212 10.14H6.67879V11.9466H7.02546ZM8.96191 9.59998H10.1352C10.7175 9.59998 11.1286 9.73331 11.3686 9.99998C11.613 10.2666 11.7352 10.6822 11.7352 11.2466V13.2333C11.7352 13.8289 11.6152 14.2733 11.3752 14.5666C11.1397 14.8555 10.7464 15 10.1952 15H8.96191V9.59998ZM10.1419 14.46C10.4041 14.46 10.593 14.4089 10.7086 14.3066C10.8286 14.2044 10.9019 14.0666 10.9286 13.8933C10.9597 13.7155 10.9752 13.4489 10.9752 13.0933V11.34C10.9752 11.0333 10.9552 10.8 10.9152 10.64C10.8797 10.4755 10.8019 10.3555 10.6819 10.28C10.5619 10.2 10.3752 10.16 10.1219 10.16H9.71525V14.46H10.1419ZM14.3975 9.59998H12.3109V15H13.0642V12.4733H14.0975V11.94H13.0642V10.14H14.3975V9.59998Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const CopyIcon = ({ color, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9999 0.833008H1.99992C1.08325 0.833008 0.333252 1.58301 0.333252 2.49967V14.1663H1.99992V2.49967H11.9999V0.833008ZM14.4999 4.16634H5.33325C4.41659 4.16634 3.66659 4.91634 3.66659 5.83301V17.4997C3.66659 18.4163 4.41659 19.1663 5.33325 19.1663H14.4999C15.4166 19.1663 16.1666 18.4163 16.1666 17.4997V5.83301C16.1666 4.91634 15.4166 4.16634 14.4999 4.16634ZM14.4999 17.4997H5.33325V5.83301H14.4999V17.4997Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const DownloadIcon = ({ color, size = 20 }) => (
  <Icon
    aria-label="download"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        data-icon="download"
        fill="currentColor"
      >
        <path
          d="M15.8333 10V15.8333H4.16667V10H2.5V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10H15.8333ZM10.8333 10.5583L12.9917 8.40833L14.1667 9.58333L10 13.75L5.83333 9.58333L7.00833 8.40833L9.16667 10.5583V2.5H10.8333V10.5583Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const DownloadIcon2 = () => (
  <Icon
    aria-label="DownloadIcon2"
    component={() => (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.25 7V12.25H1.75V7H0.25V12.25C0.25 13.075 0.925 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V7H12.25ZM7.75 7.5025L9.6925 5.5675L10.75 6.625L7 10.375L3.25 6.625L4.3075 5.5675L6.25 7.5025V0.25H7.75V7.5025Z"
          fill="#E5453D"
        />
      </svg>
    )}
  />
);

export const DownloadIcon3 = ({ color, size = 20, ...props }) => (
  <Icon
    width={size}
    height={size}
    aria-label="DownloadIcon3"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8333 7.5H12.5V2.5H7.5V7.5H4.16666L10 13.3333L15.8333 7.5ZM9.16666 9.16667V4.16667H10.8333V9.16667H11.8083L10 10.975L8.19166 9.16667H9.16666ZM4.16666 15H15.8333V16.6667H4.16666V15Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    {...props}
  />
);

export const CheckIcon = ({ color = "#424242", width = 16, height = 12, ...restProps }) => (
  <Icon
    aria-label="check"
    component={() => (
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.50001 9.50033L2.00001 6.00033L0.833344 7.16699L5.50001 11.8337L15.5 1.83366L14.3333 0.666992L5.50001 9.50033Z"
          fill={color}
        />
      </svg>
    )}
    width={width}
    height={height}
    {...restProps}
  />
);

export const CSVIcon = ({ color = "#424242", width = 16, height = 12, ...restProps }) => (
  <Icon
    aria-label="check"
    component={() => (
      <svg
        width="17"
        height="14"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 11.1667H15.6667V11.5834H14.8333V12.4167H15.6667V12.8334H14V13.6667H16.5V10.3334H14V11.1667ZM14.8333 3.66671H15.6667V0.333374H14V1.16671H14.8333V3.66671ZM14 6.16671H15.5L14 7.91671V8.66671H16.5V7.83337H15L16.5 6.08337V5.33337H14V6.16671ZM0.666656 1.16671H12.3333V2.83337H0.666656V1.16671ZM0.666656 11.1667H12.3333V12.8334H0.666656V11.1667ZM0.666656 6.16671H12.3333V7.83337H0.666656V6.16671Z"
          fill="#424242"
        />
      </svg>
    )}
    width={width}
    height={height}
    {...restProps}
  />
);

export const CheckMarkIcon = ({ color = "currentColor", size = 20, ...props }) => (
  <Icon
    aria-label="check"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_221_74549)">
          <path
            d="M7.50004 13.5L4.00004 10L2.83337 11.1667L7.50004 15.8333L17.5 5.83334L16.3334 4.66667L7.50004 13.5Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_221_74549">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const CheckDoneIcon = ({ color, size = 20, ...props }) => (
  <Icon
    aria-label="check-done"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 1.66667C5.40001 1.66667 1.66667 5.40001 1.66667 10C1.66667 14.6 5.40001 18.3333 10 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.40001 14.6 1.66667 10 1.66667ZM10 16.6667C6.32501 16.6667 3.33334 13.675 3.33334 10C3.33334 6.32501 6.32501 3.33334 10 3.33334C13.675 3.33334 16.6667 6.32501 16.6667 10C16.6667 13.675 13.675 16.6667 10 16.6667ZM13.825 6.31667L8.33334 11.8083L6.175 9.65834L5.00001 10.8333L8.33334 14.1667L15 7.50001L13.825 6.31667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const CheckDoneFilledIcon = ({ color, size = 20, ...props }) => (
  <Icon
    aria-label="check-done"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99996 1.66602C5.39996 1.66602 1.66663 5.39935 1.66663 9.99935C1.66663 14.5993 5.39996 18.3327 9.99996 18.3327C14.6 18.3327 18.3333 14.5993 18.3333 9.99935C18.3333 5.39935 14.6 1.66602 9.99996 1.66602ZM8.33329 14.166L4.16663 9.99935L5.34163 8.82435L8.33329 11.8077L14.6583 5.48268L15.8333 6.66602L8.33329 14.166Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ProgressIcon = ({ color, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.08334 9.99998C7.08334 10.6903 6.52369 11.25 5.83334 11.25C5.14298 11.25 4.58334 10.6903 4.58334 9.99998C4.58334 9.30963 5.14298 8.74998 5.83334 8.74998C6.52369 8.74998 7.08334 9.30963 7.08334 9.99998Z"
          fill={color || "currentColor"}
        />
        <path
          d="M10 11.25C10.6904 11.25 11.25 10.6903 11.25 9.99998C11.25 9.30963 10.6904 8.74998 10 8.74998C9.30965 8.74998 8.75001 9.30963 8.75001 9.99998C8.75001 10.6903 9.30965 11.25 10 11.25Z"
          fill={color || "currentColor"}
        />
        <path
          d="M15.4167 9.99998C15.4167 10.6903 14.857 11.25 14.1667 11.25C13.4763 11.25 12.9167 10.6903 12.9167 9.99998C12.9167 9.30963 13.4763 8.74998 14.1667 8.74998C14.857 8.74998 15.4167 9.30963 15.4167 9.99998Z"
          fill={color || "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.66667 9.99999C1.66667 5.39999 5.40001 1.66666 10 1.66666C14.6 1.66666 18.3333 5.39999 18.3333 9.99999C18.3333 14.6 14.6 18.3333 10 18.3333C5.40001 18.3333 1.66667 14.6 1.66667 9.99999ZM3.33334 9.99999C3.33334 13.6833 6.31667 16.6667 10 16.6667C13.6833 16.6667 16.6667 13.6833 16.6667 9.99999C16.6667 6.31666 13.6833 3.33332 10 3.33332C6.31667 3.33332 3.33334 6.31666 3.33334 9.99999Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const CircleIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 1.66667C5.4 1.66667 1.66666 5.40001 1.66666 10C1.66666 14.6 5.4 18.3333 10 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.40001 14.6 1.66667 10 1.66667ZM10 16.6667C6.31666 16.6667 3.33333 13.6833 3.33333 10C3.33333 6.31667 6.31666 3.33334 10 3.33334C13.6833 3.33334 16.6667 6.31667 16.6667 10C16.6667 13.6833 13.6833 16.6667 10 16.6667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const CircleFilledIcon = ({ color, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 1.66667C5.4 1.66667 1.66667 5.4 1.66667 10C1.66667 14.6 5.4 18.3333 10 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.4 14.6 1.66667 10 1.66667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);
export const RemoveMinus = ({ color = undefined, size = 18 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.83366 8.16675V9.83342H13.167V8.16675H4.83366ZM9.00033 0.666748C4.40033 0.666748 0.666992 4.40008 0.666992 9.00008C0.666992 13.6001 4.40033 17.3334 9.00033 17.3334C13.6003 17.3334 17.3337 13.6001 17.3337 9.00008C17.3337 4.40008 13.6003 0.666748 9.00033 0.666748ZM9.00033 15.6667C5.32533 15.6667 2.33366 12.6751 2.33366 9.00008C2.33366 5.32508 5.32533 2.33341 9.00033 2.33341C12.6753 2.33341 15.667 5.32508 15.667 9.00008C15.667 12.6751 12.6753 15.6667 9.00033 15.6667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
  ></Icon>
);
export const AddCircleOutline = ({ color, size = 18 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.83366 4.83317H8.16699V8.1665H4.83366V9.83317H8.16699V13.1665H9.83366V9.83317H13.167V8.1665H9.83366V4.83317ZM9.00033 0.666504C4.40033 0.666504 0.666992 4.39984 0.666992 8.99984C0.666992 13.5998 4.40033 17.3332 9.00033 17.3332C13.6003 17.3332 17.3337 13.5998 17.3337 8.99984C17.3337 4.39984 13.6003 0.666504 9.00033 0.666504ZM9.00033 15.6665C5.32533 15.6665 2.33366 12.6748 2.33366 8.99984C2.33366 5.32484 5.32533 2.33317 9.00033 2.33317C12.6753 2.33317 15.667 5.32484 15.667 8.99984C15.667 12.6748 12.6753 15.6665 9.00033 15.6665Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
  ></Icon>
);
export const PlusIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8333 10.8333H10.8333V15.8333H9.16667V10.8333H4.16667V9.16666H9.16667V4.16666H10.8333V9.16666H15.8333V10.8333Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ShareIcon = ({ color, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="8" fill="#5C6BC0" />
        <path
          d="M18.7999 29.6V18.2L15.2991 21.6992L13.5999 20L19.9999 13.6L26.3999 20L24.7007 21.6992L21.1999 18.2V29.6H18.7999ZM10.3999 13.6V11.2C10.3999 10.5334 10.6335 9.96698 11.1007 9.50085C11.5668 9.03365 12.1332 8.80005 12.7999 8.80005H27.1999C27.8666 8.80005 28.433 9.03365 28.8991 9.50085C29.3663 9.96698 29.5999 10.5334 29.5999 11.2V13.6H27.1999V11.2H12.7999V13.6H10.3999Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const ActionShareIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M15 13.4C14.3667 13.4 13.8 13.65 13.3667 14.0417L7.425 10.5833C7.46667 10.3917 7.5 10.2 7.5 10C7.5 9.80001 7.46667 9.60834 7.425 9.41667L13.3 5.99167C13.75 6.40834 14.3417 6.66667 15 6.66667C16.3833 6.66667 17.5 5.55001 17.5 4.16667C17.5 2.78334 16.3833 1.66667 15 1.66667C13.6167 1.66667 12.5 2.78334 12.5 4.16667C12.5 4.36667 12.5333 4.55834 12.575 4.75001L6.7 8.17501C6.25 7.75834 5.65833 7.50001 5 7.50001C3.61667 7.50001 2.5 8.61667 2.5 10C2.5 11.3833 3.61667 12.5 5 12.5C5.65833 12.5 6.25 12.2417 6.7 11.825L12.6333 15.2917C12.5917 15.4667 12.5667 15.65 12.5667 15.8333C12.5667 17.175 13.6583 18.2667 15 18.2667C16.3417 18.2667 17.4333 17.175 17.4333 15.8333C17.4333 14.4917 16.3417 13.4 15 13.4Z"
            fill={color || "currentColor"}
          />
        </g>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const CommentIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.325 3.33332C18.325 2.41666 17.5833 1.66666 16.6667 1.66666H3.33333C2.41666 1.66666 1.66666 2.41666 1.66666 3.33332V13.3333C1.66666 14.25 2.41666 15 3.33333 15H15L18.3333 18.3333L18.325 3.33332ZM16.6667 3.33332V14.3083L15.6917 13.3333H3.33333V3.33332H16.6667ZM5 9.99999H15V11.6667H5V9.99999ZM5 7.49999H15V9.16666H5V7.49999ZM5 4.99999H15V6.66666H5V4.99999Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ReportIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.66668 13.3333H13.3333V15H6.66668V13.3333ZM6.66668 9.99999H13.3333V11.6667H6.66668V9.99999ZM11.6667 1.66666H5.00001C4.08334 1.66666 3.33334 2.41666 3.33334 3.33332V16.6667C3.33334 17.5833 4.07501 18.3333 4.99168 18.3333H15C15.9167 18.3333 16.6667 17.5833 16.6667 16.6667V6.66666L11.6667 1.66666ZM15 16.6667H5.00001V3.33332H10.8333V7.49999H15V16.6667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ArrowDropDownIcon = ({ color = COLORS["gray-800"], size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2
  000/svg"
      >
        <g>
          <path d="M5.83337 8.33334L10 12.5L14.1667 8.33334H5.83337Z" fill={color} />
        </g>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ArrowDropDownIconV2 = ({ color = COLORS["gray-800"], size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0.833336 0.333313L5 4.49998L9.16667 0.333313H0.833336Z" fill={color} />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const IncrementalReportIcon = ({ color = COLORS["gray-800"], size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 20 20`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M15 14.1667H16.6666V14.5833H15.8333V15.4167H16.6666V15.8333H15V16.6667H17.5V13.3333H15V14.1667ZM15.8333 6.66667H16.6666V3.33333H15V4.16667H15.8333V6.66667ZM15 9.16666H16.5L15 10.9167V11.6667H17.5V10.8333H16L17.5 9.08333V8.33333H15V9.16666ZM1.66663 4.16667H13.3333V5.83333H1.66663V4.16667ZM1.66663 14.1667H13.3333V15.8333H1.66663V14.1667ZM1.66663 9.16666H13.3333V10.8333H1.66663V9.16666Z"
            fill={color}
          />
        </g>
        <defs></defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const LaunchIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8333 15.8333H4.16667V4.16667H10V2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10H15.8333V15.8333ZM11.6667 2.5V4.16667H14.6583L6.46667 12.3583L7.64167 13.5333L15.8333 5.34167V8.33333H17.5V2.5H11.6667Z"
          fill={color || COLORS["gray-800"]}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ErrorIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 1.66666C5.40001 1.66666 1.66667 5.39999 1.66667 9.99999C1.66667 14.6 5.40001 18.3333 10 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99999C18.3333 5.39999 14.6 1.66666 10 1.66666ZM10.8333 14.1667H9.16667V12.5H10.8333V14.1667ZM10.8333 10.8333H9.16667V5.83332H10.8333V10.8333Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ErrorIconTwoTone = ({ primary, secondary, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 1.66666C5.40001 1.66666 1.66667 5.39999 1.66667 9.99999C1.66667 14.6 5.40001 18.3333 10 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99999C18.3333 5.39999 14.6 1.66666 10 1.66666ZM9.16667 14.1667H10.8333V12.5H9.16667V14.1667ZM9.16667 10.8333H10.8333V5.83332H9.16667V10.8333Z"
          fill={primary || "currentColor"}
        />
        <path d="M10.8333 14.1667H9.16667V12.5H10.8333V14.1667Z" fill={secondary || "none"} />
        <path d="M10.8333 10.8333H9.16667V5.83332H10.8333V10.8333Z" fill={secondary || "none"} />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ErrorLineIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16667 12.5H10.8333V14.1667H9.16667V12.5ZM9.16667 5.83332H10.8333V10.8333H9.16667V5.83332ZM9.99167 1.66666C5.39167 1.66666 1.66667 5.39999 1.66667 9.99999C1.66667 14.6 5.39167 18.3333 9.99167 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99999C18.3333 5.39999 14.6 1.66666 9.99167 1.66666ZM10 16.6667C6.31667 16.6667 3.33334 13.6833 3.33334 9.99999C3.33334 6.31666 6.31667 3.33332 10 3.33332C13.6833 3.33332 16.6667 6.31666 16.6667 9.99999C16.6667 13.6833 13.6833 16.6667 10 16.6667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const WarningIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.833328 17.5H19.1667L9.99999 1.66666L0.833328 17.5ZM10.8333 15H9.16666V13.3333H10.8333V15ZM10.8333 11.6667H9.16666V8.33332H10.8333V11.6667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const WarningLineIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 4.99166L16.275 15.8333H3.72501L10 4.99166ZM10 1.66666L0.833344 17.5H19.1667L10 1.66666ZM10.8333 13.3333H9.16668V15H10.8333V13.3333ZM10.8333 8.33332H9.16668V11.6667H10.8333V8.33332Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const InfoIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16666 5.83332H10.8333V7.49999H9.16666V5.83332ZM9.16666 9.16666H10.8333V14.1667H9.16666V9.16666ZM10 1.66666C5.4 1.66666 1.66666 5.39999 1.66666 9.99999C1.66666 14.6 5.4 18.3333 10 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99999C18.3333 5.39999 14.6 1.66666 10 1.66666ZM10 16.6667C6.325 16.6667 3.33333 13.675 3.33333 9.99999C3.33333 6.32499 6.325 3.33332 10 3.33332C13.675 3.33332 16.6667 6.32499 16.6667 9.99999C16.6667 13.675 13.675 16.6667 10 16.6667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const OptimizeIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
          fill={color}
        />
        <path
          d="M7 12L10.4333 13.5667L12 17L13.5667 13.5667L17 12L13.5667 10.4333L12 7L10.4333 10.4333L7 12Z"
          fill="white"
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);
export const InfoFilledIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.8337 14.167H9.16699V9.16699H10.8337V14.167ZM10.8337 7.50033H9.16699V5.83366H10.8337V7.50033Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const HelpIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16667 15H10.8333V13.3333H9.16667V15ZM10 1.66666C5.40001 1.66666 1.66667 5.39999 1.66667 9.99999C1.66667 14.6 5.40001 18.3333 10 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99999C18.3333 5.39999 14.6 1.66666 10 1.66666ZM10 16.6667C6.32501 16.6667 3.33334 13.675 3.33334 9.99999C3.33334 6.32499 6.32501 3.33332 10 3.33332C13.675 3.33332 16.6667 6.32499 16.6667 9.99999C16.6667 13.675 13.675 16.6667 10 16.6667ZM10 4.99999C8.15834 4.99999 6.66667 6.49166 6.66667 8.33332H8.33334C8.33334 7.41666 9.08334 6.66666 10 6.66666C10.9167 6.66666 11.6667 7.41666 11.6667 8.33332C11.6667 9.99999 9.16667 9.79166 9.16667 12.5H10.8333C10.8333 10.625 13.3333 10.4167 13.3333 8.33332C13.3333 6.49166 11.8417 4.99999 10 4.99999Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ContactSupportIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.58333 1.66602C5.675 1.66602 2.5 4.84102 2.5 8.74935C2.5 12.6577 5.675 15.8327 9.58333 15.8327H10V18.3327C14.05 16.3827 16.6667 12.4993 16.6667 8.74935C16.6667 4.84102 13.4917 1.66602 9.58333 1.66602ZM10.4167 13.7493H8.75V12.0827H10.4167V13.7493ZM10.4167 10.8327H8.75C8.75 8.12435 11.25 8.33268 11.25 6.66602C11.25 5.74935 10.5 4.99935 9.58333 4.99935C8.66667 4.99935 7.91667 5.74935 7.91667 6.66602H6.25C6.25 4.82435 7.74167 3.33268 9.58333 3.33268C11.425 3.33268 12.9167 4.82435 12.9167 6.66602C12.9167 8.74935 10.4167 8.95768 10.4167 10.8327Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const SendIcon = ({ color = "currentColor", size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3.005 12.5L13.5 8L3.005 3.5L3 7L10.5 8L3 9L3.005 12.5Z" fill={color} />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const SendIcon20 = ({ color = "currentColor", size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.67496 17.5L19.1666 10L1.67496 2.5L1.66663 8.33333L14.1666 10L1.66663 11.6667L1.67496 17.5Z"
          fill={color}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const SendIcon28 = ({ color = "currentColor", size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.67508 21.5L23.1667 14L5.67508 6.5L5.66675 12.3333L18.1667 14L5.66675 15.6667L5.67508 21.5Z"
          fill={color}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const SendIconFocused = ({ color = "currentColor", size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="16" height="16" rx="2" fill={color} />
        <path
          d="M2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H12C12.8284 2.5 13.5 3.17157 13.5 4V12C13.5 12.8284 12.8284 13.5 12 13.5H4C3.17157 13.5 2.5 12.8284 2.5 12V4Z"
          fill={color}
          stroke={color}
        />
        <path d="M3.005 12.5L13.5 8L3.005 3.5L3 7L10.5 8L3 9L3.005 12.5Z" fill="white" />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const SendIconFocused20 = ({ color = "currentColor", size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="20" height="20" rx="2" fill={color} />
        <path
          d="M3.00714 17L18 10L3.00714 3L3 8.44444L13.7143 10L3 11.5556L3.00714 17Z"
          fill="white"
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const SendIconFocused28 = ({ color = "currentColor", size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="2" fill={color} />
        <path
          d="M5.67508 21.5L23.1667 14L5.67508 6.5L5.66675 12.3333L18.1667 14L5.66675 15.6667L5.67508 21.5Z"
          fill="white"
          fillOpacity="0.87"
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const UploadIcon = ({ color, size = 20 }) => (
  <Icon
    aria-label="Upload"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.50001 11.3333H8.50001V6.33333H11.8333L6.00001 0.5L0.166672 6.33333H3.50001V11.3333ZM6.00001 2.85833L7.80834 4.66667H6.83334V9.66667H5.16667V4.66667H4.19167L6.00001 2.85833ZM0.166672 13H11.8333V14.6667H0.166672V13Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const DoubleArrow = ({ color, size = 20 }) => (
  <Icon
    aria-label="Double Arrow"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.33301 4.16699H7.08301L11.2497 10.0003L7.08301 15.8337H3.33301L7.49967 10.0003L3.33301 4.16699ZM9.16638 4.16699H12.9164L17.083 10.0003L12.9164 15.8337H9.16638L13.333 10.0003L9.16638 4.16699Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const ShowLess = ({ color, size = 20 }) => (
  <Icon
    aria-label="Show Less"
    component={() => (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.17505 15.4913L7.35838 16.6663L10 14.0247L12.6417 16.6663L13.8167 15.4913L10 11.6663L6.17505 15.4913ZM13.825 4.50801L12.6417 3.33301L10 5.97467L7.35838 3.33301L6.17505 4.50801L10 8.33301L13.825 4.50801Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const ReadMoreIcon = ({ color, size = 20, ...props }) => (
  <Icon
    aria-label="Read More"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.66666 5.83333L10.8333 9.99999L6.66666 14.1667V10.8333H1.66666V9.16666H6.66666V5.83333ZM10.8333 5.83333H18.3333V7.5H10.8333V5.83333ZM10.8333 12.5H18.3333V14.1667H10.8333V12.5ZM18.3333 9.16667H13.3333V10.8333H18.3333V9.16667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ShowMore = ({ color, size = 20 }) => (
  <Icon
    aria-label="Show More"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 4.85833L12.6417 7.5L13.8167 6.325L10 2.5L6.17505 6.325L7.35838 7.5L10 4.85833ZM10 15.1417L7.35838 12.5L6.18338 13.675L10 17.5L13.825 13.675L12.6417 12.5L10 15.1417Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

const AnimatedPath = styled.path`
  transition: d ${(props) => props.duration}s;
  d: path("M7,4 L10,7 L13,4 M7,16 L10,13 L13,16");

  &[aria-expanded="true"] {
    d: path("M7,7 L10,4 L13,7 M7,13 L10,16 L13,13");
  }
`;

export const AnimatedExpandIcon = ({ color, size = 20, expanded = false, duration = 0.3 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <AnimatedPath
        aria-expanded={expanded}
        stroke={color || "currentColor"}
        strokeWidth="2"
        duration={duration}
      />
    </svg>
  );
};

export const CheckBoxChecked = ({ color, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.7583 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.7583 2.5 15.8333 2.5ZM8.33333 14.1667L4.16667 10L5.34167 8.825L8.33333 11.8083L14.6583 5.48333L15.8333 6.66667L8.33333 14.1667Z"
          fill={color || "#E5453D"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const CheckBoxOpen = ({ color, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8333 4.16667V15.8333H4.16667V4.16667H15.8333ZM15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5Z"
          fill={color || "#E5453D"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const LanguageIcon20 = ({ color = "currentColor", size = 20 }) => (
  <Icon
    aria-label="Language"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.9915 1.66602C5.3915 1.66602 1.6665 5.39935 1.6665 9.99935C1.6665 14.5993 5.3915 18.3327 9.9915 18.3327C14.5998 18.3327 18.3332 14.5993 18.3332 9.99935C18.3332 5.39935 14.5998 1.66602 9.9915 1.66602ZM15.7665 6.66602H13.3082C13.0415 5.62435 12.6582 4.62435 12.1582 3.69935C13.6915 4.22435 14.9665 5.29102 15.7665 6.66602ZM9.99984 3.36602C10.6915 4.36602 11.2332 5.47435 11.5915 6.66602H8.40817C8.7665 5.47435 9.30817 4.36602 9.99984 3.36602ZM3.54984 11.666C3.4165 11.1327 3.33317 10.5743 3.33317 9.99935C3.33317 9.42435 3.4165 8.86602 3.54984 8.33268H6.3665C6.29984 8.88268 6.24984 9.43268 6.24984 9.99935C6.24984 10.566 6.29984 11.116 6.3665 11.666H3.54984ZM4.23317 13.3327H6.6915C6.95817 14.3743 7.3415 15.3743 7.8415 16.2993C6.30817 15.7743 5.03317 14.716 4.23317 13.3327ZM6.6915 6.66602H4.23317C5.03317 5.28268 6.30817 4.22435 7.8415 3.69935C7.3415 4.62435 6.95817 5.62435 6.6915 6.66602ZM9.99984 16.6327C9.30817 15.6327 8.7665 14.5243 8.40817 13.3327H11.5915C11.2332 14.5243 10.6915 15.6327 9.99984 16.6327ZM11.9498 11.666H8.04984C7.97484 11.116 7.9165 10.566 7.9165 9.99935C7.9165 9.43268 7.97484 8.87435 8.04984 8.33268H11.9498C12.0248 8.87435 12.0832 9.43268 12.0832 9.99935C12.0832 10.566 12.0248 11.116 11.9498 11.666ZM12.1582 16.2993C12.6582 15.3743 13.0415 14.3743 13.3082 13.3327H15.7665C14.9665 14.7077 13.6915 15.7743 12.1582 16.2993ZM13.6332 11.666C13.6998 11.116 13.7498 10.566 13.7498 9.99935C13.7498 9.43268 13.6998 8.88268 13.6332 8.33268H16.4498C16.5832 8.86602 16.6665 9.42435 16.6665 9.99935C16.6665 10.5743 16.5832 11.1327 16.4498 11.666H13.6332Z"
          fill={color}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const Pin = ({ color, size = 20 }) => (
  <Icon
    aria-label="Upload"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.66663 2.33366V6.50033C7.66663 7.43366 7.97496 8.30033 8.49996 9.00033H3.49996C4.04163 8.28366 4.33329 7.41699 4.33329 6.50033V2.33366H7.66663ZM10.1666 0.666992H1.83329C1.37496 0.666992 0.999959 1.04199 0.999959 1.50033C0.999959 1.95866 1.37496 2.33366 1.83329 2.33366H2.66663V6.50033C2.66663 7.88366 1.54996 9.00033 0.166626 9.00033V10.667H5.14163V16.5003L5.97496 17.3337L6.80829 16.5003V10.667H11.8333V9.00033C10.45 9.00033 9.33329 7.88366 9.33329 6.50033V2.33366H10.1666C10.625 2.33366 11 1.95866 11 1.50033C11 1.04199 10.625 0.666992 10.1666 0.666992Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const AlertingHackIcon = ({ color, size = 20 }) => (
  <Icon
    aria-label="Upload"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path opacity="0.01" d="M20.5 0H0.5V20H20.5V0Z" fill="white" fillOpacity="0.01" />
        <path
          d="M10.5 18.9167C9.58333 18.9167 8.84167 18.175 8.84167 17.2583H12.1583C12.1583 18.175 11.4167 18.9167 10.5 18.9167Z"
          fill={color || "currentColor"}
          fillOpacity="0.6"
        />
        <path
          d="M7.55366 7.23999V13H8.79366V10.744H12.1937V13H13.4337V7.23999H12.1937V9.49599H8.79366V7.23999H7.55366Z"
          fill={color || "currentColor"}
          fillOpacity="0.6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.25 2.25C9.25 1.55833 9.80833 1 10.5 1C11.1917 1 11.75 1.55833 11.75 2.25V3.225C14.3667 3.79167 16.3333 6.125 16.3333 8.91667V13.9167L18 15.5833V16.4167H3V15.5833L4.66667 13.9167V8.91667C4.66667 6.125 6.63333 3.79167 9.25 3.225V2.25ZM14.6667 8.91667C14.6667 6.61667 12.8 4.75 10.5 4.75C8.2 4.75 6.33333 6.61667 6.33333 8.91667V14.75H14.6667V8.91667Z"
          fill={color || "currentColor"}
          fillOpacity="0.6"
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);
export const AdvancedAlertingIcon = ({ size = 40 }) => (
  <Icon
    aria-label="advanceAlert"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="8" fill="#B3751B" />
        <path
          d="M17.3467 32.0133C17.3467 33.48 18.5333 34.6667 20 34.6667C21.4667 34.6667 22.6533 33.48 22.6533 32.0133H17.3467ZM20 12C23.68 12 26.6667 14.9867 26.6667 18.6667V28H13.3333V18.6667C13.3333 14.9867 16.32 12 20 12ZM20 6C18.8933 6 18 6.89333 18 8V9.56C13.8133 10.4667 10.6667 14.2 10.6667 18.6667V26.6667L8 29.3333V30.6667H32V29.3333L29.3333 26.6667V18.6667C29.3333 14.2 26.1867 10.4667 22 9.56V8C22 6.89333 21.1067 6 20 6ZM18.6667 14.6667H21.3333V20H18.6667V14.6667ZM18.6667 22.6667H21.3333V25.3333H18.6667V22.6667Z"
          fill="white"
        />
      </svg>
    )}
  />
);
export const SkynetIcon = ({ size = 40 }) => (
  <Icon
    aria-label="skynet"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="8" fill="#5C6BC0" />
        <path
          d="M31.7596 25.6625C30.4314 24.8938 28.8127 25.1 27.7221 26.0625L26.0658 25.1031V20.3625C26.0658 19.8719 25.8033 19.4156 25.3783 19.1719L21.1283 16.725V14.6281C22.5096 14.1594 23.5033 12.8531 23.5033 11.3125C23.5033 9.37813 21.9377 7.8125 20.0033 7.8125C18.0689 7.8125 16.5033 9.37813 16.5033 11.3125C16.5033 12.8531 17.4971 14.1594 18.8783 14.6281V16.725L14.6283 19.1719C14.2033 19.4156 13.9408 19.8719 13.9408 20.3625V25.1L12.2846 26.0594C11.1939 25.0969 9.57207 24.8906 8.24707 25.6594C6.5752 26.6281 6.00645 28.7656 6.96582 30.4375C7.92832 32.1094 10.0564 32.6844 11.7221 31.7188C13.0502 30.95 13.6814 29.4375 13.3971 28.0063L14.9189 27.1219L19.3127 29.6531C19.5252 29.775 19.7627 29.8375 20.0002 29.8375C20.2377 29.8375 20.4752 29.775 20.6877 29.6531L25.0783 27.125L26.6002 28.0094C26.3158 29.4375 26.9502 30.9531 28.2752 31.7219C29.9408 32.6875 32.0721 32.1156 33.0314 30.4406C33.9939 28.7656 33.4252 26.6281 31.7596 25.6625V25.6625ZM10.7283 29.9875C10.5586 30.0858 10.3711 30.1496 10.1766 30.1751C9.98213 30.2007 9.78451 30.1875 9.59514 30.1364C9.40577 30.0853 9.22838 29.9972 9.07318 29.8773C8.91798 29.7573 8.78803 29.6079 8.69082 29.4375C8.27832 28.7219 8.52207 27.8031 9.2377 27.3906C9.40743 27.2923 9.59494 27.2286 9.78941 27.203C9.98389 27.1774 10.1815 27.1906 10.3709 27.2417C10.5602 27.2928 10.7376 27.3809 10.8928 27.5009C11.048 27.6208 11.178 27.7703 11.2752 27.9406C11.6877 28.6563 11.4439 29.575 10.7283 29.9875ZM18.5002 11.3125C18.5082 10.92 18.6698 10.5462 18.9502 10.2715C19.2306 9.9967 19.6076 9.84281 20.0002 9.84281C20.3928 9.84281 20.7698 9.9967 21.0502 10.2715C21.3306 10.5462 21.4922 10.92 21.5002 11.3125C21.4922 11.705 21.3306 12.0788 21.0502 12.3535C20.7698 12.6283 20.3928 12.7822 20.0002 12.7822C19.6076 12.7822 19.2306 12.6283 18.9502 12.3535C18.6698 12.0788 18.5082 11.705 18.5002 11.3125V11.3125ZM23.8127 25.2563L20.0002 27.4531L16.1877 25.2563V20.8688L20.0002 18.6719L23.8127 20.8688V25.2563V25.2563ZM31.3096 29.4406C30.8971 30.1563 29.9846 30.4031 29.2721 29.9906C28.5596 29.5781 28.3127 28.6594 28.7252 27.9438C29.1377 27.2281 30.0502 26.9813 30.7627 27.3938C31.4783 27.8063 31.7221 28.7219 31.3096 29.4406Z"
          fill="white"
        />
      </svg>
    )}
  />
);

export const AuditIcon32 = () => (
  <Icon
    aria-label="AuditIconLarge"
    component={() => (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.33325 9.33333H26.6666V12H5.33325V9.33333ZM5.33325 17.3333H26.6666V14.6667H5.33325V17.3333ZM5.33325 22.6667H14.6666V20H5.33325V22.6667ZM5.33325 28H14.6666V25.3333H5.33325V28ZM20.5466 24.2267L18.6666 22.3333L16.7866 24.2133L20.5466 28L26.6666 21.8933L24.7733 20L20.5466 24.2267ZM5.33325 4V6.66667H26.6666V4H5.33325Z"
          fill="#FAFAFA"
        />
      </svg>
    )}
  />
);

export const BlockIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1293_12051)">
          <path
            d="M10 1.66666C5.40002 1.66666 1.66669 5.4 1.66669 10C1.66669 14.6 5.40002 18.3333 10 18.3333C14.6 18.3333 18.3334 14.6 18.3334 10C18.3334 5.4 14.6 1.66666 10 1.66666ZM3.33335 10C3.33335 6.31666 6.31669 3.33333 10 3.33333C11.5417 3.33333 12.9584 3.85833 14.0834 4.74166L4.74169 14.0833C3.85835 12.9583 3.33335 11.5417 3.33335 10ZM10 16.6667C8.45835 16.6667 7.04169 16.1417 5.91669 15.2583L15.2584 5.91666C16.1417 7.04166 16.6667 8.45833 16.6667 10C16.6667 13.6833 13.6834 16.6667 10 16.6667Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_1293_12051">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const HackRiskIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4550_21235)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 2C11.503 2 14 5 14 5H12.45C12.4828 5.16156 12.5 5.32877 12.5 5.5C12.5 6.88071 11.3807 8 10 8C8.61929 8 7.50001 6.88071 7.50001 5.5C7.50001 5.32877 7.51722 5.16156 7.55002 5H6.00001C6.00001 5 8.49698 2 10 2ZM9.13379 5C9.0487 5.14709 9.00001 5.31786 9.00001 5.5C9.00001 6.05228 9.44772 6.5 10 6.5C10.5523 6.5 11 6.05228 11 5.5C11 5.31786 10.9513 5.14709 10.8662 5H9.13379Z"
            fill={color}
          />
          <path
            d="M7.00001 9C6.44772 9 6.00001 9.44772 6.00001 10V14C6.00001 14.5523 6.44772 15 7.00001 15H13C13.5523 15 14 14.5523 14 14V10C14 9.44772 13.5523 9 13 9H7.00001Z"
            fill={color}
          />
          <path
            d="M3.00001 16.75C3.00001 16.3358 3.33579 16 3.75001 16H16.25C16.6642 16 17 16.3358 17 16.75C17 17.1642 16.6642 17.5 16.25 17.5H3.75001C3.33579 17.5 3.00001 17.1642 3.00001 16.75Z"
            fill={color}
          />
          <path
            d="M3.46968 9.46967L4.53034 10.5303L3.06067 12L4.53034 13.4697L3.46968 14.5303L0.939346 12L3.46968 9.46967Z"
            fill={color}
          />
          <path
            d="M16.5303 9.46967L19.0607 12L16.5303 14.5303L15.4697 13.4697L16.9393 12L15.4697 10.5303L16.5303 9.46967Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4550_21235">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const FlashloanExploitationRiskIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4550_21235)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 2C11.503 2 14 5 14 5H12.45C12.4828 5.16156 12.5 5.32877 12.5 5.5C12.5 6.88071 11.3807 8 10 8C8.61929 8 7.50001 6.88071 7.50001 5.5C7.50001 5.32877 7.51722 5.16156 7.55002 5H6.00001C6.00001 5 8.49698 2 10 2ZM9.13379 5C9.0487 5.14709 9.00001 5.31786 9.00001 5.5C9.00001 6.05228 9.44772 6.5 10 6.5C10.5523 6.5 11 6.05228 11 5.5C11 5.31786 10.9513 5.14709 10.8662 5H9.13379Z"
            fill={color}
          />
          <path
            d="M7.00001 9C6.44772 9 6.00001 9.44772 6.00001 10V14C6.00001 14.5523 6.44772 15 7.00001 15H13C13.5523 15 14 14.5523 14 14V10C14 9.44772 13.5523 9 13 9H7.00001Z"
            fill={color}
          />
          <path
            d="M3.00001 16.75C3.00001 16.3358 3.33579 16 3.75001 16H16.25C16.6642 16 17 16.3358 17 16.75C17 17.1642 16.6642 17.5 16.25 17.5H3.75001C3.33579 17.5 3.00001 17.1642 3.00001 16.75Z"
            fill={color}
          />
          <path
            d="M3.46968 9.46967L4.53034 10.5303L3.06067 12L4.53034 13.4697L3.46968 14.5303L0.939346 12L3.46968 9.46967Z"
            fill={color}
          />
          <path
            d="M16.5303 9.46967L19.0607 12L16.5303 14.5303L15.4697 13.4697L16.9393 12L15.4697 10.5303L16.5303 9.46967Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4550_21235">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const ExploitationRiskIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4550_21301)">
          <path
            d="M6.82038 4.45285L7.84629 5.54715L6.29659 7L7.84629 8.45285L6.82038 9.54715L4.10341 7L6.82038 4.45285Z"
            fill={color}
          />
          <path
            d="M13.1796 4.45285L12.1537 5.54715L13.7034 7L12.1537 8.45285L13.1796 9.54715L15.8966 7L13.1796 4.45285Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V11C18 11.5523 17.5523 12 17 12H3C2.44772 12 2 11.5523 2 11V3ZM3.5 10.5V3.5H16.5V10.5H3.5Z"
            fill={color}
          />
          <path
            d="M10.5 17C11.3284 17 12 16.3284 12 15.5C12 14.6716 11.3284 14 10.5 14C9.67157 14 9 14.6716 9 15.5C9 16.3284 9.67157 17 10.5 17Z"
            fill={color}
          />
          <path
            d="M6 16.5C6 17.3284 5.32843 18 4.5 18C3.67157 18 3 17.3284 3 16.5C3 15.6716 3.67157 15 4.5 15C5.32843 15 6 15.6716 6 16.5Z"
            fill={color}
          />
          <path
            d="M18 16.5C18 17.3284 17.3284 18 16.5 18C15.6716 18 15 17.3284 15 16.5C15 15.6716 15.6716 15 16.5 15C17.3284 15 18 15.6716 18 16.5Z"
            fill={color}
          />
          <path
            d="M7.00001 14L5 14V15.5H4V13L6.00001 13L6.00001 10.5H7.00001L7.00001 14Z"
            fill={color}
          />
          <path d="M10 11H11V15H10V11Z" fill={color} />
          <path
            d="M16.9642 13H14.9934L14.9642 10.8076L13.9643 10.821L14.0066 14H15.9642L15.9642 15.8143L16.9642 15.8143L16.9642 13Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4550_21301">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const ScamRiskIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4550_21320)">
          <path
            d="M10 5.75C9.58579 5.75 9.25 6.08579 9.25 6.5V9C9.25 9.41421 9.58579 9.75 10 9.75C10.4142 9.75 10.75 9.41421 10.75 9V6.5C10.75 6.08579 10.4142 5.75 10 5.75Z"
            fill={color}
          />
          <path
            d="M9.25 11C9.25 10.5858 9.58579 10.25 10 10.25C10.4142 10.25 10.75 10.5858 10.75 11C10.75 11.4142 10.4142 11.75 10 11.75C9.58579 11.75 9.25 11.4142 9.25 11Z"
            fill={color}
          />
          <path
            d="M5.68466 13.6605C5.77083 13.724 5.8196 13.813 5.83097 13.9276H6.42045C6.41761 13.7543 6.37121 13.6018 6.28125 13.4702C6.19129 13.3385 6.06534 13.2358 5.90341 13.1619C5.74242 13.0881 5.55398 13.0511 5.33807 13.0511C5.12595 13.0511 4.93655 13.0881 4.76989 13.1619C4.60322 13.2358 4.47206 13.3385 4.37642 13.4702C4.28172 13.6018 4.23485 13.7557 4.2358 13.9318C4.23485 14.1468 4.3054 14.3177 4.44744 14.4446C4.58949 14.5715 4.78314 14.6648 5.02841 14.7244L5.34517 14.804C5.45123 14.8295 5.54072 14.858 5.61364 14.8892C5.6875 14.9205 5.74337 14.9583 5.78125 15.0028C5.82008 15.0473 5.83949 15.1023 5.83949 15.1676C5.83949 15.2377 5.81818 15.2997 5.77557 15.3537C5.73295 15.4077 5.67282 15.4498 5.59517 15.4801C5.51847 15.5104 5.42803 15.5256 5.32386 15.5256C5.2178 15.5256 5.12263 15.5095 5.03835 15.4773C4.95502 15.4441 4.88826 15.3954 4.83807 15.331C4.78883 15.2656 4.76089 15.1842 4.75426 15.0866H4.15909C4.16383 15.2959 4.21449 15.4716 4.31108 15.6136C4.40862 15.7547 4.54403 15.8613 4.71733 15.9332C4.89157 16.0052 5.09612 16.0412 5.33097 16.0412C5.56771 16.0412 5.76989 16.0057 5.9375 15.9347C6.10606 15.8627 6.23485 15.7618 6.32386 15.6321C6.41383 15.5014 6.45928 15.3471 6.46023 15.169C6.45928 15.0478 6.43703 14.9403 6.39347 14.8466C6.35085 14.7528 6.29072 14.6714 6.21307 14.6023C6.13542 14.5331 6.04356 14.4749 5.9375 14.4276C5.83144 14.3802 5.71496 14.3423 5.58807 14.3139L5.3267 14.2514C5.26326 14.2372 5.2036 14.2202 5.14773 14.2003C5.09186 14.1795 5.04261 14.1553 5 14.1278C4.95739 14.0994 4.92377 14.0658 4.89915 14.027C4.87547 13.9882 4.86458 13.9427 4.86648 13.8906C4.86648 13.8281 4.88447 13.7723 4.92045 13.723C4.95739 13.6738 5.01042 13.6354 5.07955 13.608C5.14867 13.5795 5.23343 13.5653 5.33381 13.5653C5.48153 13.5653 5.59848 13.5971 5.68466 13.6605Z"
            fill={color}
          />
          <path
            d="M8.61854 14.1094H9.2407C9.22081 13.9408 9.17535 13.7912 9.10433 13.6605C9.03426 13.5298 8.94335 13.4195 8.8316 13.3295C8.71986 13.2386 8.59155 13.1695 8.44666 13.1222C8.30272 13.0748 8.14647 13.0511 7.97791 13.0511C7.72223 13.0511 7.49212 13.1098 7.28757 13.2273C7.08303 13.3438 6.92109 13.5133 6.80178 13.7358C6.68246 13.9583 6.6228 14.2282 6.6228 14.5455C6.6228 14.8617 6.68151 15.1312 6.79893 15.3537C6.91731 15.5762 7.07829 15.7462 7.28189 15.8636C7.48643 15.9811 7.71844 16.0398 7.97791 16.0398C8.16446 16.0398 8.3316 16.0118 8.47933 15.956C8.62801 15.8991 8.75585 15.8224 8.86285 15.7259C8.97081 15.6283 9.05651 15.518 9.11996 15.3949C9.18435 15.2708 9.2246 15.142 9.2407 15.0085L8.61854 15.0057C8.60433 15.0833 8.57876 15.1525 8.54183 15.2131C8.50585 15.2737 8.46039 15.3253 8.40547 15.3679C8.35054 15.4096 8.28757 15.4413 8.21655 15.4631C8.14647 15.4848 8.07024 15.4957 7.98785 15.4957C7.84107 15.4957 7.71181 15.4598 7.60007 15.3878C7.48833 15.3158 7.40121 15.2093 7.33871 15.0682C7.27715 14.9271 7.24638 14.7528 7.24638 14.5455C7.24638 14.3438 7.27715 14.1723 7.33871 14.0312C7.40026 13.8892 7.48691 13.7812 7.59865 13.7074C7.71039 13.6326 7.84155 13.5952 7.99212 13.5952C8.07545 13.5952 8.15263 13.607 8.22365 13.6307C8.29562 13.6544 8.35907 13.6884 8.41399 13.733C8.46892 13.7775 8.5139 13.8314 8.54893 13.8949C8.58397 13.9574 8.60717 14.0289 8.61854 14.1094Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.26939 16H9.92848L10.1443 15.3366H11.1946L11.41 16H12.0691L11.0663 13.0909H10.2737L9.26939 16ZM10.6813 13.7557L11.0387 14.8565H10.3005L10.6586 13.7557H10.6813Z"
            fill={color}
          />
          <path
            d="M12.9778 13.0909H12.2192V16H12.8158V14.0994H12.84L13.5928 15.9858H13.9991L14.7519 14.1065H14.7761V16H15.3727V13.0909H14.6141L13.813 15.0455H13.7789L12.9778 13.0909Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 4L18.8142 14.8306C18.8142 14.8306 19.2323 16.2482 18.8142 16.9435C18.396 17.6389 17.2129 18 17.2129 18H2.80143C1.20016 17.4718 0.666401 16.4153 1.20016 14.8306L8 4C8 4 8.68038 3 10 3C11.3196 3 12 4 12 4ZM10.7675 4.85777L17.4174 15.4273C17.4401 15.531 17.4648 15.663 17.4814 15.8027C17.5003 15.9626 17.5041 16.0968 17.4959 16.1931L17.4958 16.1944C17.4879 16.2011 17.4787 16.2086 17.4682 16.2167C17.3945 16.2739 17.2941 16.3357 17.1762 16.3958C17.0949 16.4372 17.0162 16.4722 16.9485 16.5H3.06533C2.65588 16.3328 2.55933 16.1753 2.53899 16.1351C2.51917 16.0958 2.44555 15.9193 2.57387 15.4636L9.23279 4.85745L9.24169 4.84739C9.27325 4.81234 9.32779 4.75772 9.40219 4.70221C9.54803 4.59339 9.741 4.5 10 4.5C10.259 4.5 10.452 4.59339 10.5978 4.70221C10.6722 4.75772 10.7267 4.81234 10.7583 4.84739L10.7675 4.85777ZM17.3739 15.2497L17.3744 15.2514C17.3739 15.2495 17.3738 15.2493 17.3739 15.2497Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4550_21320">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const HoneypotRiskIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4550_21341)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.5 7V5C4.5 4.44772 4.94772 4 5.5 4H9.5C10.0523 4 10.5 4.44772 10.5 5V7H12C12.5523 7 13 7.44772 13 8V15C13 15.5523 12.5523 16 12 16H3C2.44771 16 2 15.5523 2 15V8C2 7.44772 2.44772 7 3 7H4.5ZM6 7V5.5H9V7H6ZM3.5 8.5V9.59953L6.06921 9.2325L9.01705 10.2151L11.5 9.5057V8.5H3.5ZM11.5 11.0657L8.98295 11.7849L5.93079 10.7675L3.5 11.1148V14.5H11.5V11.0657Z"
            fill={color}
          />
          <path
            d="M15.5 4C15.0858 4 14.75 4.33579 14.75 4.75C14.75 5.07655 14.9587 5.35436 15.25 5.45732V5.75H14.75C14.3358 5.75 14 6.08579 14 6.5C14 6.91421 14.3358 7.25 14.75 7.25H15.25V7.5C14.8358 7.5 14.5 7.83579 14.5 8.25C14.5 8.66421 14.8358 9 15.25 9V15.25C15.25 15.6642 15.5858 16 16 16C16.4142 16 16.75 15.6642 16.75 15.25V9C17.1642 9 17.5 8.66421 17.5 8.25C17.5 7.83579 17.1642 7.5 16.75 7.5V7.25H17.25C17.6642 7.25 18 6.91421 18 6.5C18 6.08579 17.6642 5.75 17.25 5.75H16.75V5.45732C17.0413 5.35436 17.25 5.07655 17.25 4.75C17.25 4.33579 16.9142 4 16.5 4H15.5Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4550_21341">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const PhishingRiskIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4550_21346)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 4.7C16.3866 4.7 16.7 4.3866 16.7 4C16.7 3.6134 16.3866 3.3 16 3.3C15.6134 3.3 15.3 3.6134 15.3 4C15.3 4.3866 15.6134 4.7 16 4.7ZM18 4C18 4.74028 17.5978 5.38663 17 5.73244V7C17 7.83333 16.7083 8.54167 16.125 9.125C15.5417 9.70833 14.8333 10 14 10C13.1667 10 12.4583 9.70833 11.875 9.125C11.2917 8.54167 11 7.83628 11 7.00885L10.5 7L11.75 6L13 7H12.4961C12.4961 7.4125 12.6425 7.76562 12.9355 8.05937C13.2285 8.35312 13.5819 8.5 13.9956 8.5C14.4093 8.5 14.7635 8.35312 15.0581 8.05937C15.3527 7.76562 15.5 7.4125 15.5 7V5.93699C14.6374 5.71497 14 4.93192 14 4C14 2.89543 14.8954 2 16 2C17.1046 2 18 2.89543 18 4ZM3.5 17C3.0875 17 2.73438 16.853 2.44063 16.5591C2.14688 16.2652 2 15.9119 2 15.4992V6.4941C2 6.08137 2.14688 5.72917 2.44063 5.4375C2.73438 5.14583 3.0875 5 3.5 5H10.8516H11L9.5 6.5H3.5L10 10.2292L10.8953 9.79397C11.203 10.2058 11.6141 10.536 12.09 10.746L10 12L3.5 8.27083V15.5H16.5V10.2458L16.5138 10.2427C16.7854 10.181 17.011 10.1298 17.25 10C17.4931 9.86806 18 9.5 18 9.5V15.4952C18 15.9151 17.8507 16.2708 17.5521 16.5625C17.2535 16.8542 16.9028 17 16.5 17H3.5Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4550_21346">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const RugpullRiskIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4550_21348)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.5 6.36603C8.22386 5.88773 8.38773 5.27614 8.86603 5L11.4641 3.5C11.9424 3.22386 12.554 3.38773 12.8301 3.86603L17.9915 12.8058C18.2676 13.2841 18.1038 13.8957 17.6255 14.1718L15.0274 15.6718C14.9722 15.7037 14.9152 15.7297 14.8572 15.75H19V17.25H8.79226L6.29226 15.75H1V14.25H6.70774L9.20774 15.75H14.1981C13.9795 15.6739 13.7862 15.5219 13.6614 15.3058L8.5 6.36603ZM14.7104 14.1228L10.049 6.04904L11.7811 5.04904L16.4425 13.1228L14.7104 14.1228Z"
            fill={color}
          />
          <path
            d="M1 10.7115L2.66666 12.7115V11.7115H7.66666V10.0448H2.66666V9L1 10.7115Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4550_21348">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const RansomwareRiskIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1229 7.06655V7.63636H15.5305V7.06694C15.8593 7.04973 16.146 6.9893 16.3906 6.88565C16.6856 6.7597 16.911 6.58321 17.0668 6.35617C17.2242 6.12748 17.3037 5.85736 17.3054 5.5458C17.3037 5.33368 17.2648 5.14559 17.1886 4.98153C17.114 4.81747 17.0088 4.67495 16.8729 4.55397C16.737 4.433 16.5762 4.33108 16.3906 4.24822C16.205 4.16536 16.0012 4.09907 15.7791 4.04935L15.5305 3.98991V2.75132C15.6986 2.77311 15.8378 2.82463 15.9482 2.90589C16.099 3.01692 16.1843 3.1727 16.2042 3.37322H17.2358C17.2308 3.06995 17.1496 2.80314 16.9922 2.57279C16.8348 2.34244 16.6143 2.16264 16.331 2.03337C16.0972 1.92613 15.8304 1.86338 15.5305 1.84511V1.27272H15.1229V1.8473C14.8389 1.86804 14.5804 1.93006 14.3473 2.03337C14.0556 2.16264 13.8261 2.34244 13.6587 2.57279C13.493 2.80314 13.411 3.07244 13.4126 3.38067C13.411 3.75686 13.5344 4.05598 13.783 4.27805C14.0316 4.50011 14.3705 4.66335 14.7997 4.76775L15.1229 4.8489V6.15868C15.0132 6.14568 14.9113 6.12119 14.8171 6.08522C14.6713 6.02722 14.5545 5.94187 14.4666 5.82918C14.3804 5.71484 14.3316 5.57232 14.32 5.40163H13.2784C13.2867 5.76787 13.3754 6.07528 13.5444 6.32386C13.7151 6.57078 13.9521 6.75721 14.2553 6.88316C14.5081 6.98756 14.7973 7.04869 15.1229 7.06655ZM15.5305 6.15614C15.6258 6.14328 15.7128 6.1213 15.7915 6.09019C15.9274 6.03716 16.0327 5.96342 16.1072 5.86896C16.1818 5.7745 16.2191 5.66595 16.2191 5.54332C16.2191 5.42897 16.1851 5.33285 16.1172 5.25497C16.0509 5.17708 15.9531 5.11079 15.8239 5.0561C15.7389 5.0197 15.6412 4.98551 15.5305 4.95351V6.15614ZM15.1229 3.88801V2.75311C15.0361 2.76529 14.9582 2.78556 14.8892 2.81391C14.7682 2.86197 14.6754 2.92909 14.6108 3.01526C14.5478 3.10144 14.5163 3.19921 14.5163 3.30859C14.513 3.39973 14.5321 3.47928 14.5735 3.54722C14.6166 3.61517 14.6754 3.674 14.75 3.72372C14.8246 3.77177 14.9107 3.81403 15.0085 3.85049C15.0457 3.86372 15.0838 3.87622 15.1229 3.88801Z"
          fill={color}
        />
        <path
          d="M4.5 2.99999H11.2561C11.0902 3.46916 11 3.97404 11 4.49999H4.5V13H15V8.97253C15.1642 8.99068 15.331 8.99999 15.5 8.99999C15.8437 8.99999 16.1784 8.96146 16.5 8.88848V13C16.5 13.4125 16.3531 13.7656 16.0594 14.0594C15.7656 14.3531 15.4125 14.5 15 14.5H4.5C4.0875 14.5 3.73438 14.3531 3.44063 14.0594C3.14688 13.7656 3 13.4125 3 13V4.49999C3 4.08749 3.14688 3.73437 3.44063 3.44062C3.73438 3.14687 4.0875 2.99999 4.5 2.99999Z"
          fill={color}
        />
        <path
          d="M2.21562 16.7856C2.35938 16.9285 2.5375 17 2.75 17H17.25C17.4625 17 17.6406 16.9271 17.7844 16.7812C17.9281 16.6354 18 16.4569 18 16.2456C18 16.0343 17.9281 15.8573 17.7844 15.7143C17.6406 15.5714 17.4625 15.5 17.25 15.5H2.75C2.5375 15.5 2.35938 15.5729 2.21562 15.7187C2.07187 15.8646 2 16.0431 2 16.2544C2 16.4656 2.07187 16.6427 2.21562 16.7856Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.20365 11.9422C7.33941 12.0779 7.50764 12.1458 7.70833 12.1458H11.2708C11.4715 12.1458 11.6398 12.0779 11.7755 11.9422C11.9113 11.8064 11.9792 11.6382 11.9792 11.4375V8.72916C11.9792 8.52847 11.9113 8.36024 11.7755 8.22447C11.6398 8.08871 11.4715 8.02083 11.2708 8.02083H11.1458V7.17608C11.1458 6.71147 10.9826 6.31597 10.6562 5.98958C10.3299 5.66319 9.9375 5.49999 9.47917 5.49999C9.02083 5.49999 8.62847 5.66319 8.30208 5.98958C7.9757 6.31597 7.8125 6.71147 7.8125 7.17608V8.02083H7.70833C7.50764 8.02083 7.33941 8.08871 7.20365 8.22447C7.06788 8.36024 7 8.52847 7 8.72916V11.4375C7 11.6382 7.06788 11.8064 7.20365 11.9422ZM8.64583 8.02083H10.3125V7.16666C10.3125 6.93055 10.2326 6.73263 10.0729 6.57291C9.91319 6.41319 9.71528 6.33333 9.47917 6.33333C9.24305 6.33333 9.04514 6.41319 8.88542 6.57291C8.72569 6.73263 8.64583 6.93055 8.64583 7.16666V8.02083Z"
          fill={color}
        />
      </svg>
    )}
  />
);

export const IndustryBlocklistRiskIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4557_21187)">
          <path
            d="M10.5643 2H3.42143C2.63571 2 2 2.66667 2 3.48148V13.7853C2 14.6667 2.6595 15.3333 3.6595 15.3333H6.39831C6.22406 14.8403 6.10347 14.322 6.04355 13.7853H3.42143V3.48148H10.5643V6.4354C11.02 6.26626 11.498 6.14321 11.9929 6.07191V3.48148C11.9929 2.66667 11.35 2 10.5643 2Z"
            fill={color}
          />
          <path
            d="M7.14196 9.16666C7.51 8.60536 7.95654 8.10016 8.46597 7.66666H4.6595V9.16666H7.14196Z"
            fill={color}
          />
          <path d="M4.6595 4.66666H9.6595V6.16666H4.6595V4.66666Z" fill={color} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 19C16.3137 19 19 16.3137 19 13C19 9.68629 16.3137 7 13 7C9.68629 7 7 9.68629 7 13C7 16.3137 9.68629 19 13 19ZM13 17.5C15.4853 17.5 17.5 15.4853 17.5 13C17.5 11.8172 17.0437 10.741 16.2975 9.93788L10.4025 16.6751C11.1363 17.1947 12.0325 17.5 13 17.5ZM15.1057 9.02205L9.33714 15.6147C8.81013 14.8777 8.5 13.9751 8.5 13C8.5 10.5147 10.5147 8.5 13 8.5C13.7608 8.5 14.4774 8.68878 15.1057 9.02205Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4557_21187">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const MixerRiskIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4557_21189)">
          <path
            d="M10 13.5C9.02778 13.5 8.20139 13.1597 7.52083 12.4792C6.84028 11.7986 6.5 10.9722 6.5 10C6.5 9.02778 6.84028 8.20139 7.52083 7.52083C8.20139 6.84028 9.02778 6.5 10 6.5C10.9722 6.5 11.7986 6.84028 12.4792 7.52083C13.1597 8.20139 13.5 9.02778 13.5 10C13.5 10.9722 13.1597 11.7986 12.4792 12.4792C11.7986 13.1597 10.9722 13.5 10 13.5ZM10 12C10.5556 12 11.0278 11.8056 11.4167 11.4167C11.8056 11.0278 12 10.5556 12 10C12 9.44444 11.8056 8.97222 11.4167 8.58333C11.0278 8.19444 10.5556 8 10 8C9.44444 8 8.97222 8.19444 8.58333 8.58333C8.19444 8.97222 8 9.44444 8 10C8 10.5556 8.19444 11.0278 8.58333 11.4167C8.97222 11.8056 9.44444 12 10 12ZM14.3125 18C14.4653 17.5556 14.6007 17.0799 14.7188 16.5729C14.8368 16.066 14.9514 15.4792 15.0625 14.8125C14.3958 15.5208 13.625 16.0625 12.75 16.4375C11.875 16.8125 10.9583 17 10 17C8.56944 17 7.18403 16.9097 5.84375 16.7292C4.50347 16.5486 3.22222 16.2778 2 15.9167V14.3125C2.44444 14.4653 2.92014 14.6007 3.42708 14.7188C3.93403 14.8368 4.52083 14.9514 5.1875 15.0625C4.47917 14.3958 3.9375 13.625 3.5625 12.75C3.1875 11.875 3 10.9583 3 10C3 8.55556 3.09028 7.16667 3.27083 5.83333C3.45139 4.5 3.72222 3.22222 4.08333 2H5.6875C5.52083 2.52778 5.375 3.05903 5.25 3.59375C5.125 4.12847 5.02083 4.65972 4.9375 5.1875C5.60417 4.47917 6.375 3.9375 7.25 3.5625C8.125 3.1875 9.04167 3 10 3C11.4444 3 12.8333 3.09028 14.1667 3.27083C15.5 3.45139 16.7778 3.72222 18 4.08333V5.6875C17.4722 5.52083 16.941 5.375 16.4062 5.25C15.8715 5.125 15.3403 5.02083 14.8125 4.9375C15.5208 5.60417 16.0625 6.375 16.4375 7.25C16.8125 8.125 17 9.04167 17 10C17 11.4306 16.9062 12.809 16.7188 14.1354C16.5312 15.4618 16.2569 16.75 15.8958 18H14.3125ZM10 15.5C11.5278 15.5 12.8264 14.9653 13.8958 13.8958C14.9653 12.8264 15.5 11.5278 15.5 10C15.5 8.47222 14.9653 7.17361 13.8958 6.10417C12.8264 5.03472 11.5278 4.5 10 4.5C8.47222 4.5 7.17361 5.03472 6.10417 6.10417C5.03472 7.17361 4.5 8.47222 4.5 10C4.5 11.5278 5.03472 12.8264 6.10417 13.8958C7.17361 14.9653 8.47222 15.5 10 15.5Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4557_21189">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const TerrorismRiskIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4557_21205)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.5 9.5L6.84248 7L7 4.80304L8.5 3H11L12.8742 4.80304L13 7L12.5 9.5L10 10.5L7.5 9.5ZM3 17.6819H16.712L15 11.5L13.5 11L10 12.4077L6 11L4.5 11.5L3 17.6819ZM15.5 8L14.25 10.75L16 11.5L17.2 8.7L16.1075 8.25013L17.6 4.78L17 4.5L15.5 8ZM5.90539 12L6.87132 12.2588L6.48309 13.7077C6.41162 13.9744 6.13745 14.1327 5.87071 14.0613C5.60398 13.9898 5.44569 13.7156 5.51716 13.4489L5.90539 12ZM7.39999 13L8.36591 13.2588L7.97768 14.7077C7.90621 14.9744 7.63204 15.1327 7.36531 15.0613C7.09858 14.9898 6.94029 14.7156 7.01176 14.4489L7.39999 13ZM9.96591 14.2588L8.99999 14L8.61176 15.4489C8.54029 15.7156 8.69858 15.9898 8.96531 16.0613C9.23204 16.1327 9.50621 15.9744 9.57768 15.7077L9.96591 14.2588ZM12 5H8V6.5H12V5Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4557_21205">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const DarknetRiskIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 18C8.90278 18 7.86806 17.7917 6.89583 17.375C5.92361 16.9583 5.07292 16.3854 4.34375 15.6562C3.61458 14.9271 3.04167 14.0764 2.625 13.1042C2.20833 12.1319 2 11.0972 2 10C2 8.88889 2.20833 7.85069 2.625 6.88542C3.04167 5.92014 3.61458 5.07292 4.34375 4.34375C5.07292 3.61458 5.92361 3.04167 6.89583 2.625C7.86806 2.20833 8.90278 2 10 2C11.1111 2 12.1493 2.20833 13.1146 2.625C14.0799 3.04167 14.9271 3.61458 15.6562 4.34375C16.3854 5.07292 16.9583 5.92014 17.375 6.88542C17.7917 7.85069 18 8.88889 18 10C18 11.0972 17.7917 12.1319 17.375 13.1042C16.9583 14.0764 16.3854 14.9271 15.6562 15.6562C14.9271 16.3854 14.0799 16.9583 13.1146 17.375C12.1493 17.7917 11.1111 18 10 18ZM10 16.4375C10.2361 16.2014 10.4722 15.7604 10.7083 15.1146C10.9444 14.4688 11.125 13.7639 11.25 13H8.75C8.875 13.7639 9.05556 14.4688 9.29167 15.1146C9.52778 15.7604 9.76389 16.2014 10 16.4375ZM8.10417 16.2292C7.90972 15.8125 7.73958 15.3333 7.59375 14.7917C7.44792 14.25 7.32639 13.6528 7.22917 13H4.25C4.65278 13.7917 5.1875 14.4688 5.85417 15.0312C6.52083 15.5938 7.27083 15.9931 8.10417 16.2292ZM11.8958 16.2292C12.7292 15.9931 13.4792 15.5938 14.1458 15.0312C14.8125 14.4688 15.3472 13.7917 15.75 13H12.7708C12.6736 13.6528 12.5521 14.25 12.4062 14.7917C12.2604 15.3333 12.0903 15.8125 11.8958 16.2292ZM12.9583 11.5H16.3125C16.3819 11.2361 16.4306 10.9826 16.4583 10.7396C16.4861 10.4965 16.5 10.25 16.5 10C16.5 9.75 16.4861 9.5 16.4583 9.25C16.4306 9 16.3819 8.75 16.3125 8.5H12.9583C12.9861 8.76389 13.0035 9.02431 13.0104 9.28125C13.0174 9.53819 13.0208 9.79167 13.0208 10.0417C13.0208 10.2917 13.0174 10.5382 13.0104 10.7812C13.0035 11.0243 12.9861 11.2639 12.9583 11.5ZM8.5625 11.5H11.4375C11.4653 11.2222 11.4826 10.9618 11.4896 10.7188C11.4965 10.4757 11.5 10.2361 11.5 10C11.5 9.76389 11.4965 9.52083 11.4896 9.27083C11.4826 9.02083 11.4653 8.76389 11.4375 8.5H8.5625C8.53472 8.76389 8.51736 9.02083 8.51042 9.27083C8.50347 9.52083 8.5 9.76389 8.5 10C8.5 10.2361 8.50347 10.4792 8.51042 10.7292C8.51736 10.9792 8.53472 11.2361 8.5625 11.5ZM3.6875 11.5H7.04167C7.01389 11.2361 6.99653 10.9757 6.98958 10.7188C6.98264 10.4618 6.97917 10.2083 6.97917 9.95833C6.97917 9.70833 6.98264 9.46181 6.98958 9.21875C6.99653 8.97569 7.01389 8.73611 7.04167 8.5H3.6875C3.61806 8.76389 3.56944 9.01736 3.54167 9.26042C3.51389 9.50347 3.5 9.75 3.5 10C3.5 10.25 3.51389 10.4965 3.54167 10.7396C3.56944 10.9826 3.61806 11.2361 3.6875 11.5ZM12.7708 7H15.75C15.3472 6.20833 14.8125 5.53125 14.1458 4.96875C13.4792 4.40625 12.7292 4.00694 11.8958 3.77083C12.0903 4.1875 12.2604 4.66667 12.4062 5.20833C12.5521 5.75 12.6736 6.34722 12.7708 7ZM8.75 7H11.25C11.125 6.23611 10.9444 5.53125 10.7083 4.88542C10.4722 4.23958 10.2361 3.79861 10 3.5625C9.76389 3.79861 9.52778 4.23958 9.29167 4.88542C9.05556 5.53125 8.875 6.23611 8.75 7ZM4.25 7H7.22917C7.32639 6.34722 7.44792 5.75 7.59375 5.20833C7.73958 4.66667 7.90972 4.1875 8.10417 3.77083C7.27083 4.00694 6.52083 4.40625 5.85417 4.96875C5.1875 5.53125 4.65278 6.20833 4.25 7Z"
          fill={color}
        />
        <path
          d="M8.5625 11.5H11.4375C11.4653 11.2222 11.4826 10.9618 11.4896 10.7188C11.4965 10.4757 11.5 10.2361 11.5 10C11.5 9.76389 11.4965 9.52083 11.4896 9.27083C11.4826 9.02083 11.4653 8.76389 11.4375 8.5H8.5625C8.53472 8.76389 8.51736 9.02083 8.51042 9.27083C8.50347 9.52083 8.5 9.76389 8.5 10C8.5 10.2361 8.50347 10.4792 8.51042 10.7292C8.51736 10.9792 8.53472 11.2361 8.5625 11.5Z"
          fill={color}
        />
        <path
          d="M12.9583 11.5H16.3125C16.3819 11.2361 16.4306 10.9826 16.4583 10.7396C16.4861 10.4965 16.5 10.25 16.5 10C16.5 9.75 16.4861 9.5 16.4583 9.25C16.4306 9 16.3819 8.75 16.3125 8.5H12.9583C12.9861 8.76389 13.0035 9.02431 13.0104 9.28125C13.0174 9.53819 13.0208 9.79167 13.0208 10.0417C13.0208 10.2917 13.0174 10.5382 13.0104 10.7812C13.0035 11.0243 12.9861 11.2639 12.9583 11.5Z"
          fill={color}
        />
        <path
          d="M3.6875 11.5H7.04167C7.01389 11.2361 6.99653 10.9757 6.98958 10.7188C6.98264 10.4618 6.97917 10.2083 6.97917 9.95833C6.97917 9.70833 6.98264 9.46181 6.98958 9.21875C6.99653 8.97569 7.01389 8.73611 7.04167 8.5H3.6875C3.61806 8.76389 3.56944 9.01736 3.54167 9.26042C3.51389 9.50347 3.5 9.75 3.5 10C3.5 10.25 3.51389 10.4965 3.54167 10.7396C3.56944 10.9826 3.61806 11.2361 3.6875 11.5Z"
          fill={color}
        />
      </svg>
    )}
  />
);

export const LockIcon = ({ color = COLORS["gray-800"], size = 20, ...props }) => (
  <Icon
    aria-label="lock"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M15 6.66667H14.1666V5C14.1666 2.7 12.3 0.833336 9.99998 0.833336C7.69998 0.833336 5.83331 2.7 5.83331 5V6.66667H4.99998C4.08331 6.66667 3.33331 7.41667 3.33331 8.33334V16.6667C3.33331 17.5833 4.08331 18.3333 4.99998 18.3333H15C15.9166 18.3333 16.6666 17.5833 16.6666 16.6667V8.33334C16.6666 7.41667 15.9166 6.66667 15 6.66667ZM7.49998 5C7.49998 3.61667 8.61665 2.5 9.99998 2.5C11.3833 2.5 12.5 3.61667 12.5 5V6.66667H7.49998V5ZM15 16.6667H4.99998V8.33334H15V16.6667ZM9.99998 14.1667C10.9166 14.1667 11.6666 13.4167 11.6666 12.5C11.6666 11.5833 10.9166 10.8333 9.99998 10.8333C9.08331 10.8333 8.33331 11.5833 8.33331 12.5C8.33331 13.4167 9.08331 14.1667 9.99998 14.1667Z"
            fill={color}
          />
        </g>
      </svg>
    )}
    {...props}
  />
);

export const UnlockIcon = ({ color = COLORS["gray-800"] }) => (
  <Icon
    aria-label="unlock"
    component={() => (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M15 6.66667H14.1666V5C14.1666 2.7 12.3 0.833336 9.99998 0.833336C7.69998 0.833336 5.83331 2.7 5.83331 5H7.49998C7.49998 3.61667 8.61665 2.5 9.99998 2.5C11.3833 2.5 12.5 3.61667 12.5 5V6.66667H4.99998C4.08331 6.66667 3.33331 7.41667 3.33331 8.33334V16.6667C3.33331 17.5833 4.08331 18.3333 4.99998 18.3333H15C15.9166 18.3333 16.6666 17.5833 16.6666 16.6667V8.33334C16.6666 7.41667 15.9166 6.66667 15 6.66667ZM15 16.6667H4.99998V8.33334H15V16.6667ZM9.99998 14.1667C10.9166 14.1667 11.6666 13.4167 11.6666 12.5C11.6666 11.5833 10.9166 10.8333 9.99998 10.8333C9.08331 10.8333 8.33331 11.5833 8.33331 12.5C8.33331 13.4167 9.08331 14.1667 9.99998 14.1667Z"
            fill={color}
          />
        </g>
      </svg>
    )}
  />
);
export const UploadReportIcon = ({ color = COLORS["gray-800"] }) => (
  <Icon
    aria-label="upload-report"
    component={() => (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M7.49996 13.3333H12.5V8.33333H15.8333L9.99996 2.5L4.16663 8.33333H7.49996V13.3333ZM9.99996 4.85833L11.8083 6.66667H10.8333V11.6667H9.16663V6.66667H8.19163L9.99996 4.85833ZM4.16663 15H15.8333V16.6667H4.16663V15Z"
            fill={color}
          />
        </g>
      </svg>
    )}
  />
);
export const KYCIcon = ({ size = 40 }) => (
  <Icon
    aria-label="KYC"
    component={() => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
      >
        <rect width="40" height="40" rx="8" fill="#1B8B99" />
        <g clipPath="url(#clip0_20055_17118)">
          <path opacity="0.01" d="M4 4H36V36H4V4Z" fill="white" fillOpacity="0.01" />
          <path
            d="M31.892 12.9369H8.10819C7.3121 12.9369 6.66675 13.5822 6.66675 14.3783V28.7928C6.66675 29.5889 7.3121 30.2342 8.10819 30.2342H31.892C32.6881 30.2342 33.3334 29.5889 33.3334 28.7928V14.3783C33.3334 13.5822 32.6881 12.9369 31.892 12.9369Z"
            fill="white"
          />
          <path
            opacity="0.9"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.8032 9.33331C11.6697 9.33331 11.5437 9.395 11.4618 9.50033L10.4528 10.7976C10.2319 11.0817 10.4343 11.4955 10.7942 11.4955H29.206C29.5658 11.4955 29.7682 11.0817 29.5473 10.7976L28.5383 9.50033C28.4564 9.395 28.3305 9.33331 28.1969 9.33331H11.8032ZM18.919 19.0232V17.982H14.9545V18.8765L12.3253 23.0269V17.982H8.82886L8.87019 18.9792H9.73739L9.76495 28.072H12.5869L18.3271 19.0232H18.919Z"
            fill="#E5453D"
          />
          <path
            opacity="0.8"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.10817 12.9369C7.31208 12.9369 6.66675 13.5822 6.66675 14.3783V15.8197H33.3334V14.3783C33.3334 13.5822 32.6881 12.9369 31.892 12.9369H8.10817ZM23.2434 20.0738V18.773C23.2434 18.6545 23.344 18.5585 23.4682 18.5585H30.9465C31.0706 18.5585 31.1713 18.6545 31.1713 18.773V20.0738C31.1713 20.1922 31.0706 20.2882 30.9465 20.2882H23.4682C23.344 20.2882 23.2434 20.1922 23.2434 20.0738ZM21.0811 22.6649V23.9658C21.0811 24.0842 21.1794 24.1802 21.3005 24.1802H30.9519C31.073 24.1802 31.1713 24.0842 31.1713 23.9658V22.6649C31.1713 22.5464 31.073 22.4504 30.9519 22.4504H21.3005C21.1794 22.4504 21.0811 22.5464 21.0811 22.6649ZM18.919 27.8575V26.5567C18.919 26.4382 19.0163 26.3422 19.1363 26.3422H30.954C31.074 26.3422 31.1713 26.4382 31.1713 26.5567V27.8575C31.1713 27.976 31.074 28.072 30.954 28.072H19.1363C19.0163 28.072 18.919 27.976 18.919 27.8575Z"
            fill="#C4C4C4"
          />
        </g>
        <defs>
          <clipPath id="clip0_20055_17118">
            <rect width="32" height="32" fill="white" transform="translate(4 4)" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);
export const TwitterIcon = ({ size = 40 }) => (
  <Icon
    aria-label="twitterShare"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="8" fill="#03A9F4" />
        <path
          d="M32 12.286C31.118 12.6767 30.1694 12.9373 29.1687 13.0607C30.186 12.4567 30.9687 11.4933 31.336 10.3553C30.384 10.9133 29.3294 11.3233 28.2074 11.5393C27.3114 10.5893 26.0334 10 24.6174 10C21.8974 10 19.6927 12.1853 19.6927 14.88C19.6927 15.2613 19.7374 15.6327 19.8214 15.9933C15.7294 15.788 12.1 13.8427 9.67205 10.8907C9.24538 11.612 9.00538 12.4567 9.00538 13.348C9.00538 15.042 9.87271 16.5333 11.1954 17.412C10.388 17.3873 9.62805 17.1627 8.96271 16.8027C8.96271 16.8173 8.96271 16.8393 8.96271 16.86C8.96271 19.2273 10.6607 21.1987 12.9114 21.6473C12.5 21.76 12.0654 21.8227 11.6174 21.8227C11.2994 21.8227 10.9894 21.7867 10.6894 21.7327C11.316 23.6673 13.134 25.0813 15.288 25.1233C13.6027 26.43 11.48 27.2127 9.17205 27.2127C8.77338 27.2127 8.38338 27.19 7.99805 27.1433C10.1787 28.524 12.768 29.3333 15.5474 29.3333C24.604 29.3333 29.5587 21.896 29.5587 15.444C29.5587 15.2327 29.552 15.022 29.542 14.814C30.5087 14.1313 31.342 13.27 32 12.286Z"
          fill="white"
        />
      </svg>
    )}
  />
);

export const CatNFTIcon = () => (
  <Icon
    aria-label="CatNFT"
    component={() => (
      <svg
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="#424242">
          <path d="m3.75002 10c1.15059 0 2.08333-.93274 2.08333-2.08334 0-1.15059-.93274-2.08333-2.08333-2.08333s-2.08333.93274-2.08333 2.08333c0 1.1506.93274 2.08334 2.08333 2.08334z" />
          <path d="m7.50002 6.66667c1.15059 0 2.08333-.93274 2.08333-2.08334 0-1.15059-.93274-2.08333-2.08333-2.08333s-2.08333.93274-2.08333 2.08333c0 1.1506.93274 2.08334 2.08333 2.08334z" />
          <path d="m12.5 6.66667c1.1506 0 2.0834-.93274 2.0834-2.08334 0-1.15059-.9328-2.08333-2.0834-2.08333s-2.0833.93274-2.0833 2.08333c0 1.1506.9327 2.08334 2.0833 2.08334z" />
          <path d="m16.25 10c1.1506 0 2.0834-.93274 2.0834-2.08334 0-1.15059-.9328-2.08333-2.0834-2.08333s-2.0833.93274-2.0833 2.08333c0 1.1506.9327 2.08334 2.0833 2.08334z" />
          <path d="m14.45 12.3833c-.725-.85-1.3333-1.575-2.0666-2.42497-.3834-.45-.875-.9-1.4584-1.1-.0916-.03333-.1833-.05833-.275-.075-.2083-.03333-.4333-.03333-.65-.03333-.21665 0-.44165 0-.65831.04167-.09167.01666-.18334.04166-.275.075-.58334.2-1.06667.65-1.45834 1.1-.725.85003-1.33333 1.57503-2.06667 2.42503-1.09166 1.0916-2.43333 2.3-2.18333 3.9916.24167.85.85 1.6917 1.94167 1.9334.60833.125 2.55-.3667 4.61667-.3667h.15001c2.0667 0 4.0083.4833 4.6167.3667 1.0916-.2417 1.7-1.0917 1.9416-1.9334.2584-1.7-1.0833-2.9083-2.175-4z" />
        </g>
      </svg>
    )}
  />
);

export const NFTCollectionIcon = () => (
  <Icon
    aria-label="NFTCollectionIcon"
    component={() => (
      <svg
        width="18"
        height="18"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.3334 12.3333V2.33334C17.3334 1.41667 16.5834 0.666672 15.6667 0.666672H5.66669C4.75002 0.666672 4.00002 1.41667 4.00002 2.33334V12.3333C4.00002 13.25 4.75002 14 5.66669 14H15.6667C16.5834 14 17.3334 13.25 17.3334 12.3333ZM8.16669 9.00001L9.85835 11.2583L12.3334 8.16667L15.6667 12.3333H5.66669L8.16669 9.00001ZM0.666687 4.00001V15.6667C0.666687 16.5833 1.41669 17.3333 2.33335 17.3333H14V15.6667H2.33335V4.00001H0.666687Z"
          fill="#424242"
        />
      </svg>
    )}
  />
);

export const AlertPlus = ({ color, size = 20 }) => (
  <Icon
    aria-label="AlertPlus"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.34167 17.2583C8.34167 18.175 9.08333 18.9167 10 18.9167C10.9167 18.9167 11.6583 18.175 11.6583 17.2583H8.34167ZM10 4.75001C12.3 4.75001 14.1667 6.61667 14.1667 8.91667V14.75H5.83333V8.91667C5.83333 6.61667 7.7 4.75001 10 4.75001ZM10 1.00001C9.30833 1.00001 8.75 1.55834 8.75 2.25001V3.22501C6.13333 3.79167 4.16667 6.12501 4.16667 8.91667V13.9167L2.5 15.5833V16.4167H17.5V15.5833L15.8333 13.9167V8.91667C15.8333 6.12501 13.8667 3.79167 11.25 3.22501V2.25001C11.25 1.55834 10.6917 1.00001 10 1.00001ZM9.16667 7.41667H10.8333V12.7485H9.16667V7.41667ZM7.27447 9.25001H12.5V10.9167L7.27447 10.9167V9.25001Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
  />
);

export const DotDotDot = ({ color = "#424242", size = 13 }) => (
  <Icon
    aria-label="DotDotDot"
    component={() => (
      <svg
        fill="none"
        width={size}
        height={size}
        viewBox="0 0 4 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m2.00004 3.66671c.91667 0 1.66667-.75 1.66667-1.66667s-.75-1.666666-1.66667-1.666666-1.666666.749996-1.666666 1.666666.749996 1.66667 1.666666 1.66667zm0 1.66666c-.91667 0-1.666666.75-1.666666 1.66667s.749996 1.66667 1.666666 1.66667 1.66667-.75 1.66667-1.66667-.75-1.66667-1.66667-1.66667zm0 5.00003c-.91667 0-1.666666.75-1.666666 1.6666 0 .9167.749996 1.6667 1.666666 1.6667s1.66667-.75 1.66667-1.6667c0-.9166-.75-1.6666-1.66667-1.6666z"
          fill={color}
        />
      </svg>
    )}
  />
);

export const EthereumIconWithBg = ({ size = 20, ...props }) => (
  <Icon
    aria-label="Ethereum"
    component={() => (
      <svg
        fill="#191921"
        width={size + "px"}
        height={size + "px"}
        clipRule="evenodd"
        fillRule="evenodd"
        imageRendering="optimizeQuality"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
        version="1.1"
        viewBox="0 0 784.37 1277.4"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fillRule="nonzero">
          <polygon
            points="392.07 0 383.5 29.11 383.5 873.74 392.07 882.29 784.13 650.54"
            fill="#343434"
          />
          <polygon points="392.07 0 -0 650.54 392.07 882.29 392.07 472.33" fill="#8C8C8C" />
          <polygon
            points="392.07 956.52 387.24 962.41 387.24 1263.3 392.07 1277.4 784.37 724.89"
            fill="#3C3C3B"
          />
          <polygon points="392.07 1277.4 392.07 956.52 -0 724.89" fill="#8C8C8C" />
          <polygon points="392.07 882.29 784.13 650.54 392.07 472.33" fill="#141414" />
          <polygon points="0 650.54 392.07 882.29 392.07 472.33" fill="#393939" />
        </g>
      </svg>
    )}
    {...props}
  />
);

export const EthereumIcon = ({ size = 20, ...props }) => (
  <Icon
    aria-label="EthereumIconWithBg"
    style={{
      background: "rgba(23, 25, 33, 0.12)",
      borderRadius: 3,
      width: size,
      height: size,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
    component={() => (
      <svg
        fill="#191921"
        width={size - 3.6 + "px"}
        height={size - 3.6 + "px"}
        clipRule="evenodd"
        fillRule="evenodd"
        imageRendering="optimizeQuality"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
        version="1.1"
        viewBox="0 0 784.37 1277.4"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fillRule="nonzero">
          <polygon
            points="392.07 0 383.5 29.11 383.5 873.74 392.07 882.29 784.13 650.54"
            fill="#343434"
          />
          <polygon points="392.07 0 -0 650.54 392.07 882.29 392.07 472.33" fill="#8C8C8C" />
          <polygon
            points="392.07 956.52 387.24 962.41 387.24 1263.3 392.07 1277.4 784.37 724.89"
            fill="#3C3C3B"
          />
          <polygon points="392.07 1277.4 392.07 956.52 -0 724.89" fill="#8C8C8C" />
          <polygon points="392.07 882.29 784.13 650.54 392.07 472.33" fill="#141414" />
          <polygon points="0 650.54 392.07 882.29 392.07 472.33" fill="#393939" />
        </g>
      </svg>
    )}
    {...props}
  />
);

export const OpenseaIcon = ({ size = 20 }) => (
  <Icon
    aria-label="OpenseaIcon"
    component={() => (
      <svg
        width={size + "px"}
        height={size + "px"}
        viewBox="0 0 90 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M90 45C90 69.8514 69.8514 90 45 90C20.1486 90 0 69.8514 0 45C0 20.1486 20.1486 0 45 0C69.8566 0 90 20.1486 90 45Z"
          fill="#2081E2"
        />
        <path
          d="M22.2011 46.512L22.3953 46.2069L34.1016 27.8939C34.2726 27.6257 34.6749 27.6535 34.8043 27.9447C36.76 32.3277 38.4475 37.7786 37.6569 41.1721C37.3194 42.5683 36.3948 44.4593 35.3545 46.2069C35.2204 46.4612 35.0725 46.7109 34.9153 46.9513C34.8413 47.0622 34.7165 47.127 34.5824 47.127H22.5432C22.2196 47.127 22.0301 46.7756 22.2011 46.512Z"
          fill="white"
        />
        <path
          d="M74.38 49.9149V52.8137C74.38 52.9801 74.2783 53.1281 74.1304 53.1928C73.2242 53.5812 70.1219 55.0052 68.832 56.799C65.5402 61.3807 63.0251 67.932 57.4031 67.932H33.949C25.6362 67.932 18.9 61.1727 18.9 52.8322V52.564C18.9 52.3421 19.0803 52.1618 19.3023 52.1618H32.377C32.6359 52.1618 32.8255 52.4022 32.8024 52.6565C32.7099 53.5072 32.8671 54.3764 33.2693 55.167C34.0461 56.7435 35.655 57.7283 37.3934 57.7283H43.866V52.675H37.4673C37.1391 52.675 36.9449 52.2959 37.1345 52.0277C37.2038 51.9214 37.2824 51.8104 37.3656 51.6856C37.9713 50.8257 38.8358 49.4895 39.6958 47.9684C40.2829 46.9421 40.8516 45.8463 41.3093 44.746C41.4018 44.5472 41.4758 44.3438 41.5497 44.1449C41.6746 43.7936 41.804 43.4653 41.8965 43.1371C41.9889 42.8597 42.0629 42.5684 42.1369 42.2956C42.3542 41.3617 42.4467 40.3723 42.4467 39.3459C42.4467 38.9437 42.4282 38.523 42.3912 38.1207C42.3727 37.6815 42.3172 37.2423 42.2617 36.8031C42.2247 36.4147 42.1554 36.031 42.0814 35.6288C41.9889 35.0416 41.8595 34.4591 41.7115 33.8719L41.6607 33.65C41.5497 33.2478 41.4573 32.864 41.3278 32.4618C40.9626 31.1996 40.5418 29.9698 40.098 28.8186C39.9362 28.3609 39.7512 27.9217 39.5663 27.4825C39.2935 26.8213 39.0161 26.2203 38.7619 25.6516C38.6324 25.3927 38.5214 25.1569 38.4105 24.9165C38.2857 24.6437 38.1562 24.371 38.0268 24.112C37.9343 23.9132 37.8279 23.7283 37.754 23.5434L36.9634 22.0824C36.8524 21.8836 37.0374 21.6478 37.2546 21.7079L42.2016 23.0487H42.2155C42.2247 23.0487 42.2294 23.0533 42.234 23.0533L42.8859 23.2336L43.6025 23.437L43.866 23.511V20.5706C43.866 19.1512 45.0034 18 46.4089 18C47.1116 18 47.7496 18.2866 48.2073 18.7536C48.665 19.2206 48.9517 19.8586 48.9517 20.5706V24.935L49.4787 25.0829C49.5204 25.0968 49.562 25.1153 49.599 25.143C49.7284 25.2401 49.9133 25.3835 50.1491 25.5591C50.3341 25.7071 50.5329 25.8874 50.7733 26.0723C51.2495 26.4561 51.8181 26.9508 52.4423 27.5194C52.6087 27.6628 52.7706 27.8107 52.9185 27.9587C53.723 28.7076 54.6245 29.5861 55.4845 30.557C55.7249 30.8297 55.9607 31.1071 56.2011 31.3984C56.4415 31.6943 56.6958 31.9856 56.9177 32.2769C57.209 32.6652 57.5233 33.0674 57.7961 33.4882C57.9256 33.687 58.0735 33.8904 58.1984 34.0892C58.5497 34.6209 58.8595 35.1711 59.1554 35.7212C59.2802 35.9755 59.4097 36.2529 59.5206 36.5257C59.8489 37.2608 60.1078 38.0098 60.2742 38.7588C60.3251 38.9206 60.3621 39.0963 60.3806 39.2535V39.2904C60.436 39.5124 60.4545 39.7482 60.473 39.9886C60.547 40.756 60.51 41.5235 60.3436 42.2956C60.2742 42.6239 60.1818 42.9336 60.0708 43.2619C59.9598 43.5763 59.8489 43.9045 59.7056 44.2143C59.4282 44.8569 59.0999 45.4996 58.7115 46.1006C58.5867 46.3225 58.4388 46.5583 58.2908 46.7802C58.129 47.016 57.9626 47.238 57.8146 47.4553C57.6112 47.7327 57.3939 48.0239 57.172 48.2828C56.9732 48.5556 56.7697 48.8284 56.5478 49.0688C56.2381 49.434 55.9422 49.7808 55.6324 50.1137C55.4475 50.331 55.2487 50.5529 55.0452 50.7517C54.8464 50.9736 54.643 51.1724 54.4581 51.3573C54.1483 51.6671 53.8894 51.9075 53.6721 52.1063L53.1635 52.5733C53.0896 52.638 52.9925 52.675 52.8908 52.675H48.9517V57.7283H53.9079C55.0175 57.7283 56.0716 57.3353 56.9223 56.6141C57.2136 56.3598 58.485 55.2594 59.9876 53.5997C60.0384 53.5442 60.1032 53.5026 60.1771 53.4841L73.8668 49.5265C74.1211 49.4525 74.38 49.6467 74.38 49.9149Z"
          fill="white"
        />
      </svg>
    )}
  />
);

export const OpenseaIconWithBg = ({ size = 20 }) => (
  <Icon
    aria-label="OpenseaIcon"
    style={{
      background: "rgba(23, 25, 33, 0.12)",
      borderRadius: 3,
      width: size,
      height: size,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
    component={() => (
      <svg
        width={size - 3.6 + "px"}
        height={size - 3.6 + "px"}
        viewBox="0 0 90 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M90 45C90 69.8514 69.8514 90 45 90C20.1486 90 0 69.8514 0 45C0 20.1486 20.1486 0 45 0C69.8566 0 90 20.1486 90 45Z"
          fill="#2081E2"
        />
        <path
          d="M22.2011 46.512L22.3953 46.2069L34.1016 27.8939C34.2726 27.6257 34.6749 27.6535 34.8043 27.9447C36.76 32.3277 38.4475 37.7786 37.6569 41.1721C37.3194 42.5683 36.3948 44.4593 35.3545 46.2069C35.2204 46.4612 35.0725 46.7109 34.9153 46.9513C34.8413 47.0622 34.7165 47.127 34.5824 47.127H22.5432C22.2196 47.127 22.0301 46.7756 22.2011 46.512Z"
          fill="white"
        />
        <path
          d="M74.38 49.9149V52.8137C74.38 52.9801 74.2783 53.1281 74.1304 53.1928C73.2242 53.5812 70.1219 55.0052 68.832 56.799C65.5402 61.3807 63.0251 67.932 57.4031 67.932H33.949C25.6362 67.932 18.9 61.1727 18.9 52.8322V52.564C18.9 52.3421 19.0803 52.1618 19.3023 52.1618H32.377C32.6359 52.1618 32.8255 52.4022 32.8024 52.6565C32.7099 53.5072 32.8671 54.3764 33.2693 55.167C34.0461 56.7435 35.655 57.7283 37.3934 57.7283H43.866V52.675H37.4673C37.1391 52.675 36.9449 52.2959 37.1345 52.0277C37.2038 51.9214 37.2824 51.8104 37.3656 51.6856C37.9713 50.8257 38.8358 49.4895 39.6958 47.9684C40.2829 46.9421 40.8516 45.8463 41.3093 44.746C41.4018 44.5472 41.4758 44.3438 41.5497 44.1449C41.6746 43.7936 41.804 43.4653 41.8965 43.1371C41.9889 42.8597 42.0629 42.5684 42.1369 42.2956C42.3542 41.3617 42.4467 40.3723 42.4467 39.3459C42.4467 38.9437 42.4282 38.523 42.3912 38.1207C42.3727 37.6815 42.3172 37.2423 42.2617 36.8031C42.2247 36.4147 42.1554 36.031 42.0814 35.6288C41.9889 35.0416 41.8595 34.4591 41.7115 33.8719L41.6607 33.65C41.5497 33.2478 41.4573 32.864 41.3278 32.4618C40.9626 31.1996 40.5418 29.9698 40.098 28.8186C39.9362 28.3609 39.7512 27.9217 39.5663 27.4825C39.2935 26.8213 39.0161 26.2203 38.7619 25.6516C38.6324 25.3927 38.5214 25.1569 38.4105 24.9165C38.2857 24.6437 38.1562 24.371 38.0268 24.112C37.9343 23.9132 37.8279 23.7283 37.754 23.5434L36.9634 22.0824C36.8524 21.8836 37.0374 21.6478 37.2546 21.7079L42.2016 23.0487H42.2155C42.2247 23.0487 42.2294 23.0533 42.234 23.0533L42.8859 23.2336L43.6025 23.437L43.866 23.511V20.5706C43.866 19.1512 45.0034 18 46.4089 18C47.1116 18 47.7496 18.2866 48.2073 18.7536C48.665 19.2206 48.9517 19.8586 48.9517 20.5706V24.935L49.4787 25.0829C49.5204 25.0968 49.562 25.1153 49.599 25.143C49.7284 25.2401 49.9133 25.3835 50.1491 25.5591C50.3341 25.7071 50.5329 25.8874 50.7733 26.0723C51.2495 26.4561 51.8181 26.9508 52.4423 27.5194C52.6087 27.6628 52.7706 27.8107 52.9185 27.9587C53.723 28.7076 54.6245 29.5861 55.4845 30.557C55.7249 30.8297 55.9607 31.1071 56.2011 31.3984C56.4415 31.6943 56.6958 31.9856 56.9177 32.2769C57.209 32.6652 57.5233 33.0674 57.7961 33.4882C57.9256 33.687 58.0735 33.8904 58.1984 34.0892C58.5497 34.6209 58.8595 35.1711 59.1554 35.7212C59.2802 35.9755 59.4097 36.2529 59.5206 36.5257C59.8489 37.2608 60.1078 38.0098 60.2742 38.7588C60.3251 38.9206 60.3621 39.0963 60.3806 39.2535V39.2904C60.436 39.5124 60.4545 39.7482 60.473 39.9886C60.547 40.756 60.51 41.5235 60.3436 42.2956C60.2742 42.6239 60.1818 42.9336 60.0708 43.2619C59.9598 43.5763 59.8489 43.9045 59.7056 44.2143C59.4282 44.8569 59.0999 45.4996 58.7115 46.1006C58.5867 46.3225 58.4388 46.5583 58.2908 46.7802C58.129 47.016 57.9626 47.238 57.8146 47.4553C57.6112 47.7327 57.3939 48.0239 57.172 48.2828C56.9732 48.5556 56.7697 48.8284 56.5478 49.0688C56.2381 49.434 55.9422 49.7808 55.6324 50.1137C55.4475 50.331 55.2487 50.5529 55.0452 50.7517C54.8464 50.9736 54.643 51.1724 54.4581 51.3573C54.1483 51.6671 53.8894 51.9075 53.6721 52.1063L53.1635 52.5733C53.0896 52.638 52.9925 52.675 52.8908 52.675H48.9517V57.7283H53.9079C55.0175 57.7283 56.0716 57.3353 56.9223 56.6141C57.2136 56.3598 58.485 55.2594 59.9876 53.5997C60.0384 53.5442 60.1032 53.5026 60.1771 53.4841L73.8668 49.5265C74.1211 49.4525 74.38 49.6467 74.38 49.9149Z"
          fill="white"
        />
      </svg>
    )}
  />
);

export const TimeAgoIcon = () => (
  <Icon
    aria-label="TimeAgoIcon"
    component={() => (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5 6.43333H9.85002L12.1334 4.08333C9.85836 1.83333 6.17502 1.75 3.90002 4C1.62502 6.25833 1.62502 9.9 3.90002 12.1583C6.17502 14.4167 9.85836 14.4167 12.1334 12.1583C13.2667 11.0417 13.8334 9.73333 13.8334 8.08333H15.5C15.5 9.73333 14.7667 11.875 13.3 13.325C10.375 16.225 5.62502 16.225 2.70002 13.325C-0.216643 10.4333 -0.241643 5.73333 2.68336 2.84167C5.60836 -0.0500001 10.3 -0.0500001 13.225 2.84167L15.5 0.5V6.43333ZM8.41669 4.66667V8.20833L11.3334 9.94167L10.7334 10.95L7.16669 8.83333V4.66667H8.41669Z"
          fill="#757575"
        />
      </svg>
    )}
  />
);

export const PolygonIcon = ({ size = 20 }) => (
  <Icon
    aria-label="PolygonIconWithBg"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3769_15600)">
          <path
            d="M13.0038 8.0042C12.7905 7.88231 12.5163 7.88231 12.2725 8.0042L10.566 9.00983L9.40809 9.64975L7.73208 10.6553C7.51877 10.7772 7.24452 10.7772 7.00074 10.6553L5.69041 9.863C5.4771 9.74117 5.32474 9.49733 5.32474 9.22308V7.69947C5.32474 7.45569 5.44663 7.21191 5.69041 7.05955L7.00074 6.29773C7.21405 6.17584 7.48829 6.17584 7.73208 6.29773L9.04243 7.09002C9.25568 7.21191 9.40809 7.45569 9.40809 7.72995V8.73558L10.566 8.06515V7.02907C10.566 6.78529 10.4442 6.54152 10.2003 6.38915L7.76255 4.95693C7.54925 4.83505 7.27499 4.83505 7.0312 4.95693L4.53245 6.41962C4.28867 6.54152 4.16678 6.78529 4.16678 7.02907V9.8935C4.16678 10.1372 4.28867 10.3811 4.53245 10.5334L7.00074 11.9657C7.21405 12.0875 7.48829 12.0875 7.73208 11.9657L9.40809 10.9905L10.566 10.3201L12.242 9.345C12.4553 9.22308 12.7296 9.22308 12.9733 9.345L14.2837 10.1068C14.497 10.2287 14.6493 10.4725 14.6493 10.7467V12.2703C14.6493 12.5142 14.5275 12.7579 14.2837 12.9103L13.0038 13.6721C12.7905 13.794 12.5163 13.794 12.2725 13.6721L10.9622 12.9103C10.7488 12.7884 10.5965 12.5446 10.5965 12.2703V11.2952L9.43851 11.9657V12.9712C9.43851 13.215 9.56043 13.4588 9.80418 13.6112L12.2725 15.0434C12.4858 15.1652 12.7601 15.1652 13.0038 15.0434L15.4721 13.6112C15.6854 13.4893 15.8378 13.2455 15.8378 12.9712V10.0763C15.8378 9.83258 15.7159 9.58875 15.4721 9.43642L13.0038 8.0042Z"
            fill="#8247E5"
          />
        </g>
        <defs>
          <clipPath id="clip0_3769_15600">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  ></Icon>
);

export const PolygonIconWithBg = ({ size = 20, ...props }) => (
  <Icon
    style={{
      width: size,
      height: size,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
    aria-label="PolygonIconWithBg"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_996_8157)">
          <path
            d="M15.8333 1.25H4.16667C2.55584 1.25 1.25 2.55584 1.25 4.16667V15.8333C1.25 17.4442 2.55584 18.75 4.16667 18.75H15.8333C17.4442 18.75 18.75 17.4442 18.75 15.8333V4.16667C18.75 2.55584 17.4442 1.25 15.8333 1.25Z"
            fill="#8247E5"
            fillOpacity="0.12"
          />
          <path
            d="M13.0038 8.0042C12.7905 7.88231 12.5162 7.88231 12.2725 8.0042L10.566 9.00983L9.40806 9.64975L7.73205 10.6553C7.51874 10.7772 7.24449 10.7772 7.00071 10.6553L5.69038 9.863C5.47707 9.74117 5.32471 9.49733 5.32471 9.22308V7.69947C5.32471 7.45569 5.4466 7.21191 5.69038 7.05955L7.00071 6.29773C7.21401 6.17584 7.48826 6.17584 7.73205 6.29773L9.0424 7.09002C9.25565 7.21191 9.40806 7.45569 9.40806 7.72995V8.73558L10.566 8.06515V7.02907C10.566 6.78529 10.4441 6.54152 10.2003 6.38915L7.76252 4.95693C7.54921 4.83505 7.27496 4.83505 7.03117 4.95693L4.53242 6.41962C4.28864 6.54152 4.16675 6.78529 4.16675 7.02907V9.8935C4.16675 10.1372 4.28864 10.3811 4.53242 10.5334L7.00071 11.9657C7.21401 12.0875 7.48826 12.0875 7.73205 11.9657L9.40806 10.9905L10.566 10.3201L12.242 9.345C12.4553 9.22308 12.7296 9.22308 12.9733 9.345L14.2836 10.1068C14.497 10.2287 14.6493 10.4725 14.6493 10.7467V12.2703C14.6493 12.5142 14.5275 12.7579 14.2836 12.9103L13.0038 13.6721C12.7905 13.794 12.5162 13.794 12.2725 13.6721L10.9621 12.9103C10.7488 12.7884 10.5965 12.5446 10.5965 12.2703V11.2952L9.43848 11.9657V12.9712C9.43848 13.215 9.5604 13.4588 9.80415 13.6112L12.2725 15.0434C12.4858 15.1652 12.7601 15.1652 13.0038 15.0434L15.4721 13.6112C15.6854 13.4893 15.8377 13.2455 15.8377 12.9712V10.0763C15.8377 9.83258 15.7159 9.58875 15.4721 9.43642L13.0038 8.0042Z"
            fill="#8247E5"
          />
        </g>
        <defs>
          <clipPath id="clip0_996_8157">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  ></Icon>
);

export const SolanaIconWithBg = ({ size = 20, ...props }) => (
  <Icon
    aria-label="SolanaIconWithBg"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_996_8158)">
          <path
            d="M15.8333 1.25H4.16667C2.55584 1.25 1.25 2.55584 1.25 4.16667V15.8333C1.25 17.4442 2.55584 18.75 4.16667 18.75H15.8333C17.4442 18.75 18.75 17.4442 18.75 15.8333V4.16667C18.75 2.55584 17.4442 1.25 15.8333 1.25Z"
            fill={COLORS["gray-800"]}
          />
          <path
            d="M15.0514 12.8233L13.3662 14.6302C13.3297 14.6695 13.2856 14.7008 13.2365 14.7223C13.1874 14.7437 13.1345 14.7547 13.0809 14.7548H5.09234C5.05424 14.7548 5.01698 14.7437 4.9851 14.7228C4.95323 14.7019 4.92814 14.6722 4.9129 14.6372C4.89766 14.6023 4.89293 14.5638 4.8993 14.5262C4.90567 14.4886 4.92285 14.4537 4.94874 14.4257L6.63204 12.6188C6.6685 12.5796 6.71263 12.5482 6.76172 12.5268C6.81081 12.5054 6.86379 12.4943 6.91735 12.4942H14.9059C14.9443 12.4935 14.9822 12.5041 15.0146 12.5248C15.0471 12.5453 15.0727 12.5752 15.0882 12.6103C15.1038 12.6455 15.1086 12.6845 15.102 12.7224C15.0954 12.7602 15.0778 12.7954 15.0514 12.8233ZM13.3662 9.18375C13.3297 9.14467 13.2854 9.1135 13.2364 9.09208C13.1873 9.07067 13.1344 9.05942 13.0809 9.05917H5.09234C5.05424 9.05917 5.01698 9.07033 4.9851 9.09117C4.95323 9.11208 4.92814 9.14183 4.9129 9.17675C4.89766 9.21167 4.89293 9.25025 4.8993 9.28783C4.90567 9.32542 4.92285 9.36025 4.94874 9.38825L6.63204 11.1961C6.66863 11.2352 6.71281 11.2664 6.76186 11.2878C6.81092 11.3092 6.86383 11.3204 6.91735 11.3207H14.9059C14.9439 11.3205 14.9811 11.3092 15.0128 11.2882C15.0446 11.2673 15.0695 11.2376 15.0846 11.2027C15.0997 11.1678 15.1044 11.1293 15.0979 11.0918C15.0916 11.0543 15.0744 11.0195 15.0486 10.9917L13.3662 9.18375ZM5.09234 7.88561H13.0809C13.1345 7.88556 13.1874 7.87447 13.2365 7.85302C13.2856 7.8316 13.3297 7.80027 13.3662 7.76102L15.0514 5.95409C15.0778 5.92618 15.0954 5.89107 15.102 5.85317C15.1086 5.81527 15.1038 5.77629 15.0882 5.74112C15.0727 5.70594 15.0471 5.67615 15.0146 5.6555C14.9822 5.63484 14.9443 5.62425 14.9059 5.62504H6.91735C6.86379 5.6251 6.81081 5.63619 6.76172 5.65762C6.71263 5.67906 6.6685 5.71037 6.63204 5.74962L4.94874 7.55656C4.92285 7.58451 4.90567 7.61941 4.8993 7.65697C4.89293 7.69454 4.89766 7.73314 4.9129 7.76807C4.92814 7.80298 4.95323 7.83271 4.9851 7.85358C5.01698 7.87447 5.05424 7.88559 5.09234 7.88561Z"
            fill="url(#paint0_linear_996_8158)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_996_8158"
            x1="5.75806"
            y1="14.9726"
            x2="14.1347"
            y2="5.52899"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.08" stopColor="#9945FF" />
            <stop offset="0.3" stopColor="#8752F3" />
            <stop offset="0.5" stopColor="#5497D5" />
            <stop offset="0.6" stopColor="#43B4CA" />
            <stop offset="0.72" stopColor="#28E0B9" />
            <stop offset="0.97" stopColor="#19FB9B" />
          </linearGradient>
          <clipPath id="clip0_996_8158">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  ></Icon>
);

export const PriceSlippageAlertIcon = ({ size = 20 }) => (
  <Icon
    aria-label="Price Slippage Alert Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path opacity="0.01" d="M20 0H0V20H20V0Z" fill="#888888" fillOpacity="0.01" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.55078 10.9258H10.6641C11.1068 10.9258 11.4844 10.8542 11.7969 10.7109C12.112 10.5677 12.3516 10.3633 12.5156 10.0976C12.6823 9.83202 12.7656 9.51562 12.7656 9.14843C12.7656 8.79426 12.6823 8.47916 12.5156 8.20312C12.3516 7.92447 12.112 7.70702 11.7969 7.55077C11.4844 7.39192 11.1068 7.31249 10.6641 7.31249H8.47656V13H9.55078V10.9258ZM9.55078 10.082H10.6641C10.9036 10.082 11.0977 10.043 11.2461 9.96484C11.3971 9.88411 11.5078 9.77473 11.5781 9.63671C11.6484 9.49609 11.6836 9.33593 11.6836 9.15624C11.6836 8.98176 11.6484 8.819 11.5781 8.66796C11.5078 8.51692 11.3971 8.39452 11.2461 8.30077C11.0977 8.20702 10.9036 8.16015 10.6641 8.16015H9.55078V10.082Z"
          fill="#424242"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75 2.25C8.75 1.55833 9.30833 1 10 1C10.6917 1 11.25 1.55833 11.25 2.25V3.225C13.8667 3.79167 15.8333 6.125 15.8333 8.91667V13.9167L17.5 15.5833V16.4167H2.5V15.5833L4.16667 13.9167V8.91667C4.16667 6.125 6.13333 3.79167 8.75 3.225V2.25ZM14.1667 8.91667C14.1667 6.61667 12.3 4.75 10 4.75C7.7 4.75 5.83333 6.61667 5.83333 8.91667V14.75H14.1667V8.91667Z"
          fill="#424242"
        />
        <path
          d="M10 18.9167C9.08333 18.9167 8.34167 18.175 8.34167 17.2583H11.6583C11.6583 18.175 10.9167 18.9167 10 18.9167Z"
          fill="#424242"
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const WashTradingAlertIcon = ({ size = 20 }) => (
  <Icon
    aria-label="Wash Trading Alert Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.67387 8.67999L8.24587 13H8.95987L9.97387 10.222L10.9939 13H11.7079L13.2799 8.67999H12.2959L11.3539 11.254L10.4059 8.67999H9.54787L8.60587 11.254L7.66387 8.67999H6.67387Z"
          fill="#424242"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 1C9.30833 1 8.75 1.55833 8.75 2.25V3.225C6.13333 3.79167 4.16667 6.125 4.16667 8.91667V13.9167L2.5 15.5833V16.4167H17.5V15.5833L15.8333 13.9167V8.91667C15.8333 6.125 13.8667 3.79167 11.25 3.225V2.25C11.25 1.55833 10.6917 1 10 1ZM10 4.75C12.3 4.75 14.1667 6.61667 14.1667 8.91667V14.75H5.83333V8.91667C5.83333 6.61667 7.7 4.75 10 4.75Z"
          fill="#424242"
        />
        <path
          d="M8.34167 17.2583C8.34167 18.175 9.08333 18.9167 10 18.9167C10.9167 18.9167 11.6583 18.175 11.6583 17.2583H8.34167Z"
          fill="#424242"
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const TornadoCashAlertIcon = ({ size = 20 }) => (
  <Icon
    aria-label="Tornado Cash Alert Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.53563 9.61599V13H10.4716V9.61599H12.1636V8.67999H7.84363V9.61599H9.53563Z"
          fill="#424242"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 1C9.30833 1 8.75 1.55833 8.75 2.25V3.225C6.13333 3.79167 4.16667 6.125 4.16667 8.91667V13.9167L2.5 15.5833V16.4167H17.5V15.5833L15.8333 13.9167V8.91667C15.8333 6.125 13.8667 3.79167 11.25 3.225V2.25C11.25 1.55833 10.6917 1 10 1ZM10 4.75C12.3 4.75 14.1667 6.61667 14.1667 8.91667V14.75H5.83333V8.91667C5.83333 6.61667 7.7 4.75 10 4.75Z"
          fill="#424242"
        />
        <path
          d="M8.34167 17.2583C8.34167 18.175 9.08333 18.9167 10 18.9167C10.9167 18.9167 11.6583 18.175 11.6583 17.2583H8.34167Z"
          fill="#424242"
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const DateRangeIcon = ({ size = 20 }) => (
  <Icon
    aria-label="Date Range Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5 9.16675H5.83333V10.8334H7.5V9.16675ZM10.8333 9.16675H9.16667V10.8334H10.8333V9.16675ZM14.1667 9.16675H12.5V10.8334H14.1667V9.16675ZM15.8333 3.33341H15V1.66675H13.3333V3.33341H6.66667V1.66675H5V3.33341H4.16667C3.24167 3.33341 2.50833 4.08341 2.50833 5.00008L2.5 16.6667C2.5 17.5834 3.24167 18.3334 4.16667 18.3334H15.8333C16.75 18.3334 17.5 17.5834 17.5 16.6667V5.00008C17.5 4.08341 16.75 3.33341 15.8333 3.33341ZM15.8333 16.6667H4.16667V7.50008H15.8333V16.6667Z"
          fill="#424242"
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const LeftIcon = ({ color = COLORS["gray-800"], size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.825 15L13 13.825L9.18333 10L13 6.175L11.825 5L6.825 10L11.825 15Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const RightIcon = ({ color, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.33333 5L7.15833 6.175L10.975 10L7.15833 13.825L8.33333 15L13.3333 10L8.33333 5Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const SlackIcon = ({ size = 16, whitened = false }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_15990_231307)">
          <path
            d="M4.6 13.8498C4.6 15.1498 3.6 16.1498 2.3 16.1498C1 16.1498 0 15.1498 0 13.8498C0 12.5498 1 11.5498 2.3 11.5498H4.6V13.8498Z"
            fill={whitened ? "white" : "#E01E5A"}
          />
          <path
            d="M5.80005 13.8498C5.80005 12.5498 6.80005 11.5498 8.10005 11.5498C9.40005 11.5498 10.4 12.5498 10.4 13.8498V19.6498C10.4 20.9498 9.40005 21.9498 8.10005 21.9498C6.80005 21.9498 5.80005 20.9498 5.80005 19.6498V13.8498Z"
            fill={whitened ? "white" : "#E01E5A"}
          />
          <path
            d="M8.10005 4.6498C6.80005 4.6498 5.80005 3.6498 5.80005 2.3498C5.80005 1.0498 6.80005 0.0498047 8.10005 0.0498047C9.40005 0.0498047 10.4 1.0498 10.4 2.3498V4.6498H8.10005Z"
            fill={whitened ? "white" : "#36C5F0"}
          />
          <path
            d="M8.1 5.75C9.4 5.75 10.4 6.75 10.4 8.05C10.4 9.35 9.4 10.35 8.1 10.35H2.3C1 10.35 0 9.35 0 8.05C0 6.75 1 5.75 2.3 5.75H8.1Z"
            fill={whitened ? "white" : "#36C5F0"}
          />
          <path
            d="M17.4001 8.14961C17.4001 6.84961 18.4001 5.84961 19.7001 5.84961C21.0001 5.84961 22.0001 6.84961 22.0001 8.14961C22.0001 9.44961 21.0001 10.4496 19.7001 10.4496H17.4001V8.14961Z"
            fill={whitened ? "white" : "#2EB67D"}
          />
          <path
            d="M16.2001 8.14981C16.2001 9.44981 15.2001 10.4498 13.9001 10.4498C12.6001 10.4498 11.6001 9.44981 11.6001 8.14981V2.3498C11.6001 1.0498 12.6001 0.0498047 13.9001 0.0498047C15.2001 0.0498047 16.2001 1.0498 16.2001 2.3498V8.14981Z"
            fill={whitened ? "white" : "#2EB67D"}
          />
          <path
            d="M13.9001 17.3496C15.2001 17.3496 16.2001 18.3496 16.2001 19.6496C16.2001 20.9496 15.2001 21.9496 13.9001 21.9496C12.6001 21.9496 11.6001 20.9496 11.6001 19.6496V17.3496H13.9001Z"
            fill={whitened ? "white" : "#ECB22E"}
          />
          <path
            d="M13.9001 16.2494C12.6001 16.2494 11.6001 15.2494 11.6001 13.9494C11.6001 12.6494 12.6001 11.6494 13.9001 11.6494H19.7001C21.0001 11.6494 22.0001 12.6494 22.0001 13.9494C22.0001 15.2494 21.0001 16.2494 19.7001 16.2494H13.9001Z"
            fill={whitened ? "white" : "#ECB22E"}
          />
        </g>
        <defs>
          <clipPath id="clip0_15990_231307">
            <rect width="22" height="21.9" fill="white" transform="translate(0 0.0498047)" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const TelegramIcon = ({ size = 16, whitened = false, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 10.5C18 15.1944 14.1944 19 9.5 19C4.80558 19 1 15.1944 1 10.5C1 5.80558 4.80558 2 9.5 2C14.1944 2 18 5.80558 18 10.5ZM9.80461 8.27508C8.97786 8.61896 7.32552 9.33069 4.8476 10.4103C4.44522 10.5703 4.23444 10.7268 4.21525 10.8799C4.18282 11.1386 4.50676 11.2404 4.94788 11.3791C5.00788 11.398 5.07006 11.4176 5.13379 11.4383C5.56779 11.5793 6.15159 11.7444 6.45508 11.7509C6.73038 11.7569 7.03765 11.6434 7.37687 11.4105C9.69207 9.84763 10.8872 9.05771 10.9622 9.04068C11.0152 9.02866 11.0885 9.01356 11.1382 9.05773C11.1879 9.10191 11.183 9.18557 11.1778 9.20801C11.1457 9.34482 9.87411 10.527 9.21606 11.1388C9.01091 11.3295 8.86539 11.4648 8.83564 11.4957C8.76901 11.5649 8.70109 11.6304 8.63582 11.6933C8.23263 12.082 7.93028 12.3734 8.65256 12.8494C8.99966 13.0781 9.27742 13.2673 9.55451 13.456C9.85713 13.6621 10.159 13.8676 10.5495 14.1236C10.649 14.1888 10.744 14.2566 10.8366 14.3226C11.1887 14.5736 11.5051 14.7992 11.896 14.7632C12.1231 14.7423 12.3577 14.5287 12.4769 13.8918C12.7585 12.3864 13.312 9.12475 13.4399 7.7807C13.4511 7.66294 13.437 7.51223 13.4257 7.44608C13.4144 7.37992 13.3907 7.28567 13.3047 7.21589C13.2029 7.13325 13.0457 7.11583 12.9753 7.11706C12.6556 7.1227 12.1651 7.29325 9.80461 8.27508Z"
          fill={whitened ? "white" : "#2AABEE"}
        />
      </svg>
    )}
    {...props}
  />
);

export const EmailIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.6667 3.33334H3.33335C2.41669 3.33334 1.67502 4.08334 1.67502 5L1.66669 15C1.66669 15.9167 2.41669 16.6667 3.33335 16.6667H16.6667C17.5834 16.6667 18.3334 15.9167 18.3334 15V5C18.3334 4.08334 17.5834 3.33334 16.6667 3.33334ZM16.6667 15H3.33335V6.66667L10 10.8333L16.6667 6.66667V15ZM10 9.16667L3.33335 5H16.6667L10 9.16667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const GoToChildIcon = ({ size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 3H7V7H3V3ZM2 2H3H7H8V3V7V8H7H3H2V7V3V2ZM11.5 14.5L8.99999 12L8.99999 13.6667L5.99997 13.6667L6.00005 8H4.33338L4.3333 15.3333L8.99999 15.3333V17L11.5 14.5Z"
          fill="#424242"
        />
        <rect x="11.75" y="11" width="7" height="7" fill="#E5453D" />
      </svg>
    )}
  />
);

export const GoToParentIcon = ({ size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 9.0006L3.5 11.5006L5.16667 11.5006L5.16667 14.6673L5.16667 16L12 16V17V18H13H17H18V17V13V12H17H13H12V13V14.5H6.83333L6.83333 11.5006H8.5L6 9.0006ZM13 13H17V17H13V13Z"
          fill="#424242"
        />
        <rect x="2" y="2" width="7" height="7" fill="#E5453D" />
      </svg>
    )}
  />
);

export const MoreIcon = ({ size = 20, color = "#E5453D" }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_343_76934)">
          <path
            d="M10 6.66665C10.9167 6.66665 11.6667 5.91665 11.6667 4.99998C11.6667 4.08331 10.9167 3.33331 10 3.33331C9.08337 3.33331 8.33337 4.08331 8.33337 4.99998C8.33337 5.91665 9.08337 6.66665 10 6.66665ZM10 8.33331C9.08337 8.33331 8.33337 9.08331 8.33337 9.99998C8.33337 10.9166 9.08337 11.6666 10 11.6666C10.9167 11.6666 11.6667 10.9166 11.6667 9.99998C11.6667 9.08331 10.9167 8.33331 10 8.33331ZM10 13.3333C9.08337 13.3333 8.33337 14.0833 8.33337 15C8.33337 15.9166 9.08337 16.6666 10 16.6666C10.9167 16.6666 11.6667 15.9166 11.6667 15C11.6667 14.0833 10.9167 13.3333 10 13.3333Z"
            fill={COLORS["gray-800"]}
          />
        </g>
        <defs>
          <clipPath id="clip0_343_76934">
            <rect width={size} height={size} fill={color} />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const CardListCreatedIcon = ({ state = "active" }) => (
  <Icon
    component={() =>
      state === "active" ? (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.00002 0.666687C4.40002 0.666687 0.666687 4.40002 0.666687 9.00002C0.666687 13.6 4.40002 17.3334 9.00002 17.3334C13.6 17.3334 17.3334 13.6 17.3334 9.00002C17.3334 4.40002 13.6 0.666687 9.00002 0.666687ZM9.00002 15.6667C5.31669 15.6667 2.33335 12.6834 2.33335 9.00002C2.33335 5.31669 5.31669 2.33335 9.00002 2.33335C12.6834 2.33335 15.6667 5.31669 15.6667 9.00002C15.6667 12.6834 12.6834 15.6667 9.00002 15.6667Z"
            fill={COLORS["gray-800"]}
          />
        </svg>
      ) : (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.00002 0.666687C4.40002 0.666687 0.666687 4.40002 0.666687 9.00002C0.666687 13.6 4.40002 17.3334 9.00002 17.3334C13.6 17.3334 17.3334 13.6 17.3334 9.00002C17.3334 4.40002 13.6 0.666687 9.00002 0.666687ZM9.00002 15.6667C5.31669 15.6667 2.33335 12.6834 2.33335 9.00002C2.33335 5.31669 5.31669 2.33335 9.00002 2.33335C12.6834 2.33335 15.6667 5.31669 15.6667 9.00002C15.6667 12.6834 12.6834 15.6667 9.00002 15.6667Z"
            fill="#9E9E9E"
          />
        </svg>
      )
    }
  />
);

export const CardListUpdatedIcon = ({ state = "active" }) => (
  <Icon
    component={() =>
      state === "active" ? (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5 6.43333H9.85002L12.1334 4.08333C9.85836 1.83333 6.17502 1.75 3.90002 4C1.62502 6.25833 1.62502 9.9 3.90002 12.1583C6.17502 14.4167 9.85836 14.4167 12.1334 12.1583C13.2667 11.0417 13.8334 9.73333 13.8334 8.08333H15.5C15.5 9.73333 14.7667 11.875 13.3 13.325C10.375 16.225 5.62502 16.225 2.70002 13.325C-0.216643 10.4333 -0.241643 5.73333 2.68336 2.84167C5.60836 -0.0500001 10.3 -0.0500001 13.225 2.84167L15.5 0.5V6.43333ZM8.41669 4.66667V8.20833L11.3334 9.94167L10.7334 10.95L7.16669 8.83333V4.66667H8.41669Z"
            fill={COLORS["gray-800"]}
          />
        </svg>
      ) : (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5 6.43333H9.85002L12.1334 4.08333C9.85836 1.83333 6.17502 1.75 3.90002 4C1.62502 6.25833 1.62502 9.9 3.90002 12.1583C6.17502 14.4167 9.85836 14.4167 12.1334 12.1583C13.2667 11.0417 13.8334 9.73333 13.8334 8.08333H15.5C15.5 9.73333 14.7667 11.875 13.3 13.325C10.375 16.225 5.62502 16.225 2.70002 13.325C-0.216643 10.4333 -0.241643 5.73333 2.68336 2.84167C5.60836 -0.0500001 10.3 -0.0500001 13.225 2.84167L15.5 0.5V6.43333ZM8.41669 4.66667V8.20833L11.3334 9.94167L10.7334 10.95L7.16669 8.83333V4.66667H8.41669Z"
            fill="#9E9E9E"
          />
        </svg>
      )
    }
  />
);

export const InProgressIcon = ({ size = 18, color = "#424242" }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.08317 8.99998C6.08317 9.69034 5.52352 10.25 4.83317 10.25C4.14281 10.25 3.58317 9.69034 3.58317 8.99998C3.58317 8.30963 4.14281 7.74998 4.83317 7.74998C5.52352 7.74998 6.08317 8.30963 6.08317 8.99998Z"
          fill={color}
        />
        <path
          d="M8.99984 10.25C9.6902 10.25 10.2498 9.69034 10.2498 8.99998C10.2498 8.30963 9.6902 7.74998 8.99984 7.74998C8.30948 7.74998 7.74984 8.30963 7.74984 8.99998C7.74984 9.69034 8.30948 10.25 8.99984 10.25Z"
          fill={color}
        />
        <path
          d="M14.4165 8.99998C14.4165 9.69034 13.8569 10.25 13.1665 10.25C12.4761 10.25 11.9165 9.69034 11.9165 8.99998C11.9165 8.30963 12.4761 7.74998 13.1665 7.74998C13.8569 7.74998 14.4165 8.30963 14.4165 8.99998Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.666504 8.99999C0.666504 4.39999 4.39984 0.666656 8.99984 0.666656C13.5998 0.666656 17.3332 4.39999 17.3332 8.99999C17.3332 13.6 13.5998 17.3333 8.99984 17.3333C4.39984 17.3333 0.666504 13.6 0.666504 8.99999ZM2.33317 8.99999C2.33317 12.6833 5.3165 15.6667 8.99984 15.6667C12.6832 15.6667 15.6665 12.6833 15.6665 8.99999C15.6665 5.31666 12.6832 2.33332 8.99984 2.33332C5.3165 2.33332 2.33317 5.31666 2.33317 8.99999Z"
          fill={color}
        />
      </svg>
    )}
  />
);

export const ArrowOutlinedIcon = ({
  size = 16,
  direction = "right",
  color = COLORS["gray-600"],
  ...props
}) => (
  <Icon
    {...props}
    component={() =>
      direction == "right" ? (
        <svg
          width={size}
          height={size}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.99992 0.333344L5.82492 1.50834L10.4749 6.16668H0.333252V7.83334H10.4749L5.82492 12.4917L6.99992 13.6667L13.6666 7.00001L6.99992 0.333344Z"
            fill={color}
          />
        </svg>
      ) : (
        <svg
          width={size}
          height={size}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.6667 6.16665H3.52504L8.18337 1.50831L7.00004 0.333313L0.333374 6.99998L7.00004 13.6666L8.17504 12.4916L3.52504 7.83331H13.6667V6.16665Z"
            fill={color}
          />
        </svg>
      )
    }
  />
);

export const ArrowOutlinedIconSmall = () => (
  <Icon
    component={() => (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_33_6589)">
          <path
            d="M2.66665 8.66537H10.78L7.05331 12.392L7.99998 13.332L13.3333 7.9987L7.99998 2.66537L7.05998 3.60537L10.78 7.33203L2.66665 7.33203V8.66537Z"
            fill={COLORS["gray-800"]}
          />
        </g>
        <defs>
          <clipPath id="clip0_33_6589">
            <rect width="16" height="16" fill="white" transform="translate(16 16) rotate(-180)" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const DefaultScoreIcon = () => (
  <Icon
    component={() => (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0V0C24.8366 0 32 7.16344 32 16V16C32 24.8366 24.8366 32 16 32V32C7.16344 32 0 24.8366 0 16V16Z"
          fill="url(#paint0_linear_2155_201)"
        />
        <path
          opacity="0.87"
          d="M16.3846 25C17.4 25 18.2308 24.1692 18.2308 23.1538H14.5385C14.5385 24.1692 15.36 25 16.3846 25ZM21.9231 19.4615V14.8462C21.9231 12.0123 20.4092 9.64 17.7692 9.01231V8.38462C17.7692 7.61846 17.1508 7 16.3846 7C15.6185 7 15 7.61846 15 8.38462V9.01231C12.3508 9.64 10.8462 12.0031 10.8462 14.8462V19.4615L9 21.3077V22.2308H23.7692V21.3077L21.9231 19.4615Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2155_201"
            x1="16"
            y1="0"
            x2="16"
            y2="32"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#212121" />
            <stop offset="1" stopColor="#424242" />
          </linearGradient>
        </defs>
      </svg>
    )}
  />
);

export const HandshakeIcon = ({ width = 22, height = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={width}
        height={height}
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.875 18.5C10.9583 18.5 11.0542 18.4792 11.1625 18.4375C11.2708 18.3959 11.3583 18.3417 11.425 18.275L19.85 9.82502C20.0667 9.60836 20.2292 9.36252 20.3375 9.08752C20.4458 8.81252 20.5 8.53336 20.5 8.25002C20.5 7.96669 20.4458 7.68336 20.3375 7.40002C20.2292 7.11669 20.0667 6.86669 19.85 6.65002L15.35 2.15002C15.1333 1.93336 14.8833 1.77086 14.6 1.66252C14.3167 1.55419 14.0333 1.50002 13.75 1.50002C13.4667 1.50002 13.1875 1.55419 12.9125 1.66252C12.6375 1.77086 12.3917 1.93336 12.175 2.15002L11.725 2.60002L13.75 4.65002C13.9667 4.88336 14.1583 5.15419 14.325 5.46252C14.4917 5.77086 14.575 6.10836 14.575 6.47502C14.575 7.10836 14.3292 7.66669 13.8375 8.15002C13.3458 8.63336 12.7833 8.87502 12.15 8.87502C11.7333 8.87502 11.3875 8.81252 11.1125 8.68752C10.8375 8.56252 10.5833 8.38336 10.35 8.15002L8.525 6.32502L4 10.85C3.91667 10.9334 3.85833 11.0209 3.825 11.1125C3.79167 11.2042 3.775 11.3 3.775 11.4C3.775 11.6167 3.84583 11.7959 3.9875 11.9375C4.12917 12.0792 4.30833 12.15 4.525 12.15C4.625 12.15 4.72083 12.125 4.8125 12.075C4.90417 12.025 4.98333 11.9667 5.05 11.9L8.5 8.45002L9.55 9.50002L6.125 12.925C6.04167 13.0084 5.98333 13.1 5.95 13.2C5.91667 13.3 5.9 13.4 5.9 13.5C5.9 13.7 5.975 13.875 6.125 14.025C6.275 14.175 6.45 14.25 6.65 14.25C6.75 14.25 6.84583 14.2292 6.9375 14.1875C7.02917 14.1459 7.10833 14.0917 7.175 14.025L10.625 10.575L11.675 11.625L8.25 15.05C8.18333 15.1167 8.12917 15.2042 8.0875 15.3125C8.04583 15.4209 8.025 15.525 8.025 15.625C8.025 15.825 8.1 16 8.25 16.15C8.4 16.3 8.575 16.375 8.775 16.375C8.875 16.375 8.96667 16.3584 9.05 16.325C9.13333 16.2917 9.21667 16.2334 9.3 16.15L12.75 12.7L13.8 13.75L10.35 17.2C10.2667 17.2834 10.2083 17.375 10.175 17.475C10.1417 17.575 10.125 17.6667 10.125 17.75C10.125 17.9834 10.1917 18.1667 10.325 18.3C10.4583 18.4334 10.6417 18.5 10.875 18.5ZM10.875 20C10.325 20 9.83333 19.7959 9.4 19.3875C8.96667 18.9792 8.70833 18.475 8.625 17.875C8.05833 17.7917 7.58333 17.5584 7.2 17.175C6.81667 16.7917 6.58333 16.3167 6.5 15.75C5.93333 15.6667 5.4625 15.4292 5.0875 15.0375C4.7125 14.6459 4.48333 14.175 4.4 13.625C3.78333 13.5417 3.275 13.2917 2.875 12.875C2.475 12.4584 2.275 11.9584 2.275 11.375C2.275 11.0917 2.32917 10.8084 2.4375 10.525C2.54583 10.2417 2.70833 9.99169 2.925 9.77502L8.525 4.17502L11.275 6.92502C11.4083 7.05836 11.5542 7.16252 11.7125 7.23752C11.8708 7.31252 12.025 7.35002 12.175 7.35002C12.3917 7.35002 12.5958 7.25419 12.7875 7.06252C12.9792 6.87086 13.075 6.66669 13.075 6.45002C13.075 6.35002 13.0458 6.23752 12.9875 6.11252C12.9292 5.98752 12.8333 5.85836 12.7 5.72502L9.125 2.15002C8.90833 1.93336 8.65833 1.77086 8.375 1.66252C8.09167 1.55419 7.80833 1.50002 7.525 1.50002C7.24167 1.50002 6.9625 1.55419 6.6875 1.66252C6.4125 1.77086 6.16667 1.93336 5.95 2.15002L2.15 5.95002C1.91667 6.18336 1.75417 6.42919 1.6625 6.68752C1.57083 6.94586 1.51667 7.23336 1.5 7.55002C1.48333 7.88336 1.54583 8.20419 1.6875 8.51252C1.82917 8.82086 2 9.10003 2.2 9.35003L1.125 10.425C0.791667 10.0584 0.520833 9.61669 0.3125 9.10003C0.104167 8.58336 0 8.05836 0 7.52502C0 7.02502 0.0958334 6.54586 0.2875 6.08752C0.479167 5.62919 0.75 5.22502 1.1 4.87502L4.875 1.10002C5.24167 0.733358 5.65833 0.462524 6.125 0.287524C6.59167 0.112524 7.06667 0.0250244 7.55 0.0250244C8.03333 0.0250244 8.50417 0.112524 8.9625 0.287524C9.42083 0.462524 9.83333 0.733358 10.2 1.10002L10.65 1.55002L11.1 1.10002C11.4667 0.733358 11.8833 0.462524 12.35 0.287524C12.8167 0.112524 13.2917 0.0250244 13.775 0.0250244C14.2583 0.0250244 14.7292 0.112524 15.1875 0.287524C15.6458 0.462524 16.0583 0.733358 16.425 1.10002L20.9 5.57502C21.2667 5.94169 21.5417 6.35836 21.725 6.82502C21.9083 7.29169 22 7.76669 22 8.25002C22 8.73336 21.9083 9.20419 21.725 9.66253C21.5417 10.1209 21.2667 10.5334 20.9 10.9L12.475 19.325C12.2583 19.5417 12.0125 19.7084 11.7375 19.825C11.4625 19.9417 11.175 20 10.875 20V20Z"
          fill="#424242"
        />
      </svg>
    )}
  />
);

export const WavingHand = ({ size = 20, color }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M32 44C35.3333 44 38.1667 42.8333 40.5 40.5C42.8333 38.1667 44 35.3333 44 32H41C41 34.5 40.125 36.625 38.375 38.375C36.625 40.125 34.5 41 32 41V44ZM0 12H3C3 9.5 3.875 7.375 5.625 5.625C7.375 3.875 9.5 3 12 3V0C8.66667 0 5.83333 1.16667 3.5 3.5C1.16667 5.83333 0 8.66667 0 12ZM5.05 38.95C1.81667 35.7167 0.2 31.8333 0.2 27.3C0.2 22.7667 1.81667 18.8833 5.05 15.65L12.45 8.2C13.3167 7.33333 14.375 6.9 15.625 6.9C16.875 6.9 17.9333 7.33333 18.8 8.2C18.9333 8.3 19.0833 8.46667 19.25 8.7L19.75 9.4L25.55 3.6C26.4167 2.73333 27.475 2.3 28.725 2.3C29.975 2.3 31.0333 2.73333 31.9 3.6C32.1 3.83333 32.275 4.06667 32.425 4.3C32.575 4.53333 32.6833 4.73333 32.75 4.9C33.5833 4.06667 34.6083 3.66667 35.825 3.7C37.0417 3.73333 38.0833 4.18333 38.95 5.05C39.6167 5.71667 40.0167 6.54167 40.15 7.525C40.2833 8.50833 40.1333 9.48333 39.7 10.45C39.9667 10.55 40.2167 10.6833 40.45 10.85C40.6833 11.0167 40.9 11.2 41.1 11.4C41.9667 12.2667 42.4 13.325 42.4 14.575C42.4 15.825 41.9667 16.8833 41.1 17.75L39.85 19C40.0833 19.1 40.3083 19.2333 40.525 19.4C40.7417 19.5667 40.9333 19.7333 41.1 19.9C41.9667 20.7667 42.4083 21.825 42.425 23.075C42.4417 24.325 42 25.3833 41.1 26.25L28.35 38.95C25.1167 42.1833 21.2333 43.8 16.7 43.8C12.1667 43.8 8.28333 42.1833 5.05 38.95ZM7.15 36.85C8.48333 38.1833 9.975 39.175 11.625 39.825C13.275 40.475 14.9667 40.8 16.7 40.8C18.4333 40.8 20.125 40.475 21.775 39.825C23.425 39.175 24.9167 38.1833 26.25 36.85L38.95 24.1C39.25 23.8 39.4 23.4417 39.4 23.025C39.4 22.6083 39.25 22.2667 38.95 22C38.65 21.7 38.3 21.55 37.9 21.55C37.5 21.55 37.15 21.7 36.85 22L29.8 29.05L27.65 26.95L38.95 15.65C39.25 15.35 39.4 14.9917 39.4 14.575C39.4 14.1583 39.25 13.8 38.95 13.5C38.65 13.2 38.3 13.05 37.9 13.05C37.5 13.05 37.15 13.2 36.85 13.5L26.95 23.4L24.85 21.3L36.85 9.25C37.15 8.95 37.2917 8.59167 37.275 8.175C37.2583 7.75833 37.1167 7.41667 36.85 7.15C36.55 6.85 36.2 6.7 35.8 6.7C35.4 6.7 35.05 6.85 34.75 7.15L22.7 19.15L20.6 17.05L29.8 7.85C30.1 7.55 30.2417 7.19167 30.225 6.775C30.2083 6.35833 30.0667 6.01667 29.8 5.75C29.5 5.45 29.1417 5.3 28.725 5.3C28.3083 5.3 27.95 5.45 27.65 5.75L14.45 18.95C15.15 20.6833 15.3667 22.45 15.1 24.25C14.8333 26.05 14.0667 27.65 12.8 29.05L10.7 26.95C11.7667 25.7167 12.3 24.3 12.3 22.7C12.3 21.1 11.7667 19.6833 10.7 18.45L16.7 12.45C17 12.15 17.1417 11.7917 17.125 11.375C17.1083 10.9583 16.9667 10.6167 16.7 10.35C16.4 10.05 16.05 9.9 15.65 9.9C15.25 9.9 14.9 10.05 14.6 10.35L7.15 17.75C5.81667 19.0833 4.825 20.575 4.175 22.225C3.525 23.875 3.2 25.5667 3.2 27.3C3.2 29.0333 3.525 30.725 4.175 32.375C4.825 34.025 5.81667 35.5167 7.15 36.85Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
  />
);

export const GrayInfoIcon = () => (
  <Icon
    aria-label="DownloadIcon2"
    component={() => (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.16663 4.83335H9.83329V6.50002H8.16663V4.83335ZM8.16663 8.16669H9.83329V13.1667H8.16663V8.16669ZM8.99996 0.666687C4.39996 0.666687 0.666626 4.40002 0.666626 9.00002C0.666626 13.6 4.39996 17.3334 8.99996 17.3334C13.6 17.3334 17.3333 13.6 17.3333 9.00002C17.3333 4.40002 13.6 0.666687 8.99996 0.666687ZM8.99996 15.6667C5.32496 15.6667 2.33329 12.675 2.33329 9.00002C2.33329 5.32502 5.32496 2.33335 8.99996 2.33335C12.675 2.33335 15.6666 5.32502 15.6666 9.00002C15.6666 12.675 12.675 15.6667 8.99996 15.6667Z"
          fill="#9E9E9E"
        />
      </svg>
    )}
  />
);

export const StarFilledIcon = ({ size = 20, color = COLORS["gray-800"], ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99996 14.3917L15.15 17.5L13.7833 11.6417L18.3333 7.7L12.3416 7.19167L9.99996 1.66667L7.65829 7.19167L1.66663 7.7L6.21663 11.6417L4.84996 17.5L9.99996 14.3917Z"
          fill={color}
        />
        <defs>
          <clipPath>
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  />
);

export const StarOutlinedIcon = ({ size = 20, color = COLORS["gray-800"], ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M18.3333 7.7L12.3416 7.18334L9.99996 1.66667L7.65829 7.19167L1.66663 7.7L6.21663 11.6417L4.84996 17.5L9.99996 14.3917L15.15 17.5L13.7916 11.6417L18.3333 7.7ZM9.99996 12.8333L6.86663 14.725L7.69996 11.1583L4.93329 8.75834L8.58329 8.44167L9.99996 5.08334L11.425 8.45001L15.075 8.76667L12.3083 11.1667L13.1416 14.7333L9.99996 12.8333Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath>
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  />
);

export const StepActiveIcon = () => (
  <Icon
    aria-label="DownloadIcon2"
    component={() => (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="32" height="32" rx="16" fill={COLORS["gray-800"]} />
        <path
          d="M11 14.3333C10.0833 14.3333 9.33334 15.0833 9.33334 16C9.33334 16.9167 10.0833 17.6667 11 17.6667C11.9167 17.6667 12.6667 16.9167 12.6667 16C12.6667 15.0833 11.9167 14.3333 11 14.3333ZM21 14.3333C20.0833 14.3333 19.3333 15.0833 19.3333 16C19.3333 16.9167 20.0833 17.6667 21 17.6667C21.9167 17.6667 22.6667 16.9167 22.6667 16C22.6667 15.0833 21.9167 14.3333 21 14.3333ZM16 14.3333C15.0833 14.3333 14.3333 15.0833 14.3333 16C14.3333 16.9167 15.0833 17.6667 16 17.6667C16.9167 17.6667 17.6667 16.9167 17.6667 16C17.6667 15.0833 16.9167 14.3333 16 14.3333Z"
          fill="white"
        />
      </svg>
    )}
  />
);

export const StepResolvedIcon = () => (
  <Icon
    aria-label="DownloadIcon2"
    component={() => (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="32" height="32" rx="16" fill="#43A047" />
        <path
          d="M13.5 19.5L10 16L8.83334 17.1667L13.5 21.8333L23.5 11.8333L22.3333 10.6667L13.5 19.5Z"
          fill="white"
        />
      </svg>
    )}
  />
);

export const StepSkipIcon = () => (
  <Icon
    aria-label="step skip icon"
    component={() => (
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.399902" width="32" height="32" rx="16" fill="#9E9E9E" />
        <path
          d="M16.4001 9.33333L15.2251 10.5083L19.8751 15.1667H9.7334V16.8333H19.8751L15.2251 21.4917L16.4001 22.6667L23.0667 16L16.4001 9.33333Z"
          fill="white"
        />
      </svg>
    )}
  />
);

export const SearchIcon = ({ size = 20, color, testid = null }) => (
  <Icon
    aria-label="SearchIcon"
    component={() => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 15 16"
        fill="none"
        data-testid={testid}
      >
        <path
          d="M10.4167 9.66667H9.75833L9.525 9.44167C10.3417 8.49167 10.8333 7.25833 10.8333 5.91667C10.8333 2.925 8.40833 0.5 5.41667 0.5C2.425 0.5 0 2.925 0 5.91667C0 8.90833 2.425 11.3333 5.41667 11.3333C6.75833 11.3333 7.99167 10.8417 8.94167 10.025L9.16667 10.2583V10.9167L13.3333 15.075L14.575 13.8333L10.4167 9.66667ZM5.41667 9.66667C3.34167 9.66667 1.66667 7.99167 1.66667 5.91667C1.66667 3.84167 3.34167 2.16667 5.41667 2.16667C7.49167 2.16667 9.16667 3.84167 9.16667 5.91667C9.16667 7.99167 7.49167 9.66667 5.41667 9.66667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
  />
);

// TODO remove

export const Emblem = ({ size = 32 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="8" fill="#1D7FAC" />
        <g clipPath="url(#clip0_20257_17308)">
          <path opacity="0.01" d="M4 4H36V36H4V4Z" fill="white" fillOpacity="0.01" />
          <path
            d="M16.2102 32.202L14.0607 28.5253L9.79001 27.6485L10.2708 23.4909L7.55566 20.3232L10.2708 17.1839L9.79001 13.0263L14.0607 12.1495L16.2102 8.44446L20.0001 10.198L23.79 8.44446L25.9678 12.1495L30.2102 13.0263L29.7294 17.1839L32.4446 20.3232L29.7294 23.4909L30.2102 27.6485L25.9678 28.5253L23.79 32.202L20.0001 30.4485L16.2102 32.202ZM16.9738 29.9677L20.0001 28.695L23.1112 29.9677L25.0062 27.1394L28.3153 26.2909L27.9759 22.9253L30.2668 20.3232L27.9759 17.6647L28.3153 14.299L25.0062 13.5071L23.0547 10.6788L20.0001 11.9515L16.889 10.6788L14.994 13.5071L11.685 14.299L12.0244 17.6647L9.73344 20.3232L12.0244 22.9253L11.685 26.3475L14.994 27.1394L16.9738 29.9677Z"
            fill="white"
          />
          <path
            d="M25.2042 17.7212L18.784 24.0849L14.7961 20.1253L16.0972 18.8526L18.784 21.6526L23.9315 16.5616L25.2042 17.7212Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_20257_17308">
            <rect width="32" height="32" fill="white" transform="translate(4 4)" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const CertikLogoAnimated = () => (
  <Icon
    component={() => (
      <Image
        src="/icon/certik-logo-animated.svg"
        alt="add-emblem-icon"
        width={"174px"}
        height={"55px"}
      />
    )}
  />
);

export const CloseIcon = ({ size = 16, color = "#424242" }) => (
  <Icon
    aria-label="CloseIcon"
    component={() => (
      <svg
        width={size || 16}
        height={size || 16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.6667 4.27398L11.7267 3.33398L8 7.06065L4.27334 3.33398L3.33334 4.27398L7.06 8.00065L3.33334 11.7273L4.27334 12.6673L8 8.94065L11.7267 12.6673L12.6667 11.7273L8.94 8.00065L12.6667 4.27398Z"
          fill={color}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const FindingPendingIcon = ({ size = 20, fillColor = COLORS["gray-800"] }) => (
  <Icon
    aria-label="Finding Pending Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16699 12.5003H10.8337V14.167H9.16699V12.5003ZM9.16699 5.83366H10.8337V10.8337H9.16699V5.83366ZM9.99199 1.66699C5.39199 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.39199 18.3337 9.99199 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 9.99199 1.66699ZM10.0003 16.667C6.31699 16.667 3.33366 13.6837 3.33366 10.0003C3.33366 6.31699 6.31699 3.33366 10.0003 3.33366C13.6837 3.33366 16.667 6.31699 16.667 10.0003C16.667 13.6837 13.6837 16.667 10.0003 16.667Z"
          fill={fillColor}
        />
      </svg>
    )}
  />
);

export const FindingDeclinedIcon = ({ fillColor, size = 20 }) => (
  <Icon
    aria-label="Finding Declined Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.8337 14.167H9.16699V12.5003H10.8337V14.167ZM10.8337 10.8337H9.16699V5.83366H10.8337V10.8337Z"
          fill={fillColor || "#E57373"}
        />
      </svg>
    )}
  />
);

export const FindingPartiallyResolvedIcon = ({ size = 20 }) => (
  <Icon
    aria-label="Finding Partially Resolved Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667ZM13.8253 6.31699L8.33366 11.8087L6.17533 9.65866L5.00033 10.8337L8.33366 14.167L15.0003 7.50033L13.8253 6.31699Z"
          fill="#2E7D32"
        />
      </svg>
    )}
  />
);

export const FindingMitigatedIcon = ({ size = 20 }) => (
  <Icon
    aria-label="Finding Mitigated Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667ZM13.8253 6.31699L8.33366 11.8087L6.17533 9.65866L5.00033 10.8337L8.33366 14.167L15.0003 7.50033L13.8253 6.31699Z"
          fill="#2E7D32"
        />
      </svg>
    )}
  />
);

export const FindingResolvedIcon = ({ size = 20 }) => (
  <Icon
    aria-label="Finding Resolved Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM8.33366 14.167L4.16699 10.0003L5.34199 8.82533L8.33366 11.8087L14.6587 5.48366L15.8337 6.66699L8.33366 14.167Z"
          fill="#2E7D32"
        />
      </svg>
    )}
  />
);

export const FindingAcknowledgedIcon = ({ size = 20, fillColor = COLORS["gray-800"] }) => (
  <Icon
    aria-label="Finding Resolved Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11 6.69169V8.35835H9.33333V6.69169H11Z" fill={fillColor} />
        <path d="M11 10V15H9.33333V10H11Z" fill={fillColor} />
        <path
          d="M10.325 2C5.725 2 2 5.73333 2 10.3333C2 14.9333 5.725 18.6667 10.325 18.6667C14.9333 18.6667 18.6667 14.9333 18.6667 10.3333C18.6667 9.31436 18.4835 8.33792 18.1482 7.43516L16.8154 8.76794C16.9361 9.26997 17 9.79415 17 10.3333C17 14.0167 14.0167 17 10.3333 17C6.65 17 3.66667 14.0167 3.66667 10.3333C3.66667 6.65 6.65 3.66667 10.3333 3.66667C12.0929 3.66667 13.6927 4.34747 14.8838 5.46016L16.0622 4.28435C14.5673 2.86871 12.548 2 10.325 2Z"
          fill={fillColor}
        />
        <path
          d="M18.2499 3.33334L14.4499 7.125L12.8333 5.50835L11.6583 6.69169L14.4499 9.48333L19.4249 4.50834L18.2499 3.33334Z"
          fill={fillColor}
        />
      </svg>
    )}
  />
);

export const PremiumServiceIcon = ({ size = 32 }) => (
  <Icon
    aria-label="Premium Service Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="8" fill="#C62828" />
        <g clipPath="url(#clip0_20276_17323)">
          <path opacity="0.01" d="M4 4H36V36H4V4Z" fill="white" fillOpacity="0.01" />
          <path
            d="M16.8333 21.3778L18.0333 17.5444L14.8666 15.0778H18.7333L19.9999 11.1111L21.2333 15.0778H25.1333L21.9666 17.5444L23.1333 21.3778L19.9999 19.0111L16.8333 21.3778ZM12.1333 33.7778V23.6444C11.1333 22.6 10.4166 21.4555 9.98325 20.2111C9.54992 18.9667 9.33325 17.7111 9.33325 16.4444C9.33325 13.4222 10.3555 10.8889 12.3999 8.84444C14.4444 6.79999 16.9777 5.77777 19.9999 5.77777C23.0221 5.77777 25.5555 6.79999 27.5999 8.84444C29.6444 10.8889 30.6666 13.4222 30.6666 16.4444C30.6666 17.7111 30.4499 18.9667 30.0166 20.2111C29.5833 21.4555 28.8666 22.6 27.8666 23.6444V33.7778L19.9999 31.1444L12.1333 33.7778ZM19.9999 25.1111C22.4221 25.1111 24.4721 24.2722 26.1499 22.5944C27.8277 20.9167 28.6666 18.8667 28.6666 16.4444C28.6666 14.0222 27.8277 11.9722 26.1499 10.2944C24.4721 8.61666 22.4221 7.77777 19.9999 7.77777C17.5777 7.77777 15.5277 8.61666 13.8499 10.2944C12.1721 11.9722 11.3333 14.0222 11.3333 16.4444C11.3333 18.8667 12.1721 20.9167 13.8499 22.5944C15.5277 24.2722 17.5777 25.1111 19.9999 25.1111ZM14.1333 30.9778L19.9999 29.1444L25.8666 30.9778V25.2778C24.9777 25.9222 24.0221 26.3889 22.9999 26.6778C21.9777 26.9667 20.9777 27.1111 19.9999 27.1111C19.0221 27.1111 18.0221 26.9667 16.9999 26.6778C15.9777 26.3889 15.0221 25.9222 14.1333 25.2778V30.9778Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_20276_17323">
            <rect width="32" height="32" fill="white" transform="translate(4 4)" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const EvidenceIconCircle = () => (
  <Icon
    aria-label="Evidence Icon Circle"
    component={() => (
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="36" height="36" rx="18" fill="#C5CAE9" />
        <path
          d="M12.5 26C12.0833 26 11.7293 25.854 11.438 25.562C11.146 25.2707 11 24.9167 11 24.5V13.5C11 13.0833 11.146 12.7293 11.438 12.438C11.7293 12.146 12.0833 12 12.5 12H16.5V13.5H12.5V24.5H23.5V19.688L25 21.188V24.5C25 24.9167 24.854 25.2707 24.562 25.562C24.2707 25.854 23.9167 26 23.5 26H12.5ZM13.5 23V21.5H18H22.5V23H13.5ZM25.938 20L23.375 17.438C23.097 17.618 22.802 17.7567 22.49 17.854C22.1773 17.9513 21.8473 18 21.5 18C20.528 18 19.7017 17.6597 19.021 16.979C18.3403 16.2983 18 15.472 18 14.5C18 13.528 18.3403 12.7017 19.021 12.021C19.7017 11.3403 20.528 11 21.5 11C22.472 11 23.2983 11.3403 23.979 12.021C24.6597 12.7017 25 13.528 25 14.5C25 14.8473 24.9513 15.1773 24.854 15.49C24.7567 15.802 24.618 16.097 24.438 16.375L27 18.938L25.938 20ZM21.5 16.5C22.0553 16.5 22.5277 16.3057 22.917 15.917C23.3057 15.5277 23.5 15.0553 23.5 14.5C23.5 13.9447 23.3057 13.4723 22.917 13.083C22.5277 12.6943 22.0553 12.5 21.5 12.5C20.9447 12.5 20.4723 12.6943 20.083 13.083C19.6943 13.4723 19.5 13.9447 19.5 14.5C19.5 15.0553 19.6943 15.5277 20.083 15.917C20.4723 16.3057 20.9447 16.5 21.5 16.5Z"
          fill="white"
        />
        <path d="M13.5 18.5V20H18V18.5H13.5Z" fill="white" />
      </svg>
    )}
  />
);

export const EvidenceExcludedIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    aria-label="Evidence Excluded Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 6.5C10 5.57493 10.2791 4.71505 10.7578 4H4.5C4.08333 4 3.72933 4.146 3.438 4.438C3.146 4.72933 3 5.08333 3 5.5V16.5C3 16.9167 3.146 17.2707 3.438 17.562C3.72933 17.854 4.08333 18 4.5 18H15.5C15.9167 18 16.2707 17.854 16.562 17.562C16.854 17.2707 17 16.9167 17 16.5V11.5L16.4376 10.5627C15.8508 10.843 15.1937 11 14.5 11C12.0147 11 10 8.98528 10 6.5ZM5.5 12V10.5H10V12H5.5ZM5.5 13.5V15H14.5V13.5H10H5.5ZM12 6V7.5H18V6H12Z"
          fill={color}
        />
      </svg>
    )}
  />
);

export const EvidenceOutlineIcon = ({ size = 20, color = null }) => (
  <Icon
    aria-label="Trasaction Tracing Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.89998 18.6001C1.39998 18.6001 0.975175 18.4249 0.625575 18.0745C0.275176 17.7249 0.0999756 17.3001 0.0999756 16.8001V3.6001C0.0999756 3.1001 0.275176 2.6753 0.625575 2.3257C0.975175 1.9753 1.39998 1.8001 1.89998 1.8001H6.69998V3.6001H1.89998V16.8001H15.1V11.0257L16.9 12.8257V16.8001C16.9 17.3001 16.7248 17.7249 16.3744 18.0745C16.0248 18.4249 15.6 18.6001 15.1 18.6001H1.89998ZM3.09998 15.0001V13.2001H8.49998H13.9V15.0001H3.09998ZM18.0256 11.4001L14.95 8.3257C14.6164 8.5417 14.2624 8.7081 13.888 8.8249C13.5128 8.9417 13.1168 9.0001 12.7 9.0001C11.5336 9.0001 10.542 8.5917 9.72517 7.7749C8.90837 6.9581 8.49998 5.9665 8.49998 4.8001C8.49998 3.6337 8.90837 2.6421 9.72517 1.8253C10.542 1.0085 11.5336 0.600098 12.7 0.600098C13.8664 0.600098 14.858 1.0085 15.6748 1.8253C16.4916 2.6421 16.9 3.6337 16.9 4.8001C16.9 5.2169 16.8416 5.6129 16.7248 5.9881C16.608 6.3625 16.4416 6.7165 16.2256 7.0501L19.3 10.1257L18.0256 11.4001ZM12.7 7.2001C13.3664 7.2001 13.9332 6.9669 14.4004 6.5005C14.8668 6.0333 15.1 5.4665 15.1 4.8001C15.1 4.1337 14.8668 3.5669 14.4004 3.0997C13.9332 2.6333 13.3664 2.4001 12.7 2.4001C12.0336 2.4001 11.4668 2.6333 10.9996 3.0997C10.5332 3.5669 10.3 4.1337 10.3 4.8001C10.3 5.4665 10.5332 6.0333 10.9996 6.5005C11.4668 6.9669 12.0336 7.2001 12.7 7.2001Z"
          fill={color || "currentColor"}
        />
        <path d="M3.09998 9.6001V11.4001H8.49998V9.6001H3.09998Z" fill={COLORS["gray-800"]} />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const AttachmentIcon = () => (
  <Icon
    aria-label="Attachment Icon"
    component={() => (
      <svg
        width="16"
        height="10"
        viewBox="0 0 16 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 9.5H13V8H4.604C3.77067 8 3.04167 7.71167 2.417 7.135C1.79167 6.559 1.486 5.84733 1.5 5C1.514 4.16667 1.809 3.45833 2.385 2.875C2.96167 2.29167 3.66667 2 4.5 2H12.708C13.208 2 13.6317 2.17 13.979 2.51C14.3263 2.85067 14.5 3.264 14.5 3.75C14.5 4.236 14.33 4.64933 13.99 4.99C13.6493 5.33 13.236 5.5 12.75 5.5H5C4.86133 5.5 4.74333 5.45133 4.646 5.354C4.54867 5.25667 4.5 5.13867 4.5 5C4.5 4.86133 4.54867 4.74333 4.646 4.646C4.74333 4.54867 4.86133 4.5 5 4.5H13V3H5.083C4.52767 3 4.04167 3.18733 3.625 3.562C3.20833 3.93733 3 4.41667 3 5C3 5.55533 3.19433 6.02767 3.583 6.417C3.97233 6.80567 4.44467 7 5 7H12.604C13.5207 7 14.316 6.691 14.99 6.073C15.6633 5.455 16 4.68067 16 3.75C16 2.84733 15.684 2.08 15.052 1.448C14.42 0.816 13.6527 0.5 12.75 0.5H4.646C3.382 0.5 2.29167 0.930667 1.375 1.792C0.458333 2.65267 0 3.715 0 4.979C0 6.257 0.437333 7.33 1.312 8.198C2.18733 9.066 3.25 9.5 4.5 9.5Z"
          fill={COLORS["gray-800"]}
        />
      </svg>
    )}
  />
);

export const ArrowForwardIcon = ({ size = 20, color = COLORS["gray-800"], ...props }) => (
  <Icon
    aria-label="Arrow Forward Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        {...props}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M10 3.33334L8.82504 4.50834L13.475 9.16668H3.33337V10.8333H13.475L8.82504 15.4917L10 16.6667L16.6667 10L10 3.33334Z"
            fill={color}
          />
        </g>
      </svg>
    )}
  />
);

const greenCircle = {
  display: "inline-block",
  width: "10px",
  height: "10px",
  lineHeight: "20px",
  background: "#43a047",
  borderRadius: "20px",
  verticalAlign: "middle",
  marginRight: "5px",
  marginTop: "12px",
};

const redCircle = {
  display: "inline-block",
  width: "10px",
  height: "10px",
  lineHeight: "20px",
  background: "#E5453D",
  borderRadius: "20px",
  verticalAlign: "middle",
  marginRight: "5px",
  marginTop: "12px",
};

export const OnlineIcon = () => <span style={greenCircle}></span>;

export const OfflineIcon = () => <span style={redCircle}></span>;

export const FilterClearIcon = ({ size = 17, color = COLORS["gray-800"], ...props }) => (
  <Icon
    aria-label="Filter Clear"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 16.062L0.875 1.938L1.938 0.875L16.062 15L15 16.062ZM2 4.938V3.438H3.875V4.938H2ZM4 8.688V7.188H7.625V8.688H4ZM8.125 4.938L6.625 3.438H16V4.938H8.125ZM7 12.438V10.938H11V12.438H7ZM11.875 8.688L10.375 7.188H14V8.688H11.875Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    {...props}
  />
);

export const DownArrow = ({ width = 10, height = 7, color = "#424242", ...props }) => (
  <Icon
    aria-label="Down Arrow"
    component={() => (
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 6.33331L10 1.33331L8.825 0.158313L5 3.97498L1.175 0.158313L2.38419e-07 1.33331L5 6.33331Z"
          fill={color}
        />
      </svg>
    )}
    {...props}
  />
);

export const UpArrow = ({ width = 10, height = 7, color = "#424242", ...props }) => (
  <Icon
    aria-label="Up Arrow"
    component={() => (
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 0.666687L0 5.66669L1.175 6.84169L5 3.02502L8.825 6.84169L10 5.66669L5 0.666687Z"
          fill={color}
        />
      </svg>
    )}
    {...props}
  />
);

export const FindingsCounterIcon = () => (
  <Icon
    aria-label="Attachment Icon"
    component={() => (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_171_24812)">
          <path
            d="M7.33334 10H8.66667V11.3333H7.33334V10ZM7.33334 4.66666H8.66667V8.66666H7.33334V4.66666ZM7.99334 1.33333C4.31334 1.33333 1.33334 4.31999 1.33334 8C1.33334 11.68 4.31334 14.6667 7.99334 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8C14.6667 4.31999 11.68 1.33333 7.99334 1.33333ZM8 13.3333C5.05334 13.3333 2.66667 10.9467 2.66667 8C2.66667 5.05333 5.05334 2.66666 8 2.66666C10.9467 2.66666 13.3333 5.05333 13.3333 8C13.3333 10.9467 10.9467 13.3333 8 13.3333Z"
            fill={COLORS["gray-800"]}
          />
        </g>
        <defs>
          <clipPath id="clip0_171_24812">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  />
);

export const FilterIcon = ({ size = 20, color = COLORS["gray-800"], ...props }) => (
  <Icon
    aria-label="Filter"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 14.5V13H12V14.5H8ZM5 10.75V9.25H15V10.75H5ZM3 7V5.5H17V7H3Z" fill={color} />
      </svg>
    )}
    {...props}
  />
);

export const ProjectsIcon = ({ color = COLORS["gray-300"], size = 20 }) => (
  <Icon
    aria-label="Projects Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.49996 10.834L7.99996 13.334L5.49996 15.834V14.1673H2.16663V3.33398H3.83329L3.83329 12.5007H5.49996V10.834Z"
          fill={color || "currentColor"}
        />
        <path
          d="M17.9999 14.1673H16.3333V13.334H18.8333V16.6673H16.3333V15.834H17.9999V15.4173H17.1666V14.584H17.9999V14.1673Z"
          fill={color || "currentColor"}
        />
        <path
          d="M17.9999 6.66732H17.1666V4.16732H16.3333V3.33398H17.9999V6.66732Z"
          fill={color || "currentColor"}
        />
        <path
          d="M17.8333 9.16732H16.3333V8.33398H18.8333V9.08398L17.3333 10.834H18.8333V11.6673H16.3333V10.9173L17.8333 9.16732Z"
          fill={color || "currentColor"}
        />
        <path
          d="M14.6666 4.16732H8.83325V5.83399H14.6666V4.16732Z"
          fill={color || "currentColor"}
        />
        <path d="M14.6666 14.1673H8.83325V15.834H14.6666V14.1673Z" fill={color || "currentColor"} />
        <path d="M14.6666 9.16732H8.83325V10.834H14.6666V9.16732Z" fill={color || "currentColor"} />
      </svg>
    )}
  />
);

export const CertikIcon = ({ color = COLORS["gray-300"], width = 174, height = 190 }) => (
  <Icon
    aria-label="Certik Icon"
    component={() => (
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M164.295 29.1645L165.297 35.2269C165.357 35.5826 166.394 42.0408 166.394 52.2616C166.391 64.8476 164.877 77.3877 161.885 89.6128C157.832 106.224 150.769 121.952 141.048 136.018C129.815 152.17 113.577 168.058 89.9084 180.824L86.9975 182.372L84.1066 180.809C60.4333 168.043 44.1952 152.155 32.9622 136.002C23.244 121.938 16.1818 106.215 12.1247 89.6078C9.13205 77.3828 7.61815 64.8426 7.61554 52.2566C7.61554 42.0408 8.65265 35.5826 8.71278 35.2219L9.71482 29.1595C9.79641 28.666 9.78 28.1613 9.66653 27.6742C9.55307 27.1871 9.34477 26.7271 9.05353 26.3205C8.76229 25.9138 8.39381 25.5686 7.96913 25.3043C7.54445 25.0401 7.07188 24.8621 6.57842 24.7806C6.08496 24.699 5.58026 24.7154 5.09313 24.8288C4.60601 24.9423 4.14601 25.1506 3.73938 25.4419C3.33276 25.7331 2.98749 26.1016 2.72327 26.5263C2.45906 26.9509 2.28107 27.4235 2.19949 27.917L1.19744 33.9793C1.08722 34.6757 0 41.5247 0 52.2566C0.00623966 65.4579 1.59922 78.6105 4.74468 91.4315C9.02329 108.942 16.471 125.522 26.7195 140.351C38.5737 157.416 55.7788 174.19 80.4942 187.513L85.1938 190.048C85.7483 190.349 86.3692 190.506 87 190.506C87.6308 190.506 88.2517 190.349 88.8062 190.048L93.5008 187.513C118.241 174.19 135.426 157.416 147.301 140.351C157.549 125.522 164.997 108.942 169.275 91.4315C172.421 78.6105 174.014 65.4579 174.02 52.2566C174.02 41.5247 172.933 34.6757 172.818 33.9843L171.816 27.922C171.734 27.4285 171.556 26.9559 171.292 26.5313C171.028 26.1066 170.682 25.7381 170.276 25.4469C169.869 25.1556 169.409 24.9473 168.922 24.8339C168.435 24.7204 167.93 24.704 167.437 24.7856C166.943 24.8672 166.471 25.0451 166.046 25.3094C165.621 25.5736 165.253 25.9188 164.961 26.3255C164.67 26.7321 164.462 27.1921 164.348 27.6792C164.235 28.1663 164.219 28.671 164.3 29.1645H164.295Z"
          fill={color}
        />
        <path
          d="M30.4722 25.0511L86.9975 7.78088L144.795 25.4169C145.277 25.5791 145.786 25.6431 146.293 25.605C146.8 25.567 147.294 25.4278 147.746 25.1955C148.199 24.9633 148.6 24.6427 148.926 24.2529C149.252 23.863 149.497 23.4117 149.645 22.9256C149.794 22.4396 149.844 21.9286 149.792 21.423C149.74 20.9174 149.587 20.4274 149.342 19.9819C149.097 19.5364 148.766 19.1445 148.367 18.8293C147.968 18.5142 147.51 18.2822 147.02 18.147L88.1098 0.165338C87.3863 -0.0550719 86.6137 -0.0550719 85.8902 0.165338L28.2727 17.7612C27.306 18.0529 26.4947 18.7167 26.0174 19.6065C25.5401 20.4963 25.4358 21.5392 25.7275 22.5059C26.0192 23.4726 26.6829 24.2839 27.5727 24.7612C28.4625 25.2385 29.5055 25.3428 30.4722 25.0511V25.0511Z"
          fill={color}
        />
        <path
          d="M2.57025 30.2768L83.6156 188.434C83.932 189.053 84.4115 189.572 85.0023 189.937C85.593 190.302 86.2724 190.498 86.9668 190.504C87.6611 190.511 88.3439 190.327 88.9411 189.972C89.5382 189.618 90.027 189.107 90.3543 188.495L139.785 96.071L139.86 95.9257L171.49 30.1916C171.727 29.7396 171.87 29.2446 171.912 28.736C171.953 28.2274 171.892 27.7156 171.732 27.2312C171.571 26.7468 171.315 26.2996 170.978 25.9163C170.641 25.533 170.231 25.2214 169.771 25.0001C169.311 24.7788 168.811 24.6523 168.302 24.6281C167.792 24.6039 167.283 24.6826 166.804 24.8594C166.325 25.0362 165.887 25.3075 165.516 25.6572C165.144 26.0069 164.846 26.4278 164.641 26.8949L133.041 92.5288L87.0726 178.504L9.33906 26.8097C8.87303 25.9232 8.07606 25.2563 7.12124 24.9538C6.16641 24.6514 5.13083 24.7379 4.2394 25.1945C3.34796 25.6511 2.67266 26.441 2.36014 27.3925C2.04762 28.3441 2.12312 29.3805 2.57025 30.2768V30.2768Z"
          fill={color}
        />
        <path
          d="M41.3544 100.705H131.473C132.482 100.705 133.449 100.305 134.162 99.5917C134.875 98.8785 135.276 97.9113 135.276 96.9027C135.276 95.8941 134.875 94.9269 134.162 94.2137C133.449 93.5006 132.482 93.0999 131.473 93.0999H41.3544C40.3458 93.0999 39.3786 93.5006 38.6654 94.2137C37.9523 94.9269 37.5516 95.8941 37.5516 96.9027C37.5516 97.9113 37.9523 98.8785 38.6654 99.5917C39.3786 100.305 40.3458 100.705 41.3544 100.705"
          fill={color}
        />
      </svg>
    )}
  />
);

export const BackIcon = ({ color = COLORS["gray-800"], size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.6667 6.16668H3.52504L8.18337 1.50834L7.00004 0.333344L0.333374 7.00001L7.00004 13.6667L8.17504 12.4917L3.52504 7.83334H13.6667V6.16668Z"
          fill={color}
        />
      </svg>
    )}
  />
);

export const EmojiIcon = ({ color, size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2049_23421)">
          <path
            d="M10.7998 18C9.70247 18 8.6678 17.7917 7.6958 17.375C6.7238 16.9583 5.87314 16.3853 5.1438 15.656C4.41447 14.9267 3.84147 14.076 3.4248 13.104C3.00814 12.132 2.7998 11.0973 2.7998 10C2.7998 8.88867 3.00814 7.85033 3.4248 6.885C3.84147 5.92033 4.41447 5.07333 5.1438 4.344C5.87314 3.61467 6.7238 3.04167 7.6958 2.625C8.6678 2.20833 9.70247 2 10.7998 2C11.4111 2 12.0118 2.066 12.6018 2.198C13.1925 2.33 13.7585 2.528 14.2998 2.792V4.5C13.7718 4.18067 13.2128 3.934 12.6228 3.76C12.0328 3.58667 11.4251 3.5 10.7998 3.5C8.99447 3.5 7.4598 4.132 6.1958 5.396C4.9318 6.66 4.2998 8.19467 4.2998 10C4.2998 11.8053 4.9318 13.34 6.1958 14.604C7.4598 15.868 8.99447 16.5 10.7998 16.5C12.6051 16.5 14.1398 15.868 15.4038 14.604C16.6678 13.34 17.2998 11.8053 17.2998 10C17.2998 9.472 17.2371 8.958 17.1118 8.458C16.9871 7.958 16.8068 7.472 16.5708 7H18.2378C18.4318 7.486 18.5741 7.979 18.6648 8.479C18.7548 8.979 18.7998 9.486 18.7998 10C18.7998 11.0973 18.5915 12.132 18.1748 13.104C17.7581 14.076 17.1851 14.9267 16.4558 15.656C15.7265 16.3853 14.8795 16.9583 13.9148 17.375C12.9495 17.7917 11.9111 18 10.7998 18ZM17.2998 5.5V4H15.7998V2.5H17.2998V1H18.7998V2.5H20.2998V4H18.7998V5.5H17.2998ZM13.5498 9.25C13.8971 9.25 14.1921 9.12833 14.4348 8.885C14.6781 8.64233 14.7998 8.34733 14.7998 8C14.7998 7.65267 14.6781 7.35767 14.4348 7.115C14.1921 6.87167 13.8971 6.75 13.5498 6.75C13.2025 6.75 12.9075 6.87167 12.6648 7.115C12.4215 7.35767 12.2998 7.65267 12.2998 8C12.2998 8.34733 12.4215 8.64233 12.6648 8.885C12.9075 9.12833 13.2025 9.25 13.5498 9.25ZM8.0498 9.25C8.39714 9.25 8.69214 9.12833 8.9348 8.885C9.17814 8.64233 9.2998 8.34733 9.2998 8C9.2998 7.65267 9.17814 7.35767 8.9348 7.115C8.69214 6.87167 8.39714 6.75 8.0498 6.75C7.70247 6.75 7.40747 6.87167 7.1648 7.115C6.92147 7.35767 6.7998 7.65267 6.7998 8C6.7998 8.34733 6.92147 8.64233 7.1648 8.885C7.40747 9.12833 7.70247 9.25 8.0498 9.25ZM10.7998 14C11.6331 14 12.4005 13.7847 13.1018 13.354C13.8031 12.9233 14.3551 12.34 14.7578 11.604H6.8418C7.24447 12.34 7.79647 12.9233 8.4978 13.354C9.19914 13.7847 9.96647 14 10.7998 14Z"
            fill={color}
          />
        </g>
      </svg>
    )}
  />
);

export const ReportIncidentIcon = ({ color = "#E5453D", size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M13.1083 2.5H6.89167L2.5 6.89167V13.1083L6.89167 17.5H13.1083L17.5 13.1083V6.89167L13.1083 2.5ZM15.8333 12.4167L12.4167 15.8333H7.58333L4.16667 12.4167V7.58333L7.58333 4.16667H12.4167L15.8333 7.58333V12.4167Z"
            fill={COLORS["gray-800"]}
          />
          <path
            d="M9.99996 14.1667C10.4602 14.1667 10.8333 13.7936 10.8333 13.3333C10.8333 12.8731 10.4602 12.5 9.99996 12.5C9.53972 12.5 9.16663 12.8731 9.16663 13.3333C9.16663 13.7936 9.53972 14.1667 9.99996 14.1667Z"
            fill="#E5453D"
          />
          <path d="M9.16663 5.83333H10.8333V11.6667H9.16663V5.83333Z" fill={color} />
        </g>
        <defs>
          <clipPath>
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  />
);

export const NotificationFilledIcon = ({ color = COLORS["gray-800"], size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M10 18.3333C10.9167 18.3333 11.6667 17.5833 11.6667 16.6667H8.33337C8.33337 17.5833 9.07504 18.3333 10 18.3333ZM15 13.3333V9.16668C15 6.60834 13.6334 4.46668 11.25 3.90001V3.33334C11.25 2.64168 10.6917 2.08334 10 2.08334C9.30837 2.08334 8.75004 2.64168 8.75004 3.33334V3.90001C6.35837 4.46668 5.00004 6.60001 5.00004 9.16668V13.3333L3.33337 15V15.8333H16.6667V15L15 13.3333Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath>
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  />
);

export const PinnedIcon = ({ color = COLORS["gray-800"], size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3333 7.50001V3.33334H14.1666C14.625 3.33334 15 2.95834 15 2.50001C15 2.04167 14.625 1.66667 14.1666 1.66667H5.83329C5.37496 1.66667 4.99996 2.04167 4.99996 2.50001C4.99996 2.95834 5.37496 3.33334 5.83329 3.33334H6.66663V7.50001C6.66663 8.88334 5.54996 10 4.16663 10V11.6667H9.14163V17.5L9.97496 18.3333L10.8083 17.5V11.6667H15.8333V10C14.45 10 13.3333 8.88334 13.3333 7.50001Z"
          fill={color}
        />
      </svg>
    )}
    {...props}
  />
);

export const PinIcon = ({ color = COLORS["gray-800"], size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6666 3.33334V7.50001C11.6666 8.43334 11.975 9.30001 12.5 10H7.49996C8.04163 9.28334 8.33329 8.41667 8.33329 7.50001V3.33334H11.6666ZM14.1666 1.66667H5.83329C5.37496 1.66667 4.99996 2.04167 4.99996 2.50001C4.99996 2.95834 5.37496 3.33334 5.83329 3.33334H6.66663V7.50001C6.66663 8.88334 5.54996 10 4.16663 10V11.6667H9.14163V17.5L9.97496 18.3333L10.8083 17.5V11.6667H15.8333V10C14.45 10 13.3333 8.88334 13.3333 7.50001V3.33334H14.1666C14.625 3.33334 15 2.95834 15 2.50001C15 2.04167 14.625 1.66667 14.1666 1.66667Z"
          fill={color}
        />
      </svg>
    )}
    {...props}
  />
);

export const AuditIcon = ({ color = COLORS["gray-800"], size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2241_31234)">
          <path d="M2.5 5H11.6667V6.66667H2.5V5Z" fill={color} />
          <path d="M2.5 8.33334H11.6667V10H2.5V8.33334Z" fill={color} />
          <path d="M8.33333 11.6667H2.5V13.3333H8.33333V11.6667Z" fill={color} />
          <path
            d="M13.6167 13.475L17.1583 9.94168L18.3333 11.1167L13.6167 15.8333L10.675 12.8833L11.85 11.7083L13.6167 13.475Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_2241_31234">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  />
);

export const AuditsIcon = ({ color = null, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_38_80349)">
          <path
            d="M3.33337 5.83333H16.6667V7.5H3.33337V5.83333ZM3.33337 10.8333H16.6667V9.16667H3.33337V10.8333ZM3.33337 14.1667H9.16671V12.5H3.33337V14.1667ZM3.33337 17.5H9.16671V15.8333H3.33337V17.5ZM12.8417 15.1417L11.6667 13.9583L10.4917 15.1333L12.8417 17.5L16.6667 13.6833L15.4834 12.5L12.8417 15.1417ZM3.33337 2.5V4.16667H16.6667V2.5H3.33337Z"
            fill={color || "currentColor"}
          />
        </g>
        <defs>
          <clipPath id="clip0_38_80349">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const PlusCircleIcon = ({ color = COLORS["gray-800"], size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.25 12H8.75V8.75H12V7.25H8.75V4H7.25V7.25H4V8.75H7.25V12ZM8 16C6.90267 16 5.868 15.7917 4.896 15.375C3.924 14.9583 3.07333 14.3853 2.344 13.656C1.61467 12.9267 1.04167 12.076 0.625 11.104C0.208333 10.132 0 9.09733 0 8C0 6.88867 0.208333 5.85033 0.625 4.885C1.04167 3.92033 1.61467 3.07333 2.344 2.344C3.07333 1.61467 3.924 1.04167 4.896 0.625C5.868 0.208333 6.90267 0 8 0C9.11133 0 10.1497 0.208333 11.115 0.625C12.0797 1.04167 12.9267 1.61467 13.656 2.344C14.3853 3.07333 14.9583 3.92033 15.375 4.885C15.7917 5.85033 16 6.88867 16 8C16 9.09733 15.7917 10.132 15.375 11.104C14.9583 12.076 14.3853 12.9267 13.656 13.656C12.9267 14.3853 12.0797 14.9583 11.115 15.375C10.1497 15.7917 9.11133 16 8 16ZM8 14.5C9.80533 14.5 11.34 13.868 12.604 12.604C13.868 11.34 14.5 9.80533 14.5 8C14.5 6.19467 13.868 4.66 12.604 3.396C11.34 2.132 9.80533 1.5 8 1.5C6.19467 1.5 4.66 2.132 3.396 3.396C2.132 4.66 1.5 6.19467 1.5 8C1.5 9.80533 2.132 11.34 3.396 12.604C4.66 13.868 6.19467 14.5 8 14.5Z"
          fill={color}
        />
      </svg>
    )}
    {...props}
  />
);

export const ManageSearchIcon = ({ size = 20, color = COLORS["gray-800"], ...props }) => (
  <Icon
    component={() => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M5.83317 7.5H1.6665V5.83333H5.83317V7.5ZM5.83317 10H1.6665V11.6667H5.83317V10ZM17.1582 15.8333L13.9665 12.6417C13.2998 13.075 12.5165 13.3333 11.6665 13.3333C9.3665 13.3333 7.49984 11.4667 7.49984 9.16667C7.49984 6.86667 9.3665 5 11.6665 5C13.9665 5 15.8332 6.86667 15.8332 9.16667C15.8332 10.0167 15.5748 10.8 15.1415 11.4583L18.3332 14.6583L17.1582 15.8333ZM14.1665 9.16667C14.1665 7.79167 13.0415 6.66667 11.6665 6.66667C10.2915 6.66667 9.1665 7.79167 9.1665 9.16667C9.1665 10.5417 10.2915 11.6667 11.6665 11.6667C13.0415 11.6667 14.1665 10.5417 14.1665 9.16667ZM1.6665 15.8333H9.99984V14.1667H1.6665V15.8333Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    {...props}
  />
);

export const UpdateIcon = ({ color = COLORS["gray-800"], size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M17.5 8.43333H11.85L14.1333 6.08333C11.8583 3.83333 8.17496 3.75 5.89996 6C3.62496 8.25833 3.62496 11.9 5.89996 14.1583C8.17496 16.4167 11.8583 16.4167 14.1333 14.1583C15.2666 13.0417 15.8333 11.7333 15.8333 10.0833H17.5C17.5 11.7333 16.7666 13.875 15.3 15.325C12.375 18.225 7.62496 18.225 4.69996 15.325C1.7833 12.4333 1.7583 7.73333 4.6833 4.84167C7.6083 1.95 12.3 1.95 15.225 4.84167L17.5 2.5V8.43333ZM10.4166 6.66667V10.2083L13.3333 11.9417L12.7333 12.95L9.16663 10.8333V6.66667H10.4166Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath>
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  />
);

export const RemoveMinusFilledIcon = ({ color = COLORS["gray-800"], size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M9.99996 1.66667C5.39996 1.66667 1.66663 5.40001 1.66663 10C1.66663 14.6 5.39996 18.3333 9.99996 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.40001 14.6 1.66667 9.99996 1.66667ZM14.1666 10.8333H5.83329V9.16667H14.1666V10.8333Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath>
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  />
);

export const ScoreIcon = ({ size = "40", ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="4" fill="#F5F5F5" />
        <g clipPath="url(#clip0_2563_16202)">
          <path
            d="M6.75 20C6.75 12.6822 12.6822 6.75 20 6.75C27.3178 6.75 33.25 12.6822 33.25 20C33.25 27.3178 27.3178 33.25 20 33.25C12.6822 33.25 6.75 27.3178 6.75 20Z"
            stroke="#E5453D"
            strokeWidth="1.5"
          />
          <path
            opacity="0.87"
            d="M24.4327 23.0288V23.3395L24.6524 23.5592L25.7951 24.7019H14.878L16.0207 23.5592L16.2404 23.3395V23.0288V18.9904C16.2404 16.7642 17.3952 15.0664 19.2979 14.6156L19.875 14.4788V13.8858V13.3365C19.875 13.0804 20.0804 12.875 20.3365 12.875C20.5927 12.875 20.7981 13.0804 20.7981 13.3365V13.8858V14.4784L21.3746 14.6154C23.2703 15.0661 24.4327 16.773 24.4327 18.9904V23.0288ZM20.7655 27.0096C20.6387 27.0829 20.4921 27.125 20.3365 27.125C20.1787 27.125 20.0312 27.083 19.9041 27.0096H20.7655Z"
            fill="white"
            stroke="#E5453D"
            strokeWidth="1.5"
          />
        </g>
        <defs>
          <clipPath id="clip0_2563_16202">
            <rect width="28" height="28" fill="white" transform="translate(6 6)" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  />
);

export const RadarScanningIcon = ({ color = COLORS["gray-800"], size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 18C8.90267 18 7.868 17.7917 6.896 17.375C5.924 16.9583 5.07333 16.3853 4.344 15.656C3.61467 14.9267 3.04167 14.076 2.625 13.104C2.20833 12.132 2 11.0973 2 10C2 8.88867 2.20833 7.85033 2.625 6.885C3.04167 5.92033 3.61467 5.07333 4.344 4.344C5.07333 3.61467 5.924 3.04167 6.896 2.625C7.868 2.20833 8.90267 2 10 2C11.1113 2 12.1497 2.20833 13.115 2.625C14.0797 3.04167 14.9267 3.61467 15.656 4.344C16.3853 5.07333 16.9583 5.92033 17.375 6.885C17.7917 7.85033 18 8.88867 18 10C18 11.0973 17.7917 12.132 17.375 13.104C16.9583 14.076 16.3853 14.9267 15.656 15.656C14.9267 16.3853 14.0797 16.9583 13.115 17.375C12.1497 17.7917 11.1113 18 10 18ZM10 16.5C10.764 16.5 11.4863 16.375 12.167 16.125C12.8477 15.875 13.4657 15.5277 14.021 15.083L12.958 14C12.5413 14.3193 12.083 14.566 11.583 14.74C11.083 14.9133 10.5553 15 10 15C8.61133 15 7.43067 14.514 6.458 13.542C5.486 12.5693 5 11.3887 5 10C5 8.61133 5.486 7.43067 6.458 6.458C7.43067 5.486 8.61133 5 10 5C11.3887 5 12.5693 5.486 13.542 6.458C14.514 7.43067 15 8.61133 15 10C15 10.5553 14.9133 11.083 14.74 11.583C14.566 12.083 14.3193 12.5413 14 12.958L15.083 14.021C15.5277 13.4657 15.875 12.8477 16.125 12.167C16.375 11.4863 16.5 10.764 16.5 10C16.5 8.19467 15.868 6.66 14.604 5.396C13.34 4.132 11.8053 3.5 10 3.5C8.19467 3.5 6.66 4.132 5.396 5.396C4.132 6.66 3.5 8.19467 3.5 10C3.5 11.8053 4.132 13.34 5.396 14.604C6.66 15.868 8.19467 16.5 10 16.5ZM10 13.5C10.3473 13.5 10.6773 13.4513 10.99 13.354C11.302 13.2567 11.597 13.118 11.875 12.938L10.375 11.438C10.3197 11.4653 10.2607 11.4827 10.198 11.49C10.1353 11.4967 10.0693 11.5 10 11.5C9.58333 11.5 9.22933 11.354 8.938 11.062C8.646 10.7707 8.5 10.4167 8.5 10C8.5 9.58333 8.646 9.22933 8.938 8.938C9.22933 8.646 9.58333 8.5 10 8.5C10.4167 8.5 10.7707 8.646 11.062 8.938C11.354 9.22933 11.5 9.58333 11.5 10C11.5 10.0693 11.493 10.132 11.479 10.188C11.465 10.2433 11.4513 10.3057 11.438 10.375L12.938 11.875C13.118 11.597 13.2567 11.302 13.354 10.99C13.4513 10.6773 13.5 10.3473 13.5 10C13.5 9.028 13.1597 8.20167 12.479 7.521C11.7983 6.84033 10.972 6.5 10 6.5C9.028 6.5 8.20167 6.84033 7.521 7.521C6.84033 8.20167 6.5 9.028 6.5 10C6.5 10.972 6.84033 11.7983 7.521 12.479C8.20167 13.1597 9.028 13.5 10 13.5Z"
          fill={color}
        />
      </svg>
    )}
    {...props}
  />
);

export const ThumbsUpIcon = ({ size = 24, color, opacity = 1 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color || "currentColor"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 20.9803V7.98034L13 2.03034C13.25 1.78034 13.5457 1.63434 13.887 1.59234C14.229 1.551 14.5583 1.61367 14.875 1.78034C15.1917 1.947 15.425 2.18034 15.575 2.48034C15.725 2.78034 15.7583 3.08867 15.675 3.40534L14.55 7.98034H21C21.5333 7.98034 22 8.18034 22.4 8.58034C22.8 8.98034 23 9.447 23 9.98034V11.9803C23 12.097 22.9833 12.222 22.95 12.3553C22.9167 12.4887 22.8833 12.6137 22.85 12.7303L19.85 19.7803C19.7 20.1137 19.45 20.397 19.1 20.6303C18.75 20.8637 18.3833 20.9803 18 20.9803H7ZM9 8.83034V18.9803H18L21 11.9803V9.98034H12L13.35 4.48034L9 8.83034ZM4 20.9803C3.45 20.9803 2.97933 20.7847 2.588 20.3933C2.196 20.0013 2 19.5303 2 18.9803V9.98034C2 9.43034 2.196 8.95934 2.588 8.56734C2.97933 8.176 3.45 7.98034 4 7.98034H7V9.98034H4V18.9803H7V20.9803H4ZM9 18.9803V8.83034V18.9803Z"
          fill={color}
          fillOpacity={opacity}
        />
      </svg>
    )}
  />
);

export const ThumbsDownIcon = ({ size = 24, color, opacity = 1 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color || "currentColor"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 16C2.46667 16 2 15.8 1.6 15.4C1.2 15 1 14.5333 1 14V12C1 11.8833 1.01667 11.7583 1.05 11.625C1.08333 11.4917 1.11667 11.3667 1.15 11.25L4.15 4.2C4.3 3.86667 4.55 3.58333 4.9 3.35C5.25 3.11667 5.61667 3 6 3H17V16L11 21.95C10.75 22.2 10.4543 22.3457 10.113 22.387C9.771 22.429 9.44167 22.3667 9.125 22.2C8.80833 22.0333 8.575 21.8 8.425 21.5C8.275 21.2 8.24167 20.8917 8.325 20.575L9.45 16H3ZM15 15.15V5H6L3 12V14H12L10.65 19.5L15 15.15ZM20 3C20.55 3 21.021 3.19567 21.413 3.587C21.8043 3.979 22 4.45 22 5V14C22 14.55 21.8043 15.0207 21.413 15.412C21.021 15.804 20.55 16 20 16H17V14H20V5H17V3H20ZM15 5V15.15V5Z"
          fill={color}
          fillOpacity={opacity}
        />
      </svg>
    )}
  />
);

export const BlackThumbsUpIcon = ({ size = 24, color }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color || "currentColor"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 20.9973C9.45 20.9973 8.97933 20.8017 8.588 20.4103C8.196 20.0183 8 19.5473 8 18.9973V8.82232C8 8.55566 8.05433 8.30133 8.163 8.05933C8.271 7.81799 8.41667 7.60566 8.6 7.42233L14.025 2.02232C14.275 1.78899 14.571 1.64732 14.913 1.59732C15.2543 1.54732 15.5833 1.60566 15.9 1.77232C16.2167 1.93899 16.4457 2.17232 16.587 2.47232C16.729 2.77232 16.7583 3.08066 16.675 3.39732L15.55 7.99732H21C21.5333 7.99732 22 8.19733 22.4 8.59733C22.8 8.99733 23 9.46399 23 9.99732V11.9973C23 12.114 22.9873 12.239 22.962 12.3723C22.9373 12.5057 22.9 12.6307 22.85 12.7473L19.85 19.7973C19.7 20.1307 19.45 20.414 19.1 20.6473C18.75 20.8807 18.3833 20.9973 18 20.9973H10ZM4 20.9973C3.45 20.9973 2.97933 20.8017 2.588 20.4103C2.196 20.0183 2 19.5473 2 18.9973V9.99732C2 9.44732 2.196 8.97633 2.588 8.58432C2.97933 8.19299 3.45 7.99732 4 7.99732C4.55 7.99732 5.02067 8.19299 5.412 8.58432C5.804 8.97633 6 9.44732 6 9.99732V18.9973C6 19.5473 5.804 20.0183 5.412 20.4103C5.02067 20.8017 4.55 20.9973 4 20.9973Z"
          fill={color}
        />
      </svg>
    )}
  />
);

export const BlackThumbsDownIcon = ({ size = 24, color }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color || "currentColor"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 16C2.46667 16 2 15.8 1.6 15.4C1.2 15 1 14.5333 1 14V12C1 11.8833 1.01267 11.7583 1.038 11.625C1.06267 11.4917 1.1 11.3667 1.15 11.25L4.15 4.2C4.3 3.86667 4.55 3.58333 4.9 3.35C5.25 3.11667 5.61667 3 6 3H14C14.55 3 15.021 3.19567 15.413 3.587C15.8043 3.979 16 4.45 16 5V15.175C16 15.4417 15.946 15.696 15.838 15.938C15.7293 16.1793 15.5833 16.3917 15.4 16.575L9.975 21.975C9.725 22.2083 9.42933 22.35 9.088 22.4C8.746 22.45 8.41667 22.3917 8.1 22.225C7.78333 22.0583 7.554 21.825 7.412 21.525C7.27067 21.225 7.24167 20.9167 7.325 20.6L8.45 16H3ZM20 3C20.55 3 21.021 3.19567 21.413 3.587C21.8043 3.979 22 4.45 22 5V14C22 14.55 21.8043 15.0207 21.413 15.412C21.021 15.804 20.55 16 20 16C19.45 16 18.979 15.804 18.587 15.412C18.1957 15.0207 18 14.55 18 14V5C18 4.45 18.1957 3.979 18.587 3.587C18.979 3.19567 19.45 3 20 3Z"
          fill={color}
        />
      </svg>
    )}
  />
);

export const AlertConfigIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 14V15.5H16V14H15V11H13.5V14H6.5V9C6.514 8.028 6.86133 7.20167 7.542 6.521C8.222 5.84033 9.04133 5.5 10 5.5C10.278 5.5 10.5523 5.53467 10.823 5.604C11.0937 5.67333 11.354 5.77067 11.604 5.896L12.708 4.792C12.472 4.59733 12.2047 4.45133 11.906 4.354C11.6073 4.25667 11.3053 4.17333 11 4.104V3C11 2.722 10.9027 2.486 10.708 2.292C10.514 2.09733 10.278 2 10 2C9.722 2 9.486 2.09733 9.292 2.292C9.09733 2.486 9 2.722 9 3V4.104C7.83333 4.34 6.875 4.91633 6.125 5.833C5.375 6.74967 5 7.80533 5 9V14H4Z"
          fill={color || "currentColor"}
        />
        <path
          d="M8.938 17.562C9.22933 17.854 9.58333 18 10 18C10.4167 18 10.7707 17.854 11.062 17.562C11.354 17.2707 11.5 16.9167 11.5 16.5H8.5C8.5 16.9167 8.646 17.2707 8.938 17.562Z"
          fill={color || "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.084 8.979L15.292 9.875H16.479L16.688 8.979C16.7987 8.92367 16.9063 8.86467 17.011 8.802C17.115 8.73933 17.2017 8.67333 17.271 8.604L18.167 8.917L18.771 7.875L18.042 7.25C18.056 7.18067 18.063 7.125 18.063 7.083V6.781C18.063 6.73233 18.056 6.68033 18.042 6.625L18.771 6L18.167 4.958L17.271 5.271C17.2017 5.20167 17.115 5.13233 17.011 5.063C16.9063 4.993 16.7987 4.93733 16.688 4.896L16.479 4H15.313L15.104 4.896C14.9933 4.93733 14.8857 4.993 14.781 5.063C14.677 5.13233 14.5903 5.20167 14.521 5.271L13.625 4.958L13.021 6L13.75 6.625C13.736 6.68033 13.729 6.73233 13.729 6.781V6.938C13.729 6.99333 13.7257 7.04167 13.719 7.083C13.7117 7.125 13.715 7.18067 13.729 7.25L13 7.875L13.604 8.917L14.5 8.604C14.5693 8.67333 14.6563 8.73933 14.761 8.802C14.865 8.86467 14.9727 8.92367 15.084 8.979ZM16.636 7.677C16.4347 7.87833 16.188 7.979 15.896 7.979C15.604 7.979 15.3573 7.87833 15.156 7.677C14.9547 7.47567 14.854 7.22933 14.854 6.938C14.854 6.646 14.9547 6.39933 15.156 6.198C15.3573 5.99667 15.604 5.896 15.896 5.896C16.188 5.896 16.4347 5.99667 16.636 6.198C16.8373 6.39933 16.938 6.646 16.938 6.938C16.938 7.22933 16.8373 7.47567 16.636 7.677Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    {...props}
  />
);

export const LinkIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 8H4C2.88867 8 1.94433 7.611 1.167 6.833C0.389 6.05567 0 5.11133 0 4C0 2.88867 0.389 1.94433 1.167 1.167C1.94433 0.389 2.88867 0 4 0H7V1.5H4C3.30533 1.5 2.715 1.743 2.229 2.229C1.743 2.715 1.5 3.30533 1.5 4C1.5 4.69467 1.743 5.285 2.229 5.771C2.715 6.257 3.30533 6.5 4 6.5H7V8ZM5 4.75V3.25H11V4.75H5ZM9 8V6.5H12C12.6947 6.5 13.285 6.257 13.771 5.771C14.257 5.285 14.5 4.69467 14.5 4C14.5 3.30533 14.257 2.715 13.771 2.229C13.285 1.743 12.6947 1.5 12 1.5H9V0H12C13.1113 0 14.0557 0.389 14.833 1.167C15.611 1.94433 16 2.88867 16 4C16 5.11133 15.611 6.05567 14.833 6.833C14.0557 7.611 13.1113 8 12 8H9Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    {...props}
  />
);

export const HashTagIcon = ({ size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 16L6.125 13.5H3L3.375 12H6.5L7.375 8.5H4L4.375 7H7.75L8.5 4H10L9.25 7H12.25L13 4H14.5L13.75 7H17L16.625 8.5H13.375L12.5 12H16L15.625 13.5H12.125L11.5 16H10L10.625 13.5H7.625L7 16H5.5ZM8 12H11L11.875 8.5H8.875L8 12Z"
          fill={COLORS["gray-800"]}
        />
      </svg>
    )}
    {...props}
  />
);

export const ScheduleIcon = ({ size = 12 }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 15.75L9.062 13.688L7 12.75L9.062 11.812L10 9.75L10.938 11.812L13 12.75L10.938 13.688L10 15.75ZM4.5 18C4.08333 18 3.72933 17.8507 3.438 17.552C3.146 17.2533 3 16.9027 3 16.5V5.5C3 5.09733 3.146 4.74667 3.438 4.448C3.72933 4.14933 4.08333 4 4.5 4H6V2H7.5V4H12.5V2H14V4H15.5C15.9167 4 16.2707 4.14933 16.562 4.448C16.854 4.74667 17 5.09733 17 5.5V16.5C17 16.9027 16.854 17.2533 16.562 17.552C16.2707 17.8507 15.9167 18 15.5 18H4.5ZM4.5 16.5H15.5V9H4.5V16.5ZM4.5 7.5H15.5V5.5H4.5V7.5ZM4.5 7.5V5.5V7.5Z"
          fill={COLORS["gray-800"]}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const CollectionWatchlistIcon = ({ color, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4768_7225)">
          <path
            d="M14.09 12.9993L11 11.2325L7.91 12.9993L8.73 9.66933L6 7.4288L9.595 7.13985L11 3.99933L12.405 7.13985L16 7.4288L13.27 9.66933L14.09 12.9993Z"
            fill={color || "currentColor"}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.54169 15.4577C4.79169 15.7077 5.08335 15.8327 5.41669 15.8327H17.0834C17.4167 15.8327 17.7084 15.7077 17.9584 15.4577C18.2084 15.2077 18.3334 14.916 18.3334 14.5827V2.91602C18.3334 2.58268 18.2084 2.29102 17.9584 2.04102C17.7084 1.79102 17.4167 1.66602 17.0834 1.66602H5.41669C5.08335 1.66602 4.79169 1.79102 4.54169 2.04102C4.29169 2.29102 4.16669 2.58268 4.16669 2.91602V14.5827C4.16669 14.916 4.29169 15.2077 4.54169 15.4577ZM17.0834 14.5827H5.41669V2.91602H17.0834V14.5827Z"
            fill={color || "currentColor"}
          />
          <path
            d="M2.04169 17.9577C2.29169 18.2077 2.58335 18.3327 2.91669 18.3327H15.8334V17.0827H2.91669V4.16602H1.66669V17.0827C1.66669 17.416 1.79169 17.7077 2.04169 17.9577Z"
            fill={color || "currentColor"}
          />
        </g>
        <defs>
          <clipPath id="clip0_4768_7225">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ArchivedIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 17C4.08333 17 3.72933 16.854 3.438 16.562C3.146 16.2707 3 15.9167 3 15.5V5.625C3 5.43033 3.03833 5.23933 3.115 5.052C3.191 4.86467 3.29867 4.70133 3.438 4.562L4.562 3.438C4.70133 3.29867 4.86467 3.191 5.052 3.115C5.23933 3.03833 5.43033 3 5.625 3H14.375C14.5697 3 14.7607 3.03833 14.948 3.115C15.1353 3.191 15.2987 3.29867 15.438 3.438L16.562 4.562C16.7013 4.70133 16.809 4.86467 16.885 5.052C16.9617 5.23933 17 5.43033 17 5.625V15.5C17 15.9167 16.854 16.2707 16.562 16.562C16.2707 16.854 15.9167 17 15.5 17H4.5ZM4.625 5.5H15.375L14.375 4.5H5.625L4.625 5.5ZM4.5 7V15.5H15.5V7H4.5Z"
          fill={color || "currentColor"}
        />
        <path
          d="M13.9 13.5H10.4H6.4V12H9.4H10.4H11.4H12.4H13.9V13.5Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const CaseIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 5V3.5C6 3.08333 6.146 2.72933 6.438 2.438C6.72933 2.146 7.08333 2 7.5 2H12.5C12.9167 2 13.2707 2.146 13.562 2.438C13.854 2.72933 14 3.08333 14 3.5V5H16.5C16.9167 5 17.2707 5.146 17.562 5.438C17.854 5.72933 18 6.08333 18 6.5V10.75H12.5V9H7.5V10.75H2V6.5C2 6.08333 2.146 5.72933 2.438 5.438C2.72933 5.146 3.08333 5 3.5 5H6ZM7.5 5H12.5V3.5H7.5V5ZM9 12.5V10.5H11V12.5H9ZM2 12.25H7.5V14H12.5V12.25H18V15.5C18 15.9167 17.854 16.2707 17.562 16.562C17.2707 16.854 16.9167 17 16.5 17H3.5C3.08333 17 2.72933 16.854 2.438 16.562C2.146 16.2707 2 15.9167 2 15.5V12.25Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

/** Case icon with a lock */
export const PrivateCaseIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 17 17"
        fill={color || "currentColor"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 3V1.5C4 1.08333 4.146 0.729333 4.438 0.438C4.72933 0.146 5.08333 0 5.5 0H10.5C10.9167 0 11.2707 0.146 11.562 0.438C11.854 0.729333 12 1.08333 12 1.5V3H14.5C14.9167 3 15.2707 3.146 15.562 3.438C15.854 3.72933 16 4.08333 16 4.5V7.80269C15.1175 7.29218 14.0929 7 13 7C12.1078 7 11.2611 7.19474 10.5 7.54404V7H5.5V8.75H0V4.5C0 4.08333 0.146 3.72933 0.438 3.438C0.729333 3.146 1.08333 3 1.5 3H4ZM5.5 3H10.5V1.5H5.5V3Z"
          fill={color || "currentColor"}
        />
        <path
          d="M7 13C7 12.6593 7.0284 12.3252 7.08296 12H5.5V10.25H0V13.5C0 13.9167 0.146 14.2707 0.438 14.562C0.729333 14.854 1.08333 15 1.5 15H7.34141C7.12031 14.3744 7 13.7013 7 13Z"
          fill={color || "currentColor"}
        />
        <path
          d="M7.54404 10.5C7.89043 9.74528 8.38882 9.07481 9 8.52779V8.5H7V10.5H7.54404Z"
          fill={color || "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1769 16.8231C10.2949 16.941 10.441 17 10.6154 17H15.5385C15.7128 17 15.859 16.941 15.9769 16.8231C16.0949 16.7051 16.1538 16.559 16.1538 16.3846V12.6923C16.1538 12.5179 16.0949 12.3718 15.9769 12.2538C15.859 12.1359 15.7128 12.0769 15.5385 12.0769H14.9231V10.8462C14.9231 10.3504 14.7436 9.9188 14.3846 9.55128C14.0256 9.18376 13.5916 9 13.0824 9C12.5732 9 12.1373 9.18376 11.7747 9.55128C11.4121 9.9188 11.2308 10.3504 11.2308 10.8462V12.0769H10.6154C10.441 12.0769 10.2949 12.1359 10.1769 12.2538C10.059 12.3718 10 12.5179 10 12.6923V16.3846C10 16.559 10.059 16.7051 10.1769 16.8231ZM12.1538 12.0769H14V10.8462C14 10.5846 13.9121 10.3654 13.7362 10.1885C13.5603 10.0115 13.3423 9.92308 13.0823 9.92308C12.8223 9.92308 12.6026 10.0115 12.4231 10.1885C12.2436 10.3654 12.1538 10.5846 12.1538 10.8462V12.0769Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const CasesIcon = ({ size = 20, color = null }) => (
  <Icon
    aria-label="Trasaction Tracing Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 23 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.24995 20.7999C1.74995 20.7999 1.32515 20.6247 0.975551 20.2743C0.625151 19.9247 0.449951 19.4999 0.449951 18.9999V7.5999H2.24995V18.9999H18.4499V20.7999H2.24995ZM5.84995 17.1999C5.34995 17.1999 4.92515 17.0247 4.57555 16.6743C4.22515 16.3247 4.04995 15.8999 4.04995 15.3999V3.9999H8.84995V2.1999C8.84995 1.6999 9.02515 1.2751 9.37555 0.925502C9.72515 0.575102 10.15 0.399902 10.65 0.399902H15.45C15.95 0.399902 16.3748 0.575102 16.7243 0.925502C17.0748 1.2751 17.25 1.6999 17.25 2.1999V3.9999H22.0499V15.3999C22.0499 15.8999 21.8748 16.3247 21.5244 16.6743C21.1747 17.0247 20.75 17.1999 20.25 17.1999H5.84995ZM10.65 3.9999H15.45V2.1999H10.65V3.9999Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const CasesDoubleIcon = ({ size = 20, color = null }) => (
  <Icon
    aria-label="Cases icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.00002 45.5998C5.00002 45.5998 4.15042 45.2494 3.45122 44.5486C2.75042 43.8494 2.40002 42.9998 2.40002 41.9998V19.1998H6.00002V41.9998H38.4V45.5998H6.00002ZM13.2 38.3998C12.2 38.3998 11.3504 38.0494 10.6512 37.3486C9.95042 36.6494 9.60002 35.7998 9.60002 34.7998V11.9998H19.2V8.3998C19.2 7.3998 19.5504 6.5502 20.2512 5.851C20.9504 5.1502 21.8 4.7998 22.8 4.7998H32.4C33.4 4.7998 34.2496 5.1502 34.9488 5.851C35.6496 6.5502 36 7.3998 36 8.3998V11.9998H45.6V34.7998C45.6 35.7998 45.2496 36.6494 44.5488 37.3486C43.8496 38.0494 43 38.3998 42 38.3998H13.2ZM22.8 11.9998H32.4V8.3998H22.8V11.9998Z"
          fill={color || "white"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const ListIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5368_9662)">
          <path
            d="M15.3333 14.1673H17V14.584H16.1667V15.4173H17V15.834H15.3333V16.6673H17.8333V13.334H15.3333V14.1673ZM16.1667 6.66732H17V3.33398H15.3333V4.16732H16.1667V6.66732ZM15.3333 9.16732H16.8333L15.3333 10.9173V11.6673H17.8333V10.834H16.3333L17.8333 9.08398V8.33398H15.3333V9.16732ZM2 4.16732H13.6667V5.83398H2V4.16732ZM2 14.1673H13.6667V15.834H2V14.1673ZM2 9.16732H13.6667V10.834H2V9.16732Z"
            fill={color || "currentColor"}
          />
        </g>
        <defs>
          <clipPath id="clip0_5368_9662">
            <rect width="20" height="20" fill="white" transform="translate(0.333374)" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const AddressListIcon = ({ size = 16, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size || 16}
        height={size || 16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6667 9C10.9556 9 11.1944 8.90556 11.3833 8.71667C11.5722 8.52778 11.6667 8.28889 11.6667 8C11.6667 7.71111 11.5722 7.47222 11.3833 7.28333C11.1944 7.09444 10.9556 7 10.6667 7C10.3778 7 10.1389 7.09444 9.95 7.28333C9.76111 7.47222 9.66667 7.71111 9.66667 8C9.66667 8.28889 9.76111 8.52778 9.95 8.71667C10.1389 8.90556 10.3778 9 10.6667 9ZM3.33333 12.6667V3.33333V12.6667ZM3.33333 14C2.96667 14 2.65267 13.8696 2.39133 13.6087C2.13044 13.3473 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13044 2.65267 2.39133 2.39133C2.65267 2.13044 2.96667 2 3.33333 2H12.6667C13.0333 2 13.3473 2.13044 13.6087 2.39133C13.8696 2.65267 14 2.96667 14 3.33333V5H12.6667V3.33333H3.33333V12.6667H12.6667V11H14V12.6667C14 13.0333 13.8696 13.3473 13.6087 13.6087C13.3473 13.8696 13.0333 14 12.6667 14H3.33333ZM8.66667 11.3333C8.3 11.3333 7.98622 11.2029 7.72533 10.942C7.464 10.6807 7.33333 10.3667 7.33333 10V6C7.33333 5.63333 7.464 5.31933 7.72533 5.058C7.98622 4.79711 8.3 4.66667 8.66667 4.66667H13.3333C13.7 4.66667 14.014 4.79711 14.2753 5.058C14.5362 5.31933 14.6667 5.63333 14.6667 6V10C14.6667 10.3667 14.5362 10.6807 14.2753 10.942C14.014 11.2029 13.7 11.3333 13.3333 11.3333H8.66667ZM13.3333 10V6H8.66667V10H13.3333Z"
          fill={color}
        />
      </svg>
    )}
    width={size || 16}
    height={size || 16}
  />
);

export const BookmarksIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size || 20}
        height={size || 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_238_17739)">
          <path
            d="M14.0901 13.0001L11.0001 11.2332L7.91006 13.0001L8.73006 9.67006L6.00006 7.42953L9.59506 7.14059L11.0001 4.00006L12.4051 7.14059L16.0001 7.42953L13.2701 9.67006L14.0901 13.0001Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.54175 15.4584C4.79175 15.7084 5.08341 15.8334 5.41675 15.8334H17.0834C17.4167 15.8334 17.7084 15.7084 17.9584 15.4584C18.2084 15.2084 18.3334 14.9167 18.3334 14.5834V2.91675C18.3334 2.58341 18.2084 2.29175 17.9584 2.04175C17.7084 1.79175 17.4167 1.66675 17.0834 1.66675H5.41675C5.08341 1.66675 4.79175 1.79175 4.54175 2.04175C4.29175 2.29175 4.16675 2.58341 4.16675 2.91675V14.5834C4.16675 14.9167 4.29175 15.2084 4.54175 15.4584ZM17.0834 14.5834H5.41675V2.91675H17.0834V14.5834Z"
            fill={color}
          />
          <path
            d="M2.04175 17.9584C2.29175 18.2084 2.58341 18.3334 2.91675 18.3334H15.8334V17.0834H2.91675V4.16675H1.66675V17.0834C1.66675 17.4167 1.79175 17.7084 2.04175 17.9584Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_238_17739">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size || 20}
    height={size || 20}
  />
);

export const NoteIcon = ({ size = 20 }) => (
  <Icon
    component={() => (
      <svg
        width={size || 20}
        height={size || 20}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.5 12.5H12.5V5.125L8.875 1.5H1.5V12.5ZM1.5 14C1.08333 14 0.729333 13.854 0.438 13.562C0.146 13.2707 0 12.9167 0 12.5V1.5C0 1.08333 0.146 0.729333 0.438 0.438C0.729333 0.146 1.08333 0 1.5 0H9.5L14 4.5V12.5C14 12.9167 13.854 13.2707 13.562 13.562C13.2707 13.854 12.9167 14 12.5 14H1.5ZM3 11H11V9.5H3V11ZM3 8H11V6.5H3V8ZM3 5H9V3.5H3V5ZM1.5 12.5V1.5V12.5Z"
          fill={COLORS["gray-800"]}
        />
      </svg>
    )}
    width={size || 20}
    height={size || 20}
  />
);

export const WalletIcon = ({ size = 20, color = COLORS["gray-800"], ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size || 20}
        height={size || 20}
        viewBox="0 0 14 12"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.00016 11.3337C2.26683 11.3337 1.63905 11.0725 1.11683 10.5503C0.594607 10.0281 0.333496 9.40032 0.333496 8.66699V3.33366C0.333496 2.60033 0.594607 1.97255 1.11683 1.45033C1.63905 0.928103 2.26683 0.666992 3.00016 0.666992H11.0002C11.7335 0.666992 12.3613 0.928103 12.8835 1.45033C13.4057 1.97255 13.6668 2.60033 13.6668 3.33366V8.66699C13.6668 9.40032 13.4057 10.0281 12.8835 10.5503C12.3613 11.0725 11.7335 11.3337 11.0002 11.3337H3.00016ZM3.00016 3.33366H11.0002C11.2446 3.33366 11.4779 3.36144 11.7002 3.41699C11.9224 3.47255 12.1335 3.56144 12.3335 3.68366V3.33366C12.3335 2.96699 12.2031 2.65321 11.9422 2.39233C11.6808 2.13099 11.3668 2.00033 11.0002 2.00033H3.00016C2.6335 2.00033 2.31972 2.13099 2.05883 2.39233C1.7975 2.65321 1.66683 2.96699 1.66683 3.33366V3.68366C1.86683 3.56144 2.07794 3.47255 2.30016 3.41699C2.52238 3.36144 2.75572 3.33366 3.00016 3.33366ZM1.76683 5.50033L9.1835 7.30032C9.2835 7.32255 9.3835 7.32255 9.4835 7.30032C9.5835 7.2781 9.67794 7.23366 9.76683 7.16699L12.0835 5.23366C11.9613 5.06699 11.8057 4.93099 11.6168 4.82566C11.4279 4.71988 11.2224 4.66699 11.0002 4.66699H3.00016C2.71127 4.66699 2.45861 4.74188 2.24216 4.89166C2.02527 5.04188 1.86683 5.24477 1.76683 5.50033Z"
          fill={color}
        />
      </svg>
    )}
    width={size || 20}
    height={size || 20}
    {...props}
  />
);
export const ContractIcon = ({ size = 20, color = COLORS["gray-800"], ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3999 12.4H3.5999V3.60002H9.4999L12.3999 6.50002V12.4ZM2.7503 13.2496C2.98337 13.4832 3.26657 13.6 3.5999 13.6H12.3999C12.7332 13.6 13.0164 13.4832 13.2495 13.2496C13.4831 13.0166 13.5999 12.7334 13.5999 12.4V6.00002L9.9999 2.40002H3.5999C3.26657 2.40002 2.98337 2.51682 2.7503 2.75042C2.5167 2.98349 2.3999 3.26669 2.3999 3.60002V12.4C2.3999 12.7334 2.5167 13.0166 2.7503 13.2496ZM5.9999 11.2H4.7999V10H5.9999V11.2ZM7.1999 11.2H11.1999V10H7.1999V11.2ZM7.1999 8.80002H11.1999V7.60002H7.1999V8.80002ZM5.9999 8.80002H4.7999V7.60002H5.9999V8.80002ZM5.9999 6.40002H4.7999V5.20002H5.9999V6.40002ZM7.1999 6.40002H9.5999V5.20002H7.1999V6.40002Z"
          fill={color}
        />
      </svg>
    )}
    width={size || 20}
    height={size || 20}
    {...props}
  />
);

export const AddAlertIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill={color || "currentColor"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.01"
            d="M20 0H0V20H20V0Z"
            fill={color || "currentColor"}
            fillOpacity="0.01"
          />
          <path
            d="M8.34167 17.2583C8.34167 18.175 9.08333 18.9167 10 18.9167C10.9167 18.9167 11.6583 18.175 11.6583 17.2583H8.34167ZM10 4.75001C12.3 4.75001 14.1667 6.61667 14.1667 8.91667V14.75H5.83333V8.91667C5.83333 6.61667 7.7 4.75001 10 4.75001ZM10 1.00001C9.30833 1.00001 8.75 1.55834 8.75 2.25001V3.22501C6.13333 3.79167 4.16667 6.12501 4.16667 8.91667V13.9167L2.5 15.5833V16.4167H17.5V15.5833L15.8333 13.9167V8.91667C15.8333 6.12501 13.8667 3.79167 11.25 3.22501V2.25001C11.25 1.55834 10.6917 1.00001 10 1.00001ZM9.16667 7.41667H10.8333V12.7485H9.16667V7.41667ZM7.27447 9.25001H12.5V10.9167L7.27447 10.9167V9.25001Z"
            fill={color || "currentColor"}
          />
        </g>
        <defs>
          <clipPath>
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  />
);

export const AddTxnFlowIcon = ({ size = 20, color = COLORS["gray-800"], ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.99997 5H2.5V3H6.5V4.79294L8.20706 6.5H11.9384L13.5 6.10961V4.5H17.5V6.5H14L12 7V8.26151L13.8462 9H17.5V11H13.5V9.40002L11.2499 8.5H8.526L6.5 10.6373V12H2.5V10H6.41516L8 8.3281V7.75001H6.5V8.5H2.5V6.5H6.5V7.25001H8V6.99997L5.99997 5Z"
          fill={color}
        />
        <path d="M14.5 17V15.5H13V14H14.5V12.5H16V14H17.5V15.5H16V17H14.5Z" fill={color} />
      </svg>
    )}
    {...props}
  />
);

export const AddTxnTracingIcon = ({ size = 20, color = "currentColor", ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.99997 5H2.5V3H6.5V4.79294L8.20706 6.5H11.9384L13.5 6.10961V4.5H17.5V6.5H14L12 7V8.26151L13.8462 9H17.5V11H13.5V9.40002L11.2499 8.5H8.526L6.5 10.6373V12H2.5V10H6.41516L8 8.3281V7.75001H6.5V8.5H2.5V6.5H6.5V7.25001H8V6.99997L5.99997 5Z"
          fill={color}
        />
        <path
          d="M14.5 17V15.5H13V14H14.5V12.5H16V14H17.5V15.5H16V17H14.5Z"
          fill={COLORS["gray-800"]}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const AddEvidenceIcon = ({ size = 20, color = "currentColor", ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 17C4.08333 17 3.72933 16.854 3.438 16.562C3.146 16.2707 3 15.9167 3 15.5V4.5C3 4.08333 3.146 3.72933 3.438 3.438C3.72933 3.146 4.08333 3 4.5 3H11V4.5H4.5V15.5H15.5V9H17V15.5C17 15.9167 16.854 16.2707 16.562 16.562C16.2707 16.854 15.9167 17 15.5 17H4.5ZM7 14V12.5H13V14H7ZM7 11.75V10.25H13V11.75H7ZM7 9.5V8H13V9.5H7ZM14 7.5V6H12.5V4.5H14V3H15.5V4.5H17V6H15.5V7.5H14Z"
          fill={color}
        />
      </svg>
    )}
    {...props}
  />
);

export const AddPhotoIcon = ({ size = 20, color = COLORS["gray-800"] }) => (
  <Icon
    component={() => (
      <svg
        width={size || 20}
        height={size || 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.75 6.70848V5.06248H14.104V3.31248H15.75V1.64648H17.5V3.31248H19.167V5.06248H17.5V6.70848H15.75ZM2.58301 18.3335C2.09701 18.3335 1.68401 18.1635 1.34401 17.8235C1.00334 17.4828 0.833008 17.0695 0.833008 16.5835V6.72948C0.833008 6.24348 1.00334 5.83048 1.34401 5.49048C1.68401 5.14982 2.09701 4.97948 2.58301 4.97948H5.10401L6.64601 3.31248H11.521V5.06248H7.41701L5.87501 6.72948H2.58301V16.5835H15.76H15.75V9.29248H17.5V16.5835C17.5 17.0695 17.33 17.4828 16.99 17.8235C16.6493 18.1635 16.236 18.3335 15.75 18.3335H2.58301ZM9.16701 15.4175C10.2223 15.4175 11.1147 15.0528 11.844 14.3235C12.5733 13.5942 12.938 12.7018 12.938 11.6465C12.938 10.5905 12.5733 9.69815 11.844 8.96948C11.1147 8.24015 10.2223 7.87548 9.16701 7.87548C8.09701 7.87548 7.20101 8.24015 6.47901 8.96948C5.75701 9.69815 5.39601 10.5905 5.39601 11.6465C5.39601 12.7018 5.75701 13.5942 6.47901 14.3235C7.20101 15.0528 8.09701 15.4175 9.16701 15.4175ZM9.16701 13.6675C8.58367 13.6675 8.10101 13.4728 7.71901 13.0835C7.33701 12.6948 7.14601 12.2158 7.14601 11.6465C7.14601 11.0772 7.33701 10.5978 7.71901 10.2085C8.10101 9.81982 8.58367 9.62548 9.16701 9.62548C9.73634 9.62548 10.2153 9.81982 10.604 10.2085C10.9933 10.5978 11.188 11.0772 11.188 11.6465C11.188 12.2158 10.9933 12.6948 10.604 13.0835C10.2153 13.4728 9.73634 13.6675 9.16701 13.6675Z"
          fill={color}
        />
      </svg>
    )}
    width={size || 20}
    height={size || 20}
  />
);

export const MoreHIcon = ({ size = 20, color = COLORS["gray-800"], ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size || 20}
        height={size || 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M5.00004 8.33331C4.08337 8.33331 3.33337 9.08331 3.33337 9.99998C3.33337 10.9166 4.08337 11.6666 5.00004 11.6666C5.91671 11.6666 6.66671 10.9166 6.66671 9.99998C6.66671 9.08331 5.91671 8.33331 5.00004 8.33331ZM15 8.33331C14.0834 8.33331 13.3334 9.08331 13.3334 9.99998C13.3334 10.9166 14.0834 11.6666 15 11.6666C15.9167 11.6666 16.6667 10.9166 16.6667 9.99998C16.6667 9.08331 15.9167 8.33331 15 8.33331ZM10 8.33331C9.08337 8.33331 8.33337 9.08331 8.33337 9.99998C8.33337 10.9166 9.08337 11.6666 10 11.6666C10.9167 11.6666 11.6667 10.9166 11.6667 9.99998C11.6667 9.08331 10.9167 8.33331 10 8.33331Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath>
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  />
);

export const AddToMainPathIcon = ({ size = 16 }) => (
  <Icon
    aria-label="AddToMainPathIcon"
    component={() => (
      <svg
        width={size || 20}
        height={size || 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_6329_43241)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.25 9V6.75H13V5.25H15.25V3H16.75V5.25H19V6.75H16.75V9H15.25ZM1 12H5V13H7.5V12H11.5V13H14V12H18V13H19V14H18V15H14V14H11.5V15H7.5V14H5V15H1V12Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_6329_43241">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const BalanceIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <Icon
    aria-label="BalanceIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 13.5C16.4333 13.5 16.7917 13.3583 17.075 13.075C17.3583 12.7917 17.5 12.4333 17.5 12C17.5 11.5667 17.3583 11.2083 17.075 10.925C16.7917 10.6417 16.4333 10.5 16 10.5C15.5667 10.5 15.2083 10.6417 14.925 10.925C14.6417 11.2083 14.5 11.5667 14.5 12C14.5 12.4333 14.6417 12.7917 14.925 13.075C15.2083 13.3583 15.5667 13.5 16 13.5ZM5 19V5V19ZM5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H19C19.55 3 20.021 3.19567 20.413 3.587C20.8043 3.979 21 4.45 21 5V7.5H19V5H5V19H19V16.5H21V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H5ZM13 17C12.45 17 11.9793 16.8043 11.588 16.413C11.196 16.021 11 15.55 11 15V9C11 8.45 11.196 7.979 11.588 7.587C11.9793 7.19567 12.45 7 13 7H20C20.55 7 21.021 7.19567 21.413 7.587C21.8043 7.979 22 8.45 22 9V15C22 15.55 21.8043 16.021 21.413 16.413C21.021 16.8043 20.55 17 20 17H13ZM20 15V9H13V15H20Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const EvidenceIcon = ({ size = 24, color = undefined, ...props }) => (
  <Icon
    aria-label="EvidenceIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.14998 21.5998C5.64998 21.5998 5.22518 21.4246 4.87558 21.0742C4.52518 20.7246 4.34998 20.2998 4.34998 19.7998V6.5998C4.34998 6.0998 4.52518 5.675 4.87558 5.3254C5.22518 4.975 5.64998 4.7998 6.14998 4.7998H10.95V6.5998H6.14998V19.7998H19.35V14.0254L21.15 15.8254V19.7998C21.15 20.2998 20.9748 20.7246 20.6244 21.0742C20.2748 21.4246 19.85 21.5998 19.35 21.5998H6.14998ZM7.34998 17.9998V16.1998H12.75H18.15V17.9998H7.34998Z"
          fill={color || "currentColor"}
        />
        <path d="M7.34998 12.5998V14.3998H12.75V12.5998H7.34998Z" fill={color || "currentColor"} />
        <path
          d="M17.55 10.7996L18.678 8.31561L21.15 7.19961L18.678 6.08361L17.55 3.59961L16.446 6.08361L13.95 7.19961L16.446 8.31561L17.55 10.7996Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const Evidence2Icon = ({ size = 24, color, ...props }) => (
  <Icon
    aria-label="EvidenceIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill={color || "currentColor"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 18C4.08333 18 3.72933 17.854 3.438 17.562C3.146 17.2707 3 16.9167 3 16.5V5.5C3 5.08333 3.146 4.72933 3.438 4.438C3.72933 4.146 4.08333 4 4.5 4H8.5V5.5H4.5V16.5H15.5V11.688L17 13.188V16.5C17 16.9167 16.854 17.2707 16.562 17.562C16.2707 17.854 15.9167 18 15.5 18H4.5ZM5.5 15V13.5H10H14.5V15H5.5ZM17.938 12L15.375 9.438C15.097 9.618 14.802 9.75667 14.49 9.854C14.1773 9.95133 13.8473 10 13.5 10C12.528 10 11.7017 9.65967 11.021 8.979C10.3403 8.29833 10 7.472 10 6.5C10 5.528 10.3403 4.70167 11.021 4.021C11.7017 3.34033 12.528 3 13.5 3C14.472 3 15.2983 3.34033 15.979 4.021C16.6597 4.70167 17 5.528 17 6.5C17 6.84733 16.9513 7.17733 16.854 7.49C16.7567 7.802 16.618 8.097 16.438 8.375L19 10.938L17.938 12ZM13.5 8.5C14.0553 8.5 14.5277 8.30567 14.917 7.917C15.3057 7.52767 15.5 7.05533 15.5 6.5C15.5 5.94467 15.3057 5.47233 14.917 5.083C14.5277 4.69433 14.0553 4.5 13.5 4.5C12.9447 4.5 12.4723 4.69433 12.083 5.083C11.6943 5.47233 11.5 5.94467 11.5 6.5C11.5 7.05533 11.6943 7.52767 12.083 7.917C12.4723 8.30567 12.9447 8.5 13.5 8.5Z"
          fill={color || "currentColor"}
        />
        <path d="M5.5 10.5V12H10V10.5H5.5Z" fill={color || "currentColor"} />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const TxnTracingIcon = ({ size = 24, color, ...props }) => (
  <Icon
    aria-label="TxnTracingIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.09986 9.6002H2.8999V7.2002H7.6999V9.35173L9.74837 11.4002H14.226L16.0999 10.9317V9.0002H20.8999V11.4002H16.6999L14.2999 12.0002V13.514L16.5154 14.4002H20.8999V16.8002H16.0999V14.8802L13.3998 13.8002H10.1311L7.6999 16.3649V18.0002H2.8999V15.6002H7.59809L9.4999 13.5939V12.9002H7.6999V13.8002H2.8999V11.4002H7.6999V12.3002H9.4999V12.0002L7.09986 9.6002Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const AuditTrailIcon = ({ size = 24, color = COLORS["gray-800"], ...props }) => (
  <Icon
    aria-label="AuditTrailIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_6288_24500)">
          <path
            d="M14.4531 3.14453C13.2461 3.14453 12.2656 4.125 12.2656 5.33203C12.2656 6.31055 12.9121 7.14062 13.7988 7.41992V9.29297L6.25 11.7656V6.21289C7.11328 5.91992 7.73438 5.10156 7.73438 4.14062C7.73438 2.93359 6.75391 1.95312 5.54688 1.95312C4.33984 1.95312 3.35938 2.93359 3.35938 4.14062C3.35938 5.10156 3.98047 5.91797 4.84375 6.21289V13.7891C3.98047 14.082 3.35938 14.9004 3.35938 15.8613C3.35938 17.0684 4.33984 18.0488 5.54688 18.0488C6.75391 18.0488 7.73438 17.0684 7.73438 15.8613C7.73438 14.9004 7.11328 14.084 6.25 13.7891V13.2461L14.5215 10.5371C14.7201 10.4725 14.8931 10.3466 15.0156 10.1774C15.1381 10.0082 15.2038 9.80456 15.2031 9.5957V7.38672C16.041 7.07812 16.6406 6.27344 16.6406 5.33203C16.6406 4.125 15.6602 3.14453 14.4531 3.14453ZM4.60938 4.14062C4.61438 3.8953 4.71536 3.66171 4.89063 3.48998C5.0659 3.31825 5.3015 3.22207 5.54688 3.22207C5.79225 3.22207 6.02785 3.31825 6.20312 3.48998C6.37839 3.66171 6.47937 3.8953 6.48438 4.14062C6.47937 4.38595 6.37839 4.61954 6.20312 4.79127C6.02785 4.963 5.79225 5.05918 5.54688 5.05918C5.3015 5.05918 5.0659 4.963 4.89063 4.79127C4.71536 4.61954 4.61438 4.38595 4.60938 4.14062ZM6.48438 15.8594C6.47937 16.1047 6.37839 16.3383 6.20312 16.51C6.02785 16.6817 5.79225 16.7779 5.54688 16.7779C5.3015 16.7779 5.0659 16.6817 4.89063 16.51C4.71536 16.3383 4.61438 16.1047 4.60938 15.8594C4.61438 15.614 4.71536 15.3805 4.89063 15.2087C5.0659 15.037 5.3015 14.9408 5.54688 14.9408C5.79225 14.9408 6.02785 15.037 6.20312 15.2087C6.37839 15.3805 6.47937 15.614 6.48438 15.8594ZM14.4531 6.26953C14.2078 6.26452 13.9742 6.16355 13.8025 5.98828C13.6308 5.81301 13.5346 5.57741 13.5346 5.33203C13.5346 5.08665 13.6308 4.85105 13.8025 4.67578C13.9742 4.50051 14.2078 4.39954 14.4531 4.39453C14.6985 4.39954 14.932 4.50051 15.1038 4.67578C15.2755 4.85105 15.3717 5.08665 15.3717 5.33203C15.3717 5.57741 15.2755 5.81301 15.1038 5.98828C14.932 6.16355 14.6985 6.26452 14.4531 6.26953Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_6288_24500">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const ScreenshotIcon = ({ size = 24 }) => (
  <Icon
    aria-label="ScreenshotIcon"
    component={() => (
      <svg
        width={size || "24"}
        height={size || "24"}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 7.5H8.25C8.46667 7.5 8.646 7.429 8.788 7.287C8.92933 7.14567 9 6.96667 9 6.75C9 6.53333 8.92933 6.35433 8.788 6.213C8.646 6.071 8.46667 6 8.25 6H6C5.71667 6 5.479 6.09567 5.287 6.287C5.09567 6.479 5 6.71667 5 7V9.25C5 9.46667 5.071 9.64567 5.213 9.787C5.35433 9.929 5.53333 10 5.75 10C5.96667 10 6.14567 9.929 6.287 9.787C6.429 9.64567 6.5 9.46667 6.5 9.25V7.5ZM17.5 14.5H15.75C15.5333 14.5 15.3543 14.5707 15.213 14.712C15.071 14.854 15 15.0333 15 15.25C15 15.4667 15.071 15.6457 15.213 15.787C15.3543 15.929 15.5333 16 15.75 16H18C18.2833 16 18.5207 15.904 18.712 15.712C18.904 15.5207 19 15.2833 19 15V12.75C19 12.5333 18.9293 12.354 18.788 12.212C18.646 12.0707 18.4667 12 18.25 12C18.0333 12 17.854 12.0707 17.712 12.212C17.5707 12.354 17.5 12.5333 17.5 12.75V14.5ZM9 21C8.71667 21 8.47933 20.904 8.288 20.712C8.096 20.5207 8 20.2833 8 20V19H4C3.45 19 2.97933 18.8043 2.588 18.413C2.196 18.021 2 17.55 2 17V5C2 4.45 2.196 3.979 2.588 3.587C2.97933 3.19567 3.45 3 4 3H20C20.55 3 21.021 3.19567 21.413 3.587C21.8043 3.979 22 4.45 22 5V17C22 17.55 21.8043 18.021 21.413 18.413C21.021 18.8043 20.55 19 20 19H16V20C16 20.2833 15.9043 20.5207 15.713 20.712C15.521 20.904 15.2833 21 15 21H9ZM4 17H20V5H4V17ZM4 17V5V17Z"
          fill="#616161"
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const UndecidedIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <Icon
    aria-label="ScreenshotIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.13324 10C7.13324 9.2 7.21379 8.60278 7.3749 8.20833C7.53601 7.81389 7.87212 7.39444 8.38324 6.95C8.86101 6.53889 9.18324 6.20833 9.3499 5.95833C9.51657 5.70833 9.5999 5.42778 9.5999 5.11667C9.5999 4.69444 9.4499 4.34722 9.1499 4.075C8.8499 3.80278 8.46657 3.66667 7.9999 3.66667C7.58879 3.66667 7.22768 3.79444 6.91657 4.05C6.60546 4.30556 6.38324 4.65556 6.2499 5.1L4.6499 4.43333C4.88324 3.7 5.30824 3.11111 5.9249 2.66667C6.54157 2.22222 7.23324 2 7.9999 2C8.98879 2 9.79435 2.28611 10.4166 2.85833C11.0388 3.43056 11.3499 4.16667 11.3499 5.06667C11.3499 5.53333 11.2471 5.95833 11.0416 6.34167C10.836 6.725 10.4666 7.16667 9.93324 7.66667C9.47768 8.08889 9.19712 8.425 9.09157 8.675C8.98601 8.925 8.92768 9.36667 8.91657 10H7.13324ZM7.9999 13.6C7.66657 13.6 7.38324 13.4833 7.1499 13.25C6.91657 13.0167 6.7999 12.7333 6.7999 12.4C6.7999 12.0667 6.91657 11.7833 7.1499 11.55C7.38324 11.3167 7.66657 11.2 7.9999 11.2C8.33324 11.2 8.61657 11.3167 8.8499 11.55C9.08324 11.7833 9.1999 12.0667 9.1999 12.4C9.1999 12.7333 9.08324 13.0167 8.8499 13.25C8.61657 13.4833 8.33324 13.6 7.9999 13.6Z"
          fill={color}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

// UndecidedIcon with circular border
export const UndecidedIcon2 = ({ size = 16, color = "currentColor", ...props }) => (
  <Icon
    aria-label="ScreenshotIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_12137_416997)">
          <path
            d="M7.20011 1.64744C6.61514 1.71864 6.05403 1.86937 5.51678 2.09962C4.739 2.43295 4.05844 2.89129 3.47511 3.47462C2.89178 4.05795 2.43344 4.73573 2.10011 5.50795C1.86883 6.04376 1.71778 6.60765 1.64697 7.19962H2.85488C3.01051 6.09637 3.49781 5.13525 4.31678 4.31629C5.13574 3.49732 6.09685 3.01002 7.20011 2.85439V1.64744Z"
            fill="#424242"
          />
          <path
            d="M8.80011 2.85439V1.64648C9.39208 1.71729 9.95597 1.86834 10.4918 2.09962C11.264 2.43295 11.9418 2.89129 12.5251 3.47462C13.1084 4.05795 13.5668 4.73573 13.9001 5.50795C14.1314 6.04376 14.2824 6.60765 14.3532 7.19962H13.1453C12.9897 6.09637 12.5024 5.13525 11.6834 4.31629C10.8645 3.49732 9.90336 3.01002 8.80011 2.85439Z"
            fill="#424242"
          />
          <path
            d="M13.1453 8.79962C12.9897 9.90288 12.5024 10.864 11.6834 11.683C10.8645 12.5019 9.90336 12.9892 8.80011 13.1449V14.3528C9.39208 14.2819 9.95597 14.1309 10.4918 13.8996C11.264 13.5663 11.9418 13.108 12.5251 12.5246C13.1084 11.9413 13.5668 11.2607 13.9001 10.483C14.1304 9.9457 14.2811 9.38459 14.3523 8.79962H13.1453Z"
            fill="#424242"
          />
          <path
            d="M7.20011 14.3518V13.1449C6.09685 12.9892 5.13574 12.5019 4.31678 11.683C3.49781 10.864 3.01051 9.90288 2.85488 8.79962H1.64792C1.71913 9.38459 1.86986 9.9457 2.10011 10.483C2.43344 11.2607 2.89178 11.9413 3.47511 12.5246C4.05844 13.108 4.739 13.5663 5.51678 13.8996C6.05403 14.1299 6.61514 14.2806 7.20011 14.3518Z"
            fill="#424242"
          />
          <path
            d="M8.56678 11.7663C8.41122 11.9218 8.22233 11.9996 8.00011 11.9996C7.77789 11.9996 7.589 11.9218 7.43344 11.7663C7.27789 11.6107 7.20011 11.4218 7.20011 11.1996C7.20011 10.9774 7.27789 10.7885 7.43344 10.633C7.589 10.4774 7.77789 10.3996 8.00011 10.3996C8.22233 10.3996 8.41122 10.4774 8.56678 10.633C8.72233 10.7885 8.80011 10.9774 8.80011 11.1996C8.80011 11.4218 8.72233 11.6107 8.56678 11.7663Z"
            fill="#424242"
          />
          <path
            d="M8.61678 9.44962H7.40011C7.40011 8.87184 7.44733 8.46907 7.54178 8.24129C7.63622 8.01351 7.87789 7.72184 8.26678 7.36629C8.47789 7.1774 8.66955 6.98295 8.84178 6.78295C9.014 6.58295 9.10011 6.35518 9.10011 6.09962C9.10011 5.81073 9.00011 5.5774 8.80011 5.39962C8.60011 5.22184 8.34455 5.13295 8.03344 5.13295C7.74455 5.13295 7.49178 5.21906 7.27511 5.39129C7.05844 5.56351 6.90011 5.80518 6.80011 6.11629L5.71678 5.66629C5.88344 5.15518 6.17511 4.74962 6.59178 4.44962C7.00844 4.14962 7.50011 3.99962 8.06678 3.99962C8.71122 3.99962 9.24178 4.19129 9.65844 4.57462C10.0751 4.95795 10.2834 5.45518 10.2834 6.06629C10.2834 6.38851 10.2084 6.68295 10.0584 6.94962C9.90844 7.21629 9.639 7.53851 9.25011 7.91629C8.97233 8.18295 8.79733 8.4024 8.72511 8.57462C8.65289 8.74684 8.61678 9.03851 8.61678 9.44962Z"
            fill="#424242"
          />
        </g>
        <defs>
          <clipPath id="clip0_12137_416997">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const BellOutlineIcon = ({ size = 16, color = "" }) => (
  <Icon
    aria-label="BellOutlineIcon"
    component={() => (
      <svg
        width={size || "16"}
        height={size || "16"}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_6447_183407)">
          <path
            d="M7.99996 14.666C8.73329 14.666 9.33329 14.066 9.33329 13.3327H6.66663C6.66663 14.066 7.26663 14.666 7.99996 14.666ZM12 10.666V7.33268C12 5.28602 10.9133 3.57268 8.99996 3.11935V2.66602C8.99996 2.11268 8.55329 1.66602 7.99996 1.66602C7.44663 1.66602 6.99996 2.11268 6.99996 2.66602V3.11935C5.09329 3.57268 3.99996 5.27935 3.99996 7.33268V10.666L2.66663 11.9993V12.666H13.3333V11.9993L12 10.666ZM10.6666 11.3327H5.33329V7.33268C5.33329 5.67935 6.33996 4.33268 7.99996 4.33268C9.65996 4.33268 10.6666 5.67935 10.6666 7.33268V11.3327Z"
            fill={color || COLORS["gray-800"]}
          />
        </g>
        <defs>
          <clipPath id="clip0_6447_183407">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const TransactionTracingIcon = ({ size = 20, color = null }) => (
  <Icon
    aria-label="Trasaction Tracing Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 19 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.34998 2.59995H0.150024V0.199951H4.95002V2.35148L6.9985 4.39995H11.4761L13.35 3.93148V1.99995H18.15V4.39995H13.95L11.55 4.99995V6.51376L13.7655 7.39995H18.15V9.79995H13.35V7.87998L10.65 6.79995H7.38122L4.95002 9.36469V11H0.150024V8.59995H4.84821L6.75002 6.59368V5.89996H4.95002V6.79995H0.150024V4.39995H4.95002V5.29996H6.75002V4.99991L4.34998 2.59995Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const TransactionTxnIcon = ({ size = 16, color = COLORS["gray-800"] }) => (
  <Icon
    aria-label="Trasaction Tracing Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.79961 13.2008L1.59961 10.0008L4.79961 6.80078L5.64921 7.65038L3.89961 9.40078H8.79961V10.6008H3.89961L5.64921 12.3512L4.79961 13.2008ZM11.1996 9.20078L10.35 8.35118L12.0996 6.60078H7.19961V5.40078H12.0996L10.35 3.65038L11.1996 2.80078L14.3996 6.00078L11.1996 9.20078Z"
          fill={color}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const CameraIcon = ({ size = 20, color = null }) => (
  <Icon
    component={() => (
      <svg
        width={size || 20}
        height={size || 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.75 6.70848V5.06248H14.104V3.31248H15.75V1.64648H17.5V3.31248H19.167V5.06248H17.5V6.70848H15.75ZM2.58301 18.3335C2.09701 18.3335 1.68401 18.1635 1.34401 17.8235C1.00334 17.4828 0.833008 17.0695 0.833008 16.5835V6.72948C0.833008 6.24348 1.00334 5.83048 1.34401 5.49048C1.68401 5.14982 2.09701 4.97948 2.58301 4.97948H5.10401L6.64601 3.31248H11.521V5.06248H7.41701L5.87501 6.72948H2.58301V16.5835H15.76H15.75V9.29248H17.5V16.5835C17.5 17.0695 17.33 17.4828 16.99 17.8235C16.6493 18.1635 16.236 18.3335 15.75 18.3335H2.58301ZM9.16701 15.4175C10.2223 15.4175 11.1147 15.0528 11.844 14.3235C12.5733 13.5942 12.938 12.7018 12.938 11.6465C12.938 10.5905 12.5733 9.69815 11.844 8.96948C11.1147 8.24015 10.2223 7.87548 9.16701 7.87548C8.09701 7.87548 7.20101 8.24015 6.47901 8.96948C5.75701 9.69815 5.39601 10.5905 5.39601 11.6465C5.39601 12.7018 5.75701 13.5942 6.47901 14.3235C7.20101 15.0528 8.09701 15.4175 9.16701 15.4175ZM9.16701 13.6675C8.58367 13.6675 8.10101 13.4728 7.71901 13.0835C7.33701 12.6948 7.14601 12.2158 7.14601 11.6465C7.14601 11.0772 7.33701 10.5978 7.71901 10.2085C8.10101 9.81982 8.58367 9.62548 9.16701 9.62548C9.73634 9.62548 10.2153 9.81982 10.604 10.2085C10.9933 10.5978 11.188 11.0772 11.188 11.6465C11.188 12.2158 10.9933 12.6948 10.604 13.0835C10.2153 13.4728 9.73634 13.6675 9.16701 13.6675Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
  />
);

export const FindMeIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.771 7.417L3 5.646L4.062 4.583L5.833 6.354L4.771 7.417ZM9.25 5V2.5H10.75V5H9.25ZM15.229 7.417L14.167 6.354L15.938 4.583L17 5.646L15.229 7.417ZM8 18.5V14.5L6 12.5V8.5H14V12.5L12 14.5V18.5H8ZM9.5 17H10.5V13.875L12.5 11.875V10H7.5V11.875L9.5 13.875V17Z"
          fill="white"
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const LoginJoinIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="LoginJoinIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <path
          d="M10 17V15.5H15.5V4.5H10V3H15.5C15.9167 3 16.2707 3.146 16.562 3.438C16.854 3.72933 17 4.08333 17 4.5V15.5C17 15.9167 16.854 16.2707 16.562 16.562C16.2707 16.854 15.9167 17 15.5 17H10ZM8.5 13.5L7.438 12.438L9.125 10.75H3V9.25H9.125L7.438 7.562L8.5 6.5L12 10L8.5 13.5Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const InspectRiskIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="InspectRiskIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4093 6.10815C9.67425 6.25603 8.99225 6.55044 8.39506 6.95962C8.33539 6.82221 8.30556 6.669 8.30556 6.5C8.30556 6.18704 8.40787 5.92824 8.6125 5.72361C8.81713 5.51898 9.07593 5.41667 9.38889 5.41667C9.70185 5.41667 9.96065 5.51898 10.1653 5.72361C10.2772 5.83557 10.3586 5.96375 10.4093 6.10815Z"
          fill={color || "currentColor"}
        />
        <path
          d="M7.22222 4.33333V8.04274C6.8126 8.54894 6.49101 9.12932 6.28073 9.76056C6.25417 9.73726 6.22807 9.71279 6.20244 9.68717C5.91933 9.40406 5.77778 9.06389 5.77778 8.66667V4.33333C5.77778 3.93611 5.91933 3.59594 6.20244 3.31283C6.48507 3.0302 6.825 2.88889 7.22222 2.88889H11.5556V1.44444H1.44444V11.5556H6.00027C6.00523 12.0559 6.07698 12.5402 6.20703 13H1.44444C1.04722 13 0.707055 12.8587 0.423944 12.5761C0.141315 12.2929 0 11.9528 0 11.5556V1.44444C0 1.04722 0.141315 0.707055 0.423944 0.423944C0.707055 0.141315 1.04722 0 1.44444 0H11.5556C11.9528 0 12.2929 0.141315 12.5761 0.423944C12.8587 0.707055 13 1.04722 13 1.44444V3.07958C13.1056 3.142 13.205 3.21975 13.2983 3.31283C13.5809 3.59594 13.7222 3.93611 13.7222 4.33333V6.46742C13.2695 6.26723 12.7848 6.12633 12.2778 6.05457V4.33333H7.22222Z"
          fill={color || "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3723 14.3485L16.0238 17L17 16.0238L14.3485 13.3654C14.7085 12.8185 14.9231 12.1677 14.9231 11.4615C14.9231 9.55077 13.3723 8 11.4615 8C9.55077 8 8 9.55077 8 11.4615C8 13.3723 9.55077 14.9231 11.4615 14.9231C12.1677 14.9231 12.8185 14.7085 13.3723 14.3485ZM11.4615 9.38461C12.6038 9.38461 13.5385 10.3192 13.5385 11.4615C13.5385 12.6038 12.6038 13.5385 11.4615 13.5385C10.3192 13.5385 9.38462 12.6038 9.38462 11.4615C9.38462 10.3192 10.3192 9.38461 11.4615 9.38461Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const HistoryIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="History Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 17C8.05533 17 6.40267 16.3193 5.042 14.958C3.68067 13.5973 3 11.9447 3 10H4.5C4.5 11.514 5.03833 12.809 6.115 13.885C7.191 14.9617 8.486 15.5 10 15.5C11.514 15.5 12.809 14.9617 13.885 13.885C14.9617 12.809 15.5 11.514 15.5 10C15.5 8.486 14.9617 7.191 13.885 6.115C12.809 5.03833 11.514 4.5 10 4.5C9.13867 4.5 8.34367 4.677 7.615 5.031C6.88567 5.385 6.271 5.87467 5.771 6.5H8V8H3V3H4.5V5.708C5.13867 4.87467 5.93367 4.215 6.885 3.729C7.83633 3.243 8.87467 3 10 3C10.972 3 11.8817 3.184 12.729 3.552C13.5763 3.92 14.316 4.42 14.948 5.052C15.58 5.684 16.08 6.42367 16.448 7.271C16.816 8.11833 17 9.028 17 10C17 10.972 16.816 11.8817 16.448 12.729C16.08 13.5763 15.58 14.316 14.948 14.948C14.316 15.58 13.5763 16.08 12.729 16.448C11.8817 16.816 10.972 17 10 17ZM12.083 12.833L9.25 10V6H10.75V9.375L13.146 11.771L12.083 12.833Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const CEXIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="CEX Icon"
    component={() => (
      <svg
        width={size || 20}
        height={size || 20}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_7662_57041)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.2 1.8001C7.2 2.38065 6.78773 2.86491 6.24 2.97609V4.98893C6.46108 5.04141 6.65987 5.1653 6.80451 5.34222L8.45119 4.39797C8.4179 4.28786 8.4 4.17107 8.4 4.0501C8.4 3.38736 8.93726 2.8501 9.6 2.8501C10.2627 2.8501 10.8 3.38736 10.8 4.0501C10.8 4.71284 10.2627 5.2501 9.6 5.2501C9.21947 5.2501 8.88032 5.07298 8.66047 4.79669L7.00736 5.74463C7.05319 5.92539 7.04959 6.11565 6.99656 6.29491L8.62768 7.24667C8.84573 6.9458 9.20001 6.7501 9.6 6.7501C10.2627 6.7501 10.8 7.28736 10.8 7.9501C10.8 8.61284 10.2627 9.1501 9.6 9.1501C8.93726 9.1501 8.4 8.61284 8.4 7.9501C8.4 7.84863 8.41259 7.75011 8.4363 7.65601L6.77843 6.68864C6.63641 6.84922 6.44808 6.96187 6.24 7.01126V9.0241C6.78773 9.13529 7.2 9.61955 7.2 10.2001C7.2 10.8628 6.66274 11.4001 6 11.4001C5.33726 11.4001 4.8 10.8628 4.8 10.2001C4.8 9.609 5.22738 9.11771 5.79 9.01841V7.01791C5.59342 6.97736 5.41305 6.88068 5.27069 6.74048L3.57638 7.71204C3.59187 7.78898 3.6 7.86859 3.6 7.9501C3.6 8.61284 3.06274 9.1501 2.4 9.1501C1.73726 9.1501 1.2 8.61284 1.2 7.9501C1.2 7.28736 1.73726 6.7501 2.4 6.7501C2.81985 6.7501 3.18935 6.96572 3.40379 7.29227L5.02585 6.36214C4.94193 6.13641 4.93917 5.88837 5.01756 5.66116L3.39824 4.71629C3.18302 5.03815 2.81626 5.2501 2.4 5.2501C1.73726 5.2501 1.2 4.71284 1.2 4.0501C1.2 3.38736 1.73726 2.8501 2.4 2.8501C3.06274 2.8501 3.6 3.38736 3.6 4.0501C3.6 4.1351 3.59116 4.21804 3.57435 4.29804L5.25302 5.27755C5.39798 5.1277 5.58519 5.02453 5.79 4.98228V2.98178C5.22738 2.88248 4.8 2.3912 4.8 1.8001C4.8 1.13736 5.33726 0.600098 6 0.600098C6.66274 0.600098 7.2 1.13736 7.2 1.8001Z"
            fill={COLORS["gray-800"]}
          />
        </g>
        <defs>
          <clipPath id="clip0_7662_57041">
            <rect width={size || 20} height={size || 20} fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);
export const DEXIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="DEX Icon"
    component={() => (
      <svg
        width={size || 20}
        height={size || 20}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_7662_57056)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.09366 2.59449C7.16197 2.44368 7.2 2.27623 7.2 2.0999C7.2 1.43716 6.66274 0.899902 6 0.899902C5.33726 0.899902 4.8 1.43716 4.8 2.0999C4.8 2.27623 4.83804 2.44368 4.90634 2.59449L3.07295 3.92653C2.8581 3.72402 2.56855 3.5999 2.25 3.5999C1.58726 3.5999 1.05 4.13716 1.05 4.7999C1.05 5.46264 1.58726 5.9999 2.25 5.9999C2.30883 5.9999 2.36667 5.99567 2.42324 5.98749L3.13936 8.1915C2.70523 8.37212 2.4 8.80037 2.4 9.2999C2.4 9.96264 2.93726 10.4999 3.6 10.4999C4.22979 10.4999 4.74627 10.0147 4.79607 9.39777H7.32394C7.37374 10.0147 7.89022 10.4999 8.52001 10.4999C9.18275 10.4999 9.72001 9.96264 9.72001 9.2999C9.72001 8.7601 9.36358 8.30354 8.87324 8.15273L9.57822 5.98301C9.64382 5.99412 9.71124 5.9999 9.78 5.9999C10.4427 5.9999 10.98 5.46264 10.98 4.7999C10.98 4.13716 10.4427 3.5999 9.78 3.5999C9.45501 3.5999 9.16019 3.72909 8.94411 3.93892L7.09366 2.59449ZM5.41818 3.14967C5.59052 3.24539 5.78889 3.2999 6 3.2999C6.21111 3.2999 6.40949 3.24539 6.58182 3.14967L8.59461 4.61205C8.58499 4.67325 8.58 4.73599 8.58 4.7999C8.58 5.11846 8.70412 5.40802 8.90665 5.62287L8.07399 8.18553C7.84245 8.27829 7.64655 8.44111 7.5125 8.64777H4.60751C4.4482 8.40215 4.2015 8.21845 3.91146 8.14072L3.1009 5.64606C3.31666 5.42909 3.45 5.13007 3.45 4.7999C3.45 4.72921 3.44389 4.65994 3.43216 4.5926L5.41818 3.14967Z"
            fill={COLORS["gray-800"]}
          />
        </g>
        <defs>
          <clipPath id="clip0_7662_57056">
            <rect width={size || 20} height={size || 20} fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const UrlLinkIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="url link Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_7662_20686)">
          <path
            d="M9.5 9.5H2.5V2.5H6V1.5H2.5C1.945 1.5 1.5 1.95 1.5 2.5V9.5C1.5 10.05 1.945 10.5 2.5 10.5H9.5C10.05 10.5 10.5 10.05 10.5 9.5V6H9.5V9.5ZM7 1.5V2.5H8.795L3.88 7.415L4.585 8.12L9.5 3.205V5H10.5V1.5H7Z"
            fill={color || "#9E9E9E"}
          />
        </g>
        <defs>
          <clipPath id="clip0_7662_20686">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const PeopleConfigIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8182_162459)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.084 5.979L15.292 6.875H16.479L16.688 5.979C16.7987 5.92367 16.9063 5.86467 17.011 5.802C17.115 5.73933 17.2017 5.67333 17.271 5.604L18.167 5.917L18.771 4.875L18.042 4.25C18.056 4.18067 18.063 4.125 18.063 4.083V3.781C18.063 3.73233 18.056 3.68033 18.042 3.625L18.771 3L18.167 1.958L17.271 2.271C17.2017 2.20167 17.115 2.13233 17.011 2.063C16.9063 1.993 16.7987 1.93733 16.688 1.896L16.479 1H15.313L15.104 1.896C14.9933 1.93733 14.8857 1.993 14.781 2.063C14.677 2.13233 14.5903 2.20167 14.521 2.271L13.625 1.958L13.021 3L13.75 3.625C13.736 3.68033 13.729 3.73233 13.729 3.781V3.938C13.729 3.99333 13.7257 4.04167 13.719 4.083C13.7117 4.125 13.715 4.18067 13.729 4.25L13 4.875L13.604 5.917L14.5 5.604C14.5693 5.67333 14.6563 5.73933 14.761 5.802C14.865 5.86467 14.9727 5.92367 15.084 5.979ZM16.636 4.677C16.4347 4.87833 16.188 4.979 15.896 4.979C15.604 4.979 15.3573 4.87833 15.156 4.677C14.9547 4.47567 14.854 4.22933 14.854 3.938C14.854 3.646 14.9547 3.39933 15.156 3.198C15.3573 2.99667 15.604 2.896 15.896 2.896C16.188 2.896 16.4347 2.99667 16.636 3.198C16.8373 3.39933 16.938 3.646 16.938 3.938C16.938 4.22933 16.8373 4.47567 16.636 4.677Z"
            fill={color || "currentColor"}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.66663 16.375C1.66663 14.4333 5.54996 13.4583 7.49996 13.4583C9.44996 13.4583 13.3333 14.4333 13.3333 16.375V17.8333H1.66663V16.375ZM7.49996 15.125C6.00829 15.125 4.31663 15.6833 3.61663 16.1667H11.3833C10.6833 15.6833 8.99163 15.125 7.49996 15.125Z"
            fill={color || "currentColor"}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4166 9.08333C10.4166 10.6917 9.10829 12 7.49996 12C5.89163 12 4.58329 10.6917 4.58329 9.08333C4.58329 7.475 5.89163 6.16667 7.49996 6.16667C9.10829 6.16667 10.4166 7.475 10.4166 9.08333ZM8.74996 9.08333C8.74996 8.39167 8.19163 7.83333 7.49996 7.83333C6.80829 7.83333 6.24996 8.39167 6.24996 9.08333C6.24996 9.775 6.80829 10.3333 7.49996 10.3333C8.19163 10.3333 8.74996 9.775 8.74996 9.08333Z"
            fill={color || "currentColor"}
          />
          <path
            d="M15 16.375C15 15.1417 14.3333 14.2083 13.3666 13.5083C15.4166 13.7333 18.3333 14.6917 18.3333 16.375V17.8333H15V16.375Z"
            fill={color || "currentColor"}
          />
          <path
            d="M15.4166 9.08333C15.4166 10.6917 14.1083 12 12.5 12C12.05 12 11.6333 11.8917 11.25 11.7083C11.775 10.9667 12.0833 10.0583 12.0833 9.08333C12.0833 8.10833 11.775 7.2 11.25 6.45833C11.6333 6.275 12.05 6.16667 12.5 6.16667C14.1816 6.16667 15.4166 7.75282 15.4166 9.08333Z"
            fill={color || "currentColor"}
          />
        </g>
        <defs>
          <clipPath id="clip0_8182_162459">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const EmptyIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width="138"
        height="160"
        viewBox="0 0 138 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8505_244016)">
          <path
            d="M0.428711 8C0.428711 3.58172 4.01043 0 8.42871 0H84.2846C86.3905 0 88.4115 0.830354 89.909 2.31091L112.714 24.8571L135.094 46.2076C136.676 47.7172 137.572 49.8089 137.572 51.9959V152C137.572 156.418 133.99 160 129.572 160H8.42869C4.01042 160 0.428711 156.418 0.428711 152V8Z"
            fill="#FAFAFA"
          />
          <path
            d="M136.143 47.1431L88.4287 0.857422V35.3268C88.4287 42.4901 89.2659 48.0003 97.9171 48.0003C106.568 48.0003 136.143 47.1431 136.143 47.1431Z"
            fill="#C5CAE9"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.85742 72.5714C7.85742 70.0467 9.90412 68 12.4289 68H50.7146C53.2393 68 55.286 70.0467 55.286 72.5714C55.286 75.0962 53.2393 77.1429 50.7146 77.1429H12.4288C9.90412 77.1429 7.85742 75.0962 7.85742 72.5714ZM7.85742 98.2857C7.85742 95.761 9.90412 93.7143 12.4288 93.7143H50.7146C53.2393 93.7143 55.286 95.761 55.286 98.2857C55.286 100.81 53.2393 102.857 50.7146 102.857H12.4288C9.90412 102.857 7.85742 100.81 7.85742 98.2857ZM12.4289 121.714C9.90412 121.714 7.85742 123.761 7.85742 126.286C7.85742 128.81 9.90412 130.857 12.4288 130.857H50.7146C53.2393 130.857 55.286 128.81 55.286 126.286C55.286 123.761 53.2393 121.714 50.7146 121.714H12.4289ZM113.572 72.5714C113.572 70.0467 115.618 68 118.143 68H126.143C128.668 68 130.715 70.0467 130.715 72.5714C130.715 75.0962 128.668 77.1429 126.143 77.1429H118.143C115.618 77.1429 113.572 75.0962 113.572 72.5714ZM118.143 93.7143C115.618 93.7143 113.572 95.761 113.572 98.2857C113.572 100.81 115.618 102.857 118.143 102.857H126.143C128.668 102.857 130.715 100.81 130.715 98.2857C130.715 95.761 128.668 93.7143 126.143 93.7143H118.143ZM113.572 126.286C113.572 123.761 115.618 121.714 118.143 121.714H126.143C128.668 121.714 130.715 123.761 130.715 126.286C130.715 128.81 128.668 130.857 126.143 130.857H118.143C115.618 130.857 113.572 128.81 113.572 126.286ZM65.0003 68C62.4756 68 60.4289 70.0467 60.4289 72.5714C60.4289 75.0962 62.4756 77.1429 65.0003 77.1429H103.286C105.811 77.1429 107.857 75.0962 107.857 72.5714C107.857 70.0467 105.811 68 103.286 68H65.0003ZM60.4289 98.2857C60.4289 95.761 62.4755 93.7143 65.0003 93.7143H103.286C105.811 93.7143 107.857 95.761 107.857 98.2857C107.857 100.81 105.811 102.857 103.286 102.857H65.0003C62.4755 102.857 60.4289 100.81 60.4289 98.2857ZM65.0003 121.714C62.4756 121.714 60.4289 123.761 60.4289 126.286C60.4289 128.81 62.4756 130.857 65.0003 130.857H103.286C105.811 130.857 107.857 128.81 107.857 126.286C107.857 123.761 105.811 121.714 103.286 121.714H65.0003Z"
            fill="#C5CAE9"
          />
          <path
            d="M112.429 13.1426L114.611 20.7907L122.326 18.8569L116.794 24.5711L122.326 30.2854L114.611 28.3516L112.429 35.9997L110.246 28.3516L102.531 30.2854L108.063 24.5711L102.531 18.8569L110.246 20.7907L112.429 13.1426Z"
            fill="#FFE0B2"
          />
        </g>
        <defs>
          <clipPath id="clip0_8505_244016">
            <rect width="137.143" height="160" fill="white" transform="translate(0.428711)" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const EmptyChartIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 138 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8505_242007)">
          <path
            d="M0 8C0 3.58172 3.58172 0 8 0H83.8559C85.9618 0 87.9828 0.830354 89.4803 2.31091L112.286 24.8571L134.665 46.2076C136.247 47.7172 137.143 49.8089 137.143 51.9959V152C137.143 156.418 133.561 160 129.143 160H7.99998C3.58171 160 0 156.418 0 152V8Z"
            fill="#FAFAFA"
          />
          <path
            d="M68.5714 54.8555C58.6981 54.8555 49.1042 58.1338 41.2955 64.1759C33.4868 70.218 27.9053 78.6818 25.427 88.2391C22.9487 97.7963 23.7139 107.906 27.6025 116.981C31.4911 126.057 38.2829 133.584 46.9121 138.382C55.5413 143.18 65.5194 144.977 75.2802 143.491C85.0411 142.004 94.0322 137.319 100.843 130.171C107.653 123.022 111.897 113.815 112.908 103.993C113.92 94.1719 111.642 84.2926 106.431 75.9059L89.2251 86.5956C92.0674 91.1707 93.3102 96.5601 92.7584 101.918C92.2066 107.276 89.8914 112.299 86.1762 116.199C82.461 120.098 77.5561 122.654 72.2313 123.465C66.9064 124.276 61.4632 123.295 56.7557 120.678C52.0482 118.06 48.3431 113.954 46.2218 109.003C44.1004 104.052 43.683 98.5374 45.035 93.3236C46.3869 88.1099 49.4318 83.4926 53.6917 80.1965C57.9515 76.9004 63.1853 75.112 68.5714 75.112L68.5714 54.8555Z"
            fill="#C5CAE9"
          />
          <path
            d="M108.106 67.5825C104.111 62.0621 98.9023 57.5315 92.8819 54.3388C86.8614 51.1461 80.1891 49.3765 73.3777 49.1658L72.7516 69.4127C76.4674 69.5276 80.1073 70.493 83.3916 72.2347C86.676 73.9764 89.5172 76.4479 91.6969 79.4594L108.106 67.5825Z"
            fill="#E0E0E0"
          />
          <path
            d="M136 47.4269L88 0.855469V35.3249C88 42.4881 88.8372 47.9983 97.4884 47.9983C106.14 47.9983 136 47.4269 136 47.4269Z"
            fill="#C5CAE9"
          />
          <path
            d="M112 13.1445L114.183 20.7926L121.897 18.8588L116.365 24.5731L121.897 30.2874L114.183 28.3536L112 36.0017L109.817 28.3536L102.103 30.2874L107.635 24.5731L102.103 18.8588L109.817 20.7926L112 13.1445Z"
            fill="#FFE0B2"
          />
        </g>
        <defs>
          <clipPath id="clip0_8505_242007">
            <rect width="137.143" height="160" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);
export const EmptyPieChartIcon = ({ color = undefined, size = 164, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 164 164"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M164 82C164 127.287 127.287 164 82 164C36.7127 164 0 127.287 0 82C0 36.7127 36.7127 0 82 0C127.287 0 164 36.7127 164 82ZM30.9953 82C30.9953 110.169 53.8309 133.005 82 133.005C110.169 133.005 133.005 110.169 133.005 82C133.005 53.8309 110.169 30.9953 82 30.9953C53.8309 30.9953 30.9953 53.8309 30.9953 82Z"
          fill="#E0E0E0"
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const EvidenceAttachmentIcon = ({ color = undefined, size = 20, ...props }) => (
  <Icon
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 17.5H15V16H6.604C5.77067 16 5.04167 15.7117 4.417 15.135C3.79167 14.559 3.486 13.8473 3.5 13C3.514 12.1667 3.809 11.4583 4.385 10.875C4.96167 10.2917 5.66667 10 6.5 10H14.708C15.208 10 15.6317 10.17 15.979 10.51C16.3263 10.8507 16.5 11.264 16.5 11.75C16.5 12.236 16.33 12.6493 15.99 12.99C15.6493 13.33 15.236 13.5 14.75 13.5H7C6.86133 13.5 6.74333 13.4513 6.646 13.354C6.54867 13.2567 6.5 13.1387 6.5 13C6.5 12.8613 6.54867 12.7433 6.646 12.646C6.74333 12.5487 6.86133 12.5 7 12.5H15V11H7.083C6.52767 11 6.04167 11.1873 5.625 11.562C5.20833 11.9373 5 12.4167 5 13C5 13.5553 5.19433 14.0277 5.583 14.417C5.97233 14.8057 6.44467 15 7 15H14.604C15.5207 15 16.316 14.691 16.99 14.073C17.6633 13.455 18 12.6807 18 11.75C18 10.8473 17.684 10.08 17.052 9.448C16.42 8.816 15.6527 8.5 14.75 8.5H6.646C5.382 8.5 4.29167 8.93067 3.375 9.792C2.45833 10.6527 2 11.715 2 12.979C2 14.257 2.43733 15.33 3.312 16.198C4.18733 17.066 5.25 17.5 6.5 17.5Z"
          fill={COLORS["gray-800"]}
        />
        <path
          d="M15 7L15.94 4.93L18 4L15.94 3.07L15 1L14.08 3.07L12 4L14.08 4.93L15 7Z"
          fill={COLORS["gray-800"]}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const TraceIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="Trace Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.49997 10H2V8H6V9.79294L7.70706 11.5H11.4384L13 11.1096V9.5H17V11.5H13.5L11.5 12V13.2615L13.3462 14H17V16H13V14.4L10.7499 13.5H8.026L6 15.6373V17H2V15H5.91516L7.5 13.3281V12.75H6V13.5H2V11.5H6V12.25H7.5V12L5.49997 10Z"
          fill={COLORS["gray-800"]}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const AddTraceIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="Trace Icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.66671 5H3.16675V3H7.16675V4.79294L8.87381 6.5H12.6052L14.1667 6.10961V4.5H18.1667V6.5H14.6667L12.6667 7V8.26151L14.513 9H18.1667V11H14.1667V9.40002L11.9167 8.5H9.19275L7.16675 10.6373V12H3.16675V10H7.0819L8.66675 8.3281V7.75001H7.16675V8.5H3.16675V6.5H7.16675V7.25001H8.66675V6.99997L6.66671 5Z"
          fill={color || "currentColor"}
        />
        <path
          d="M15.1667 17V15.5H13.6667V14H15.1667V12.5H16.6667V14H18.1667V15.5H16.6667V17H15.1667Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const EvidenceAttachedIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="EvidenceAttachedIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 17.5H15V16H6.604C5.77067 16 5.04167 15.7117 4.417 15.135C3.79167 14.559 3.486 13.8473 3.5 13C3.514 12.1667 3.809 11.4583 4.385 10.875C4.96167 10.2917 5.66667 10 6.5 10H14.708C15.208 10 15.6317 10.17 15.979 10.51C16.3263 10.8507 16.5 11.264 16.5 11.75C16.5 12.236 16.33 12.6493 15.99 12.99C15.6493 13.33 15.236 13.5 14.75 13.5H7C6.86133 13.5 6.74333 13.4513 6.646 13.354C6.54867 13.2567 6.5 13.1387 6.5 13C6.5 12.8613 6.54867 12.7433 6.646 12.646C6.74333 12.5487 6.86133 12.5 7 12.5H15V11H7.083C6.52767 11 6.04167 11.1873 5.625 11.562C5.20833 11.9373 5 12.4167 5 13C5 13.5553 5.19433 14.0277 5.583 14.417C5.97233 14.8057 6.44467 15 7 15H14.604C15.5207 15 16.316 14.691 16.99 14.073C17.6633 13.455 18 12.6807 18 11.75C18 10.8473 17.684 10.08 17.052 9.448C16.42 8.816 15.6527 8.5 14.75 8.5H6.646C5.382 8.5 4.29167 8.93067 3.375 9.792C2.45833 10.6527 2 11.715 2 12.979C2 14.257 2.43733 15.33 3.312 16.198C4.18733 17.066 5.25 17.5 6.5 17.5Z"
          fill={COLORS["gray-800"]}
        />
        <path
          d="M15 7L15.94 4.93L18 4L15.94 3.07L15 1L14.08 3.07L12 4L14.08 4.93L15 7Z"
          fill={COLORS["gray-800"]}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const AlertSettingIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="AlertSettingIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.19995 11.2016V12.4016H12.8V11.2016H12V8.80156H10.8V11.2016H5.19995V7.20156C5.21115 6.42396 5.48902 5.7629 6.03355 5.21836C6.57755 4.67383 7.23302 4.40156 7.99995 4.40156C8.22235 4.40156 8.44182 4.4293 8.65835 4.48476C8.87489 4.54023 9.08315 4.6181 9.28315 4.71836L10.1664 3.83516C9.97755 3.67943 9.76368 3.56263 9.52475 3.48476C9.28582 3.4069 9.04422 3.34023 8.79995 3.28476V2.40156C8.79995 2.17916 8.72208 1.99036 8.56635 1.83516C8.41115 1.67943 8.22235 1.60156 7.99995 1.60156C7.77755 1.60156 7.58875 1.67943 7.43355 1.83516C7.27782 1.99036 7.19995 2.17916 7.19995 2.40156V3.28476C6.26662 3.47356 5.49995 3.93463 4.89995 4.66796C4.29995 5.4013 3.99995 6.24583 3.99995 7.20156V11.2016H3.19995Z"
          fill={COLORS["gray-800"]}
        />
        <path
          d="M7.15035 14.0512C7.38342 14.2848 7.66662 14.4016 7.99995 14.4016C8.33328 14.4016 8.61649 14.2848 8.84955 14.0512C9.08315 13.8181 9.19995 13.5349 9.19995 13.2016H6.79995C6.79995 13.5349 6.91675 13.8181 7.15035 14.0512Z"
          fill={COLORS["gray-800"]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0672 7.18476L12.2336 7.90156H13.1832L13.3504 7.18476C13.4389 7.1405 13.525 7.0933 13.6088 7.04316C13.692 6.99303 13.7613 6.94023 13.8168 6.88476L14.5336 7.13516L15.0168 6.30156L14.4336 5.80156C14.4448 5.7461 14.4504 5.70156 14.4504 5.66796V5.42636C14.4504 5.38743 14.4448 5.34583 14.4336 5.30156L15.0168 4.80156L14.5336 3.96796L13.8168 4.21836C13.7613 4.1629 13.692 4.10743 13.6088 4.05196C13.525 3.99596 13.4389 3.95143 13.3504 3.91836L13.1832 3.20156H12.2504L12.0832 3.91836C11.9946 3.95143 11.9085 3.99596 11.8248 4.05196C11.7416 4.10743 11.6722 4.1629 11.6168 4.21836L10.9 3.96796L10.4168 4.80156L11 5.30156C10.9888 5.34583 10.9832 5.38743 10.9832 5.42636V5.55196C10.9832 5.59623 10.9805 5.6349 10.9752 5.66796C10.9693 5.70156 10.972 5.7461 10.9832 5.80156L10.4 6.30156L10.8832 7.13516L11.6 6.88476C11.6554 6.94023 11.725 6.99303 11.8088 7.04316C11.892 7.0933 11.9781 7.1405 12.0672 7.18476ZM13.3088 6.14316C13.1477 6.30423 12.9504 6.38476 12.7168 6.38476C12.4832 6.38476 12.2858 6.30423 12.1248 6.14316C11.9637 5.9821 11.8832 5.78503 11.8832 5.55196C11.8832 5.31836 11.9637 5.12103 12.1248 4.95996C12.2858 4.7989 12.4832 4.71836 12.7168 4.71836C12.9504 4.71836 13.1477 4.7989 13.3088 4.95996C13.4698 5.12103 13.5504 5.31836 13.5504 5.55196C13.5504 5.78503 13.4698 5.9821 13.3088 6.14316Z"
          fill={COLORS["gray-800"]}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const PendingIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="PendingIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.1999 13.3992C8.31084 13.3992 7.55537 13.088 6.9335 12.4656C6.3111 11.8438 5.9999 11.0883 5.9999 10.1992C5.9999 9.31015 6.3111 8.55469 6.9335 7.93282C7.55537 7.31042 8.31084 6.99922 9.1999 6.99922C10.089 6.99922 10.8444 7.31042 11.4663 7.93282C12.0887 8.55469 12.3999 9.31015 12.3999 10.1992C12.3999 11.0883 12.0887 11.8438 11.4663 12.4656C10.8444 13.088 10.089 13.3992 9.1999 13.3992ZM10.1167 11.6824L10.6831 11.116L9.5999 10.0328V8.59922H8.7999V10.3656L10.1167 11.6824ZM1.5999 12.5992C1.26657 12.5992 0.983369 12.4824 0.750302 12.2488C0.516702 12.0158 0.399902 11.7326 0.399902 11.3992V2.59922C0.399902 2.26589 0.519369 1.98269 0.758302 1.74962C0.997236 1.51602 1.27777 1.39922 1.5999 1.39922H4.4495C4.56097 1.02162 4.75004 0.727219 5.0167 0.516019C5.28337 0.304819 5.6111 0.199219 5.9999 0.199219C6.3999 0.199219 6.73324 0.304819 6.9999 0.516019C7.26657 0.727219 7.45004 1.02162 7.5503 1.39922H10.3999C10.722 1.39922 11.0026 1.51602 11.2415 1.74962C11.4804 1.98269 11.5999 2.26589 11.5999 2.59922V6.51602C11.4111 6.39389 11.2194 6.28562 11.0247 6.19122C10.8306 6.09629 10.6223 6.02109 10.3999 5.96562V2.59922H9.1999V4.59922H2.7999V2.59922H1.5999V11.3992H4.9663C5.04417 11.6328 5.12204 11.844 5.1999 12.0328C5.27777 12.2216 5.38337 12.4104 5.5167 12.5992H1.5999ZM5.9999 2.59922C6.1663 2.59922 6.3079 2.54082 6.4247 2.42402C6.5415 2.30722 6.5999 2.16562 6.5999 1.99922C6.5999 1.83282 6.5415 1.69122 6.4247 1.57442C6.3079 1.45762 6.1663 1.39922 5.9999 1.39922C5.8335 1.39922 5.6919 1.45762 5.5751 1.57442C5.4583 1.69122 5.3999 1.83282 5.3999 1.99922C5.3999 2.16562 5.4583 2.30722 5.5751 2.42402C5.6919 2.54082 5.8335 2.59922 5.9999 2.59922Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const EventIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="EventIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_11085_7638)">
          <path
            d="M6.19995 13L9.19995 16L6.19995 19V17H2.19995V4H4.19995L4.19995 15H6.19995V13Z"
            fill={COLORS["gray-800"]}
          />
          <path d="M14.2 9V7H22.2V9H14.2Z" fill={COLORS["gray-800"]} />
          <path d="M12.2 13H10.2V11H12.2V13Z" fill={COLORS["gray-800"]} />
          <path d="M12.2 17H10.2V15H12.2V17Z" fill={COLORS["gray-800"]} />
          <path d="M12.2 9H10.2V7H12.2V9Z" fill={COLORS["gray-800"]} />
          <path d="M22.2 13H14.2V11H22.2V13Z" fill={COLORS["gray-800"]} />
          <path d="M22.2 17H14.2V15H22.2V17Z" fill={COLORS["gray-800"]} />
        </g>
        <defs>
          <clipPath id="clip0_11085_7638">
            <rect x="0.199951" width="24" height="24" rx="4" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const FlagIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="FlagIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.40002 20.4016V3.60156H13.8L14.4 6.00156H19.8V15.6016H13.8L13.2 13.2016H7.20002V20.4016H5.40002ZM15.2004 13.8016H18V7.80156H12.9996L12.3996 5.40156H7.20002V11.4016H14.6004L15.2004 13.8016Z"
          fill="#424242"
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const LegendLineIcon = ({ color = null, ...props }) => (
  <Icon
    aria-label="PendingIcon"
    component={() => (
      <svg width="41" height="8" viewBox="0 0 41 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.374 3H40.5V5H24.374C23.9299 6.72523 22.3638 8 20.5 8C18.6362 8 17.0701 6.72523 16.626 5H0.5V3H16.626C17.0701 1.27477 18.6362 0 20.5 0C22.3638 0 23.9299 1.27477 24.374 3Z"
          fill={color}
        />
      </svg>
    )}
    {...props}
  />
);

export const NeutralIcon = ({ size = 16, color = null, ...props }) => (
  <Icon
    aria-label="FlagIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.59998 7.59999C1.59998 6.93725 2.13723 6.39999 2.79998 6.39999H13.2C13.8627 6.39999 14.4 6.93725 14.4 7.59999C14.4 8.26274 13.8627 8.79999 13.2 8.79999H2.79998C2.13724 8.79999 1.59998 8.26274 1.59998 7.59999Z"
          fill={color}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const RedFlagIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="RedFlagIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 17V3H11L11.5 5H16V13H11L10.5 11H5.5V17H4Z" fill="#E5453D" />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const CheckVerifiedFilledIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="Check verified filled icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_11833_200662)">
          <path
            d="M19.1667 10.2129L17.1333 7.88789L17.4167 4.81289L14.4083 4.12956L12.8333 1.46289L10 2.67956L7.16668 1.46289L5.59168 4.12122L2.58334 4.79622L2.86668 7.87956L0.833344 10.2129L2.86668 12.5379L2.58334 15.6212L5.59168 16.3046L7.16668 18.9629L10 17.7379L12.8333 18.9546L14.4083 16.2962L17.4167 15.6129L17.1333 12.5379L19.1667 10.2129ZM8.40834 14.1462L5.24168 10.9712L6.47501 9.73789L8.40834 11.6796L13.2833 6.78789L14.5167 8.02122L8.40834 14.1462Z"
            fill={color || "currentColor"}
          />
        </g>
        <defs>
          <clipPath id="clip0_11833_200662">
            <rect width="20" height="20" fill="white" transform="translate(0 0.212891)" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const SidePanelIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="Check verified filled icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 17V4H18V17H2ZM14.5 7.83333H16.5V5.5H14.5V7.83333ZM14.5 11.6667H16.5V9.33333H14.5V11.6667ZM3.5 15.5H13V5.5H3.5V15.5ZM14.5 15.5H16.5V13.1667H14.5V15.5Z"
          fill={color || "#424242"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const FitScreenIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="fit screen icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5 8V5.5H14V4H16.5C16.9125 4 17.2656 4.14687 17.5594 4.44062C17.8531 4.73437 18 5.0875 18 5.5V8H16.5ZM2 8V5.5C2 5.0875 2.14688 4.73437 2.44063 4.44062C2.73438 4.14687 3.0875 4 3.5 4H6V5.5H3.5V8H2ZM14 16V14.5H16.5V12H18V14.5C18 14.9125 17.8531 15.2656 17.5594 15.5594C17.2656 15.8531 16.9125 16 16.5 16H14ZM3.5 16C3.0875 16 2.73438 15.8531 2.44063 15.5594C2.14688 15.2656 2 14.9125 2 14.5V12H3.5V14.5H6V16H3.5ZM5 13V7H15V13H5ZM6.5 11.5H13.5V8.5H6.5V11.5Z"
          fill={color || "#424242"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const FullScreenExitIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="full screen exit icon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 15.5V13H4.5V11.5H8.5V15.5H7ZM11.5 15.5V11.5H15.5V13H13V15.5H11.5ZM4.5 8.5V7H7V4.5H8.5V8.5H4.5ZM11.5 8.5V4.5H13V7H15.5V8.5H11.5Z"
          fill={color || "#424242"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const BlackListedIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="blacklisted icon"
    component={() => (
      <svg
        width="33"
        height="20"
        viewBox="0 0 33 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.75" width="32" height="20" rx="10" fill="#FFCDD2" />
        <g clipPath="url(#clip0_12511_108772)">
          <path
            d="M16.7497 3.33301C13.0697 3.33301 10.083 6.31967 10.083 9.99968C10.083 13.6797 13.0697 16.6663 16.7497 16.6663C20.4297 16.6663 23.4163 13.6797 23.4163 9.99968C23.4163 6.31967 20.4297 3.33301 16.7497 3.33301ZM11.4163 9.99968C11.4163 7.05301 13.803 4.66634 16.7497 4.66634C17.983 4.66634 19.1163 5.08634 20.0163 5.79301L12.543 13.2663C11.8363 12.3663 11.4163 11.233 11.4163 9.99968ZM16.7497 15.333C15.5163 15.333 14.383 14.913 13.483 14.2063L20.9563 6.73301C21.663 7.63301 22.083 8.76634 22.083 9.99968C22.083 12.9463 19.6963 15.333 16.7497 15.333Z"
            fill="#AA0011"
          />
        </g>
        <defs>
          <clipPath id="clip0_12511_108772">
            <rect width="16" height="16" fill="white" transform="translate(8.75 2)" />
          </clipPath>
        </defs>
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const CertikLogoHorWhite = ({ ...props }) => {
  return (
    <Icon
      aria-label="blacklisted icon"
      component={() => (
        <svg
          width="162"
          height="40"
          viewBox="0 0 162 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.2556 0.0342335C20.0737 -0.0114112 19.8545 -0.0114112 19.6726 0.0342335L7.76099 3.67483L7.75479 3.67691C7.19686 3.86361 6.92367 4.42656 7.05941 4.97162L7.06252 4.98413L7.06691 4.99625C7.24904 5.49907 7.80294 5.83601 8.3712 5.6479L19.9816 2.1051L31.8409 5.75478C32.4145 5.94484 32.9687 5.6003 33.1477 5.06123C33.3385 4.48665 32.9971 3.92865 32.4577 3.74814L20.2676 0.0372408L20.2556 0.0342335ZM2.20752 6.28378C2.15255 5.86019 2.3804 5.44512 2.7324 5.23309L2.74457 5.22576L2.7575 5.21986C2.87504 5.16622 2.99778 5.13501 3.12044 5.12506C3.22173 5.11074 3.32736 5.11155 3.43474 5.12951C3.86774 5.20196 4.19161 5.52856 4.27301 5.93406L11.0873 19.2831H29.1463C29.183 19.2831 29.2193 19.2851 29.2551 19.289L35.6873 5.95553C35.7374 5.68144 35.9005 5.44241 36.1424 5.29949C36.4361 5.09618 36.8306 5.06467 37.1707 5.21986C37.5109 5.3751 37.7046 5.68501 37.7405 6.01926L37.9509 7.25161C37.999 7.46727 38.2043 8.90408 38.2043 11.0806C38.2043 13.2365 37.9896 16.074 37.2025 19.2706C36.451 22.2884 35.0904 25.9201 32.6186 29.4804C30.1469 33.0406 26.5663 36.5623 21.4155 39.3276L21.4139 39.3285L20.4609 39.86L20.4595 39.8608C20.135 40.0464 19.7932 40.0464 19.4687 39.8608L19.4673 39.86L18.5143 39.3285L18.5127 39.3276C13.3619 36.5623 9.78129 33.0406 7.30957 29.4804C4.83861 25.9212 3.47721 22.2899 2.79606 19.2322C2.0095 16.0366 1.79492 13.1644 1.79492 11.045C1.79492 8.86845 2.0002 7.43165 2.04834 7.21596L2.20752 6.28378ZM12.1424 21.3501H28.1599L19.9864 36.7162L12.1424 21.3501ZM3.88556 9.69711C3.86754 10.1001 3.85574 10.5518 3.85574 11.045C3.85574 13.0278 4.03217 15.7525 4.7719 18.723C5.47655 21.588 6.74465 24.9471 9.03305 28.2696C10.9848 31.0729 13.6802 33.878 17.4499 36.2675L3.88556 9.69711ZM22.5676 36.2279C26.2902 33.8538 28.9911 31.0855 30.9304 28.27C33.2187 24.9478 34.4869 21.5536 35.1918 18.723C35.9316 15.7525 36.108 13.0278 36.108 11.045C36.108 10.6048 36.0986 10.1978 36.0838 9.82887L31.1002 20.1594V20.2003L22.5676 36.2279Z"
            fill="white"
          />
          <path
            d="M61.8776 14.5669H50.3073C50.1037 14.5669 49.934 14.635 49.7644 14.8054C49.6287 14.9416 49.5269 15.146 49.5269 15.3504V24.6496C49.5269 24.854 49.5947 25.0243 49.7644 25.1946C49.9001 25.3309 50.1037 25.4331 50.3073 25.4331H61.8776V27H50.3073C49.6626 27 49.1197 26.7616 48.6786 26.3187C48.2375 25.8759 48 25.3309 48 24.6837V15.3163C48 14.6691 48.2375 14.1241 48.6786 13.6813C49.1197 13.2384 49.6626 13 50.3073 13H61.8776V14.5669Z"
            fill="white"
            stroke="white"
            strokeWidth="0.3"
            strokeMiterlimit="10"
          />
          <path
            d="M83.5933 13V14.5669H72.4641V19.1995H81.4218V20.8005H72.4641V25.4331H83.5933V27H70.9033V13.0341H83.5933V13Z"
            fill="white"
            stroke="white"
            strokeWidth="0.3"
            strokeMiterlimit="10"
          />
          <path
            d="M106.53 15.3163V19.4039C106.53 20.0511 106.292 20.5961 105.851 21.0389C105.41 21.4817 104.867 21.7202 104.222 21.7202H102.085L106.462 26.9319H104.392L100.015 21.7543H94.9254C94.8236 21.7543 94.5522 21.7202 94.179 21.6861V26.9659H92.6182V13H104.222C104.867 13 105.41 13.2384 105.851 13.6813C106.292 14.1241 106.53 14.6691 106.53 15.3163ZM94.9254 20.1533H104.188C104.392 20.1533 104.562 20.0852 104.697 19.9489C104.833 19.8127 104.901 19.6423 104.901 19.438V15.3504C104.901 15.146 104.833 14.9757 104.697 14.8054C104.562 14.6691 104.392 14.5669 104.188 14.5669H94.9254C94.7219 14.5669 94.5522 14.635 94.3825 14.8054C94.2468 14.9416 94.145 15.146 94.145 15.3504V19.438C94.145 19.6423 94.2129 19.8127 94.3825 19.9489C94.5183 20.0852 94.7219 20.1533 94.9254 20.1533Z"
            fill="white"
            stroke="white"
            strokeWidth="0.3"
            strokeMiterlimit="10"
          />
          <path
            d="M114.843 13H128.754V14.5669H122.579V26.9659H121.018V14.5669H114.843V13Z"
            fill="white"
            stroke="white"
            strokeWidth="0.3"
            strokeMiterlimit="10"
          />
          <path
            d="M137.169 26.9659V13H138.73V26.9659H137.169Z"
            fill="white"
            stroke="white"
            strokeWidth="0.3"
            strokeMiterlimit="10"
          />
          <path
            d="M159.631 13H161.633L155.831 19.983L161.667 26.9659H159.631L154.44 20.7664H149.961V26.9659H148.366V13H149.961V19.1995H154.44L159.631 13Z"
            fill="white"
            stroke="white"
            strokeWidth="0.3"
            strokeMiterlimit="10"
          />
        </svg>
      )}
      {...props}
    />
  );
};

export const ScoresGaugeReference = ({ ...props }) => (
  <Icon
    aria-label="scores gauge"
    component={() => (
      <svg
        width="592"
        height="87"
        viewBox="0 0 592 87"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.03871 15V5.54545H4.40874C5.14122 5.54545 5.74905 5.67164 6.23224 5.92401C6.71851 6.17637 7.08168 6.52569 7.32173 6.97195C7.56179 7.41513 7.68182 7.92756 7.68182 8.50923C7.68182 9.08783 7.56025 9.59718 7.31712 10.0373C7.07706 10.4743 6.7139 10.8144 6.22763 11.0575C5.74444 11.3007 5.1366 11.4222 4.40412 11.4222H1.85121V10.1942H4.27486C4.73651 10.1942 5.11198 10.1281 5.40128 9.99574C5.69366 9.8634 5.90755 9.67105 6.04297 9.41868C6.17839 9.16631 6.24609 8.86316 6.24609 8.50923C6.24609 8.15222 6.17685 7.84292 6.03835 7.58132C5.90294 7.31972 5.68904 7.11967 5.39666 6.98118C5.10736 6.83961 4.72727 6.76882 4.25639 6.76882H2.4652V15H1.03871ZM5.70597 10.7344L8.0419 15H6.4169L4.12713 10.7344H5.70597ZM9.30682 15V7.90909H10.6871V15H9.30682ZM10.0039 6.81499C9.76385 6.81499 9.55765 6.73497 9.3853 6.57493C9.21603 6.41181 9.13139 6.21792 9.13139 5.99325C9.13139 5.76551 9.21603 5.57161 9.3853 5.41158C9.55765 5.24846 9.76385 5.1669 10.0039 5.1669C10.244 5.1669 10.4486 5.24846 10.6179 5.41158C10.7902 5.57161 10.8764 5.76551 10.8764 5.99325C10.8764 6.21792 10.7902 6.41181 10.6179 6.57493C10.4486 6.73497 10.244 6.81499 10.0039 6.81499ZM17.8577 9.64027L16.6066 9.86186C16.5543 9.70182 16.4712 9.54948 16.3573 9.40483C16.2465 9.26018 16.0957 9.14169 15.9049 9.04936C15.7141 8.95703 15.4756 8.91087 15.1894 8.91087C14.7985 8.91087 14.4723 8.99858 14.2107 9.17401C13.9491 9.34635 13.8183 9.56948 13.8183 9.84339C13.8183 10.0804 13.906 10.2712 14.0814 10.4158C14.2568 10.5605 14.54 10.679 14.9308 10.7713L16.0573 11.0298C16.7097 11.1806 17.196 11.413 17.5161 11.7269C17.8361 12.0408 17.9962 12.4486 17.9962 12.9503C17.9962 13.375 17.8731 13.7536 17.6269 14.0859C17.3837 14.4152 17.0436 14.6738 16.6066 14.8615C16.1727 15.0492 15.6695 15.1431 15.097 15.1431C14.303 15.1431 13.6552 14.9738 13.1535 14.6353C12.6518 14.2937 12.3441 13.8089 12.2302 13.1811L13.5644 12.978C13.6475 13.3258 13.8183 13.5889 14.0768 13.7674C14.3353 13.9428 14.6723 14.0305 15.0878 14.0305C15.5402 14.0305 15.9018 13.9367 16.1727 13.7489C16.4435 13.5581 16.5789 13.3258 16.5789 13.0518C16.5789 12.8303 16.4958 12.6441 16.3296 12.4933C16.1665 12.3424 15.9157 12.2286 15.5771 12.1516L14.3769 11.8885C13.7152 11.7377 13.2258 11.4976 12.9088 11.1683C12.5949 10.839 12.4379 10.422 12.4379 9.91726C12.4379 9.4987 12.5549 9.13246 12.7888 8.81854C13.0227 8.50462 13.3459 8.25994 13.7583 8.08452C14.1707 7.90601 14.6431 7.81676 15.1755 7.81676C15.9419 7.81676 16.5451 7.98295 16.9852 8.31534C17.4253 8.64465 17.7161 9.08629 17.8577 9.64027ZM20.7834 12.5948L20.7741 10.9098H21.0142L23.8395 7.90909H25.4922L22.2699 11.3253H22.0529L20.7834 12.5948ZM19.5138 15V5.54545H20.8942V15H19.5138ZM23.9918 15L21.4528 11.63L22.4038 10.6651L25.6861 15H23.9918ZM35.458 8.02912C35.4088 7.59209 35.2056 7.25355 34.8486 7.01349C34.4916 6.77036 34.0423 6.64879 33.5006 6.64879C33.1128 6.64879 32.7774 6.71035 32.4942 6.83345C32.2111 6.95348 31.991 7.11967 31.8341 7.33203C31.6802 7.54131 31.6032 7.77983 31.6032 8.04759C31.6032 8.27225 31.6556 8.46615 31.7602 8.62926C31.8679 8.79238 32.008 8.92933 32.1803 9.04013C32.3557 9.14785 32.5435 9.23864 32.7435 9.3125C32.9436 9.38329 33.1359 9.44176 33.3206 9.48793L34.2439 9.72798C34.5455 9.80185 34.8548 9.90187 35.1718 10.0281C35.4888 10.1542 35.7827 10.3204 36.0535 10.5266C36.3244 10.7328 36.5429 10.9883 36.7091 11.293C36.8783 11.5977 36.963 11.9624 36.963 12.3871C36.963 12.9226 36.8245 13.3981 36.5475 13.8136C36.2736 14.229 35.875 14.5568 35.3518 14.7969C34.8317 15.0369 34.2023 15.157 33.4637 15.157C32.7558 15.157 32.1434 15.0446 31.6263 14.82C31.1093 14.5953 30.7046 14.2768 30.4122 13.8643C30.1198 13.4489 29.9582 12.9564 29.9275 12.3871H31.3586C31.3863 12.7287 31.4971 13.0134 31.691 13.2411C31.8879 13.4658 32.1388 13.6335 32.4434 13.7443C32.7512 13.852 33.0882 13.9059 33.4545 13.9059C33.8576 13.9059 34.2162 13.8428 34.5301 13.7166C34.8471 13.5874 35.0964 13.4089 35.278 13.1811C35.4595 12.9503 35.5503 12.681 35.5503 12.3732C35.5503 12.0932 35.4703 11.8639 35.3103 11.6854C35.1533 11.5069 34.9394 11.3591 34.6686 11.2422C34.4008 11.1252 34.0977 11.0221 33.7591 10.9329L32.642 10.6282C31.8849 10.422 31.2847 10.1188 30.8415 9.71875C30.4014 9.31866 30.1814 8.7893 30.1814 8.13068C30.1814 7.58594 30.3291 7.11044 30.6246 6.70419C30.92 6.29794 31.3201 5.98248 31.8248 5.75781C32.3296 5.53007 32.8989 5.41619 33.5329 5.41619C34.1731 5.41619 34.7378 5.52853 35.2272 5.7532C35.7196 5.97786 36.1074 6.28717 36.3905 6.68111C36.6737 7.07197 36.8214 7.52131 36.8337 8.02912H35.458ZM41.5437 15.1431C40.8574 15.1431 40.2665 14.9877 39.771 14.6768C39.2785 14.3629 38.9 13.9305 38.6353 13.3796C38.3706 12.8287 38.2383 12.1978 38.2383 11.4869C38.2383 10.7667 38.3737 10.1312 38.6445 9.58026C38.9154 9.02628 39.297 8.59387 39.7894 8.28303C40.2818 7.97218 40.862 7.81676 41.5298 7.81676C42.0684 7.81676 42.5485 7.91679 42.9702 8.11683C43.3918 8.3138 43.7319 8.59079 43.9904 8.9478C44.252 9.30481 44.4074 9.72183 44.4567 10.1989H43.1133C43.0394 9.86648 42.8701 9.58026 42.6055 9.3402C42.3439 9.10014 41.993 8.98011 41.5529 8.98011C41.1682 8.98011 40.8312 9.08168 40.5419 9.2848C40.2557 9.48485 40.0326 9.77107 39.8725 10.1435C39.7125 10.5128 39.6325 10.9498 39.6325 11.4545C39.6325 11.9716 39.7109 12.4179 39.8679 12.7933C40.0249 13.1688 40.2464 13.4596 40.5327 13.6658C40.822 13.872 41.1621 13.9751 41.5529 13.9751C41.8145 13.9751 42.0515 13.9274 42.2638 13.832C42.4793 13.7335 42.6593 13.5935 42.804 13.4119C42.9517 13.2304 43.0548 13.0118 43.1133 12.7564H44.4567C44.4074 13.215 44.2582 13.6243 44.0089 13.9844C43.7596 14.3445 43.4257 14.6276 43.0071 14.8338C42.5916 15.04 42.1038 15.1431 41.5437 15.1431ZM48.9197 15.1431C48.2549 15.1431 47.6747 14.9908 47.1792 14.6861C46.6837 14.3814 46.299 13.9551 46.0251 13.4073C45.7512 12.8595 45.6143 12.2193 45.6143 11.4869C45.6143 10.7513 45.7512 10.1081 46.0251 9.55717C46.299 9.00627 46.6837 8.57848 47.1792 8.27379C47.6747 7.96911 48.2549 7.81676 48.9197 7.81676C49.5844 7.81676 50.1646 7.96911 50.6601 8.27379C51.1556 8.57848 51.5403 9.00627 51.8142 9.55717C52.0881 10.1081 52.2251 10.7513 52.2251 11.4869C52.2251 12.2193 52.0881 12.8595 51.8142 13.4073C51.5403 13.9551 51.1556 14.3814 50.6601 14.6861C50.1646 14.9908 49.5844 15.1431 48.9197 15.1431ZM48.9243 13.9844C49.3551 13.9844 49.7122 13.8705 49.9953 13.6428C50.2784 13.415 50.4877 13.1119 50.6231 12.7333C50.7616 12.3548 50.8309 11.9377 50.8309 11.4822C50.8309 11.0298 50.7616 10.6143 50.6231 10.2358C50.4877 9.85417 50.2784 9.54794 49.9953 9.31712C49.7122 9.08629 49.3551 8.97088 48.9243 8.97088C48.4903 8.97088 48.1302 9.08629 47.844 9.31712C47.5609 9.54794 47.3501 9.85417 47.2116 10.2358C47.0761 10.6143 47.0084 11.0298 47.0084 11.4822C47.0084 11.9377 47.0761 12.3548 47.2116 12.7333C47.3501 13.1119 47.5609 13.415 47.844 13.6428C48.1302 13.8705 48.4903 13.9844 48.9243 13.9844ZM53.7658 15V7.90909H55.1V9.03551H55.1738C55.3031 8.65388 55.5308 8.35381 55.8571 8.1353C56.1864 7.91371 56.5588 7.80291 56.9743 7.80291C57.0604 7.80291 57.162 7.80599 57.2789 7.81214C57.399 7.8183 57.4928 7.82599 57.5605 7.83523V9.15554C57.5051 9.14015 57.4067 9.12322 57.2651 9.10476C57.1235 9.08321 56.9819 9.07244 56.8404 9.07244C56.5141 9.07244 56.2233 9.14169 55.9679 9.28018C55.7155 9.4156 55.5154 9.60488 55.3677 9.84801C55.22 10.0881 55.1461 10.362 55.1461 10.6697V15H53.7658ZM61.5573 15.1431C60.8586 15.1431 60.257 14.9938 59.7522 14.6953C59.2506 14.3937 58.8628 13.9705 58.5889 13.4258C58.318 12.878 58.1826 12.2363 58.1826 11.5007C58.1826 10.7744 58.318 10.1342 58.5889 9.58026C58.8628 9.02628 59.2444 8.59387 59.7338 8.28303C60.2262 7.97218 60.8017 7.81676 61.4603 7.81676C61.8604 7.81676 62.2482 7.88293 62.6237 8.01527C62.9991 8.14761 63.3361 8.35535 63.6347 8.63849C63.9332 8.92164 64.1686 9.28942 64.341 9.74183C64.5133 10.1912 64.5995 10.7375 64.5995 11.3807V11.87H58.9628V10.8359H63.2469C63.2469 10.4728 63.173 10.1512 63.0253 9.87109C62.8776 9.58795 62.6698 9.36482 62.4021 9.2017C62.1374 9.03859 61.8266 8.95703 61.4695 8.95703C61.0818 8.95703 60.7432 9.05244 60.4539 9.24325C60.1677 9.43099 59.9461 9.6772 59.7892 9.98189C59.6353 10.2835 59.5583 10.6113 59.5583 10.9652V11.7731C59.5583 12.247 59.6414 12.6502 59.8076 12.9826C59.9769 13.315 60.2123 13.5689 60.5139 13.7443C60.8155 13.9167 61.1679 14.0028 61.5711 14.0028C61.8327 14.0028 62.0712 13.9659 62.2867 13.892C62.5021 13.8151 62.6883 13.7012 62.8453 13.5504C63.0022 13.3996 63.1222 13.2134 63.2053 12.9918L64.5118 13.2273C64.4072 13.612 64.2194 13.949 63.9486 14.2383C63.6808 14.5245 63.3438 14.7476 62.9376 14.9077C62.5344 15.0646 62.0743 15.1431 61.5573 15.1431ZM69.6823 15V5.54545H73.0523C73.7848 5.54545 74.3926 5.67164 74.8758 5.92401C75.3621 6.17637 75.7252 6.52569 75.9653 6.97195C76.2053 7.41513 76.3254 7.92756 76.3254 8.50923C76.3254 9.08783 76.2038 9.59718 75.9607 10.0373C75.7206 10.4743 75.3575 10.8144 74.8712 11.0575C74.388 11.3007 73.7802 11.4222 73.0477 11.4222H70.4948V10.1942H72.9184C73.3801 10.1942 73.7555 10.1281 74.0448 9.99574C74.3372 9.8634 74.5511 9.67105 74.6865 9.41868C74.8219 9.16631 74.8896 8.86316 74.8896 8.50923C74.8896 8.15222 74.8204 7.84292 74.6819 7.58132C74.5465 7.31972 74.3326 7.11967 74.0402 6.98118C73.7509 6.83961 73.3708 6.76882 72.8999 6.76882H71.1088V15H69.6823ZM74.3495 10.7344L76.6855 15H75.0605L72.7707 10.7344H74.3495ZM80.9176 15.1431C80.219 15.1431 79.6173 14.9938 79.1126 14.6953C78.6109 14.3937 78.2231 13.9705 77.9492 13.4258C77.6784 12.878 77.543 12.2363 77.543 11.5007C77.543 10.7744 77.6784 10.1342 77.9492 9.58026C78.2231 9.02628 78.6048 8.59387 79.0941 8.28303C79.5865 7.97218 80.1621 7.81676 80.8207 7.81676C81.2208 7.81676 81.6085 7.88293 81.984 8.01527C82.3595 8.14761 82.6965 8.35535 82.995 8.63849C83.2936 8.92164 83.529 9.28942 83.7013 9.74183C83.8737 10.1912 83.9599 10.7375 83.9599 11.3807V11.87H78.3232V10.8359H82.6072C82.6072 10.4728 82.5334 10.1512 82.3857 9.87109C82.2379 9.58795 82.0302 9.36482 81.7624 9.2017C81.4978 9.03859 81.1869 8.95703 80.8299 8.95703C80.4421 8.95703 80.1036 9.05244 79.8143 9.24325C79.5281 9.43099 79.3065 9.6772 79.1495 9.98189C78.9956 10.2835 78.9187 10.6113 78.9187 10.9652V11.7731C78.9187 12.247 79.0018 12.6502 79.168 12.9826C79.3372 13.315 79.5727 13.5689 79.8743 13.7443C80.1759 13.9167 80.5283 14.0028 80.9315 14.0028C81.1931 14.0028 81.4316 13.9659 81.647 13.892C81.8625 13.8151 82.0487 13.7012 82.2056 13.5504C82.3626 13.3996 82.4826 13.2134 82.5657 12.9918L83.8722 13.2273C83.7675 13.612 83.5798 13.949 83.3089 14.2383C83.0412 14.5245 82.7042 14.7476 82.2979 14.9077C81.8948 15.0646 81.4347 15.1431 80.9176 15.1431ZM88.866 7.90909V9.01705H84.8589V7.90909H88.866ZM85.9577 15V7.08736C85.9577 6.64418 86.0546 6.2764 86.2485 5.98402C86.4424 5.68857 86.6994 5.46851 87.0194 5.32386C87.3395 5.17614 87.6873 5.10227 88.0628 5.10227C88.3398 5.10227 88.5767 5.12535 88.7737 5.17152C88.9707 5.21461 89.1169 5.25462 89.2123 5.29155L88.8891 6.40874C88.8245 6.39027 88.7414 6.36873 88.6398 6.34411C88.5383 6.31641 88.4152 6.30256 88.2705 6.30256C87.935 6.30256 87.695 6.38565 87.5503 6.55185C87.4088 6.71804 87.338 6.9581 87.338 7.27202V15H85.9577ZM93.067 15.1431C92.3684 15.1431 91.7667 14.9938 91.262 14.6953C90.7603 14.3937 90.3725 13.9705 90.0986 13.4258C89.8278 12.878 89.6924 12.2363 89.6924 11.5007C89.6924 10.7744 89.8278 10.1342 90.0986 9.58026C90.3725 9.02628 90.7542 8.59387 91.2435 8.28303C91.7359 7.97218 92.3115 7.81676 92.9701 7.81676C93.3702 7.81676 93.758 7.88293 94.1334 8.01527C94.5089 8.14761 94.8459 8.35535 95.1444 8.63849C95.443 8.92164 95.6784 9.28942 95.8508 9.74183C96.0231 10.1912 96.1093 10.7375 96.1093 11.3807V11.87H90.4726V10.8359H94.7567C94.7567 10.4728 94.6828 10.1512 94.5351 9.87109C94.3873 9.58795 94.1796 9.36482 93.9118 9.2017C93.6472 9.03859 93.3363 8.95703 92.9793 8.95703C92.5915 8.95703 92.253 9.05244 91.9637 9.24325C91.6775 9.43099 91.4559 9.6772 91.2989 9.98189C91.145 10.2835 91.0681 10.6113 91.0681 10.9652V11.7731C91.0681 12.247 91.1512 12.6502 91.3174 12.9826C91.4867 13.315 91.7221 13.5689 92.0237 13.7443C92.3253 13.9167 92.6777 14.0028 93.0809 14.0028C93.3425 14.0028 93.581 13.9659 93.7964 13.892C94.0119 13.8151 94.1981 13.7012 94.355 13.5504C94.512 13.3996 94.632 13.2134 94.7151 12.9918L96.0216 13.2273C95.9169 13.612 95.7292 13.949 95.4584 14.2383C95.1906 14.5245 94.8536 14.7476 94.4474 14.9077C94.0442 15.0646 93.5841 15.1431 93.067 15.1431ZM97.6408 15V7.90909H98.975V9.03551H99.0488C99.1781 8.65388 99.4058 8.35381 99.7321 8.1353C100.061 7.91371 100.434 7.80291 100.849 7.80291C100.935 7.80291 101.037 7.80599 101.154 7.81214C101.274 7.8183 101.368 7.82599 101.436 7.83523V9.15554C101.38 9.14015 101.282 9.12322 101.14 9.10476C100.999 9.08321 100.857 9.07244 100.715 9.07244C100.389 9.07244 100.098 9.14169 99.8429 9.28018C99.5905 9.4156 99.3904 9.60488 99.2427 9.84801C99.095 10.0881 99.0211 10.362 99.0211 10.6697V15H97.6408ZM105.432 15.1431C104.734 15.1431 104.132 14.9938 103.627 14.6953C103.126 14.3937 102.738 13.9705 102.464 13.4258C102.193 12.878 102.058 12.2363 102.058 11.5007C102.058 10.7744 102.193 10.1342 102.464 9.58026C102.738 9.02628 103.119 8.59387 103.609 8.28303C104.101 7.97218 104.677 7.81676 105.335 7.81676C105.735 7.81676 106.123 7.88293 106.499 8.01527C106.874 8.14761 107.211 8.35535 107.51 8.63849C107.808 8.92164 108.044 9.28942 108.216 9.74183C108.388 10.1912 108.475 10.7375 108.475 11.3807V11.87H102.838V10.8359H107.122C107.122 10.4728 107.048 10.1512 106.9 9.87109C106.753 9.58795 106.545 9.36482 106.277 9.2017C106.012 9.03859 105.702 8.95703 105.345 8.95703C104.957 8.95703 104.618 9.05244 104.329 9.24325C104.043 9.43099 103.821 9.6772 103.664 9.98189C103.51 10.2835 103.433 10.6113 103.433 10.9652V11.7731C103.433 12.247 103.516 12.6502 103.683 12.9826C103.852 13.315 104.087 13.5689 104.389 13.7443C104.691 13.9167 105.043 14.0028 105.446 14.0028C105.708 14.0028 105.946 13.9659 106.162 13.892C106.377 13.8151 106.563 13.7012 106.72 13.5504C106.877 13.3996 106.997 13.2134 107.08 12.9918L108.387 13.2273C108.282 13.612 108.094 13.949 107.824 14.2383C107.556 14.5245 107.219 14.7476 106.813 14.9077C106.409 15.0646 105.949 15.1431 105.432 15.1431ZM111.386 10.7898V15H110.006V7.90909H111.331V9.06321H111.419C111.582 8.68774 111.837 8.38613 112.185 8.15838C112.536 7.93063 112.978 7.81676 113.51 7.81676C113.993 7.81676 114.416 7.91832 114.779 8.12145C115.143 8.3215 115.424 8.62003 115.624 9.01705C115.824 9.41406 115.924 9.90495 115.924 10.4897V15H114.544V10.6559C114.544 10.1419 114.41 9.74029 114.142 9.45099C113.875 9.15862 113.507 9.01243 113.039 9.01243C112.719 9.01243 112.434 9.08168 112.185 9.22017C111.939 9.35866 111.743 9.56179 111.599 9.82955C111.457 10.0942 111.386 10.4143 111.386 10.7898ZM120.762 15.1431C120.076 15.1431 119.485 14.9877 118.99 14.6768C118.497 14.3629 118.119 13.9305 117.854 13.3796C117.589 12.8287 117.457 12.1978 117.457 11.4869C117.457 10.7667 117.592 10.1312 117.863 9.58026C118.134 9.02628 118.516 8.59387 119.008 8.28303C119.501 7.97218 120.081 7.81676 120.749 7.81676C121.287 7.81676 121.767 7.91679 122.189 8.11683C122.611 8.3138 122.951 8.59079 123.209 8.9478C123.471 9.30481 123.626 9.72183 123.675 10.1989H122.332C122.258 9.86648 122.089 9.58026 121.824 9.3402C121.563 9.10014 121.212 8.98011 120.772 8.98011C120.387 8.98011 120.05 9.08168 119.761 9.2848C119.474 9.48485 119.251 9.77107 119.091 10.1435C118.931 10.5128 118.851 10.9498 118.851 11.4545C118.851 11.9716 118.93 12.4179 119.087 12.7933C119.244 13.1688 119.465 13.4596 119.751 13.6658C120.041 13.872 120.381 13.9751 120.772 13.9751C121.033 13.9751 121.27 13.9274 121.483 13.832C121.698 13.7335 121.878 13.5935 122.023 13.4119C122.17 13.2304 122.274 13.0118 122.332 12.7564H123.675C123.626 13.215 123.477 13.6243 123.228 13.9844C122.978 14.3445 122.644 14.6276 122.226 14.8338C121.81 15.04 121.323 15.1431 120.762 15.1431ZM128.208 15.1431C127.509 15.1431 126.907 14.9938 126.403 14.6953C125.901 14.3937 125.513 13.9705 125.239 13.4258C124.968 12.878 124.833 12.2363 124.833 11.5007C124.833 10.7744 124.968 10.1342 125.239 9.58026C125.513 9.02628 125.895 8.59387 126.384 8.28303C126.877 7.97218 127.452 7.81676 128.111 7.81676C128.511 7.81676 128.899 7.88293 129.274 8.01527C129.65 8.14761 129.987 8.35535 130.285 8.63849C130.584 8.92164 130.819 9.28942 130.991 9.74183C131.164 10.1912 131.25 10.7375 131.25 11.3807V11.87H125.613V10.8359H129.897C129.897 10.4728 129.823 10.1512 129.676 9.87109C129.528 9.58795 129.32 9.36482 129.052 9.2017C128.788 9.03859 128.477 8.95703 128.12 8.95703C127.732 8.95703 127.394 9.05244 127.104 9.24325C126.818 9.43099 126.597 9.6772 126.44 9.98189C126.286 10.2835 126.209 10.6113 126.209 10.9652V11.7731C126.209 12.247 126.292 12.6502 126.458 12.9826C126.627 13.315 126.863 13.5689 127.164 13.7443C127.466 13.9167 127.818 14.0028 128.222 14.0028C128.483 14.0028 128.722 13.9659 128.937 13.892C129.152 13.8151 129.339 13.7012 129.496 13.5504C129.653 13.3996 129.773 13.2134 129.856 12.9918L131.162 13.2273C131.058 13.612 130.87 13.949 130.599 14.2383C130.331 14.5245 129.994 14.7476 129.588 14.9077C129.185 15.0646 128.725 15.1431 128.208 15.1431Z"
          fill="#616161"
        />
        <g clipPath="url(#clip0_503_34414)">
          <rect y="28" width="51" height="24" fill="#668F56" />
          <rect x="51" y="28" width="51" height="24" fill="#9DC671" />
          <rect x="102" y="28" width="51" height="24" fill="#9DC671" />
          <rect x="153" y="28" width="51" height="24" fill="#9DC671" />
          <rect x="204" y="28" width="51" height="24" fill="#FFE8C5" />
          <rect x="255" y="28" width="51" height="24" fill="#FFE8C5" />
          <rect x="306" y="28" width="51" height="24" fill="#FCA940" />
          <rect x="357" y="28" width="51" height="24" fill="#FCA940" />
          <rect x="408" y="28" width="51" height="24" fill="#FCAA42" />
          <rect x="459" y="28" width="51" height="24" fill="#EA7D70" />
          <rect x="510" y="28" width="25.5" height="24" fill="#EA7D70" />
          <rect x="535.5" y="28" width="25.5" height="24" fill="#C95555" />
        </g>
        <path
          d="M1.72159 49.2727L4.15057 56.3807H4.24858L6.67756 49.2727H8.10085L4.96023 58H3.43892L0.298295 49.2727H1.72159ZM11.4237 58.1321C10.7788 58.1321 10.2234 57.9943 9.75746 57.7188C9.29439 57.4403 8.93643 57.0497 8.68359 56.5469C8.43359 56.0412 8.30859 55.4489 8.30859 54.7699C8.30859 54.0994 8.43359 53.5085 8.68359 52.9972C8.93643 52.4858 9.28871 52.0866 9.74041 51.7997C10.195 51.5128 10.7262 51.3693 11.3342 51.3693C11.7035 51.3693 12.0614 51.4304 12.408 51.5526C12.7546 51.6747 13.0657 51.8665 13.3413 52.1278C13.6168 52.3892 13.8342 52.7287 13.9933 53.1463C14.1523 53.5611 14.2319 54.0653 14.2319 54.6591V55.1108H9.02876V54.1562H12.9833C12.9833 53.821 12.9151 53.5241 12.7788 53.2656C12.6424 53.0043 12.4506 52.7983 12.2035 52.6477C11.9592 52.4972 11.6722 52.4219 11.3427 52.4219C10.9847 52.4219 10.6722 52.5099 10.4052 52.6861C10.141 52.8594 9.93643 53.0866 9.79155 53.3679C9.6495 53.6463 9.57848 53.9489 9.57848 54.2756V55.0213C9.57848 55.4588 9.65518 55.831 9.80859 56.1378C9.96484 56.4446 10.1822 56.679 10.4606 56.8409C10.739 57 11.0643 57.0795 11.4364 57.0795C11.6779 57.0795 11.8981 57.0455 12.0969 56.9773C12.2958 56.9062 12.4677 56.8011 12.6126 56.6619C12.7575 56.5227 12.8683 56.3509 12.945 56.1463L14.1509 56.3636C14.0543 56.7187 13.881 57.0298 13.631 57.2969C13.3839 57.5611 13.0728 57.767 12.6978 57.9148C12.3256 58.0597 11.9009 58.1321 11.4237 58.1321ZM15.6456 58V51.4545H16.8771V52.4943H16.9453C17.0646 52.142 17.2749 51.8651 17.576 51.6634C17.88 51.4588 18.2237 51.3565 18.6072 51.3565C18.6868 51.3565 18.7805 51.3594 18.8885 51.3651C18.9993 51.3707 19.0859 51.3778 19.1484 51.3864V52.6051C19.0973 52.5909 19.0064 52.5753 18.8757 52.5582C18.745 52.5384 18.6143 52.5284 18.4837 52.5284C18.1825 52.5284 17.9141 52.5923 17.6783 52.7202C17.4453 52.8452 17.2607 53.0199 17.1243 53.2443C16.9879 53.4659 16.9197 53.7187 16.9197 54.0028V58H15.6456ZM21.2557 60.4545C21.0653 60.4545 20.892 60.4389 20.7358 60.4077C20.5795 60.3793 20.4631 60.348 20.3864 60.3139L20.6932 59.2699C20.9261 59.3324 21.1335 59.3594 21.3153 59.3509C21.4972 59.3423 21.6577 59.2741 21.7969 59.1463C21.9389 59.0185 22.0639 58.8097 22.1719 58.5199L22.3295 58.0852L19.9347 51.4545H21.2983L22.956 56.5341H23.0241L24.6818 51.4545H26.0497L23.3523 58.8736C23.2273 59.2145 23.0682 59.5028 22.875 59.7386C22.6818 59.9773 22.4517 60.1563 22.1847 60.2756C21.9176 60.3949 21.608 60.4545 21.2557 60.4545ZM30.5252 58V49.2727H31.842V56.8665H35.7965V58H30.5252ZM39.9535 58.1321C39.3398 58.1321 38.8043 57.9915 38.3469 57.7102C37.8896 57.429 37.5344 57.0355 37.2816 56.5298C37.0288 56.0241 36.9023 55.4332 36.9023 54.7571C36.9023 54.0781 37.0288 53.4844 37.2816 52.9759C37.5344 52.4673 37.8896 52.0724 38.3469 51.7912C38.8043 51.5099 39.3398 51.3693 39.9535 51.3693C40.5671 51.3693 41.1026 51.5099 41.56 51.7912C42.0174 52.0724 42.3725 52.4673 42.6254 52.9759C42.8782 53.4844 43.0046 54.0781 43.0046 54.7571C43.0046 55.4332 42.8782 56.0241 42.6254 56.5298C42.3725 57.0355 42.0174 57.429 41.56 57.7102C41.1026 57.9915 40.5671 58.1321 39.9535 58.1321ZM39.9577 57.0625C40.3555 57.0625 40.685 56.9574 40.9464 56.7472C41.2077 56.5369 41.4009 56.2571 41.5259 55.9077C41.6538 55.5582 41.7177 55.1733 41.7177 54.7528C41.7177 54.3352 41.6538 53.9517 41.5259 53.6023C41.4009 53.25 41.2077 52.9673 40.9464 52.7543C40.685 52.5412 40.3555 52.4347 39.9577 52.4347C39.5572 52.4347 39.2248 52.5412 38.9606 52.7543C38.6992 52.9673 38.5046 53.25 38.3768 53.6023C38.2518 53.9517 38.1893 54.3352 38.1893 54.7528C38.1893 55.1733 38.2518 55.5582 38.3768 55.9077C38.5046 56.2571 38.6992 56.5369 38.9606 56.7472C39.2248 56.9574 39.5572 57.0625 39.9577 57.0625ZM45.6467 58L43.7205 51.4545H45.0373L46.32 56.2614H46.3839L47.6708 51.4545H48.9876L50.266 56.2401H50.3299L51.604 51.4545H52.9208L50.9989 58H49.6992L48.3697 53.2741H48.2717L46.9421 58H45.6467Z"
          fill="#616161"
        />
        <path
          d="M112.155 58V49.2727H113.472V56.8665H117.427V58H112.155ZM121.584 58.1321C120.97 58.1321 120.434 57.9915 119.977 57.7102C119.52 57.429 119.165 57.0355 118.912 56.5298C118.659 56.0241 118.532 55.4332 118.532 54.7571C118.532 54.0781 118.659 53.4844 118.912 52.9759C119.165 52.4673 119.52 52.0724 119.977 51.7912C120.434 51.5099 120.97 51.3693 121.584 51.3693C122.197 51.3693 122.733 51.5099 123.19 51.7912C123.647 52.0724 124.003 52.4673 124.255 52.9759C124.508 53.4844 124.635 54.0781 124.635 54.7571C124.635 55.4332 124.508 56.0241 124.255 56.5298C124.003 57.0355 123.647 57.429 123.19 57.7102C122.733 57.9915 122.197 58.1321 121.584 58.1321ZM121.588 57.0625C121.986 57.0625 122.315 56.9574 122.576 56.7472C122.838 56.5369 123.031 56.2571 123.156 55.9077C123.284 55.5582 123.348 55.1733 123.348 54.7528C123.348 54.3352 123.284 53.9517 123.156 53.6023C123.031 53.25 122.838 52.9673 122.576 52.7543C122.315 52.5412 121.986 52.4347 121.588 52.4347C121.187 52.4347 120.855 52.5412 120.591 52.7543C120.329 52.9673 120.135 53.25 120.007 53.6023C119.882 53.9517 119.819 54.3352 119.819 54.7528C119.819 55.1733 119.882 55.5582 120.007 55.9077C120.135 56.2571 120.329 56.5369 120.591 56.7472C120.855 56.9574 121.187 57.0625 121.588 57.0625ZM127.277 58L125.351 51.4545H126.667L127.95 56.2614H128.014L129.301 51.4545H130.618L131.896 56.2401H131.96L133.234 51.4545H134.551L132.629 58H131.329L130 53.2741H129.902L128.572 58H127.277Z"
          fill="#616161"
        />
        <path
          d="M241.464 49.2727V58H240.254L235.818 51.5994H235.737V58H234.42V49.2727H235.639L240.08 55.6818H240.16V49.2727H241.464ZM246.104 58.1321C245.459 58.1321 244.904 57.9943 244.438 57.7188C243.975 57.4403 243.617 57.0497 243.364 56.5469C243.114 56.0412 242.989 55.4489 242.989 54.7699C242.989 54.0994 243.114 53.5085 243.364 52.9972C243.617 52.4858 243.969 52.0866 244.421 51.7997C244.875 51.5128 245.407 51.3693 246.015 51.3693C246.384 51.3693 246.742 51.4304 247.088 51.5526C247.435 51.6747 247.746 51.8665 248.022 52.1278C248.297 52.3892 248.515 52.7287 248.674 53.1463C248.833 53.5611 248.912 54.0653 248.912 54.6591V55.1108H243.709V54.1562H247.664C247.664 53.821 247.595 53.5241 247.459 53.2656C247.323 53.0043 247.131 52.7983 246.884 52.6477C246.64 52.4972 246.353 52.4219 246.023 52.4219C245.665 52.4219 245.353 52.5099 245.086 52.6861C244.821 52.8594 244.617 53.0866 244.472 53.3679C244.33 53.6463 244.259 53.9489 244.259 54.2756V55.0213C244.259 55.4588 244.336 55.831 244.489 56.1378C244.645 56.4446 244.863 56.679 245.141 56.8409C245.419 57 245.745 57.0795 246.117 57.0795C246.358 57.0795 246.578 57.0455 246.777 56.9773C246.976 56.9062 247.148 56.8011 247.293 56.6619C247.438 56.5227 247.549 56.3509 247.625 56.1463L248.831 56.3636C248.735 56.7187 248.561 57.0298 248.311 57.2969C248.064 57.5611 247.753 57.767 247.378 57.9148C247.006 58.0597 246.581 58.1321 246.104 58.1321ZM254.472 55.2855V51.4545H255.751V58H254.498V56.8665H254.43C254.279 57.2159 254.038 57.5071 253.705 57.7401C253.376 57.9702 252.965 58.0852 252.474 58.0852C252.053 58.0852 251.681 57.9929 251.357 57.8082C251.036 57.6207 250.783 57.3438 250.599 56.9773C250.417 56.6108 250.326 56.1577 250.326 55.6179V51.4545H251.6V55.4645C251.6 55.9105 251.724 56.2656 251.971 56.5298C252.218 56.794 252.539 56.9261 252.934 56.9261C253.173 56.9261 253.41 56.8665 253.646 56.7472C253.884 56.6278 254.082 56.4474 254.238 56.206C254.397 55.9645 254.475 55.6577 254.472 55.2855ZM260.518 51.4545V52.4773H256.943V51.4545H260.518ZM257.902 49.8864H259.176V56.0781C259.176 56.3253 259.213 56.5114 259.287 56.6364C259.36 56.7585 259.456 56.8423 259.572 56.8878C259.691 56.9304 259.821 56.9517 259.96 56.9517C260.062 56.9517 260.152 56.9446 260.228 56.9304C260.305 56.9162 260.365 56.9048 260.407 56.8963L260.637 57.9489C260.564 57.9773 260.458 58.0057 260.322 58.0341C260.186 58.0653 260.015 58.0824 259.811 58.0852C259.475 58.0909 259.163 58.0312 258.873 57.9062C258.583 57.7812 258.349 57.5881 258.17 57.3267C257.991 57.0653 257.902 56.7372 257.902 56.3423V49.8864ZM261.928 58V51.4545H263.159V52.4943H263.227C263.347 52.142 263.557 51.8651 263.858 51.6634C264.162 51.4588 264.506 51.3565 264.889 51.3565C264.969 51.3565 265.062 51.3594 265.17 51.3651C265.281 51.3707 265.368 51.3778 265.43 51.3864V52.6051C265.379 52.5909 265.288 52.5753 265.158 52.5582C265.027 52.5384 264.896 52.5284 264.766 52.5284C264.464 52.5284 264.196 52.5923 263.96 52.7202C263.727 52.8452 263.543 53.0199 263.406 53.2443C263.27 53.4659 263.202 53.7187 263.202 54.0028V58H261.928ZM268.379 58.1449C267.964 58.1449 267.589 58.0682 267.254 57.9148C266.919 57.7585 266.653 57.5327 266.457 57.2372C266.264 56.9418 266.168 56.5795 266.168 56.1506C266.168 55.7812 266.239 55.4773 266.381 55.2386C266.523 55 266.714 54.8111 266.956 54.6719C267.197 54.5327 267.467 54.4276 267.766 54.3565C268.064 54.2855 268.368 54.2315 268.678 54.1946C269.07 54.1491 269.388 54.1122 269.632 54.0838C269.876 54.0526 270.054 54.0028 270.165 53.9347C270.276 53.8665 270.331 53.7557 270.331 53.6023V53.5724C270.331 53.2003 270.226 52.9119 270.016 52.7074C269.808 52.5028 269.499 52.4006 269.087 52.4006C268.658 52.4006 268.32 52.4957 268.072 52.6861C267.828 52.8736 267.659 53.0824 267.565 53.3125L266.368 53.0398C266.51 52.642 266.717 52.321 266.99 52.0767C267.266 51.8295 267.582 51.6506 267.94 51.5398C268.298 51.4261 268.675 51.3693 269.07 51.3693C269.331 51.3693 269.608 51.4006 269.901 51.4631C270.196 51.5227 270.472 51.6335 270.727 51.7955C270.986 51.9574 271.197 52.1889 271.362 52.4901C271.527 52.7884 271.609 53.1761 271.609 53.6534V58H270.365V57.1051H270.314C270.232 57.2699 270.108 57.4318 269.943 57.5909C269.778 57.75 269.567 57.8821 269.308 57.9872C269.05 58.0923 268.74 58.1449 268.379 58.1449ZM268.656 57.1222C269.008 57.1222 269.31 57.0526 269.56 56.9134C269.812 56.7741 270.004 56.5923 270.135 56.3679C270.268 56.1406 270.335 55.8977 270.335 55.6392V54.7955C270.29 54.8409 270.202 54.8835 270.071 54.9233C269.943 54.9602 269.797 54.9929 269.632 55.0213C269.467 55.0469 269.307 55.071 269.151 55.0938C268.994 55.1136 268.864 55.1307 268.758 55.1449C268.511 55.1761 268.285 55.2287 268.081 55.3026C267.879 55.3764 267.717 55.483 267.595 55.6222C267.476 55.7585 267.416 55.9403 267.416 56.1676C267.416 56.483 267.533 56.7216 267.766 56.8835C267.999 57.0426 268.295 57.1222 268.656 57.1222ZM274.581 49.2727V58H273.306V49.2727H274.581Z"
          fill="#616161"
        />
        <path
          d="M362.981 49.2727H364.579L367.358 56.0568H367.46L370.239 49.2727H371.837V58H370.584V51.6847H370.503L367.929 57.9872H366.889L364.315 51.6804H364.234V58H362.981V49.2727ZM376.47 58.1321C375.825 58.1321 375.269 57.9943 374.804 57.7188C374.34 57.4403 373.983 57.0497 373.73 56.5469C373.48 56.0412 373.355 55.4489 373.355 54.7699C373.355 54.0994 373.48 53.5085 373.73 52.9972C373.983 52.4858 374.335 52.0866 374.787 51.7997C375.241 51.5128 375.772 51.3693 376.38 51.3693C376.75 51.3693 377.108 51.4304 377.454 51.5526C377.801 51.6747 378.112 51.8665 378.387 52.1278C378.663 52.3892 378.88 52.7287 379.039 53.1463C379.198 53.5611 379.278 54.0653 379.278 54.6591V55.1108H374.075V54.1562H378.029C378.029 53.821 377.961 53.5241 377.825 53.2656C377.688 53.0043 377.497 52.7983 377.25 52.6477C377.005 52.4972 376.718 52.4219 376.389 52.4219C376.031 52.4219 375.718 52.5099 375.451 52.6861C375.187 52.8594 374.983 53.0866 374.838 53.3679C374.696 53.6463 374.625 53.9489 374.625 54.2756V55.0213C374.625 55.4588 374.701 55.831 374.855 56.1378C375.011 56.4446 375.228 56.679 375.507 56.8409C375.785 57 376.11 57.0795 376.483 57.0795C376.724 57.0795 376.944 57.0455 377.143 56.9773C377.342 56.9062 377.514 56.8011 377.659 56.6619C377.804 56.5227 377.914 56.3509 377.991 56.1463L379.197 56.3636C379.1 56.7187 378.927 57.0298 378.677 57.2969C378.43 57.5611 378.119 57.767 377.744 57.9148C377.372 58.0597 376.947 58.1321 376.47 58.1321ZM383.142 58.1278C382.614 58.1278 382.142 57.9929 381.727 57.723C381.315 57.4503 380.991 57.0625 380.756 56.5597C380.523 56.054 380.406 55.4474 380.406 54.7401C380.406 54.0327 380.524 53.4276 380.76 52.9247C380.999 52.4219 381.325 52.0369 381.74 51.7699C382.155 51.5028 382.625 51.3693 383.15 51.3693C383.557 51.3693 383.883 51.4375 384.131 51.5739C384.381 51.7074 384.574 51.8636 384.71 52.0426C384.849 52.2216 384.957 52.3793 385.034 52.5156H385.111V49.2727H386.385V58H385.141V56.9815H385.034C384.957 57.1207 384.847 57.2798 384.702 57.4588C384.56 57.6378 384.364 57.794 384.114 57.9276C383.864 58.0611 383.54 58.1278 383.142 58.1278ZM383.423 57.0412C383.79 57.0412 384.099 56.9446 384.352 56.7514C384.608 56.5554 384.801 56.2841 384.932 55.9375C385.065 55.5909 385.132 55.1875 385.132 54.7273C385.132 54.2727 385.067 53.875 384.936 53.5341C384.805 53.1932 384.614 52.9276 384.361 52.7372C384.108 52.5469 383.795 52.4517 383.423 52.4517C383.04 52.4517 382.72 52.5511 382.464 52.75C382.209 52.9489 382.016 53.2202 381.885 53.5639C381.757 53.9077 381.693 54.2955 381.693 54.7273C381.693 55.1648 381.758 55.5582 381.889 55.9077C382.02 56.2571 382.213 56.5341 382.469 56.7386C382.727 56.9403 383.045 57.0412 383.423 57.0412ZM388.203 58V51.4545H389.478V58H388.203ZM388.847 50.4446C388.625 50.4446 388.435 50.3707 388.276 50.223C388.12 50.0724 388.041 49.8935 388.041 49.6861C388.041 49.4759 388.12 49.2969 388.276 49.1491C388.435 48.9986 388.625 48.9233 388.847 48.9233C389.068 48.9233 389.257 48.9986 389.414 49.1491C389.573 49.2969 389.652 49.4759 389.652 49.6861C389.652 49.8935 389.573 50.0724 389.414 50.223C389.257 50.3707 389.068 50.4446 388.847 50.4446ZM395.338 55.2855V51.4545H396.616V58H395.364V56.8665H395.295C395.145 57.2159 394.903 57.5071 394.571 57.7401C394.241 57.9702 393.831 58.0852 393.339 58.0852C392.919 58.0852 392.547 57.9929 392.223 57.8082C391.902 57.6207 391.649 57.3438 391.464 56.9773C391.283 56.6108 391.192 56.1577 391.192 55.6179V51.4545H392.466V55.4645C392.466 55.9105 392.589 56.2656 392.837 56.5298C393.084 56.794 393.405 56.9261 393.8 56.9261C394.038 56.9261 394.275 56.8665 394.511 56.7472C394.75 56.6278 394.947 56.4474 395.104 56.206C395.263 55.9645 395.341 55.6577 395.338 55.2855ZM398.328 58V51.4545H399.551V52.5199H399.632C399.769 52.1591 399.992 51.8778 400.301 51.6761C400.611 51.4716 400.982 51.3693 401.414 51.3693C401.851 51.3693 402.218 51.4716 402.513 51.6761C402.811 51.8807 403.032 52.1619 403.174 52.5199H403.242C403.398 52.1705 403.647 51.892 403.987 51.6847C404.328 51.4744 404.735 51.3693 405.206 51.3693C405.8 51.3693 406.284 51.5554 406.659 51.9276C407.037 52.2997 407.226 52.8608 407.226 53.6108V58H405.952V53.7301C405.952 53.2869 405.831 52.9659 405.59 52.767C405.348 52.5682 405.06 52.4688 404.725 52.4688C404.31 52.4688 403.987 52.5966 403.757 52.8523C403.527 53.1051 403.412 53.4304 403.412 53.8281V58H402.142V53.6491C402.142 53.294 402.032 53.0085 401.81 52.7926C401.588 52.5767 401.3 52.4688 400.945 52.4688C400.703 52.4688 400.48 52.5327 400.276 52.6605C400.074 52.7855 399.911 52.9602 399.786 53.1847C399.664 53.4091 399.603 53.669 399.603 53.9645V58H398.328Z"
          fill="#616161"
        />
        <path
          d="M484.549 58V49.2727H485.866V53.0653H490.216V49.2727H491.537V58H490.216V54.1946H485.866V58H484.549ZM493.353 58V51.4545H494.627V58H493.353ZM493.996 50.4446C493.775 50.4446 493.584 50.3707 493.425 50.223C493.269 50.0724 493.191 49.8935 493.191 49.6861C493.191 49.4759 493.269 49.2969 493.425 49.1491C493.584 48.9986 493.775 48.9233 493.996 48.9233C494.218 48.9233 494.407 48.9986 494.563 49.1491C494.722 49.2969 494.802 49.4759 494.802 49.6861C494.802 49.8935 494.722 50.0724 494.563 50.223C494.407 50.3707 494.218 50.4446 493.996 50.4446ZM499.085 60.5909C498.566 60.5909 498.118 60.5227 497.743 60.3864C497.371 60.25 497.067 60.0696 496.831 59.8452C496.595 59.6207 496.419 59.375 496.303 59.108L497.398 58.6562C497.475 58.7812 497.577 58.9134 497.705 59.0526C497.835 59.1946 498.012 59.3153 498.233 59.4148C498.458 59.5142 498.746 59.5639 499.098 59.5639C499.581 59.5639 499.98 59.446 500.296 59.2102C500.611 58.9773 500.769 58.6051 500.769 58.0938V56.8068H500.688C500.611 56.946 500.5 57.1009 500.355 57.2713C500.213 57.4418 500.017 57.5895 499.767 57.7145C499.517 57.8395 499.192 57.902 498.791 57.902C498.274 57.902 497.808 57.7812 497.394 57.5398C496.982 57.2955 496.655 56.9361 496.414 56.4616C496.175 55.9844 496.056 55.3977 496.056 54.7017C496.056 54.0057 496.173 53.4091 496.409 52.9119C496.648 52.4148 496.975 52.0341 497.389 51.7699C497.804 51.5028 498.274 51.3693 498.8 51.3693C499.206 51.3693 499.534 51.4375 499.784 51.5739C500.034 51.7074 500.229 51.8636 500.368 52.0426C500.51 52.2216 500.62 52.3793 500.696 52.5156H500.79V51.4545H502.039V58.1449C502.039 58.7074 501.908 59.169 501.647 59.5298C501.385 59.8906 501.031 60.1577 500.585 60.331C500.142 60.5043 499.642 60.5909 499.085 60.5909ZM499.073 56.8452C499.439 56.8452 499.749 56.7599 500.002 56.5895C500.257 56.4162 500.45 56.169 500.581 55.848C500.715 55.5241 500.781 55.1364 500.781 54.6847C500.781 54.2443 500.716 53.8565 500.585 53.5213C500.455 53.1861 500.263 52.9247 500.01 52.7372C499.757 52.5469 499.445 52.4517 499.073 52.4517C498.689 52.4517 498.37 52.5511 498.114 52.75C497.858 52.946 497.665 53.2131 497.534 53.5511C497.406 53.8892 497.343 54.267 497.343 54.6847C497.343 55.1136 497.408 55.4901 497.539 55.8139C497.669 56.1378 497.862 56.3906 498.118 56.5724C498.377 56.7543 498.695 56.8452 499.073 56.8452ZM505.022 54.1136V58H503.747V49.2727H505.004V52.5199H505.085C505.239 52.1676 505.473 51.8878 505.789 51.6804C506.104 51.473 506.516 51.3693 507.024 51.3693C507.473 51.3693 507.865 51.4616 508.2 51.6463C508.539 51.831 508.8 52.1065 508.985 52.473C509.172 52.8366 509.266 53.2912 509.266 53.8366V58H507.992V53.9901C507.992 53.5099 507.868 53.1378 507.621 52.8736C507.374 52.6065 507.03 52.473 506.59 52.473C506.289 52.473 506.019 52.5369 505.78 52.6648C505.544 52.7926 505.358 52.9801 505.222 53.2273C505.088 53.4716 505.022 53.767 505.022 54.1136Z"
          fill="#616161"
        />
        <path
          d="M537.636 49.2727L540.065 56.3807H540.163L542.592 49.2727H544.015L540.874 58H539.353L536.212 49.2727H537.636ZM547.338 58.1321C546.693 58.1321 546.137 57.9943 545.671 57.7188C545.208 57.4403 544.85 57.0497 544.598 56.5469C544.348 56.0412 544.223 55.4489 544.223 54.7699C544.223 54.0994 544.348 53.5085 544.598 52.9972C544.85 52.4858 545.203 52.0866 545.654 51.7997C546.109 51.5128 546.64 51.3693 547.248 51.3693C547.617 51.3693 547.975 51.4304 548.322 51.5526C548.669 51.6747 548.98 51.8665 549.255 52.1278C549.531 52.3892 549.748 52.7287 549.907 53.1463C550.066 53.5611 550.146 54.0653 550.146 54.6591V55.1108H544.943V54.1562H548.897C548.897 53.821 548.829 53.5241 548.693 53.2656C548.556 53.0043 548.365 52.7983 548.117 52.6477C547.873 52.4972 547.586 52.4219 547.257 52.4219C546.899 52.4219 546.586 52.5099 546.319 52.6861C546.055 52.8594 545.85 53.0866 545.706 53.3679C545.563 53.6463 545.492 53.9489 545.492 54.2756V55.0213C545.492 55.4588 545.569 55.831 545.723 56.1378C545.879 56.4446 546.096 56.679 546.375 56.8409C546.653 57 546.978 57.0795 547.35 57.0795C547.592 57.0795 547.812 57.0455 548.011 56.9773C548.21 56.9062 548.382 56.8011 548.527 56.6619C548.671 56.5227 548.782 56.3509 548.859 56.1463L550.065 56.3636C549.968 56.7187 549.795 57.0298 549.545 57.2969C549.298 57.5611 548.987 57.767 548.612 57.9148C548.24 58.0597 547.815 58.1321 547.338 58.1321ZM551.56 58V51.4545H552.791V52.4943H552.859C552.979 52.142 553.189 51.8651 553.49 51.6634C553.794 51.4588 554.138 51.3565 554.521 51.3565C554.601 51.3565 554.695 51.3594 554.802 51.3651C554.913 51.3707 555 51.3778 555.062 51.3864V52.6051C555.011 52.5909 554.92 52.5753 554.79 52.5582C554.659 52.5384 554.528 52.5284 554.398 52.5284C554.096 52.5284 553.828 52.5923 553.592 52.7202C553.359 52.8452 553.175 53.0199 553.038 53.2443C552.902 53.4659 552.834 53.7187 552.834 54.0028V58H551.56ZM557.17 60.4545C556.979 60.4545 556.806 60.4389 556.65 60.4077C556.494 60.3793 556.377 60.348 556.3 60.3139L556.607 59.2699C556.84 59.3324 557.047 59.3594 557.229 59.3509C557.411 59.3423 557.572 59.2741 557.711 59.1463C557.853 59.0185 557.978 58.8097 558.086 58.5199L558.244 58.0852L555.849 51.4545H557.212L558.87 56.5341H558.938L560.596 51.4545H561.964L559.266 58.8736C559.141 59.2145 558.982 59.5028 558.789 59.7386C558.596 59.9773 558.366 60.1563 558.099 60.2756C557.832 60.3949 557.522 60.4545 557.17 60.4545ZM566.439 58V49.2727H567.756V53.0653H572.107V49.2727H573.428V58H572.107V54.1946H567.756V58H566.439ZM575.243 58V51.4545H576.517V58H575.243ZM575.887 50.4446C575.665 50.4446 575.475 50.3707 575.316 50.223C575.159 50.0724 575.081 49.8935 575.081 49.6861C575.081 49.4759 575.159 49.2969 575.316 49.1491C575.475 48.9986 575.665 48.9233 575.887 48.9233C576.108 48.9233 576.297 48.9986 576.453 49.1491C576.612 49.2969 576.692 49.4759 576.692 49.6861C576.692 49.8935 576.612 50.0724 576.453 50.223C576.297 50.3707 576.108 50.4446 575.887 50.4446ZM580.976 60.5909C580.456 60.5909 580.008 60.5227 579.633 60.3864C579.261 60.25 578.957 60.0696 578.721 59.8452C578.486 59.6207 578.31 59.375 578.193 59.108L579.288 58.6562C579.365 58.7812 579.467 58.9134 579.595 59.0526C579.726 59.1946 579.902 59.3153 580.123 59.4148C580.348 59.5142 580.636 59.5639 580.989 59.5639C581.471 59.5639 581.871 59.446 582.186 59.2102C582.501 58.9773 582.659 58.6051 582.659 58.0938V56.8068H582.578C582.501 56.946 582.391 57.1009 582.246 57.2713C582.104 57.4418 581.908 57.5895 581.658 57.7145C581.408 57.8395 581.082 57.902 580.682 57.902C580.165 57.902 579.699 57.7812 579.284 57.5398C578.872 57.2955 578.545 56.9361 578.304 56.4616C578.065 55.9844 577.946 55.3977 577.946 54.7017C577.946 54.0057 578.064 53.4091 578.3 52.9119C578.538 52.4148 578.865 52.0341 579.28 51.7699C579.695 51.5028 580.165 51.3693 580.69 51.3693C581.096 51.3693 581.425 51.4375 581.675 51.5739C581.925 51.7074 582.119 51.8636 582.258 52.0426C582.4 52.2216 582.51 52.3793 582.587 52.5156H582.68V51.4545H583.929V58.1449C583.929 58.7074 583.798 59.169 583.537 59.5298C583.275 59.8906 582.922 60.1577 582.476 60.331C582.033 60.5043 581.533 60.5909 580.976 60.5909ZM580.963 56.8452C581.329 56.8452 581.639 56.7599 581.892 56.5895C582.148 56.4162 582.341 56.169 582.471 55.848C582.605 55.5241 582.672 55.1364 582.672 54.6847C582.672 54.2443 582.606 53.8565 582.476 53.5213C582.345 53.1861 582.153 52.9247 581.9 52.7372C581.648 52.5469 581.335 52.4517 580.963 52.4517C580.579 52.4517 580.26 52.5511 580.004 52.75C579.748 52.946 579.555 53.2131 579.425 53.5511C579.297 53.8892 579.233 54.267 579.233 54.6847C579.233 55.1136 579.298 55.4901 579.429 55.8139C579.56 56.1378 579.753 56.3906 580.008 56.5724C580.267 56.7543 580.585 56.8452 580.963 56.8452ZM586.912 54.1136V58H585.638V49.2727H586.895V52.5199H586.976C587.129 52.1676 587.364 51.8878 587.679 51.6804C587.994 51.473 588.406 51.3693 588.915 51.3693C589.364 51.3693 589.756 51.4616 590.091 51.6463C590.429 51.831 590.69 52.1065 590.875 52.473C591.062 52.8366 591.156 53.2912 591.156 53.8366V58H589.882V53.9901C589.882 53.5099 589.758 53.1378 589.511 52.8736C589.264 52.6065 588.92 52.473 588.48 52.473C588.179 52.473 587.909 52.5369 587.67 52.6648C587.435 52.7926 587.248 52.9801 587.112 53.2273C586.979 53.4716 586.912 53.767 586.912 54.1136Z"
          fill="#616161"
        />
        <path
          d="M3.87784 76.1449C3.20455 76.142 2.62926 75.9645 2.15199 75.6122C1.67472 75.2599 1.30966 74.7472 1.05682 74.0739C0.803977 73.4006 0.677557 72.5895 0.677557 71.6406C0.677557 70.6946 0.803977 69.8864 1.05682 69.2159C1.3125 68.5455 1.67898 68.0341 2.15625 67.6818C2.63636 67.3295 3.21023 67.1534 3.87784 67.1534C4.54545 67.1534 5.1179 67.331 5.59517 67.6861C6.07244 68.0384 6.4375 68.5497 6.69034 69.2202C6.94602 69.8878 7.07386 70.6946 7.07386 71.6406C7.07386 72.5923 6.94744 73.4048 6.6946 74.0781C6.44176 74.7486 6.0767 75.2614 5.59943 75.6165C5.12216 75.9688 4.5483 76.1449 3.87784 76.1449ZM3.87784 75.0071C4.46875 75.0071 4.9304 74.7188 5.26278 74.142C5.59801 73.5653 5.76562 72.7315 5.76562 71.6406C5.76562 70.9162 5.68892 70.304 5.53551 69.804C5.38494 69.3011 5.16761 68.9205 4.88352 68.6619C4.60227 68.4006 4.26705 68.2699 3.87784 68.2699C3.28977 68.2699 2.82813 68.5597 2.4929 69.1392C2.15767 69.7187 1.98864 70.5526 1.9858 71.6406C1.9858 72.3679 2.06108 72.983 2.21165 73.4858C2.36506 73.9858 2.58239 74.3651 2.86364 74.6236C3.14489 74.8793 3.48295 75.0071 3.87784 75.0071ZM15.6349 71.0824V72.1903H11.7656V71.0824H15.6349ZM23.3938 67.1534C23.783 67.1562 24.1665 67.2273 24.5444 67.3665C24.9222 67.5057 25.2631 67.733 25.5671 68.0483C25.8739 68.3636 26.1183 68.7898 26.3001 69.3267C26.4847 69.8608 26.5785 70.5256 26.5813 71.321C26.5813 72.0852 26.5046 72.7656 26.3512 73.3622C26.1978 73.956 25.9776 74.4574 25.6907 74.8665C25.4066 75.2756 25.0614 75.5866 24.6552 75.7997C24.2489 76.0128 23.7915 76.1193 23.283 76.1193C22.7631 76.1193 22.3015 76.017 21.8981 75.8125C21.4947 75.608 21.1665 75.3253 20.9137 74.9645C20.6609 74.6009 20.5032 74.1832 20.4407 73.7116H21.7404C21.8256 74.0866 21.9989 74.3906 22.2603 74.6236C22.5245 74.8537 22.8654 74.9688 23.283 74.9688C23.9222 74.9688 24.4208 74.6903 24.7788 74.1335C25.1367 73.5739 25.3171 72.7926 25.32 71.7898H25.2518C25.104 72.0341 24.9194 72.2443 24.6978 72.4205C24.479 72.5966 24.2333 72.733 23.9606 72.8295C23.6879 72.9261 23.3967 72.9744 23.087 72.9744C22.5842 72.9744 22.1268 72.8509 21.7148 72.6037C21.3029 72.3565 20.9748 72.017 20.7305 71.5852C20.4862 71.1534 20.364 70.6605 20.364 70.1065C20.364 69.5554 20.489 69.0554 20.739 68.6065C20.9918 68.1577 21.3441 67.8026 21.7958 67.5412C22.2504 67.277 22.783 67.1477 23.3938 67.1534ZM23.3981 68.2614C23.0657 68.2614 22.766 68.3437 22.4989 68.5085C22.2347 68.6705 22.0259 68.8906 21.8725 69.169C21.7191 69.4446 21.6424 69.7514 21.6424 70.0895C21.6424 70.4276 21.7163 70.7344 21.864 71.0099C22.0146 71.2827 22.2191 71.5 22.4776 71.6619C22.739 71.821 23.0373 71.9006 23.3725 71.9006C23.6225 71.9006 23.8555 71.8523 24.0714 71.7557C24.2873 71.6591 24.4762 71.5256 24.6381 71.3551C24.8001 71.1818 24.9265 70.9858 25.0174 70.767C25.1083 70.5483 25.1538 70.3182 25.1538 70.0767C25.1538 69.7557 25.0771 69.4574 24.9237 69.1818C24.7731 68.9062 24.5657 68.6847 24.3015 68.517C24.0373 68.3466 23.7362 68.2614 23.3981 68.2614ZM32.6761 74.3636V73.9034C32.6761 73.5739 32.7443 73.2727 32.8807 73C33.0199 72.7244 33.2216 72.5043 33.4858 72.3395C33.7528 72.1719 34.0753 72.0881 34.4531 72.0881C34.8395 72.0881 35.1634 72.1705 35.4247 72.3352C35.6861 72.5 35.8835 72.7202 36.017 72.9957C36.1534 73.2713 36.2216 73.5739 36.2216 73.9034V74.3636C36.2216 74.6932 36.1534 74.9957 36.017 75.2713C35.8807 75.544 35.6804 75.7642 35.4162 75.9318C35.1548 76.0966 34.8338 76.179 34.4531 76.179C34.0696 76.179 33.7457 76.0966 33.4815 75.9318C33.2173 75.7642 33.017 75.544 32.8807 75.2713C32.7443 74.9957 32.6761 74.6932 32.6761 74.3636ZM33.669 73.9034V74.3636C33.669 74.608 33.7273 74.8295 33.8438 75.0284C33.9602 75.2273 34.1634 75.3267 34.4531 75.3267C34.7401 75.3267 34.9403 75.2273 35.054 75.0284C35.1676 74.8295 35.2244 74.608 35.2244 74.3636V73.9034C35.2244 73.6591 35.169 73.4375 35.0582 73.2386C34.9503 73.0398 34.7486 72.9403 34.4531 72.9403C34.169 72.9403 33.9673 73.0398 33.848 73.2386C33.7287 73.4375 33.669 73.6591 33.669 73.9034ZM28.2869 69.3693V68.9091C28.2869 68.5795 28.3551 68.277 28.4915 68.0014C28.6307 67.7259 28.8324 67.5057 29.0966 67.3409C29.3636 67.1761 29.6861 67.0938 30.0639 67.0938C30.4503 67.0938 30.7741 67.1761 31.0355 67.3409C31.2969 67.5057 31.4943 67.7259 31.6278 68.0014C31.7614 68.277 31.8281 68.5795 31.8281 68.9091V69.3693C31.8281 69.6989 31.7599 70.0014 31.6236 70.277C31.4901 70.5497 31.2912 70.7699 31.027 70.9375C30.7656 71.1023 30.4446 71.1847 30.0639 71.1847C29.6776 71.1847 29.3523 71.1023 29.0881 70.9375C28.8267 70.7699 28.6278 70.5497 28.4915 70.277C28.3551 70.0014 28.2869 69.6989 28.2869 69.3693ZM29.2841 68.9091V69.3693C29.2841 69.6136 29.3409 69.8352 29.4545 70.0341C29.571 70.233 29.7741 70.3324 30.0639 70.3324C30.348 70.3324 30.5469 70.233 30.6605 70.0341C30.777 69.8352 30.8352 69.6136 30.8352 69.3693V68.9091C30.8352 68.6648 30.7798 68.4432 30.669 68.2443C30.5582 68.0455 30.3565 67.946 30.0639 67.946C29.7798 67.946 29.5781 68.0455 29.4588 68.2443C29.3423 68.4432 29.2841 68.6648 29.2841 68.9091ZM28.6918 76L34.6918 67.2727H35.7102L29.7102 76H28.6918Z"
          fill="#616161"
        />
        <path
          d="M101.888 67.2727V76H100.567V68.5938H100.516L98.4278 69.9574V68.696L100.605 67.2727H101.888ZM107.287 76.1449C106.614 76.142 106.039 75.9645 105.561 75.6122C105.084 75.2599 104.719 74.7472 104.466 74.0739C104.213 73.4006 104.087 72.5895 104.087 71.6406C104.087 70.6946 104.213 69.8864 104.466 69.2159C104.722 68.5455 105.088 68.0341 105.566 67.6818C106.046 67.3295 106.62 67.1534 107.287 67.1534C107.955 67.1534 108.527 67.331 109.005 67.6861C109.482 68.0384 109.847 68.5497 110.1 69.2202C110.355 69.8878 110.483 70.6946 110.483 71.6406C110.483 72.5923 110.357 73.4048 110.104 74.0781C109.851 74.7486 109.486 75.2614 109.009 75.6165C108.532 75.9688 107.958 76.1449 107.287 76.1449ZM107.287 75.0071C107.878 75.0071 108.34 74.7188 108.672 74.142C109.007 73.5653 109.175 72.7315 109.175 71.6406C109.175 70.9162 109.098 70.304 108.945 69.804C108.794 69.3011 108.577 68.9205 108.293 68.6619C108.012 68.4006 107.676 68.2699 107.287 68.2699C106.699 68.2699 106.237 68.5597 105.902 69.1392C105.567 69.7187 105.398 70.5526 105.395 71.6406C105.395 72.3679 105.47 72.983 105.621 73.4858C105.774 73.9858 105.992 74.3651 106.273 74.6236C106.554 74.8793 106.892 75.0071 107.287 75.0071ZM119.044 71.0824V72.1903H115.175V71.0824H119.044ZM126.94 76.1193C126.354 76.1193 125.832 76.0185 125.371 75.8168C124.914 75.6151 124.552 75.3352 124.285 74.9773C124.021 74.6165 123.878 74.1989 123.859 73.7244H125.197C125.214 73.983 125.3 74.2074 125.457 74.3977C125.616 74.5852 125.823 74.7301 126.079 74.8324C126.334 74.9347 126.619 74.9858 126.931 74.9858C127.275 74.9858 127.579 74.9261 127.843 74.8068C128.11 74.6875 128.319 74.5213 128.469 74.3082C128.62 74.0923 128.695 73.8438 128.695 73.5625C128.695 73.2699 128.62 73.0128 128.469 72.7912C128.322 72.5668 128.104 72.3906 127.817 72.2628C127.533 72.1349 127.19 72.071 126.786 72.071H126.049V70.9972H126.786C127.11 70.9972 127.394 70.9389 127.638 70.8224C127.886 70.706 128.079 70.544 128.218 70.3366C128.357 70.1264 128.427 69.8807 128.427 69.5994C128.427 69.3295 128.366 69.0952 128.244 68.8963C128.124 68.6946 127.954 68.5369 127.732 68.4233C127.513 68.3097 127.255 68.2528 126.957 68.2528C126.673 68.2528 126.407 68.3054 126.16 68.4105C125.915 68.5128 125.717 68.6605 125.563 68.8537C125.41 69.044 125.327 69.2727 125.316 69.5398H124.042C124.056 69.0682 124.195 68.6534 124.459 68.2955C124.726 67.9375 125.079 67.6577 125.516 67.456C125.954 67.2543 126.44 67.1534 126.974 67.1534C127.533 67.1534 128.016 67.2628 128.423 67.4815C128.832 67.6974 129.147 67.9858 129.369 68.3466C129.593 68.7074 129.704 69.1023 129.701 69.5312C129.704 70.0199 129.567 70.4347 129.292 70.7756C129.019 71.1165 128.655 71.3452 128.201 71.4616V71.5298C128.78 71.6179 129.229 71.848 129.548 72.2202C129.869 72.5923 130.028 73.054 130.025 73.6051C130.028 74.0852 129.894 74.5156 129.624 74.8963C129.357 75.277 128.992 75.5767 128.529 75.7955C128.066 76.0114 127.536 76.1193 126.94 76.1193ZM134.538 67.1534C134.927 67.1562 135.31 67.2273 135.688 67.3665C136.066 67.5057 136.407 67.733 136.711 68.0483C137.018 68.3636 137.262 68.7898 137.444 69.3267C137.628 69.8608 137.722 70.5256 137.725 71.321C137.725 72.0852 137.648 72.7656 137.495 73.3622C137.342 73.956 137.121 74.4574 136.834 74.8665C136.55 75.2756 136.205 75.5866 135.799 75.7997C135.393 76.0128 134.935 76.1193 134.427 76.1193C133.907 76.1193 133.445 76.017 133.042 75.8125C132.638 75.608 132.31 75.3253 132.057 74.9645C131.805 74.6009 131.647 74.1832 131.584 73.7116H132.884C132.969 74.0866 133.143 74.3906 133.404 74.6236C133.668 74.8537 134.009 74.9688 134.427 74.9688C135.066 74.9688 135.565 74.6903 135.923 74.1335C136.28 73.5739 136.461 72.7926 136.464 71.7898H136.396C136.248 72.0341 136.063 72.2443 135.842 72.4205C135.623 72.5966 135.377 72.733 135.104 72.8295C134.832 72.9261 134.54 72.9744 134.231 72.9744C133.728 72.9744 133.271 72.8509 132.859 72.6037C132.447 72.3565 132.119 72.017 131.874 71.5852C131.63 71.1534 131.508 70.6605 131.508 70.1065C131.508 69.5554 131.633 69.0554 131.883 68.6065C132.136 68.1577 132.488 67.8026 132.94 67.5412C133.394 67.277 133.927 67.1477 134.538 67.1534ZM134.542 68.2614C134.209 68.2614 133.91 68.3437 133.643 68.5085C133.378 68.6705 133.17 68.8906 133.016 69.169C132.863 69.4446 132.786 69.7514 132.786 70.0895C132.786 70.4276 132.86 70.7344 133.008 71.0099C133.158 71.2827 133.363 71.5 133.621 71.6619C133.883 71.821 134.181 71.9006 134.516 71.9006C134.766 71.9006 134.999 71.8523 135.215 71.7557C135.431 71.6591 135.62 71.5256 135.782 71.3551C135.944 71.1818 136.07 70.9858 136.161 70.767C136.252 70.5483 136.298 70.3182 136.298 70.0767C136.298 69.7557 136.221 69.4574 136.067 69.1818C135.917 68.9062 135.709 68.6847 135.445 68.517C135.181 68.3466 134.88 68.2614 134.542 68.2614ZM143.82 74.3636V73.9034C143.82 73.5739 143.888 73.2727 144.024 73C144.164 72.7244 144.365 72.5043 144.63 72.3395C144.897 72.1719 145.219 72.0881 145.597 72.0881C145.983 72.0881 146.307 72.1705 146.568 72.3352C146.83 72.5 147.027 72.7202 147.161 72.9957C147.297 73.2713 147.365 73.5739 147.365 73.9034V74.3636C147.365 74.6932 147.297 74.9957 147.161 75.2713C147.024 75.544 146.824 75.7642 146.56 75.9318C146.299 76.0966 145.978 76.179 145.597 76.179C145.213 76.179 144.889 76.0966 144.625 75.9318C144.361 75.7642 144.161 75.544 144.024 75.2713C143.888 74.9957 143.82 74.6932 143.82 74.3636ZM144.813 73.9034V74.3636C144.813 74.608 144.871 74.8295 144.987 75.0284C145.104 75.2273 145.307 75.3267 145.597 75.3267C145.884 75.3267 146.084 75.2273 146.198 75.0284C146.311 74.8295 146.368 74.608 146.368 74.3636V73.9034C146.368 73.6591 146.313 73.4375 146.202 73.2386C146.094 73.0398 145.892 72.9403 145.597 72.9403C145.313 72.9403 145.111 73.0398 144.992 73.2386C144.872 73.4375 144.813 73.6591 144.813 73.9034ZM139.431 69.3693V68.9091C139.431 68.5795 139.499 68.277 139.635 68.0014C139.774 67.7259 139.976 67.5057 140.24 67.3409C140.507 67.1761 140.83 67.0938 141.208 67.0938C141.594 67.0938 141.918 67.1761 142.179 67.3409C142.441 67.5057 142.638 67.7259 142.772 68.0014C142.905 68.277 142.972 68.5795 142.972 68.9091V69.3693C142.972 69.6989 142.904 70.0014 142.767 70.277C142.634 70.5497 142.435 70.7699 142.171 70.9375C141.909 71.1023 141.588 71.1847 141.208 71.1847C140.821 71.1847 140.496 71.1023 140.232 70.9375C139.97 70.7699 139.772 70.5497 139.635 70.277C139.499 70.0014 139.431 69.6989 139.431 69.3693ZM140.428 68.9091V69.3693C140.428 69.6136 140.485 69.8352 140.598 70.0341C140.715 70.233 140.918 70.3324 141.208 70.3324C141.492 70.3324 141.691 70.233 141.804 70.0341C141.921 69.8352 141.979 69.6136 141.979 69.3693V68.9091C141.979 68.6648 141.924 68.4432 141.813 68.2443C141.702 68.0455 141.5 67.946 141.208 67.946C140.924 67.946 140.722 68.0455 140.603 68.2443C140.486 68.4432 140.428 68.6648 140.428 68.9091ZM139.836 76L145.836 67.2727H146.854L140.854 76H139.836Z"
          fill="#616161"
        />
        <path
          d="M229.85 74.2955V73.2301L233.622 67.2727H234.461V68.8409H233.928L231.231 73.1108V73.179H236.4V74.2955H229.85ZM233.988 76V73.9716L233.997 73.4858V67.2727H235.245V76H233.988ZM240.923 76.1449C240.25 76.142 239.675 75.9645 239.198 75.6122C238.72 75.2599 238.355 74.7472 238.102 74.0739C237.85 73.4006 237.723 72.5895 237.723 71.6406C237.723 70.6946 237.85 69.8864 238.102 69.2159C238.358 68.5455 238.725 68.0341 239.202 67.6818C239.682 67.3295 240.256 67.1534 240.923 67.1534C241.591 67.1534 242.164 67.331 242.641 67.6861C243.118 68.0384 243.483 68.5497 243.736 69.2202C243.992 69.8878 244.119 70.6946 244.119 71.6406C244.119 72.5923 243.993 73.4048 243.74 74.0781C243.487 74.7486 243.122 75.2614 242.645 75.6165C242.168 75.9688 241.594 76.1449 240.923 76.1449ZM240.923 75.0071C241.514 75.0071 241.976 74.7188 242.308 74.142C242.644 73.5653 242.811 72.7315 242.811 71.6406C242.811 70.9162 242.735 70.304 242.581 69.804C242.431 69.3011 242.213 68.9205 241.929 68.6619C241.648 68.4006 241.313 68.2699 240.923 68.2699C240.335 68.2699 239.874 68.5597 239.539 69.1392C239.203 69.7187 239.034 70.5526 239.031 71.6406C239.031 72.3679 239.107 72.983 239.257 73.4858C239.411 73.9858 239.628 74.3651 239.909 74.6236C240.19 74.8793 240.529 75.0071 240.923 75.0071ZM252.681 71.0824V72.1903H248.811V71.0824H252.681ZM260.418 76.1193C259.884 76.1193 259.404 76.017 258.978 75.8125C258.554 75.6051 258.216 75.321 257.964 74.9602C257.711 74.5994 257.576 74.1875 257.559 73.7244H258.837C258.868 74.0994 259.035 74.4077 259.336 74.6491C259.637 74.8906 259.998 75.0114 260.418 75.0114C260.753 75.0114 261.05 74.9347 261.309 74.7812C261.57 74.625 261.775 74.4105 261.922 74.1378C262.073 73.8651 262.148 73.554 262.148 73.2045C262.148 72.8494 262.072 72.5327 261.918 72.2543C261.765 71.9759 261.553 71.7571 261.283 71.598C261.016 71.4389 260.709 71.358 260.363 71.3551C260.099 71.3551 259.833 71.4006 259.566 71.4915C259.299 71.5824 259.083 71.7017 258.918 71.8494L257.712 71.6705L258.202 67.2727H263.001V68.402H259.297L259.02 70.8438H259.072C259.242 70.679 259.468 70.5412 259.749 70.4304C260.033 70.3196 260.337 70.2642 260.661 70.2642C261.192 70.2642 261.665 70.3906 262.08 70.6435C262.498 70.8963 262.826 71.2415 263.064 71.679C263.306 72.1136 263.425 72.6136 263.422 73.179C263.425 73.7443 263.297 74.2486 263.039 74.6918C262.783 75.1349 262.428 75.4844 261.974 75.7401C261.522 75.9929 261.003 76.1193 260.418 76.1193ZM267.881 67.1534C268.27 67.1562 268.654 67.2273 269.031 67.3665C269.409 67.5057 269.75 67.733 270.054 68.0483C270.361 68.3636 270.605 68.7898 270.787 69.3267C270.972 69.8608 271.065 70.5256 271.068 71.321C271.068 72.0852 270.992 72.7656 270.838 73.3622C270.685 73.956 270.465 74.4574 270.178 74.8665C269.894 75.2756 269.548 75.5866 269.142 75.7997C268.736 76.0128 268.279 76.1193 267.77 76.1193C267.25 76.1193 266.789 76.017 266.385 75.8125C265.982 75.608 265.654 75.3253 265.401 74.9645C265.148 74.6009 264.99 74.1832 264.928 73.7116H266.227C266.313 74.0866 266.486 74.3906 266.747 74.6236C267.012 74.8537 267.352 74.9688 267.77 74.9688C268.409 74.9688 268.908 74.6903 269.266 74.1335C269.624 73.5739 269.804 72.7926 269.807 71.7898H269.739C269.591 72.0341 269.406 72.2443 269.185 72.4205C268.966 72.5966 268.72 72.733 268.448 72.8295C268.175 72.9261 267.884 72.9744 267.574 72.9744C267.071 72.9744 266.614 72.8509 266.202 72.6037C265.79 72.3565 265.462 72.017 265.217 71.5852C264.973 71.1534 264.851 70.6605 264.851 70.1065C264.851 69.5554 264.976 69.0554 265.226 68.6065C265.479 68.1577 265.831 67.8026 266.283 67.5412C266.737 67.277 267.27 67.1477 267.881 67.1534ZM267.885 68.2614C267.553 68.2614 267.253 68.3437 266.986 68.5085C266.722 68.6705 266.513 68.8906 266.36 69.169C266.206 69.4446 266.129 69.7514 266.129 70.0895C266.129 70.4276 266.203 70.7344 266.351 71.0099C266.502 71.2827 266.706 71.5 266.965 71.6619C267.226 71.821 267.524 71.9006 267.86 71.9006C268.11 71.9006 268.342 71.8523 268.558 71.7557C268.774 71.6591 268.963 71.5256 269.125 71.3551C269.287 71.1818 269.414 70.9858 269.504 70.767C269.595 70.5483 269.641 70.3182 269.641 70.0767C269.641 69.7557 269.564 69.4574 269.411 69.1818C269.26 68.9062 269.053 68.6847 268.789 68.517C268.524 68.3466 268.223 68.2614 267.885 68.2614ZM277.163 74.3636V73.9034C277.163 73.5739 277.231 73.2727 277.368 73C277.507 72.7244 277.709 72.5043 277.973 72.3395C278.24 72.1719 278.562 72.0881 278.94 72.0881C279.326 72.0881 279.65 72.1705 279.912 72.3352C280.173 72.5 280.371 72.7202 280.504 72.9957C280.64 73.2713 280.709 73.5739 280.709 73.9034V74.3636C280.709 74.6932 280.64 74.9957 280.504 75.2713C280.368 75.544 280.167 75.7642 279.903 75.9318C279.642 76.0966 279.321 76.179 278.94 76.179C278.557 76.179 278.233 76.0966 277.969 75.9318C277.704 75.7642 277.504 75.544 277.368 75.2713C277.231 74.9957 277.163 74.6932 277.163 74.3636ZM278.156 73.9034V74.3636C278.156 74.608 278.214 74.8295 278.331 75.0284C278.447 75.2273 278.65 75.3267 278.94 75.3267C279.227 75.3267 279.427 75.2273 279.541 75.0284C279.655 74.8295 279.711 74.608 279.711 74.3636V73.9034C279.711 73.6591 279.656 73.4375 279.545 73.2386C279.437 73.0398 279.236 72.9403 278.94 72.9403C278.656 72.9403 278.454 73.0398 278.335 73.2386C278.216 73.4375 278.156 73.6591 278.156 73.9034ZM272.774 69.3693V68.9091C272.774 68.5795 272.842 68.277 272.978 68.0014C273.118 67.7259 273.319 67.5057 273.584 67.3409C273.851 67.1761 274.173 67.0938 274.551 67.0938C274.937 67.0938 275.261 67.1761 275.523 67.3409C275.784 67.5057 275.981 67.7259 276.115 68.0014C276.248 68.277 276.315 68.5795 276.315 68.9091V69.3693C276.315 69.6989 276.247 70.0014 276.111 70.277C275.977 70.5497 275.778 70.7699 275.514 70.9375C275.253 71.1023 274.932 71.1847 274.551 71.1847C274.165 71.1847 273.839 71.1023 273.575 70.9375C273.314 70.7699 273.115 70.5497 272.978 70.277C272.842 70.0014 272.774 69.6989 272.774 69.3693ZM273.771 68.9091V69.3693C273.771 69.6136 273.828 69.8352 273.942 70.0341C274.058 70.233 274.261 70.3324 274.551 70.3324C274.835 70.3324 275.034 70.233 275.148 70.0341C275.264 69.8352 275.322 69.6136 275.322 69.3693V68.9091C275.322 68.6648 275.267 68.4432 275.156 68.2443C275.045 68.0455 274.844 67.946 274.551 67.946C274.267 67.946 274.065 68.0455 273.946 68.2443C273.829 68.4432 273.771 68.6648 273.771 68.9091ZM273.179 76L279.179 67.2727H280.197L274.197 76H273.179Z"
          fill="#616161"
        />
        <path
          d="M363.097 76.1193C362.707 76.1136 362.324 76.0426 361.946 75.9062C361.571 75.7699 361.23 75.5426 360.923 75.2244C360.616 74.9062 360.371 74.4787 360.186 73.9418C360.004 73.4048 359.913 72.7344 359.913 71.9304C359.913 71.169 359.989 70.4929 360.139 69.902C360.293 69.3111 360.513 68.8125 360.8 68.4062C361.087 67.9972 361.433 67.6861 361.839 67.473C362.246 67.2599 362.702 67.1534 363.207 67.1534C363.727 67.1534 364.189 67.2557 364.592 67.4602C364.996 67.6648 365.322 67.9474 365.572 68.3082C365.825 68.669 365.986 69.0795 366.054 69.5398H364.754C364.666 69.1761 364.491 68.8793 364.23 68.6491C363.969 68.419 363.628 68.304 363.207 68.304C362.568 68.304 362.07 68.5824 361.712 69.1392C361.356 69.696 361.177 70.4702 361.175 71.4616H361.239C361.389 71.2145 361.574 71.0043 361.793 70.831C362.014 70.6548 362.261 70.5199 362.534 70.4261C362.81 70.3295 363.099 70.2812 363.403 70.2812C363.909 70.2812 364.366 70.4048 364.775 70.652C365.187 70.8963 365.516 71.2344 365.76 71.6662C366.004 72.098 366.126 72.5923 366.126 73.1491C366.126 73.706 366 74.2102 365.747 74.6619C365.497 75.1136 365.145 75.4716 364.69 75.7358C364.236 75.9972 363.704 76.125 363.097 76.1193ZM363.092 75.0114C363.427 75.0114 363.727 74.929 363.991 74.7642C364.256 74.5994 364.464 74.3778 364.618 74.0994C364.771 73.821 364.848 73.5099 364.848 73.1662C364.848 72.831 364.773 72.5256 364.622 72.25C364.474 71.9744 364.27 71.7557 364.008 71.5938C363.75 71.4318 363.454 71.3509 363.122 71.3509C362.869 71.3509 362.635 71.3991 362.419 71.4957C362.206 71.5923 362.018 71.7259 361.856 71.8963C361.695 72.0668 361.567 72.2628 361.473 72.4844C361.382 72.7031 361.337 72.9347 361.337 73.179C361.337 73.5057 361.412 73.8082 361.562 74.0866C361.716 74.3651 361.925 74.5895 362.189 74.7599C362.456 74.9276 362.757 75.0114 363.092 75.0114ZM370.717 76.1449C370.044 76.142 369.468 75.9645 368.991 75.6122C368.514 75.2599 368.149 74.7472 367.896 74.0739C367.643 73.4006 367.517 72.5895 367.517 71.6406C367.517 70.6946 367.643 69.8864 367.896 69.2159C368.152 68.5455 368.518 68.0341 368.995 67.6818C369.475 67.3295 370.049 67.1534 370.717 67.1534C371.385 67.1534 371.957 67.331 372.434 67.6861C372.912 68.0384 373.277 68.5497 373.529 69.2202C373.785 69.8878 373.913 70.6946 373.913 71.6406C373.913 72.5923 373.787 73.4048 373.534 74.0781C373.281 74.7486 372.916 75.2614 372.438 75.6165C371.961 75.9688 371.387 76.1449 370.717 76.1449ZM370.717 75.0071C371.308 75.0071 371.769 74.7188 372.102 74.142C372.437 73.5653 372.605 72.7315 372.605 71.6406C372.605 70.9162 372.528 70.304 372.375 69.804C372.224 69.3011 372.007 68.9205 371.723 68.6619C371.441 68.4006 371.106 68.2699 370.717 68.2699C370.129 68.2699 369.667 68.5597 369.332 69.1392C368.997 69.7187 368.828 70.5526 368.825 71.6406C368.825 72.3679 368.9 72.983 369.051 73.4858C369.204 73.9858 369.421 74.3651 369.703 74.6236C369.984 74.8793 370.322 75.0071 370.717 75.0071ZM382.474 71.0824V72.1903H378.605V71.0824H382.474ZM387.625 76L391.435 68.4659V68.402H387.028V67.2727H392.798V68.4403L389.001 76H387.625ZM397.065 67.1534C397.454 67.1562 397.838 67.2273 398.215 67.3665C398.593 67.5057 398.934 67.733 399.238 68.0483C399.545 68.3636 399.789 68.7898 399.971 69.3267C400.156 69.8608 400.25 70.5256 400.252 71.321C400.252 72.0852 400.176 72.7656 400.022 73.3622C399.869 73.956 399.649 74.4574 399.362 74.8665C399.078 75.2756 398.733 75.5866 398.326 75.7997C397.92 76.0128 397.463 76.1193 396.954 76.1193C396.434 76.1193 395.973 76.017 395.569 75.8125C395.166 75.608 394.838 75.3253 394.585 74.9645C394.332 74.6009 394.174 74.1832 394.112 73.7116H395.412C395.497 74.0866 395.67 74.3906 395.931 74.6236C396.196 74.8537 396.537 74.9688 396.954 74.9688C397.593 74.9688 398.092 74.6903 398.45 74.1335C398.808 73.5739 398.988 72.7926 398.991 71.7898H398.923C398.775 72.0341 398.59 72.2443 398.369 72.4205C398.15 72.5966 397.904 72.733 397.632 72.8295C397.359 72.9261 397.068 72.9744 396.758 72.9744C396.255 72.9744 395.798 72.8509 395.386 72.6037C394.974 72.3565 394.646 72.017 394.402 71.5852C394.157 71.1534 394.035 70.6605 394.035 70.1065C394.035 69.5554 394.16 69.0554 394.41 68.6065C394.663 68.1577 395.015 67.8026 395.467 67.5412C395.921 67.277 396.454 67.1477 397.065 67.1534ZM397.069 68.2614C396.737 68.2614 396.437 68.3437 396.17 68.5085C395.906 68.6705 395.697 68.8906 395.544 69.169C395.39 69.4446 395.313 69.7514 395.313 70.0895C395.313 70.4276 395.387 70.7344 395.535 71.0099C395.686 71.2827 395.89 71.5 396.149 71.6619C396.41 71.821 396.708 71.9006 397.044 71.9006C397.294 71.9006 397.527 71.8523 397.742 71.7557C397.958 71.6591 398.147 71.5256 398.309 71.3551C398.471 71.1818 398.598 70.9858 398.688 70.767C398.779 70.5483 398.825 70.3182 398.825 70.0767C398.825 69.7557 398.748 69.4574 398.595 69.1818C398.444 68.9062 398.237 68.6847 397.973 68.517C397.708 68.3466 397.407 68.2614 397.069 68.2614ZM406.347 74.3636V73.9034C406.347 73.5739 406.415 73.2727 406.552 73C406.691 72.7244 406.893 72.5043 407.157 72.3395C407.424 72.1719 407.746 72.0881 408.124 72.0881C408.511 72.0881 408.834 72.1705 409.096 72.3352C409.357 72.5 409.555 72.7202 409.688 72.9957C409.825 73.2713 409.893 73.5739 409.893 73.9034V74.3636C409.893 74.6932 409.825 74.9957 409.688 75.2713C409.552 75.544 409.351 75.7642 409.087 75.9318C408.826 76.0966 408.505 76.179 408.124 76.179C407.741 76.179 407.417 76.0966 407.153 75.9318C406.888 75.7642 406.688 75.544 406.552 75.2713C406.415 74.9957 406.347 74.6932 406.347 74.3636ZM407.34 73.9034V74.3636C407.34 74.608 407.398 74.8295 407.515 75.0284C407.631 75.2273 407.834 75.3267 408.124 75.3267C408.411 75.3267 408.611 75.2273 408.725 75.0284C408.839 74.8295 408.896 74.608 408.896 74.3636V73.9034C408.896 73.6591 408.84 73.4375 408.729 73.2386C408.621 73.0398 408.42 72.9403 408.124 72.9403C407.84 72.9403 407.638 73.0398 407.519 73.2386C407.4 73.4375 407.34 73.6591 407.34 73.9034ZM401.958 69.3693V68.9091C401.958 68.5795 402.026 68.277 402.163 68.0014C402.302 67.7259 402.503 67.5057 402.768 67.3409C403.035 67.1761 403.357 67.0938 403.735 67.0938C404.121 67.0938 404.445 67.1761 404.707 67.3409C404.968 67.5057 405.165 67.7259 405.299 68.0014C405.432 68.277 405.499 68.5795 405.499 68.9091V69.3693C405.499 69.6989 405.431 70.0014 405.295 70.277C405.161 70.5497 404.962 70.7699 404.698 70.9375C404.437 71.1023 404.116 71.1847 403.735 71.1847C403.349 71.1847 403.023 71.1023 402.759 70.9375C402.498 70.7699 402.299 70.5497 402.163 70.277C402.026 70.0014 401.958 69.6989 401.958 69.3693ZM402.955 68.9091V69.3693C402.955 69.6136 403.012 69.8352 403.126 70.0341C403.242 70.233 403.445 70.3324 403.735 70.3324C404.019 70.3324 404.218 70.233 404.332 70.0341C404.448 69.8352 404.506 69.6136 404.506 69.3693V68.9091C404.506 68.6648 404.451 68.4432 404.34 68.2443C404.229 68.0455 404.028 67.946 403.735 67.946C403.451 67.946 403.249 68.0455 403.13 68.2443C403.013 68.4432 402.955 68.6648 402.955 68.9091ZM402.363 76L408.363 67.2727H409.381L403.381 76H402.363Z"
          fill="#616161"
        />
        <path
          d="M479.488 76.1193C478.877 76.1193 478.337 76.0142 477.868 75.804C477.403 75.5937 477.037 75.304 476.773 74.9347C476.509 74.5653 476.378 74.1449 476.381 73.6733C476.378 73.304 476.454 72.9645 476.607 72.6548C476.763 72.3423 476.975 72.0824 477.242 71.875C477.509 71.6648 477.807 71.5312 478.137 71.4744V71.4233C477.702 71.3182 477.354 71.0852 477.093 70.7244C476.832 70.3636 476.702 69.9489 476.705 69.4801C476.702 69.0341 476.82 68.6364 477.059 68.2869C477.3 67.9347 477.631 67.6577 478.052 67.456C478.472 67.2543 478.951 67.1534 479.488 67.1534C480.019 67.1534 480.493 67.2557 480.911 67.4602C481.332 67.6619 481.662 67.9389 481.904 68.2912C482.145 68.6406 482.268 69.0369 482.27 69.4801C482.268 69.9489 482.134 70.3636 481.87 70.7244C481.606 71.0852 481.262 71.3182 480.839 71.4233V71.4744C481.165 71.5312 481.459 71.6648 481.721 71.875C481.985 72.0824 482.195 72.3423 482.351 72.6548C482.51 72.9645 482.591 73.304 482.594 73.6733C482.591 74.1449 482.458 74.5653 482.194 74.9347C481.93 75.304 481.563 75.5937 481.094 75.804C480.628 76.0142 480.093 76.1193 479.488 76.1193ZM479.488 75.0412C479.849 75.0412 480.161 74.9815 480.425 74.8622C480.689 74.7401 480.894 74.571 481.039 74.3551C481.184 74.1364 481.258 73.8807 481.26 73.5881C481.258 73.2841 481.178 73.0156 481.022 72.7827C480.868 72.5497 480.66 72.3665 480.395 72.233C480.131 72.0994 479.829 72.0327 479.488 72.0327C479.144 72.0327 478.839 72.0994 478.572 72.233C478.305 72.3665 478.094 72.5497 477.941 72.7827C477.787 73.0156 477.712 73.2841 477.715 73.5881C477.712 73.8807 477.782 74.1364 477.924 74.3551C478.069 74.571 478.275 74.7401 478.542 74.8622C478.809 74.9815 479.124 75.0412 479.488 75.0412ZM479.488 70.9801C479.778 70.9801 480.035 70.9219 480.259 70.8054C480.484 70.6889 480.66 70.527 480.787 70.3196C480.918 70.1122 480.985 69.8693 480.988 69.5909C480.985 69.3182 480.92 69.0795 480.792 68.875C480.667 68.6705 480.492 68.5128 480.268 68.402C480.043 68.2884 479.783 68.2315 479.488 68.2315C479.187 68.2315 478.922 68.2884 478.695 68.402C478.471 68.5128 478.296 68.6705 478.171 68.875C478.046 69.0795 477.985 69.3182 477.988 69.5909C477.985 69.8693 478.047 70.1122 478.175 70.3196C478.303 70.527 478.479 70.6889 478.704 70.8054C478.931 70.9219 479.192 70.9801 479.488 70.9801ZM487.159 76.1449C486.486 76.142 485.911 75.9645 485.433 75.6122C484.956 75.2599 484.591 74.7472 484.338 74.0739C484.085 73.4006 483.959 72.5895 483.959 71.6406C483.959 70.6946 484.085 69.8864 484.338 69.2159C484.594 68.5455 484.96 68.0341 485.438 67.6818C485.918 67.3295 486.492 67.1534 487.159 67.1534C487.827 67.1534 488.399 67.331 488.877 67.6861C489.354 68.0384 489.719 68.5497 489.972 69.2202C490.227 69.8878 490.355 70.6946 490.355 71.6406C490.355 72.5923 490.229 73.4048 489.976 74.0781C489.723 74.7486 489.358 75.2614 488.881 75.6165C488.404 75.9688 487.83 76.1449 487.159 76.1449ZM487.159 75.0071C487.75 75.0071 488.212 74.7188 488.544 74.142C488.879 73.5653 489.047 72.7315 489.047 71.6406C489.047 70.9162 488.97 70.304 488.817 69.804C488.666 69.3011 488.449 68.9205 488.165 68.6619C487.884 68.4006 487.548 68.2699 487.159 68.2699C486.571 68.2699 486.11 68.5597 485.774 69.1392C485.439 69.7187 485.27 70.5526 485.267 71.6406C485.267 72.3679 485.343 72.983 485.493 73.4858C485.647 73.9858 485.864 74.3651 486.145 74.6236C486.426 74.8793 486.764 75.0071 487.159 75.0071ZM495.741 71.0824V72.1903H491.871V71.0824H495.741ZM500.324 67.1534C500.713 67.1562 501.096 67.2273 501.474 67.3665C501.852 67.5057 502.193 67.733 502.497 68.0483C502.804 68.3636 503.048 68.7898 503.23 69.3267C503.415 69.8608 503.508 70.5256 503.511 71.321C503.511 72.0852 503.434 72.7656 503.281 73.3622C503.128 73.956 502.908 74.4574 502.621 74.8665C502.336 75.2756 501.991 75.5866 501.585 75.7997C501.179 76.0128 500.721 76.1193 500.213 76.1193C499.693 76.1193 499.231 76.017 498.828 75.8125C498.425 75.608 498.096 75.3253 497.844 74.9645C497.591 74.6009 497.433 74.1832 497.371 73.7116H498.67C498.756 74.0866 498.929 74.3906 499.19 74.6236C499.454 74.8537 499.795 74.9688 500.213 74.9688C500.852 74.9688 501.351 74.6903 501.709 74.1335C502.067 73.5739 502.247 72.7926 502.25 71.7898H502.182C502.034 72.0341 501.849 72.2443 501.628 72.4205C501.409 72.5966 501.163 72.733 500.89 72.8295C500.618 72.9261 500.327 72.9744 500.017 72.9744C499.514 72.9744 499.057 72.8509 498.645 72.6037C498.233 72.3565 497.905 72.017 497.66 71.5852C497.416 71.1534 497.294 70.6605 497.294 70.1065C497.294 69.5554 497.419 69.0554 497.669 68.6065C497.922 68.1577 498.274 67.8026 498.726 67.5412C499.18 67.277 499.713 67.1477 500.324 67.1534ZM500.328 68.2614C499.996 68.2614 499.696 68.3437 499.429 68.5085C499.165 68.6705 498.956 68.8906 498.802 69.169C498.649 69.4446 498.572 69.7514 498.572 70.0895C498.572 70.4276 498.646 70.7344 498.794 71.0099C498.944 71.2827 499.149 71.5 499.408 71.6619C499.669 71.821 499.967 71.9006 500.302 71.9006C500.552 71.9006 500.785 71.8523 501.001 71.7557C501.217 71.6591 501.406 71.5256 501.568 71.3551C501.73 71.1818 501.856 70.9858 501.947 70.767C502.038 70.5483 502.084 70.3182 502.084 70.0767C502.084 69.7557 502.007 69.4574 501.854 69.1818C501.703 68.9062 501.496 68.6847 501.231 68.517C500.967 68.3466 500.666 68.2614 500.328 68.2614ZM504.867 74.2955V73.2301L508.639 67.2727H509.478V68.8409H508.946L506.248 73.1108V73.179H511.417V74.2955H504.867ZM509.005 76V73.9716L509.014 73.4858V67.2727H510.262V76H509.005ZM517.458 74.3636V73.9034C517.458 73.5739 517.526 73.2727 517.662 73C517.801 72.7244 518.003 72.5043 518.267 72.3395C518.534 72.1719 518.857 72.0881 519.235 72.0881C519.621 72.0881 519.945 72.1705 520.206 72.3352C520.468 72.5 520.665 72.7202 520.798 72.9957C520.935 73.2713 521.003 73.5739 521.003 73.9034V74.3636C521.003 74.6932 520.935 74.9957 520.798 75.2713C520.662 75.544 520.462 75.7642 520.198 75.9318C519.936 76.0966 519.615 76.179 519.235 76.179C518.851 76.179 518.527 76.0966 518.263 75.9318C517.999 75.7642 517.798 75.544 517.662 75.2713C517.526 74.9957 517.458 74.6932 517.458 74.3636ZM518.45 73.9034V74.3636C518.45 74.608 518.509 74.8295 518.625 75.0284C518.742 75.2273 518.945 75.3267 519.235 75.3267C519.522 75.3267 519.722 75.2273 519.835 75.0284C519.949 74.8295 520.006 74.608 520.006 74.3636V73.9034C520.006 73.6591 519.95 73.4375 519.84 73.2386C519.732 73.0398 519.53 72.9403 519.235 72.9403C518.95 72.9403 518.749 73.0398 518.629 73.2386C518.51 73.4375 518.45 73.6591 518.45 73.9034ZM513.068 69.3693V68.9091C513.068 68.5795 513.137 68.277 513.273 68.0014C513.412 67.7259 513.614 67.5057 513.878 67.3409C514.145 67.1761 514.468 67.0938 514.845 67.0938C515.232 67.0938 515.556 67.1761 515.817 67.3409C516.078 67.5057 516.276 67.7259 516.409 68.0014C516.543 68.277 516.61 68.5795 516.61 68.9091V69.3693C516.61 69.6989 516.541 70.0014 516.405 70.277C516.272 70.5497 516.073 70.7699 515.808 70.9375C515.547 71.1023 515.226 71.1847 514.845 71.1847C514.459 71.1847 514.134 71.1023 513.87 70.9375C513.608 70.7699 513.409 70.5497 513.273 70.277C513.137 70.0014 513.068 69.6989 513.068 69.3693ZM514.066 68.9091V69.3693C514.066 69.6136 514.122 69.8352 514.236 70.0341C514.352 70.233 514.556 70.3324 514.845 70.3324C515.129 70.3324 515.328 70.233 515.442 70.0341C515.558 69.8352 515.617 69.6136 515.617 69.3693V68.9091C515.617 68.6648 515.561 68.4432 515.45 68.2443C515.34 68.0455 515.138 67.946 514.845 67.946C514.561 67.946 514.36 68.0455 514.24 68.2443C514.124 68.4432 514.066 68.6648 514.066 68.9091ZM513.473 76L519.473 67.2727H520.492L514.492 76H513.473Z"
          fill="#616161"
        />
        <path
          d="M551.741 67.1534C552.131 67.1562 552.514 67.2273 552.892 67.3665C553.27 67.5057 553.611 67.733 553.915 68.0483C554.222 68.3636 554.466 68.7898 554.648 69.3267C554.832 69.8608 554.926 70.5256 554.929 71.321C554.929 72.0852 554.852 72.7656 554.699 73.3622C554.545 73.956 554.325 74.4574 554.038 74.8665C553.754 75.2756 553.409 75.5866 553.003 75.7997C552.597 76.0128 552.139 76.1193 551.631 76.1193C551.111 76.1193 550.649 76.017 550.246 75.8125C549.842 75.608 549.514 75.3253 549.261 74.9645C549.009 74.6009 548.851 74.1832 548.788 73.7116H550.088C550.173 74.0866 550.347 74.3906 550.608 74.6236C550.872 74.8537 551.213 74.9688 551.631 74.9688C552.27 74.9688 552.768 74.6903 553.126 74.1335C553.484 73.5739 553.665 72.7926 553.668 71.7898H553.599C553.452 72.0341 553.267 72.2443 553.045 72.4205C552.827 72.5966 552.581 72.733 552.308 72.8295C552.036 72.9261 551.744 72.9744 551.435 72.9744C550.932 72.9744 550.474 72.8509 550.062 72.6037C549.651 72.3565 549.322 72.017 549.078 71.5852C548.834 71.1534 548.712 70.6605 548.712 70.1065C548.712 69.5554 548.837 69.0554 549.087 68.6065C549.339 68.1577 549.692 67.8026 550.143 67.5412C550.598 67.277 551.131 67.1477 551.741 67.1534ZM551.746 68.2614C551.413 68.2614 551.114 68.3437 550.847 68.5085C550.582 68.6705 550.374 68.8906 550.22 69.169C550.067 69.4446 549.99 69.7514 549.99 70.0895C549.99 70.4276 550.064 70.7344 550.212 71.0099C550.362 71.2827 550.567 71.5 550.825 71.6619C551.087 71.821 551.385 71.9006 551.72 71.9006C551.97 71.9006 552.203 71.8523 552.419 71.7557C552.635 71.6591 552.824 71.5256 552.986 71.3551C553.148 71.1818 553.274 70.9858 553.365 70.767C553.456 70.5483 553.501 70.3182 553.501 70.0767C553.501 69.7557 553.425 69.4574 553.271 69.1818C553.121 68.9062 552.913 68.6847 552.649 68.517C552.385 68.3466 552.084 68.2614 551.746 68.2614ZM559.349 76.1193C558.815 76.1193 558.335 76.017 557.909 75.8125C557.485 75.6051 557.147 75.321 556.895 74.9602C556.642 74.5994 556.507 74.1875 556.49 73.7244H557.768C557.799 74.0994 557.966 74.4077 558.267 74.6491C558.568 74.8906 558.929 75.0114 559.349 75.0114C559.684 75.0114 559.981 74.9347 560.24 74.7812C560.501 74.625 560.706 74.4105 560.853 74.1378C561.004 73.8651 561.079 73.554 561.079 73.2045C561.079 72.8494 561.002 72.5327 560.849 72.2543C560.696 71.9759 560.484 71.7571 560.214 71.598C559.947 71.4389 559.64 71.358 559.294 71.3551C559.029 71.3551 558.764 71.4006 558.497 71.4915C558.23 71.5824 558.014 71.7017 557.849 71.8494L556.643 71.6705L557.133 67.2727H561.931V68.402H558.228L557.951 70.8438H558.002C558.173 70.679 558.399 70.5412 558.68 70.4304C558.964 70.3196 559.268 70.2642 559.592 70.2642C560.123 70.2642 560.596 70.3906 561.011 70.6435C561.429 70.8963 561.757 71.2415 561.995 71.679C562.237 72.1136 562.356 72.6136 562.353 73.179C562.356 73.7443 562.228 74.2486 561.97 74.6918C561.714 75.1349 561.359 75.4844 560.904 75.7401C560.453 75.9929 559.934 76.1193 559.349 76.1193ZM568.465 74.3636V73.9034C568.465 73.5739 568.533 73.2727 568.67 73C568.809 72.7244 569.011 72.5043 569.275 72.3395C569.542 72.1719 569.864 72.0881 570.242 72.0881C570.629 72.0881 570.952 72.1705 571.214 72.3352C571.475 72.5 571.673 72.7202 571.806 72.9957C571.942 73.2713 572.011 73.5739 572.011 73.9034V74.3636C572.011 74.6932 571.942 74.9957 571.806 75.2713C571.67 75.544 571.469 75.7642 571.205 75.9318C570.944 76.0966 570.623 76.179 570.242 76.179C569.859 76.179 569.535 76.0966 569.271 75.9318C569.006 75.7642 568.806 75.544 568.67 75.2713C568.533 74.9957 568.465 74.6932 568.465 74.3636ZM569.458 73.9034V74.3636C569.458 74.608 569.516 74.8295 569.633 75.0284C569.749 75.2273 569.952 75.3267 570.242 75.3267C570.529 75.3267 570.729 75.2273 570.843 75.0284C570.957 74.8295 571.013 74.608 571.013 74.3636V73.9034C571.013 73.6591 570.958 73.4375 570.847 73.2386C570.739 73.0398 570.538 72.9403 570.242 72.9403C569.958 72.9403 569.756 73.0398 569.637 73.2386C569.518 73.4375 569.458 73.6591 569.458 73.9034ZM564.076 69.3693V68.9091C564.076 68.5795 564.144 68.277 564.281 68.0014C564.42 67.7259 564.621 67.5057 564.886 67.3409C565.153 67.1761 565.475 67.0938 565.853 67.0938C566.239 67.0938 566.563 67.1761 566.825 67.3409C567.086 67.5057 567.283 67.7259 567.417 68.0014C567.55 68.277 567.617 68.5795 567.617 68.9091V69.3693C567.617 69.6989 567.549 70.0014 567.413 70.277C567.279 70.5497 567.08 70.7699 566.816 70.9375C566.555 71.1023 566.234 71.1847 565.853 71.1847C565.467 71.1847 565.141 71.1023 564.877 70.9375C564.616 70.7699 564.417 70.5497 564.281 70.277C564.144 70.0014 564.076 69.6989 564.076 69.3693ZM565.073 68.9091V69.3693C565.073 69.6136 565.13 69.8352 565.244 70.0341C565.36 70.233 565.563 70.3324 565.853 70.3324C566.137 70.3324 566.336 70.233 566.45 70.0341C566.566 69.8352 566.624 69.6136 566.624 69.3693V68.9091C566.624 68.6648 566.569 68.4432 566.458 68.2443C566.347 68.0455 566.146 67.946 565.853 67.946C565.569 67.946 565.367 68.0455 565.248 68.2443C565.131 68.4432 565.073 68.6648 565.073 68.9091ZM564.481 76L570.481 67.2727H571.499L565.499 76H564.481ZM576.43 74.5341V68.7727H577.576V74.5341H576.43ZM574.124 72.2244V71.0824H579.886V72.2244H574.124Z"
          fill="#616161"
        />
        <defs>
          <clipPath id="clip0_503_34414">
            <rect width="561" height="12" fill="white" transform="translate(0 28)" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  />
);

export const IgnoreIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="IgnoreIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 12.5H12V11.5H9.375L12 8.5V7.5H8V8.5H10.625L8 11.5V12.5ZM4 15.5V14H5V9C5 7.80915 5.37153 6.75103 6.11458 5.82563C6.85764 4.90021 7.81944 4.32639 9 4.10417V3C9 2.72222 9.09722 2.48611 9.29167 2.29167C9.48611 2.09722 9.72222 2 10 2C10.2778 2 10.5139 2.09722 10.7083 2.29167C10.9028 2.48611 11 2.72222 11 3V4.10417C12.1806 4.32639 13.1424 4.89583 13.8854 5.8125C14.6285 6.72917 15 7.79167 15 9V14H16V15.5H4ZM9.99558 18C9.58186 18 9.22917 17.8531 8.9375 17.5594C8.64583 17.2656 8.5 16.9125 8.5 16.5H11.5C11.5 16.9167 11.3527 17.2708 11.0581 17.5625C10.7635 17.8542 10.4093 18 9.99558 18ZM6.5 14H13.5V9C13.5 8.02778 13.1597 7.20139 12.4792 6.52083C11.7986 5.84028 10.9722 5.5 10 5.5C9.02778 5.5 8.20139 5.84028 7.52083 6.52083C6.84028 7.20139 6.5 8.02778 6.5 9V14Z"
          fill="#424242"
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const RiskIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="RiskIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3542 5.39583L6.75 11H9.79167L9.10417 14.8125L12.9167 10H9.8125L10.3542 5.39583ZM12.25 2L11.5 8.5H16L8.5 18H7L8 12.5H4L10.75 2H12.25Z"
          fill="#424242"
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const Risk2Icon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="RiskIcon"
    component={() => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 13.0417L12.7083 9H10.5417L12.0417 3.5H7.5V10H10V13.0417ZM8.5 18V11.5H6V2H14L12.5 7.5H15.5L8.5 18Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

// very high:  #C62828   high: #EA7D70    medium: #F9A825
export const RiskStatusIcon = ({ size = 40, fill = null, stroke = null, ...props }) => (
  <Icon
    aria-label="RiskIcon"
    component={() => (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {fill && <rect width={size} height={size} rx={size / 2} fill={fill} />}
        <path
          d="M20 30C21.1 30 22 29.1 22 28H18C18 29.1 18.89 30 20 30ZM26 24V19C26 15.93 24.36 13.36 21.5 12.68V12C21.5 11.17 20.83 10.5 20 10.5C19.17 10.5 18.5 11.17 18.5 12V12.68C15.63 13.36 14 15.92 14 19V24L12 26V27H28V26L26 24Z"
          fill="white"
        />
        {stroke && (
          <rect
            x="1"
            y="0.75"
            width="38.5"
            height="38.5"
            rx="19.25"
            strokeWidth="1.5"
            stroke={stroke}
          />
        )}
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const AddressIcon = ({ size = 40, fill = null, stroke = null, ...props }) => (
  <Icon
    aria-label="AddressIcon"
    component={() => (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="#F5F5F5" />
        <path
          d="M14 28C12.9 28 11.9583 27.6083 11.175 26.825C10.3917 26.0417 10 25.1 10 24V16C10 14.9 10.3917 13.9583 11.175 13.175C11.9583 12.3917 12.9 12 14 12H26C27.1 12 28.0417 12.3917 28.825 13.175C29.6083 13.9583 30 14.9 30 16V24C30 25.1 29.6083 26.0417 28.825 26.825C28.0417 27.6083 27.1 28 26 28H14ZM14 16H26C26.3667 16 26.7167 16.0417 27.05 16.125C27.3833 16.2083 27.7 16.3417 28 16.525V16C28 15.45 27.8043 14.9793 27.413 14.588C27.021 14.196 26.55 14 26 14H14C13.45 14 12.9793 14.196 12.588 14.588C12.196 14.9793 12 15.45 12 16V16.525C12.3 16.3417 12.6167 16.2083 12.95 16.125C13.2833 16.0417 13.6333 16 14 16ZM12.15 19.25L23.275 21.95C23.425 21.9833 23.575 21.9833 23.725 21.95C23.875 21.9167 24.0167 21.85 24.15 21.75L27.625 18.85C27.4417 18.6 27.2083 18.396 26.925 18.238C26.6417 18.0793 26.3333 18 26 18H14C13.5667 18 13.1877 18.1123 12.863 18.337C12.5377 18.5623 12.3 18.8667 12.15 19.25Z"
          fill="#424242"
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);
export const RiskScoreIcon = ({ size = 40, fill = null, stroke = null, ...props }) => (
  <Icon
    aria-label="AddressIcon"
    component={() => (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="#F5F5F5" />
        <path
          d="M21.7998 18.2004L22.6998 10.4004H20.8998L12.7998 23.0004H17.5998L16.3998 29.6004H18.1998L27.1998 18.2004H21.7998Z"
          fill="#424242"
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);
export const TransactionsIcon = ({ size = 40, fill = null, stroke = null, ...props }) => (
  <Icon
    aria-label="AddressIcon"
    component={() => (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="#F5F5F5" />
        <path
          d="M15.2004 27.7992L10.4004 22.9992L15.2004 18.1992L16.4748 19.4736L13.8504 22.0992H21.2004V23.8992H13.8504L16.4748 26.5248L15.2004 27.7992ZM24.8004 21.7992L23.526 20.5248L26.1504 17.8992H18.8004V16.0992H26.1504L23.526 13.4736L24.8004 12.1992L29.6004 16.9992L24.8004 21.7992Z"
          fill="#424242"
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);
export const AlertsIcon = ({ size = 40, fill = null, stroke = null, ...props }) => (
  <Icon
    aria-label="AddressIcon"
    component={() => (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="#F5F5F5" />
        <path
          d="M20 30C21.1 30 22 29.1 22 28H18C18 29.1 18.89 30 20 30ZM26 24V19C26 15.93 24.36 13.36 21.5 12.68V12C21.5 11.17 20.83 10.5 20 10.5C19.17 10.5 18.5 11.17 18.5 12V12.68C15.63 13.36 14 15.92 14 19V24L12 26V27H28V26L26 24Z"
          fill="#424242"
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);

export const CheckMarkChunkyIcon = ({ size = 20, color = null, ...props }) => (
  <Icon
    aria-label="AddressIcon"
    component={() => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 12 10"
        fill="none"
      >
        <path
          d="M11.2689 3.02418L4.90373 9.38882C4.83008 9.46249 4.74264 9.52092 4.64641 9.56079C4.55017 9.60066 4.44702 9.62118 4.34286 9.62118C4.23869 9.62118 4.13554 9.60066 4.03931 9.56079C3.94307 9.52092 3.85563 9.46249 3.78199 9.38882L0.231863 5.81986C0.0833912 5.67116 0 5.46962 0 5.25949C0 5.04935 0.0833912 4.84781 0.231863 4.69911L1.42152 3.50946C1.56974 3.36119 1.77064 3.27765 1.98029 3.27709C2.18993 3.27654 2.39127 3.35901 2.54029 3.50648L4.35649 5.25478L4.36194 5.26023L8.95846 0.731122C9.1071 0.583104 9.30833 0.5 9.51809 0.5C9.72786 0.5 9.92909 0.583104 10.0777 0.731122L11.2674 1.89896C11.3417 1.97258 11.4007 2.06016 11.441 2.15666C11.4813 2.25316 11.5021 2.35668 11.5022 2.46126C11.5024 2.56584 11.4818 2.66942 11.4418 2.76603C11.4017 2.86263 11.343 2.95037 11.2689 3.02418Z"
          fill={color || "currentColor"}
        />
      </svg>
    )}
    width={size}
    height={size}
    {...props}
  />
);
